(function() {
  'use strict';

  angular
    .module('trident', ['ngAnimate', 'ngCookies', 'ngSanitize', 'ngAria', 'ui.router', 'ui.bootstrap', 'toastr', 'LocalStorageModule', 'angular-md5']);

})();

(function() {
    'use strict';

    angular
        .module('trident')
        .factory('ucenter', ucenter);

    /** @ngInject */
    function ucenter($http) {
        var apiHost = 'http://tridentstudio.cn:3000';

        return {
            apiHost: apiHost,
            login: login,
            register: register
        };

        function login(params) {
            return $http.post(apiHost + '/login', params)
        }

        function register(params) {
            return $http.post(apiHost + "/register", params)
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trident')
        .directive('siteFooter', siteFooter);

    /** @ngInject */
    function siteFooter() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/siteFooter/siteFooter.html'
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('trident')
        .directive('navbar', navbar);

    /** @ngInject */
    function navbar() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {},
            controller: NavbarController,
            controllerAs: 'nb',
            bindToController: true
        };

        /** @ngInject */
        function NavbarController($log, localStorageService, $rootScope, _, $state, $location) {
            var vm = this;
            var current_path = $location.path();

            vm.userName = localStorageService.get('user_name') || "登录";
            $log.debug(vm.userName);

            vm.logout = function() {
                localStorageService.remove('user_name');
                vm.userName = "登录";
                $state.go("app.home");
            };

            vm.changeEvent = $rootScope.$on('$stateChangeSuccess', function() {
                vm.setActiveMenu($state.current.name)
            });

            vm.setActiveMenu = function(activeState) {
                _.forEach(vm.navbarMenus, function(nm) {
                    nm.isActive = (nm.uiState == activeState);
                })
            };

            function getItemState(path) {
                return path == current_path;
            }

            vm.navbarMenus = [
                {
                    name: "主页",
                    isActive: getItemState('/app/home'),
                    uiState: 'app.home'
                },
                {
                    name: "项目展示",
                    isActive: getItemState('/app/show'),
                    uiState: 'app.show'
                },
                {
                    name: "公告",
                    isActive: getItemState('/app/announcement'),
                    uiState: 'app.announcement'
                },
                {
                    name: "隐私政策",
                    isActive: getItemState('/app/privacy'),
                    uiState: 'app.privacy'
                }
            ];
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('trident')
        .controller('ShowController', ShowController);

    /** @ngInject */
    function ShowController() {
        var vm = this;

        vm.title = "show page";
    }
})();
(function() {
    'use strict';

    angular
        .module('trident')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController(localStorageService, $state, toastr, _, md5, $log, ucenter) {
        var vm = this;
        vm.user = localStorageService.get('cache_user_info') ||{};
        vm.registered_users = localStorageService.get("registered_users") || [];

        vm.register = function() {
            if (isEmailAddressRegistered(vm.user.email)) {
                toastr.error("该邮箱地址已经被注册", "信息有误");
                return;
            }
            if (!isEmailValid(vm.user.email)) {
                toastr.error("邮箱地址不合法", "信息有误");
                return;
            }
            if (vm.user.password != vm.user.passwordConfirm) {
                toastr.error("两次输入密码不匹配", "信息有误");
                return;
            }
            if (!vm.user.name) {
                toastr.error("姓名为空", "信息有误");
                return;
            }
            if (!isIDValid(vm.user.ID)) {
                toastr.error("身份证号不合法","信息有误");
                return;
            }

            ucenter.register({
                email: vm.user.email,
                password: (md5.createHash(vm.user.password)).toString().toUpperCase(),
                realName: vm.user.name,
                userID: vm.user.ID,
                cardType: 1
            }).then(function(res) {
                toastr.success(res.data.message);
                $state.go('app.home');
            }, function(reason) {
                $log.error(reason.data);
                toastr.error(reason.data.message);
            });
            localStorageService.remove('cache_user_info');
        };

        vm.cacheRegisterInfo = function() {
            localStorageService.set('cache_user_info', vm.user)
        };

        function isEmailAddressRegistered(email) {
            return (_.filter(vm.registered_users, function(ru) {
                return ru.email == email;
            })).length != 0
        }

        function isEmailValid(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        function isIDValid(ID, GB_code) {
            var util = {
                checkArg:function(id){
                    id = id.toUpperCase();

                    var code = null;
                    if( id.length === 18 ){
                        //18位
                        code = {
                            body : id.slice(0,17),
                            checkBit : id.slice(-1),
                            type : 18
                        };
                    }else if( id.length === 15 ){
                        //15位
                        code = {
                            body : id,
                            type : 15
                        };
                    }else{
                        return false;
                    }

                    return code;
                }
                //地址码检查
                ,checkAddr:function(addr,GB2260){
                    var addrInfo = util.getAddrInfo(addr,GB2260);
                    return ( addrInfo !== false );
                }
                //取得地址码信息
                ,getAddrInfo:function(addr,GB2260){
                    GB2260 = GB2260 || null;
                    //查询GB/T2260,没有引入GB2260时略过
                    if( GB2260 === null ){
                        return addr;
                    }
                    if( !GB2260.hasOwnProperty(addr) ){
                        //考虑标准不全的情况，搜索不到时向上搜索
                        var tmpAddr;
                        tmpAddr = addr.slice(0,4) + '00';
                        if( !GB2260.hasOwnProperty(tmpAddr) ){
                            tmpAddr = addr.slice(0,2) + '0000';
                            if( !GB2260.hasOwnProperty(tmpAddr) ){
                                return false;
                            }else{
                                return GB2260[tmpAddr] + '未知地区';
                            }
                        }else{
                            return GB2260[tmpAddr] + '未知地区';
                        }
                    }else{
                        return GB2260[addr];
                    }
                }
                //生日码检查
                ,checkBirth:function(birth){
                    var month, day;
                    if( birth.length == 8 ){
                        month = parseInt( birth.slice(4,6),10 );
                        day   = parseInt( birth.slice(-2),10 );
                    }else if( birth.length == 6 ){
                        month = parseInt( birth.slice(2,4),10 );
                        day   = parseInt( birth.slice(-2),10 );
                    }else{
                        return false;
                    }
                    return !(month > 12 || month === 0 || day > 31 || day === 0);


                }
                //顺序码检查
                ,checkOrder:function(){
                    //暂无需检测

                    return true;
                }
                //加权
                ,weight:function(t){
                    return Math.pow(2,t-1)%11;
                }
                //随机整数
                ,rand:function(max,min){
                    min = min || 1;
                    return Math.round( Math.random() * (max-min) ) + min;
                }
                //数字补位
                ,str_pad:function(str,len,chr,right){
                    str = str.toString();
                    len = len || 2;
                    chr = chr || '0';
                    right = right || false;
                    if( str.length >= len ){
                        return str;
                    }else{
                        for( var i=0,j=len-str.length;i<j;i++ ){
                            if( right ){
                                str = str+chr;
                            }else{
                                str = chr+str;
                            }
                        }
                        return str;
                    }
                }
                //抛错
                ,error:function(msg){
                    var e = new Error();
                    e.message = 'IDValidator: ' + msg;
                    throw e;
                }
            };

            var GB2260 = GB_code || null;
            var code = util.checkArg(ID);
            if( code === false ){
                return false;
            }


            var addr = code.body.slice(0,6);
            var birth = ( code.type === 18 ? code.body.slice(6,14) : code.body.slice(6,12) );
            var order = code.body.slice(-3);

            if( !( util.checkAddr(addr,GB2260) && util.checkBirth(birth) && util.checkOrder(order) ) ) {
                return false;
            }

            //15位不含校验码，到此已结束
            if( code.type === 15 ){
                return true;
            }

            /* 校验位部分 */

            //位置加权
            var posWeight = [];
            for(var i=18;i>1;i--){
                posWeight[i] = util.weight(i);
            }

            //累加body部分与位置加权的积
            var bodySum = 0;
            var bodyArr = code.body.split('');
            for(var j=0;j<bodyArr.length;j++){
                bodySum += ( parseInt( bodyArr[j],10 ) * posWeight[18 - j] );
            }

            //得出校验码
            var checkBit = 12 - ( bodySum % 11 );
            if( checkBit == 10 ){
                checkBit = 'X';
            }else if( checkBit>10 ){
                checkBit = checkBit%11;
            }
            checkBit = (angular.isNumber(checkBit)?checkBit.toString():checkBit );

            //检查校验码
            return checkBit === code.checkBit;
        }

        vm.title = "register page";
    }
})();

(function() {
    'use strict';

    angular
        .module('trident')
        .controller('PrivacyController', PrivacyController);

    /** @ngInject */
    function PrivacyController() {
        var vm = this;

        vm.title = "privacy page";

        vm.supported_languages = [
            'zh-CN', 'en', 'de-DE', 'es-419', 'fr-FR', 'pt-BR', 'ru-RU'
        ];
        vm.local_name = {
            'zh-CN': '简体中文',
            'en': 'English',
            'de-DE': 'Deutsche',
            'es-419': 'español',
            'fr-FR': 'Français',
            'pt-BR': 'Português',
            'ru-RU': 'Русский'
        };

        vm.lang = 'en';  // default en
        // from https://stackoverflow.com/a/38150585
        var language = navigator.languages && navigator.languages[0] || // Chrome / Firefox
               navigator.language ||   // All browsers
               navigator.userLanguage; // IE <= 10
        for (var i in vm.supported_languages) {
            var lang = vm.supported_languages[i];
            if (lang.includes(language)) {
                vm.lang = lang;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trident')
        .controller('ParentalController', ParentalController);

    /** @ngInject */
    function ParentalController() {
        var vm = this;

        vm.title = "parental page";

        vm.showTips = false;

        vm.studio = {
            cn_name: "三叉戟",
            name: "trident"
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trident')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController() {
        var vm = this;

        vm.title = 'abstract main controller';
    }
})();

(function () {
    'use strict';

    angular
        .module('trident')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($log, $state, localStorageService, _, toastr, ucenter, md5) {
        var vm = this;

        vm.title = "login page";

        vm.login = function () {
            ucenter.login({
                email: vm.userName,
                password: (md5.createHash(vm.userPassword)).toString().toUpperCase()
            }).then(function (res) {
                toastr.success(res.data.message);
                localStorageService.set('user_name', vm.userName);
                $state.go('app.home')
            }, function (reason) {
                $log.error(reason.data);
                toastr.error(reason.data.message)
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trident')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController() {
        var vm = this;

        vm.title = "home page";
    }
})();

(function() {
  'use strict';

  angular
    .module('trident')
    .controller('DisputeHandlingController', DisputeHandlingController);

  /** @ngInject */
  function DisputeHandlingController() {
    var vm = this;

    vm.title = "dispute handling page";
  }
})();

(function() {
    'use strict';

    angular
        .module('trident')
        .controller('ContactController', ContactController);

    /** @ngInject */
    function ContactController() {
        var vm = this;

        vm.title = "contact page";
    }
})();

(function() {
    'use strict';

    angular
        .module('trident')
        .controller('AnnouncementController', AnnouncementController);

    /** @ngInject */
    /**
     https://git.tap4fun.com/huangchangjun/notebook/blob/master/ba/trindent_tsv2json/BA%E6%9B%B4%E6%96%B0%E6%B4%BB%E5%8A%A8%E5%85%AC%E5%91%8A%E4%B8%8E%E6%A6%82%E7%8E%87%E5%85%AC%E5%91%8A.md
     * **/
    /**
    
            {
                name: "【幸运石】活动概率公布",
                date: "2021-08-06",
                show: false,
                description: "",
                outHeaders: ["每块石板奖励", "每块石板发光概率", "石板相同概率"],
                tables: [
                    { 表1
                    },
                    { 表2
                    },
                    { 表3
                    }
                ]
            },
    
    **/
    
    /** 
     
    新版本: 
    ba-trident tmp.txt 2021-09-10 【祭司暴击】活动概率 
    
    **/

    function AnnouncementController() {
        var vm = this;

        vm.title = "announcement page";

        vm.showTips = false;

        vm.studio = {
            cn_name: "三叉戟",
            name: "trident"
        };
        /** AOA **/
        /** AOAAOA **/
        vm.activities_aoa = [
            {
                "name": "【弹珠机】活动概率公布",
                "date": "2026-10-23",
                "show": false,
                "description": "撞击达到11次时，基础得分为20分。",
                "outHeaders": [
                    "撞击次数概率",
                    "落槽概率"
                ],
                "tables": [
                    {
                        "subHeaders": [
                            "撞击次数",
                            "概率"
                        ],
                        "data": [
                            {
                                "撞击次数": "3击",
                                "概率": "3.0%"
                            },
                            {
                                "撞击次数": "4击",
                                "概率": "5.0%"
                            },
                            {
                                "撞击次数": "5击",
                                "概率": "8.0%"
                            },
                            {
                                "撞击次数": "6击",
                                "概率": "10.0%"
                            },
                            {
                                "撞击次数": "7击",
                                "概率": "12.0%"
                            },
                            {
                                "撞击次数": "8击",
                                "概率": "14.0%"
                            },
                            {
                                "撞击次数": "9击",
                                "概率": "14.0%"
                            },
                            {
                                "撞击次数": "10击",
                                "概率": "16.0%"
                            },
                            {
                                "撞击次数": "11击",
                                "概率": "18.0%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "落槽位置",
                            "得分倍率",
                            "概率"
                        ],
                        "data": [
                            {
                                "落槽位置": "1槽",
                                "得分倍率": "×1",
                                "概率": "1.0%"
                            },
                            {
                                "落槽位置": "2槽",
                                "得分倍率": "×2",
                                "概率": "16.0%"
                            },
                            {
                                "落槽位置": "3槽",
                                "得分倍率": "×3",
                                "概率": "25.0%"
                            },
                            {
                                "落槽位置": "4槽",
                                "得分倍率": "×10",
                                "概率": "16.0%"
                            },
                            {
                                "落槽位置": "5槽",
                                "得分倍率": "×3",
                                "概率": "25.0%"
                            },
                            {
                                "落槽位置": "6槽",
                                "得分倍率": "×2",
                                "概率": "16.0%"
                            },
                            {
                                "落槽位置": "7槽",
                                "得分倍率": "×1",
                                "概率": "1.0%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "秘境探险",
                date: "2024-04-25",
                show: false,
                description: "",
                outHeaders: ['骰子投掷前进步数概率', '秘境起点宝箱开启概率', '传说/超凡战装图纸碎片箱开启概率', '战装重铸随机宝箱开启概率'],
                tables: [
                    {
                        "subHeaders": [
                            "前进步数",
                            "概率"
                        ],
                        "data": [
                            {
                                "前进步数": "1",
                                "概率": "16.67%"
                            },
                            {
                                "前进步数": "2",
                                "概率": "16.67%"
                            },
                            {
                                "前进步数": "3",
                                "概率": "16.67%"
                            },
                            {
                                "前进步数": "4",
                                "概率": "16.67%"
                            },
                            {
                                "前进步数": "5",
                                "概率": "16.67%"
                            },
                            {
                                "前进步数": "6",
                                "概率": "16.67%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励道具": "纳米×5",
                                "概率": "70%"
                            },
                            {
                                "奖励道具": "纳米×6",
                                "概率": "15%"
                            },
                            {
                                "奖励道具": "纳米×7",
                                "概率": "8%"
                            },
                            {
                                "奖励道具": "纳米×8",
                                "概率": "4%"
                            },
                            {
                                "奖励道具": "纳米×9",
                                "概率": "2%"
                            },
                            {
                                "奖励道具": "纳米×10",
                                "概率": "1%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "图纸碎片",
                            "概率"
                        ],
                        "data": [
                            {
                                "图纸碎片": "驱动器碎片",
                                "概率": "25%"
                            },
                            {
                                "图纸碎片": "防护服碎片",
                                "概率": "25%"
                            },
                            {
                                "图纸碎片": "探测仪碎片",
                                "概率": "25%"
                            },
                            {
                                "图纸碎片": "应急包碎片",
                                "概率": "25%"
                            },
                            {
                                "图纸碎片": "※所有不同的战装图纸碎片箱概率相同",
                                "概率": "-"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励道具": "纳米材料×1",
                                "概率": "90.00%"
                            },
                            {
                                "奖励道具": "纳米材料×2",
                                "概率": "5.00%"
                            },
                            {
                                "奖励道具": "重铸矿晶×1",
                                "概率": "4.00%"
                            },
                            {
                                "奖励道具": "高级重铸矿晶×1",
                                "概率": "1.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "太空争霸wonder",
                date: "2023-09-20",
                show: false,
                description: "",
                outHeaders: ['太空争霸wonder-祈愿宝箱奖励概率', '太空争霸wonder-捐献获取祈愿宝箱概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级级资源自选宝箱1K*2",
                                "概率": "9.20%"
                            },
                            {
                                "道具": "初级级资源自选宝箱1K*3",
                                "概率": "21.47%"
                            },
                            {
                                "道具": "加速随机宝箱*1",
                                "概率": "30.67%"
                            },
                            {
                                "道具": "英雄经验-100*2",
                                "概率": "6.13%"
                            },
                            {
                                "道具": "英雄经验-100*3",
                                "概率": "9.20%"
                            },
                            {
                                "道具": "英雄经验-500*1",
                                "概率": "15.34%"
                            },
                            {
                                "道具": "英雄经验-1000*1",
                                "概率": "6.13%"
                            },
                            {
                                "道具": "英雄经验-5000*1",
                                "概率": "1.53%"
                            },
                            {
                                "道具": "普通奖池抽奖券*1",
                                "概率": "0.31%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祈愿宝箱*1",
                                "概率": "13.64%"
                            },
                            {
                                "道具": "祈愿宝箱*2",
                                "概率": "31.82%"
                            },
                            {
                                "道具": "祈愿宝箱*4",
                                "概率": "27.27%"
                            },
                            {
                                "道具": "祈愿宝箱*6",
                                "概率": "13.64%"
                            },
                            {
                                "道具": "祈愿宝箱*10",
                                "概率": "13.64%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "太空漫游",
                date: "2023-09-20",
                show: false,
                description: "",
                outHeaders: ['太空漫游-外圈奖励概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "收藏品-橙色升星道具-传说*2",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "军备零件箱*30",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "万能英雄碎片-橙色*1",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "登月节-兑换道具*20",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "英雄经验-50000*1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "登月节-兑换道具*10",
                                "概率": "12.00%"
                            },
                            {
                                "道具": "高级探测抽奖券*1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "登月节-兑换道具*2",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "军备零件箱*10",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "高级资源自选宝箱10w*1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "登月节-兑换道具*5",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "60分钟训练加速*1",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "欢乐游园会",
                date: "2023-08-22",
                show: false,
                description: "",
                outHeaders: ['欢乐游园会-外圈奖励概率', '欢乐游园会-内圈奖励概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "幸运传送球*1",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "传说收藏品升星石*5",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "8小时加速*1",
                                "概率": "2.82%"
                            },
                            {
                                "道具": "万能奖牌-传说*1",
                                "概率": "3.62%"
                            },
                            {
                                "道具": "军备零件箱*100",
                                "概率": "4.02%"
                            },
                            {
                                "道具": "5.0万斗士经验*5",
                                "概率": "6.44%"
                            },
                            {
                                "道具": "2小时训练加速*1",
                                "概率": "7.24%"
                            },
                            {
                                "道具": "高级探测雷达*1",
                                "概率": "9.05%"
                            },
                            {
                                "道具": "豪华宴会券*1",
                                "概率": "10.06%"
                            },
                            {
                                "道具": "军备零件箱*30",
                                "概率": "12.87%"
                            },
                            {
                                "道具": "50万钢铁*1",
                                "概率": "11.45%"
                            },
                            {
                                "道具": "50万粮食*1",
                                "概率": "10.64%"
                            },
                            {
                                "道具": "1小时训练加速*1",
                                "概率": "12.25%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "8小时训练加速*1",
                                "概率": "4.17%"
                            },
                            {
                                "道具": "8小时加速*2",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "24小时加速*3",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "收藏品-橙色升星道具-传说*100",
                                "概率": "8.33%"
                            },
                            {
                                "道具": "7天加速*3",
                                "概率": "8.33%"
                            },
                            {
                                "道具": "万能英雄碎片-橙色*15",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "万能英雄碎片-橙色*40",
                                "概率": "6.62%"
                            },
                            {
                                "道具": "装备材料-纳米材料*200",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "机甲经验-50000*120",
                                "概率": "8.33%"
                            },
                            {
                                "道具": "英雄升星-橙色-大*10",
                                "概率": "4.17%"
                            },
                            {
                                "道具": "周年主城自选道具",
                                "概率": "5.82%"
                            },
                            {
                                "道具": "主城皮肤-周年庆典2023",
                                "概率": "4.24%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "幸运时刻",
                date: "2023-07-25",
                show: false,
                description: "",
                outHeaders: ['外环：', '内环：'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "金刚的增强芯片*1",
                                "概率": "75%"
                            },
                            {
                                "道具": "金刚的增强芯片*2",
                                "概率": "20%"
                            },
                            {
                                "道具": "金刚的增强芯片*5",
                                "概率": "4%"
                            },
                            {
                                "道具": "金刚的增强芯片*10",
                                "概率": "1%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "50,000机甲能源*5",
                                "概率": "42%"
                            },
                            {
                                "道具": "50,000机甲经验*15",
                                "概率": "38%"
                            },
                            {
                                "道具": "本轮奖励翻倍",
                                "概率": "20%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "机械秘宝",
                date: "2023-04-27",
                show: false,
                description: "",
                outHeaders: ['机械秘宝-外圈奖励概率', '机械秘宝-展台奖励概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "幸运传送球*1",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "传说收藏品升星石*5",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "8小时加速*1",
                                "概率": "2.82%"
                            },
                            {
                                "道具": "万能奖牌-传说*1",
                                "概率": "3.62%"
                            },
                            {
                                "道具": "军备零件箱*100",
                                "概率": "4.02%"
                            },
                            {
                                "道具": "5.0万斗士经验*5",
                                "概率": "6.44%"
                            },
                            {
                                "道具": "2小时训练加速*1",
                                "概率": "7.24%"
                            },
                            {
                                "道具": "高级探测雷达*1",
                                "概率": "9.05%"
                            },
                            {
                                "道具": "豪华宴会券*1",
                                "概率": "10.06%"
                            },
                            {
                                "道具": "军备零件箱*30",
                                "概率": "12.87%"
                            },
                            {
                                "道具": "50万钢铁*1",
                                "概率": "11.45%"
                            },
                            {
                                "道具": "50万粮食*1",
                                "概率": "10.64%"
                            },
                            {
                                "道具": "1小时训练加速*1",
                                "概率": "12.25%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "8小时训练加速*2",
                                "概率": "21.92%"
                            },
                            {
                                "道具": "普通传说基因药水*5",
                                "概率": "12.33%"
                            },
                            {
                                "道具": "24小时加速*5",
                                "概率": "10.96%"
                            },
                            {
                                "道具": "军备图纸*50",
                                "概率": "8.64%"
                            },
                            {
                                "道具": "万能奖牌-传说*10",
                                "概率": "9.04%"
                            },
                            {
                                "道具": "7天加速*7",
                                "概率": "5.48%"
                            },
                            {
                                "道具": "24小时加速*7",
                                "概率": "9.57%"
                            },
                            {
                                "道具": "大份传说基因药水*10",
                                "概率": "6.85%"
                            },
                            {
                                "道具": "传说收藏品升星石*100",
                                "概率": "6.85%"
                            },
                            {
                                "道具": "万能奖牌-传说*40",
                                "概率": "5.62%"
                            },
                            {
                                "道具": "拓荒之城（主城皮肤）*1",
                                "概率": "2.74%"
                            }
                        ]
                    }
                ]
            },

             {
                name: "复活节gacha",
                date: "2023-04-18",
                show: false,
                description: "",
                outHeaders: ['复活节gacha'],
                tables: [
                    {
                        "subHeaders": [
                            "格子奖励",
                            "格子权重"
                        ],
                        "data": [
                            {
                                "格子奖励": "主城皮肤-复活节-2023",
                                "格子权重": "0.90%"
                            },
                            {
                                "格子奖励": "英雄升星-橙色-大",
                                "格子权重": "2.18%"
                            },
                            {
                                "格子奖励": "万能英雄碎片-橙色",
                                "格子权重": "6.90%"
                            },
                            {
                                "格子奖励": "万能英雄碎片-橙色",
                                "格子权重": "3.51%"
                            },
                            {
                                "格子奖励": "万能英雄碎片-橙色",
                                "格子权重": "1.88%"
                            },
                            {
                                "格子奖励": "7天加速",
                                "格子权重": "2.32%"
                            },
                            {
                                "格子奖励": "3天加速",
                                "格子权重": "4.17%"
                            },
                            {
                                "格子奖励": "军备图纸",
                                "格子权重": "10.89%"
                            },
                            {
                                "格子奖励": "收藏品-橙色升星道具-传说",
                                "格子权重": "10.90%"
                            },
                            {
                                "格子奖励": "24小时加速",
                                "格子权重": "10.88%"
                            },
                            {
                                "格子奖励": "12小时加速",
                                "格子权重": "9.09%"
                            },
                            {
                                "格子奖励": "英雄升星-橙色-中",
                                "格子权重": "9.06%"
                            },
                            {
                                "格子奖励": "高级探测抽奖券",
                                "格子权重": "13.66%"
                            },
                            {
                                "格子奖励": "高级奖池抽奖券",
                                "格子权重": "4.55%"
                            },
                            {
                                "格子奖励": "8小时加速",
                                "格子权重": "9.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "惊喜藏品屋",
                date: "2023-04-18",
                show: false,
                description: "",
                outHeaders: ['惊喜藏品屋'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "三星传说收藏品",
                                "概率": "8.87%"
                            },
                            {
                                "道具": "三星传说收藏品",
                                "概率": "8.87%"
                            },
                            {
                                "道具": "三星传说收藏品",
                                "概率": "8.87%"
                            },
                            {
                                "道具": "传说收藏品升星石50个",
                                "概率": "3.28%"
                            },
                            {
                                "道具": "传说收藏品升星石30个",
                                "概率": "4.27%"
                            },
                            {
                                "道具": "传说收藏品升星石30个",
                                "概率": "3.11%"
                            },
                            {
                                "道具": "传说收藏品升星石28个",
                                "概率": "4.37%"
                            },
                            {
                                "道具": "传说收藏品升星石25个",
                                "概率": "4.30%"
                            },
                            {
                                "道具": "传说收藏品升星石18个",
                                "概率": "4.36%"
                            },
                            {
                                "道具": "传说收藏品升星石18个",
                                "概率": "4.42%"
                            },
                            {
                                "道具": "传说收藏品升星石15个",
                                "概率": "4.49%"
                            },
                            {
                                "道具": "传说收藏品升星石15个",
                                "概率": "4.55%"
                            },
                            {
                                "道具": "传说收藏品升星石13个",
                                "概率": "4.52%"
                            },
                            {
                                "道具": "传说收藏品升星石13个",
                                "概率": "4.40%"
                            },
                            {
                                "道具": "传说收藏品升星石10个",
                                "概率": "4.53%"
                            },
                            {
                                "道具": "传说收藏品升星石10个",
                                "概率": "4.49%"
                            },
                            {
                                "道具": "传说收藏品升星石10个",
                                "概率": "4.51%"
                            },
                            {
                                "道具": "传说收藏品升星石10个",
                                "概率": "4.56%"
                            },
                            {
                                "道具": "传说收藏品升星石3个",
                                "概率": "4.61%"
                            },
                            {
                                "道具": "传说收藏品升星石2个",
                                "概率": "4.83%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "狙击强盗猿",
                date: "2022-07-21",
                show: false,
                description: "",
                outHeaders: ['狙击强盗猿'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "军备零件箱",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "军备图纸",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "500镭射唱片",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "100镭射唱片",
                                "概率": "1.40%"
                            },
                            {
                                "道具": "2小时训练加速",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "2小时科研加速",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "2小时建筑加速",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "60分钟训练加速",
                                "概率": "9.35%"
                            },
                            {
                                "道具": "15分钟科研加速",
                                "概率": "12.15%"
                            },
                            {
                                "道具": "15分钟建筑加速",
                                "概率": "12.15%"
                            },
                            {
                                "道具": "大份传说基因药水",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "普通传说基因药水",
                                "概率": "0.75%"
                            },
                            {
                                "道具": "迷你传说基因药水",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "斗士经验-10000",
                                "概率": "5.61%"
                            },
                            {
                                "道具": "斗士经验-5000",
                                "概率": "9.35%"
                            },
                            {
                                "道具": "斗士经验-1000",
                                "概率": "11.21%"
                            },
                            {
                                "道具": "500电池",
                                "概率": "2.80%"
                            },
                            {
                                "道具": "100电池",
                                "概率": "4.67%"
                            },
                            {
                                "道具": "150,000食物",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "150,000钢铁",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "50,000食物",
                                "概率": "9.35%"
                            },
                            {
                                "道具": "50,000钢铁",
                                "概率": "9.35%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "飞艇击落战",
                date: "2022-07-21",
                show: false,
                description: "",
                outHeaders: ['飞艇击落战'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "军备零件箱",
                                "概率": "7.97%"
                            },
                            {
                                "道具": "军备图纸",
                                "概率": "4.78%"
                            },
                            {
                                "道具": "合金零件",
                                "概率": "7.97%"
                            },
                            {
                                "道具": "涂料",
                                "概率": "7.97%"
                            },
                            {
                                "道具": "精密纤维",
                                "概率": "3.99%"
                            },
                            {
                                "道具": "1000镭射唱片",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "500镭射唱片",
                                "概率": "0.64%"
                            },
                            {
                                "道具": "8小时训练加速",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "2小时科研加速",
                                "概率": "2.39%"
                            },
                            {
                                "道具": "2小时建筑加速",
                                "概率": "2.39%"
                            },
                            {
                                "道具": "2小时训练加速",
                                "概率": "3.19%"
                            },
                            {
                                "道具": "60分钟科研加速",
                                "概率": "6.38%"
                            },
                            {
                                "道具": "60分钟建筑加速",
                                "概率": "6.38%"
                            },
                            {
                                "道具": "大份传说基因药水",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "普通传说基因药水",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "迷你传说基因药水",
                                "概率": "0.64%"
                            },
                            {
                                "道具": "斗士经验-50000",
                                "概率": "11.16%"
                            },
                            {
                                "道具": "斗士经验-20000",
                                "概率": "7.97%"
                            },
                            {
                                "道具": "500电池",
                                "概率": "1.59%"
                            },
                            {
                                "道具": "100电池",
                                "概率": "3.19%"
                            },
                            {
                                "道具": "150,000食物",
                                "概率": "1.59%"
                            },
                            {
                                "道具": "150,000钢铁",
                                "概率": "1.59%"
                            },
                            {
                                "道具": "500,000食物",
                                "概率": "7.97%"
                            },
                            {
                                "道具": "500,000钢铁",
                                "概率": "7.97%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "泳池派对",
                date: "2022-07-21",
                show: false,
                description: "",
                outHeaders: ['泳池派对'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "泳池皮肤",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "1000镭射唱片",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "500镭射唱片",
                                "概率": "0.43%"
                            },
                            {
                                "道具": "100镭射唱片",
                                "概率": "1.28%"
                            },
                            {
                                "道具": "8小时训练加速",
                                "概率": "3.42%"
                            },
                            {
                                "道具": "8小时科研加速",
                                "概率": "3.42%"
                            },
                            {
                                "道具": "8小时建筑加速",
                                "概率": "3.42%"
                            },
                            {
                                "道具": "2小时训练加速",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "60分钟科研加速",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "60分钟建筑加速",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "大份传说基因药水",
                                "概率": "0.43%"
                            },
                            {
                                "道具": "普通传说基因药水",
                                "概率": "1.20%"
                            },
                            {
                                "道具": "迷你传说基因药水",
                                "概率": "3.42%"
                            },
                            {
                                "道具": "豪华宴会券",
                                "概率": "8.54%"
                            },
                            {
                                "道具": "斗士经验-50000",
                                "概率": "13.68%"
                            },
                            {
                                "道具": "斗士经验-20000",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "500电池",
                                "概率": "2.56%"
                            },
                            {
                                "道具": "100电池",
                                "概率": "4.27%"
                            },
                            {
                                "道具": "500,000食物",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "500,000钢铁",
                                "概率": "10.26%"
                            }
                        ]
                    }
                ]
            },



            {
                name: "幸运转盘",
                date: "2022-07-21",
                show: false,
                description: "",
                outHeaders: ['幸运转盘'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "24小时训练加速",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "8小时训练加速",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "60分钟训练加速",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "1500,000食物",
                                "概率": "14.00%"
                            },
                            {
                                "道具": "1500,000钢铁",
                                "概率": "14.00%"
                            },
                            {
                                "道具": "斗士经验-50000",
                                "概率": "35.00%"
                            },
                            {
                                "道具": "迷你传说基因药水",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "普通传说基因药水",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "大份传说基因药水",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "橙色斗士奖牌",
                                "概率": "15.00%"
                            }
                        ]
                    }
                ]
            }
        ];

        /** BABA1 **/
        /** BABABA **/
        vm.activities = [

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2026-06-29",
                show: false,
                description: "",
                outHeaders: ['荒原毒蝎伙伴池', '朔风领主伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "幽冥魔镰",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "血誓猎龙者",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【荒原毒蝎降临】获得伙伴概率公布",
                date: "2026-06-02",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "荒原毒蝎",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "荒原毒蝎",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】活动道具概率公布",
                date: "2026-05-11",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银转盘奖池E', '白银宝箱 - 装备 V', '白银宝箱-资源 III', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金转盘奖池E', '黄金宝箱-龙印 III', '黄金宝箱-资源 III'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "1",
                                "概率": "23.36%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "6",
                                "概率": "19.12%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "5",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "8",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "3",
                                "概率": "19.12%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "7",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "23",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "7000",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "10500",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "14000",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "12000",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "9000",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "6000",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "25000",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "700",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1050",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1400",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1200",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "900",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "600",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "2500",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "70",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "105",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "140",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "120",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "90",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "白银宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "60",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "250",
                                "概率": "0.096%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1.0",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1.0",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1.0",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1.0",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1.0",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1.0",
                                "概率": "30.75%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1.0",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5.0",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1.0",
                                "概率": "9.23%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1.0",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3.0",
                                "概率": "13.84%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1.0",
                                "概率": "0.001%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "2500",
                                "概率": "3.33%"
                            },
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "5000",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "2500",
                                "概率": "3.33%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "5000",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "2500",
                                "概率": "3.33%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "5000",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "800",
                                "概率": "9.99%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "1000",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "1540",
                                "概率": "19.98%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "3075",
                                "概率": "6.66%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "6154",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "12300",
                                "概率": "0.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "3.23%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "480",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "240",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "24.19%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "4.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "28",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "38",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "86",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "55",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "43",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "28",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXV",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "55000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "82500",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "110000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "110000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "82500",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "55000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXV",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "5500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "8250",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "11000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "11000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "8250",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "5500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXV",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "550",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "825",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "1100",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "1100",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "825",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱 - 装备 V",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "550",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXV",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "传说五星自选 XXXV",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "5000",
                                "概率": "3.330%"
                            },
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "10000",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "5000",
                                "概率": "3.330%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "10000",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "5000",
                                "概率": "3.330%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "10000",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "1075",
                                "概率": "9.990%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "1540",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "1845",
                                "概率": "19.980%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "3690",
                                "概率": "6.660%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "7385",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "雪域灵石",
                                "数量": "14770",
                                "概率": "0.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "1000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "2000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "400",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "4",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙血环契】概率公示",
                date: "2026-05-04",
                show: false,
                description: "",
                outHeaders: ['第一层', '第二层', '第三层'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 血精石",
                                "数量": "15",
                                "概率": "22.14%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "20",
                                "概率": "14.76%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "30",
                                "概率": "3.69%"
                            },
                            {
                                "道具": "龙血基础宝箱",
                                "数量": "1",
                                "概率": "7.38%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "6",
                                "概率": "22.14%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "9",
                                "概率": "14.76%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "10",
                                "概率": "7.38%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "20",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "破解",
                                "数量": "1",
                                "概率": "7.38%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙血基础宝箱",
                                "数量": "1",
                                "概率": "3.69%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "15",
                                "概率": "22.14%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "20",
                                "概率": "14.76%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "3",
                                "概率": "3.69%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "5",
                                "概率": "7.38%"
                            },
                            {
                                "道具": "龙血基础宝箱",
                                "数量": "1",
                                "概率": "3.69%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "10",
                                "概率": "22.14%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "15",
                                "概率": "14.76%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "20",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "破解",
                                "数量": "1",
                                "概率": "7.38%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙血金币",
                                "数量": "13",
                                "概率": "7.38%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "22.14%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "4",
                                "概率": "14.76%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "6",
                                "概率": "7.38%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "8",
                                "概率": "3.69%"
                            },
                            {
                                "道具": "龙血基础宝箱",
                                "数量": "1",
                                "概率": "7.38%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "15",
                                "概率": "18.45%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "20",
                                "概率": "11.07%"
                            },
                            {
                                "道具": "龙血金币",
                                "数量": "25",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "破解",
                                "数量": "1",
                                "概率": "7.38%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【星空幻域】概率公布",
                date: "2026-04-20",
                show: false,
                description: "",
                outHeaders: ['普通奖励概率', '幻域大奖概率（不放回奖池的首次抽取非保底概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "转盘奖池",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊甜蜜堡垒（友谊）",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "中型战争增益自选宝箱",
                                "数量": "1",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "300",
                                "概率": "7.48%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "300",
                                "概率": "7.48%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "3.74%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "100",
                                "概率": "3.74%"
                            },
                            {
                                "道具": "鎏金统御契约",
                                "数量": "2",
                                "概率": "37.36%"
                            },
                            {
                                "道具": "鎏金统御契约",
                                "数量": "4",
                                "概率": "18.67%"
                            },
                            {
                                "道具": "鎏金统御契约",
                                "数量": "6",
                                "概率": "7.48%"
                            },
                            {
                                "道具": "鎏金统御契约",
                                "数量": "10",
                                "概率": "0.75%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "3.74%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "3.74%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "稀有宝藏类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "稀有宝藏类型": "超级大奖",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.030%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.030%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.028%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.028%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.028%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.285%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.285%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.285%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2026-04-16",
                show: false,
                description: "",
                outHeaders: ['冰羽祭司伙伴池', '血誓猎龙者伙伴池', '涌动之灵伙伴池', '森之游侠伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【嗜血猎手】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【血誓猎龙者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【涌动之灵】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【森之游侠】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2026-04-03",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.41%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "爱神·芙蕾雅碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰花篮",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "爱神·芙蕾雅碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "爱神·芙蕾雅碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "爱神·芙蕾雅碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "爱神·芙蕾雅碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "爱神·芙蕾雅碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "爱神·芙蕾雅碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "死亡女神·赫尔碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "死亡女神·赫尔碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "死亡女神·赫尔碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "死亡女神·赫尔碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "死亡女神·赫尔碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "死亡女神·赫尔碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "9",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "12",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "15",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "18",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "22",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "27",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【宝物探秘】获得道具概率公布",
                date: "2026-03-31",
                show: false,
                description: "",
                outHeaders: ['普通奖池1', '普通奖池2', '普通奖池3', '普通奖池4', '普通奖池5', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '【高级大奖】奖池概率', '【特级大奖】奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "幽寂原石",
                                "数量": "200",
                                "概率": "0.003%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "20",
                                "概率": "7.909%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "25",
                                "概率": "31.635%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "150",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "30",
                                "概率": "31.635%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "35",
                                "概率": "15.817%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "100",
                                "概率": "0.316%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "40",
                                "概率": "7.909%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "50",
                                "概率": "3.163%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "60",
                                "概率": "1.581%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷雾星尘",
                                "数量": "300",
                                "概率": "0.311%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "50",
                                "概率": "15.571%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "100",
                                "概率": "31.143%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "400",
                                "概率": "0.031%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "125",
                                "概率": "31.142%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "150",
                                "概率": "15.571%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "500",
                                "概率": "0.003%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "175",
                                "概率": "3.114%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "200",
                                "概率": "1.557%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "225",
                                "概率": "1.557%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法粉尘",
                                "数量": "180000",
                                "概率": "0.204%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "100000",
                                "概率": "10.181%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "110000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "190000",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "120000",
                                "概率": "40.724%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "130000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "200000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "140000",
                                "概率": "5.091%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "150000",
                                "概率": "2.036%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "160000",
                                "概率": "1.018%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法碎片",
                                "数量": "18000",
                                "概率": "0.204%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "10000",
                                "概率": "10.181%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "11000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "19000",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "12000",
                                "概率": "40.724%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "13000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "20000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "14000",
                                "概率": "5.091%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "15000",
                                "概率": "2.036%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "16000",
                                "概率": "1.018%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "1800",
                                "概率": "0.204%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1000",
                                "概率": "10.181%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1100",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1900",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1200",
                                "概率": "40.724%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1300",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "2000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1400",
                                "概率": "5.091%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1500",
                                "概率": "2.036%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1600",
                                "概率": "1.018%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷雾宝物自选宝箱IV",
                                "数量": "1",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱III",
                                "数量": "1",
                                "概率": "0.050%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱II",
                                "数量": "1",
                                "概率": "0.460%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱I",
                                "数量": "1",
                                "概率": "4.620%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "100",
                                "概率": "46.190%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "150",
                                "概率": "23.090%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "200",
                                "概率": "0.460%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "300",
                                "概率": "18.000%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "400",
                                "概率": "1.800%"
                            },
                            {
                                "道具": "幽寂原石",
                                "数量": "500",
                                "概率": "0.180%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "600000",
                                "概率": "4.620%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "800000",
                                "概率": "0.460%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1000000",
                                "概率": "0.050%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷雾宝物自选宝箱V",
                                "数量": "1",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱IV",
                                "数量": "1",
                                "概率": "0.060%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱III",
                                "数量": "1",
                                "概率": "0.640%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【开斋新月派对】概率",
                date: "2026-03-21",
                show: false,
                description: "",
                outHeaders: ['普通拼图奖励概率', '鎏金拼图大奖概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "星枢月垒（永久）",
                                "数量": "1",
                                "概率": "0.00200%"
                            },
                            {
                                "道具": "天陨核心",
                                "数量": "10",
                                "概率": "8.16310%"
                            },
                            {
                                "道具": "天陨灵砂",
                                "数量": "40",
                                "概率": "8.16310%"
                            },
                            {
                                "道具": "太古蛮石",
                                "数量": "5",
                                "概率": "10.20390%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "150",
                                "概率": "10.20390%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "250",
                                "概率": "10.20390%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "150",
                                "概率": "10.20390%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "6.12230%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "6.12230%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "15",
                                "概率": "6.12230%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "4",
                                "概率": "6.12230%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "数量": "70",
                                "概率": "6.12230%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "6.12230%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.12230%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "稀有宝藏类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "稀有宝藏类型": "至尊新月大奖",
                                "数量": "1",
                                "概率": "0.00000%"
                            },
                            {
                                "稀有宝藏类型": "传奇新月大奖",
                                "数量": "1",
                                "概率": "0.03030%"
                            },
                            {
                                "稀有宝藏类型": "传奇新月大奖",
                                "数量": "1",
                                "概率": "0.03030%"
                            },
                            {
                                "稀有宝藏类型": "瑰丽新月大奖",
                                "数量": "1",
                                "概率": "3.02850%"
                            },
                            {
                                "稀有宝藏类型": "瑰丽新月大奖",
                                "数量": "1",
                                "概率": "3.02850%"
                            },
                            {
                                "稀有宝藏类型": "瑰丽新月大奖",
                                "数量": "1",
                                "概率": "3.02850%"
                            },
                            {
                                "稀有宝藏类型": "珍藏新月大奖",
                                "数量": "1",
                                "概率": "30.28470%"
                            },
                            {
                                "稀有宝藏类型": "珍藏新月大奖",
                                "数量": "1",
                                "概率": "30.28470%"
                            },
                            {
                                "稀有宝藏类型": "珍藏新月大奖",
                                "数量": "1",
                                "概率": "30.28470%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【春神福礼】道具概率公布",
                date: "2026-03-10",
                show: false,
                description: "",
                outHeaders: ['春神福礼基础奖池', '奖池道具翻倍概率', '春神的祝福大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "春樱礼券",
                                "数量": "50",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "春樱礼券",
                                "数量": "30",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "春樱礼券",
                                "数量": "20",
                                "概率": "1.20%"
                            },
                            {
                                "道具": "春樱礼券",
                                "数量": "10",
                                "概率": "4.81%"
                            },
                            {
                                "道具": "春樱礼券",
                                "数量": "8",
                                "概率": "9.61%"
                            },
                            {
                                "道具": "春樱礼券",
                                "数量": "6",
                                "概率": "19.23%"
                            },
                            {
                                "道具": "春樱礼券",
                                "数量": "4",
                                "概率": "28.84%"
                            },
                            {
                                "道具": "2026春日伙伴自选宝箱",
                                "数量": "3",
                                "概率": "9.61%"
                            },
                            {
                                "道具": "2026春日巨龙自选宝箱",
                                "数量": "3",
                                "概率": "2.40%"
                            },
                            {
                                "道具": "2026春日发展自选宝箱",
                                "数量": "3",
                                "概率": "9.61%"
                            },
                            {
                                "道具": "2026春日首领自选宝箱",
                                "数量": "3",
                                "概率": "2.40%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "4",
                                "概率": "12.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "70.32%"
                            },
                            {
                                "倍数": "2",
                                "概率": "28.13%"
                            },
                            {
                                "倍数": "5",
                                "概率": "1.41%"
                            },
                            {
                                "倍数": "8",
                                "概率": "0.14%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "圣蚀裁决（永久）",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "传说五星自选 XXXIV",
                                "数量": "1",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "2026春日伙伴自选宝箱",
                                "数量": "50",
                                "概率": "33.31%"
                            },
                            {
                                "道具": "2026春日巨龙自选宝箱",
                                "数量": "50",
                                "概率": "16.65%"
                            },
                            {
                                "道具": "2026春日发展自选宝箱",
                                "数量": "50",
                                "概率": "33.31%"
                            },
                            {
                                "道具": "2026春日首领自选宝箱",
                                "数量": "50",
                                "概率": "16.65%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【新年有新装】概率公布",
                date: "2026-02-19",
                show: false,
                description: "",
                outHeaders: ['银装奖池概率', '金装奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "熵链武装（随机）",
                                "数量": "1",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "锋刃甜心（随机）",
                                "数量": "1",
                                "概率": "3.32%"
                            },
                            {
                                "道具": "暗影魔魇（随机）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "法老之翼（随机）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "神弓巫女（随机）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "暗影裁决者（随机）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "幽魂DJ（随机）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "裂空龙战者（随机）",
                                "数量": "1",
                                "概率": "13.29%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "熵链武装（自选）",
                                "数量": "1",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "锋刃甜心（自选）",
                                "数量": "1",
                                "概率": "3.32%"
                            },
                            {
                                "道具": "暗影魔魇（自选）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "法老之翼（自选）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "神弓巫女（自选）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "暗影裁决者（自选）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "幽魂DJ（自选）",
                                "数量": "1",
                                "概率": "16.61%"
                            },
                            {
                                "道具": "裂空龙战者（自选）",
                                "数量": "1",
                                "概率": "13.29%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【神驹行天下】概率公布",
                date: "2026-02-16",
                show: false,
                description: "",
                outHeaders: ['华彩明灯奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "赤焰魔龙（永久）",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "福马（永久）",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "500",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "50",
                                "概率": "2.70%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "30",
                                "概率": "5.39%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "25",
                                "概率": "8.09%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "20",
                                "概率": "10.78%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "15",
                                "概率": "32.34%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "10",
                                "概率": "26.95%"
                            },
                            {
                                "道具": "福运金铃",
                                "数量": "5",
                                "概率": "13.48%"
                            }
                        ]
                    }
                ]
            },

            

            {
                name: "【欢庆星光祭】概率公布",
                date: "2026-01-19",
                show: false,
                description: "",
                outHeaders: ['普通奖励概率', '星光祭大奖概率（不放回奖池的首次抽取非保底概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "转盘奖池",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "100",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "大型战争增益自选宝箱",
                                "数量": "1",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "200",
                                "概率": "4.90%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "200",
                                "概率": "4.90%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.45%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "9.79%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "4.90%"
                            },
                            {
                                "道具": "欢庆兑换券",
                                "数量": "2",
                                "概率": "48.96%"
                            },
                            {
                                "道具": "欢庆兑换券",
                                "数量": "4",
                                "概率": "12.24%"
                            },
                            {
                                "道具": "欢庆兑换券",
                                "数量": "6",
                                "概率": "4.90%"
                            },
                            {
                                "道具": "欢庆兑换券",
                                "数量": "10",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "2.45%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "2.45%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "稀有宝藏类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "稀有宝藏类型": "超级大奖",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】活动道具概率公布",
                date: "2026-01-06",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银转盘奖池E', '白银宝箱-龙印 III', '白银宝箱-资源 III', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金转盘奖池E', '黄金宝箱-龙印 III', '黄金宝箱-资源 III'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "3",
                                "概率": "23.36%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "6",
                                "概率": "19.12%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "4",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "6",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "4",
                                "概率": "19.12%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "5",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "18",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "17500",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "21000",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "42000",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "45000",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "21000",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "17500",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "52500",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "700",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1400",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "950",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "950",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1400",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "700",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "2100",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "70",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "140",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "95",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "95",
                                "概率": "11.52%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "140",
                                "概率": "17.28%"
                            },
                            {
                                "道具": "白银宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "70",
                                "概率": "21.12%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "210",
                                "概率": "0.096%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "30.75%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "9.23%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3",
                                "概率": "13.84%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.001%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "2750",
                                "概率": "3.33%"
                            },
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "5500",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "2750",
                                "概率": "3.33%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "5500",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "2750",
                                "概率": "3.33%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "5500",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "600",
                                "概率": "9.99%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "900",
                                "概率": "13.32%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "1350",
                                "概率": "19.98%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "2700",
                                "概率": "6.66%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "5400",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "10800",
                                "概率": "0.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "3.23%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "480",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "240",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "24.19%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "4.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVI",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "22",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "33",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "66",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "66",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "33",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "22",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVI",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "147500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "221250",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "295000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "295000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "221250",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "147500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVI",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "6000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "9000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "12000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "12000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "9000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "6000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVI",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "600",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "900",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "1200",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "1200",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "900",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 III",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "600",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXXIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选 XXVI",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "传说五星自选 XXXIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "6500",
                                "概率": "3.330%"
                            },
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "13000",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "6500",
                                "概率": "3.330%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "13000",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "6500",
                                "概率": "3.330%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "13000",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "800",
                                "概率": "9.990%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "1200",
                                "概率": "13.320%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "1800",
                                "概率": "19.980%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "3600",
                                "概率": "6.660%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "7200",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "数量": "14400",
                                "概率": "0.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "1000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "2000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "400",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "4",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【新年许愿】道具概率公布",
                date: "2026-01-01",
                show: false,
                description: "",
                outHeaders: ['各类型道具出现的概率'],
                tables: [
                    {
                        "subHeaders": [
                            "普通奖励",
                            "76.10%"
                        ],
                        "data": [
                            {
                                "普通奖励": "高级奖励",
                                "76.10%": "22.83%"
                            },
                            {
                                "普通奖励": "珍稀奖励",
                                "76.10%": "1.07%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【赛季挑战】获得道具概率公布",
                date: "2025-12-29",
                show: false,
                description: "",
                outHeaders: ['赛季宝箱概率', '超级寻宝概率(本概率为首次抽取概率，实际概率随奖池剩余奖励变化而浮动。)'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有五星自选 XI",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "14800",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "296000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "12000",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "60000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "6000",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "148000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "7.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XXXII",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "200",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "100",
                                "概率": "0.69%"
                            },
                            {
                                "道具": "行军特效碎片自选宝箱I",
                                "数量": "50",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "惊喜战争宝箱",
                                "数量": "1",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "40",
                                "概率": "1.78%"
                            },
                            {
                                "道具": "史诗五星自选 XII",
                                "数量": "1",
                                "概率": "1.39%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "40",
                                "概率": "1.94%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "6",
                                "概率": "65.33%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "35",
                                "概率": "14.06%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "22",
                                "概率": "6.54%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "6.45%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【圣诞娃娃机】活动概率公布",
                date: "2025-12-22",
                show: false,
                description: "",
                outHeaders: ['欢乐奖池', '特典奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "大奖奖池",
                                "个数": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "圣诞帽2025",
                                "个数": "2",
                                "概率": "0.74%"
                            },
                            {
                                "道具": "水晶球2025",
                                "个数": "10",
                                "概率": "24.57%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "2",
                                "概率": "5.90%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "个数": "1",
                                "概率": "9.83%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "个数": "1",
                                "概率": "9.83%"
                            },
                            {
                                "道具": "500,000 象牙",
                                "个数": "1",
                                "概率": "9.83%"
                            },
                            {
                                "道具": "500,000 石头",
                                "个数": "1",
                                "概率": "9.83%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "个数": "1",
                                "概率": "9.83%"
                            },
                            {
                                "道具": "1小时加速",
                                "个数": "12",
                                "概率": "9.83%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "个数": "1",
                                "概率": "9.83%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "大奖奖池",
                                "个数": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "糖果堡垒（友谊）",
                                "个数": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "圣诞帽2025",
                                "个数": "100",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "2025圣诞装备自选箱",
                                "个数": "1",
                                "概率": "9.49%"
                            },
                            {
                                "道具": "2025圣诞龙印自选箱",
                                "个数": "1",
                                "概率": "9.49%"
                            },
                            {
                                "道具": "2025圣诞宝物自选箱",
                                "个数": "1",
                                "概率": "9.49%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "200",
                                "概率": "4.75%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "20",
                                "概率": "4.75%"
                            },
                            {
                                "道具": "巨龙精晶高级自选宝箱",
                                "个数": "7",
                                "概率": "2.37%"
                            },
                            {
                                "道具": "太古蛮石",
                                "个数": "5",
                                "概率": "2.37%"
                            },
                            {
                                "道具": "圣诞帽2025",
                                "个数": "2",
                                "概率": "42.71%"
                            },
                            {
                                "道具": "圣诞帽2025",
                                "个数": "4",
                                "概率": "9.49%"
                            },
                            {
                                "道具": "圣诞帽2025",
                                "个数": "6",
                                "概率": "4.75%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2025-12-18",
                show: false,
                description: "",
                outHeaders: ['冰羽祭司伙伴池', '幽冥魔镰伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "幽冥魔镰",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "血誓猎龙者",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【灵脉开采】活动概率公布",
                date: "2025-12-08",
                show: false,
                description: "",
                outHeaders: ['荣耀灵砂奖池', '荣耀核心奖池', '荣耀灵砂大奖奖池', '荣耀核心大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.25%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "1500",
                                "阶段0概率": "0.03%",
                                "阶段1之后概率": "0.03%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "1200",
                                "阶段0概率": "0.13%",
                                "阶段1之后概率": "0.13%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "1000",
                                "阶段0概率": "0.95%",
                                "阶段1之后概率": "0.94%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "800",
                                "阶段0概率": "2.22%",
                                "阶段1之后概率": "2.19%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "600",
                                "阶段0概率": "19.02%",
                                "阶段1之后概率": "18.78%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "500",
                                "阶段0概率": "19.02%",
                                "阶段1之后概率": "18.78%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "400",
                                "阶段0概率": "28.53%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "300",
                                "阶段0概率": "22.19%",
                                "阶段1之后概率": "21.91%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "240",
                                "阶段0概率": "7.92%",
                                "阶段1之后概率": "7.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.25%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "150",
                                "阶段0概率": "0.03%",
                                "阶段1之后概率": "0.03%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "120",
                                "阶段0概率": "0.13%",
                                "阶段1之后概率": "0.13%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "100",
                                "阶段0概率": "0.95%",
                                "阶段1之后概率": "0.94%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "80",
                                "阶段0概率": "2.22%",
                                "阶段1之后概率": "2.19%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "60",
                                "阶段0概率": "19.02%",
                                "阶段1之后概率": "18.78%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "50",
                                "阶段0概率": "19.02%",
                                "阶段1之后概率": "18.78%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "40",
                                "阶段0概率": "28.53%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "30",
                                "阶段0概率": "22.19%",
                                "阶段1之后概率": "21.91%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "24",
                                "阶段0概率": "7.92%",
                                "阶段1之后概率": "7.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀灵砂",
                                "个数": "2,400",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "3,840",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "荣耀灵砂",
                                "个数": "11,200",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀核心",
                                "个数": "240",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "384",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "荣耀核心",
                                "个数": "1,120",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2025-12-02",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.41%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰花篮",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "雷神·索尔碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "9",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "12",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "15",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "18",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "22",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "27",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【火鸡庆典】概率公布",
                date: "2025-11-25",
                show: false,
                description: "",
                outHeaders: ['火鸡庆典参与奖概率', '火鸡庆典大奖概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "转盘奖池",
                                "数量": "1",
                                "概率": "0.037%"
                            },
                            {
                                "道具": "裂空圣龙（永久）",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "感恩战斗增益自选宝箱",
                                "数量": "1",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "龙专精综合宝箱",
                                "数量": "1",
                                "概率": "3.74%"
                            },
                            {
                                "道具": "碎岩材料自选宝箱IV",
                                "数量": "1",
                                "概率": "7.47%"
                            },
                            {
                                "道具": "炉火加速自选宝箱V",
                                "数量": "1",
                                "概率": "7.47%"
                            },
                            {
                                "道具": "火鸡尾羽（2025）",
                                "数量": "5",
                                "概率": "20.55%"
                            },
                            {
                                "道具": "火鸡尾羽（2025）",
                                "数量": "8",
                                "概率": "31.76%"
                            },
                            {
                                "道具": "火鸡尾羽（2025）",
                                "数量": "10",
                                "概率": "7.47%"
                            },
                            {
                                "道具": "火鸡尾羽（2025）",
                                "数量": "20",
                                "概率": "0.75%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "2",
                                "概率": "3.74%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "1",
                                "概率": "1.87%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "7.47%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "2",
                                "概率": "7.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "稀有宝藏类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "稀有宝藏类型": "超级大奖",
                                "数量": "1",
                                "概率": "0.003%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【冰羽祭司降临】获得伙伴概率公布",
                date: "2025-11-17",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "无畏怒焰",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "无畏怒焰",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂野狩猎】狩猎猛犸象概率公布",
                date: "2025-11-10",
                show: false,
                description: "",
                outHeaders: ['狂野模式狩猎奖池', '狂野模式灵魂宝箱奖池', '普通模式狩猎奖池', '普通模式灵魂宝箱奖池', '最后一击额外奖励（必得雷神祝福油）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天谕·云霄",
                                "数量": "11",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "11",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "天谕·云霄",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "天谕·云霄",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "11",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "11",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生疏流（Lv.1）自选宝箱",
                                "数量": "11",
                                "概率": "1.34%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天谕·云霄",
                                "数量": "11",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "11",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "天谕·云霄",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "天谕·云霄",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "11",
                                "概率": "14.07%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "11",
                                "概率": "14.07%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "33",
                                "概率": "0.07%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天谕·云霄",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "天谕云霄符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "天谕星陨符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "天谕云霄符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "天谕星陨符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "1",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "1",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生启明符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生虚妄符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生启明符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生虚妄符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生疏流（Lv.1）自选宝箱",
                                "数量": "1",
                                "概率": "1.34%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天谕·云霄",
                                "数量": "1",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "1",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "天谕·云霄",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "天谕·云霄",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "1",
                                "概率": "14.08%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "1",
                                "概率": "14.08%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "3",
                                "概率": "0.07%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天谕·云霄",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天谕·云霄",
                                "数量": "1",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天谕·星陨",
                                "数量": "1",
                                "概率": "25.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【惊奇派对】活动概率公布",
                date: "2025-10-29",
                show: false,
                description: "",
                outHeaders: ['万圣南瓜类型', '华丽万圣南瓜奖池', '稀有万圣南瓜奖池', '普通万圣南瓜奖池', '幸运值暴击倍数概率', '幸运值奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "华丽万圣南瓜",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "稀有万圣南瓜",
                                "数量": "1",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "普通万圣南瓜",
                                "数量": "1",
                                "概率": "60.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魅影狂欢(友谊)",
                                "数量": "1",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "100",
                                "概率": "0.060%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "50",
                                "概率": "0.260%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "20",
                                "概率": "3.830%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "15",
                                "概率": "57.50%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "10",
                                "概率": "15.33%"
                            },
                            {
                                "道具": "惊奇巨龙自选宝箱",
                                "数量": "3",
                                "概率": "7.67%"
                            },
                            {
                                "道具": "惊奇伙伴自选宝箱",
                                "数量": "3",
                                "概率": "7.67%"
                            },
                            {
                                "道具": "惊奇发展自选宝箱",
                                "数量": "3",
                                "概率": "7.67%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "万圣侦查守卫自选宝箱",
                                "数量": "1",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "20",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "15",
                                "概率": "1.09%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "10",
                                "概率": "10.92%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "5",
                                "概率": "54.59%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "3",
                                "概率": "10.92%"
                            },
                            {
                                "道具": "惊奇巨龙自选宝箱",
                                "数量": "1",
                                "概率": "10.92%"
                            },
                            {
                                "道具": "惊奇伙伴自选宝箱",
                                "数量": "1",
                                "概率": "10.92%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "总概率"
                        ],
                        "data": [
                            {
                                "道具": "惊奇糖果",
                                "数量": "10",
                                "总概率": "0.99%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "5",
                                "总概率": "4.95%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "3",
                                "总概率": "39.60%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "2",
                                "总概率": "39.60%"
                            },
                            {
                                "道具": "惊奇糖果",
                                "数量": "1",
                                "总概率": "14.85%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "类型",
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "类型": "幸运值",
                                "倍数": "1",
                                "概率": "1.408%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "2",
                                "概率": "70.423%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "5",
                                "概率": "21.127%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "10",
                                "概率": "4.225%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "20",
                                "概率": "2.817%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 血精核",
                                "数量": "2",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "50",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "数量": "21",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "太古蛮石",
                                "数量": "1",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "40",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "70",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "70",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "70",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "琥珀神奇龟",
                                "数量": "10",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "10",
                                "概率": "10.000%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2025-10-14",
                show: false,
                description: "",
                outHeaders: ['血誓猎龙者伙伴池', '涌动之灵伙伴池', '森之游侠伙伴池', '嗜血猎手伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【血誓猎龙者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【涌动之灵】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【森之游侠】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【嗜血猎手】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2025-09-24",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.41%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰花篮",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "日光之神·弗雷碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "破晓之神·海尔达姆碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "9",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "12",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "15",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "18",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "22",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "燧火祭司自选宝箱",
                                "数量": "27",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2025-09-18",
                show: false,
                description: "",
                outHeaders: ['幽冥魔镰伙伴池', '血誓猎龙者伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "幽冥魔镰",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "血誓猎龙者",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【装备工坊】活动概率公布",
                date: "2025-09-08",
                show: false,
                description: "",
                outHeaders: ['星尘奖池', '粉尘奖池', '碎片奖池', '结晶奖池', '混合大奖奖池', '粉尘大奖奖池', '碎片大奖奖池', '结晶大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "150",
                                "阶段0概率": "0.03%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "120",
                                "阶段0概率": "0.13%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "100",
                                "阶段0概率": "0.95%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "80",
                                "阶段0概率": "2.22%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "60",
                                "阶段0概率": "19.02%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "50",
                                "阶段0概率": "19.02%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "40",
                                "阶段0概率": "28.53%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "30",
                                "阶段0概率": "22.19%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "25",
                                "阶段0概率": "7.92%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "280000",
                                "阶段0概率": "1.41%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "240000",
                                "阶段0概率": "1.41%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "200000",
                                "阶段0概率": "2.82%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "160000",
                                "阶段0概率": "5.63%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "144000",
                                "阶段0概率": "28.17%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "136000",
                                "阶段0概率": "28.17%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "120000",
                                "阶段0概率": "14.08%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "96000",
                                "阶段0概率": "11.27%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "80000",
                                "阶段0概率": "5.63%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "28000",
                                "阶段0概率": "1.41%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "24000",
                                "阶段0概率": "1.41%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "20000",
                                "阶段0概率": "2.82%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "16000",
                                "阶段0概率": "5.63%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "14400",
                                "阶段0概率": "28.17%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "13600",
                                "阶段0概率": "28.17%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "12000",
                                "阶段0概率": "14.08%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "9600",
                                "阶段0概率": "11.27%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "8000",
                                "阶段0概率": "5.63%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "2800",
                                "阶段0概率": "1.41%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "2400",
                                "阶段0概率": "1.41%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "2000",
                                "阶段0概率": "2.82%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "1600",
                                "阶段0概率": "5.63%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "1440",
                                "阶段0概率": "28.17%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "1360",
                                "阶段0概率": "28.17%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "1200",
                                "阶段0概率": "14.08%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "960",
                                "阶段0概率": "11.27%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "800",
                                "阶段0概率": "5.63%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "雪域灵石",
                                "个数": "300",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "480",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "雪域灵石",
                                "个数": "1400",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿粉",
                                "个数": "988,000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "1,495,000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "4,095,000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿石",
                                "个数": "98,800",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "149,500",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "409,500",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "个数": "9,880",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "14,950",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "40,950",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【甜蜜暴击】道具概率公布",
                date: "2025-08-28",
                show: false,
                description: "",
                outHeaders: ['甜蜜暴击-基础奖池', '奖池道具翻倍概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "桃源仙居",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "2025七夕伙伴自选宝箱",
                                "数量": "1",
                                "概率": "4.06%"
                            },
                            {
                                "道具": "2025七夕巨龙自选宝箱",
                                "数量": "1",
                                "概率": "4.06%"
                            },
                            {
                                "道具": "2025七夕发展自选宝箱",
                                "数量": "1",
                                "概率": "4.06%"
                            },
                            {
                                "道具": "银河心饰",
                                "数量": "2",
                                "概率": "40.65%"
                            },
                            {
                                "道具": "银河心饰",
                                "数量": "4",
                                "概率": "20.32%"
                            },
                            {
                                "道具": "银河心饰",
                                "数量": "6",
                                "概率": "2.03%"
                            },
                            {
                                "道具": "银河心饰",
                                "数量": "8",
                                "概率": "0.41%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "4",
                                "概率": "8.13%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "3",
                                "概率": "8.13%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "3",
                                "概率": "8.13%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "90.00%"
                            },
                            {
                                "倍数": "2",
                                "概率": "7.40%"
                            },
                            {
                                "倍数": "3",
                                "概率": "2.00%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.50%"
                            },
                            {
                                "倍数": "5",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【璀璨星光祭】概率公布",
                date: "2025-06-18",
                show: false,
                description: "",
                outHeaders: ['普通奖励概率', '星光祭大奖概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "转盘奖池",
                                "数量": "1",
                                "概率": "0.05000%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "100",
                                "概率": "0.05000%"
                            },
                            {
                                "道具": "大型战争增益自选宝箱",
                                "数量": "1",
                                "概率": "0.46000%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "100",
                                "概率": "4.64000%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "100",
                                "概率": "9.27000%"
                            },
                            {
                                "道具": "太古蛮石",
                                "数量": "10",
                                "概率": "4.64000%"
                            },
                            {
                                "道具": "1 血精核",
                                "数量": "50",
                                "概率": "4.64000%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "4.64000%"
                            },
                            {
                                "道具": "庆典代金券",
                                "数量": "3",
                                "概率": "46.34000%"
                            },
                            {
                                "道具": "庆典代金券",
                                "数量": "6",
                                "概率": "9.27000%"
                            },
                            {
                                "道具": "庆典代金券",
                                "数量": "8",
                                "概率": "4.64000%"
                            },
                            {
                                "道具": "庆典代金券",
                                "数量": "10",
                                "概率": "1.16000%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.46000%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "0.46000%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "4.64000%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "4",
                                "概率": "4.64000%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "稀有宝藏类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "稀有宝藏类型": "超级大奖",
                                "数量": "1",
                                "概率": "0.00003%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.03028%"
                            },
                            {
                                "稀有宝藏类型": "一等奖",
                                "数量": "1",
                                "概率": "0.03028%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.02847%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.02847%"
                            },
                            {
                                "稀有宝藏类型": "二等奖",
                                "数量": "1",
                                "概率": "3.02847%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.28467%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.28467%"
                            },
                            {
                                "稀有宝藏类型": "三等奖",
                                "数量": "1",
                                "概率": "30.28467%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【舟浪争锋】概率公布",
                date: "2025-05-30",
                show: false,
                description: "",
                outHeaders: ['普通模式奖池', '激情模式奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "外观金币",
                                "数量": "20",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "4",
                                "概率": "48.64%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "6",
                                "概率": "9.73%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "8",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "10",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "2025端午节增益自选宝箱",
                                "数量": "1",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "2025端午节伙伴自选宝箱",
                                "数量": "1",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "2025端午节巨龙自选宝箱",
                                "数量": "1",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "2025端午节发展自选宝箱",
                                "数量": "1",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "炉火加速自选宝箱Ⅳ",
                                "数量": "2",
                                "概率": "9.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "9.73%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "4",
                                "概率": "9.73%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "外观金币",
                                "数量": "220",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "44",
                                "概率": "48.64%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "66",
                                "概率": "9.73%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "88",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "110",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "2025端午节增益自选宝箱",
                                "数量": "11",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "2025端午节伙伴自选宝箱",
                                "数量": "11",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "2025端午节巨龙自选宝箱",
                                "数量": "11",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "2025端午节发展自选宝箱",
                                "数量": "11",
                                "概率": "2.43%"
                            },
                            {
                                "道具": "炉火加速自选宝箱Ⅳ",
                                "数量": "22",
                                "概率": "9.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "11",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "11",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "44",
                                "概率": "9.73%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "44",
                                "概率": "9.73%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "碧波亭台（友谊）",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "传说五星自选 XXXI",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "行军特效碎片自选宝箱IV",
                                "数量": "10",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "100",
                                "概率": "20.79%"
                            },
                            {
                                "道具": "清涟之水",
                                "数量": "200",
                                "概率": "2.08%"
                            },
                            {
                                "道具": "2025端午节增益自选宝箱",
                                "数量": "1",
                                "概率": "2.08%"
                            },
                            {
                                "道具": "2025端午节伙伴自选宝箱",
                                "数量": "20",
                                "概率": "10.39%"
                            },
                            {
                                "道具": "2025端午节巨龙自选宝箱",
                                "数量": "20",
                                "概率": "10.39%"
                            },
                            {
                                "道具": "2025端午节发展自选宝箱",
                                "数量": "20",
                                "概率": "10.39%"
                            },
                            {
                                "道具": "炉火加速自选宝箱Ⅳ",
                                "数量": "100",
                                "概率": "10.39%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "20",
                                "概率": "10.39%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "20",
                                "概率": "10.39%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "20",
                                "概率": "10.39%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "10",
                                "概率": "2.08%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2025-05-27",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.41%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰花篮",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "众神之父·奥丁碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "月神·托特碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "15",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "20",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "25",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "30",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "35",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "45",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【龙巢探宝】活动概率公布",
                date: "2025-05-16",
                show: false,
                description: "",
                outHeaders: ['星尘奖池', '粉尘奖池', '碎片奖池', '结晶奖池', '混合大奖奖池', '粉尘大奖奖池', '碎片大奖奖池', '结晶大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "150",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "120",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "100",
                                "阶段0概率": "2.86%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "80",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "60",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "50",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "40",
                                "阶段0概率": "14.29%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "30",
                                "阶段0概率": "11.43%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "25",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "700000",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "600000",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "500000",
                                "阶段0概率": "2.86%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "400000",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "360000",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "340000",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "300000",
                                "阶段0概率": "14.29%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "240000",
                                "阶段0概率": "11.43%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "200000",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "28000",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "24000",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "20000",
                                "阶段0概率": "2.86%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "16000",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "14400",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "13600",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "12000",
                                "阶段0概率": "14.29%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "9600",
                                "阶段0概率": "11.43%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "8000",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "阶段0概率",
                            "阶段1之后概率"
                        ],
                        "data": [
                            {
                                "道具": "进入大奖奖池",
                                "个数": "",
                                "阶段0概率": "",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "2800",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "2400",
                                "阶段0概率": "1.43%",
                                "阶段1之后概率": "1.41%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "2000",
                                "阶段0概率": "2.86%",
                                "阶段1之后概率": "2.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "1600",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "1440",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "1360",
                                "阶段0概率": "28.57%",
                                "阶段1之后概率": "28.17%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "1200",
                                "阶段0概率": "14.29%",
                                "阶段1之后概率": "14.08%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "960",
                                "阶段0概率": "11.43%",
                                "阶段1之后概率": "11.27%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "800",
                                "阶段0概率": "5.71%",
                                "阶段1之后概率": "5.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "炼狱星尘",
                                "个数": "300",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "480",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "炼狱星尘",
                                "个数": "1400",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "2470000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "3737500",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "10237500",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片",
                                "个数": "98800",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "149500",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "409500",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "个数": "9880",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "14950",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "40950",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【蛮石宝藏】概率公布",
                date: "2025-05-10",
                show: false,
                description: "",
                outHeaders: ['远古奖池概率', '远古奖池单抽连线概率公布', '太古奖池概率', '太古奖池单抽连线概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "远古蛮石",
                                "数量": "3",
                                "概率": "30.43%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "4",
                                "概率": "56.52%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "5",
                                "概率": "8.70%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "7",
                                "概率": "4.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "活动",
                            "概率"
                        ],
                        "data": [
                            {
                                "活动": "单抽连线概率",
                                "概率": "0.08490%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "太古蛮石",
                                "数量": "1",
                                "概率": "30.43%"
                            },
                            {
                                "道具": "太古蛮石",
                                "数量": "2",
                                "概率": "56.52%"
                            },
                            {
                                "道具": "太古蛮石",
                                "数量": "3",
                                "概率": "8.70%"
                            },
                            {
                                "道具": "太古蛮石",
                                "数量": "4",
                                "概率": "4.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "活动",
                            "概率"
                        ],
                        "data": [
                            {
                                "活动": "单抽连线概率",
                                "概率": "0.08490%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幸运占卜】翻牌结果概率公布",
                date: "2025-04-15",
                show: false,
                description: "",
                outHeaders: ['幸运占卜'],
                tables: [
                    {
                        "subHeaders": [
                            "翻牌结果",
                            "概率"
                        ],
                        "data": [
                            {
                                "翻牌结果": "0个太阳",
                                "概率": "0.20%"
                            },
                            {
                                "翻牌结果": "1个太阳",
                                "概率": "1.76%"
                            },
                            {
                                "翻牌结果": "2个太阳",
                                "概率": "7.03%"
                            },
                            {
                                "翻牌结果": "3个太阳",
                                "概率": "16.40%"
                            },
                            {
                                "翻牌结果": "4个太阳",
                                "概率": "24.61%"
                            },
                            {
                                "翻牌结果": "5个太阳",
                                "概率": "24.61%"
                            },
                            {
                                "翻牌结果": "6个太阳",
                                "概率": "16.40%"
                            },
                            {
                                "翻牌结果": "7个太阳",
                                "概率": "7.03%"
                            },
                            {
                                "翻牌结果": "8个太阳",
                                "概率": "1.76%"
                            },
                            {
                                "翻牌结果": "9个太阳",
                                "概率": "0.20%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂野狩猎】狩猎猛犸象概率公布",
                date: "2025-04-03",
                show: false,
                description: "",
                outHeaders: ['狂野模式狩猎奖池', '狂野模式灵魂宝箱奖池', '普通模式狩猎奖池', '普通模式灵魂宝箱奖池', '最后一击额外奖励（必得雷神祝福油）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·启明",
                                "数量": "11",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "11",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "11",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "11",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生源流（Lv.1）自选宝箱",
                                "数量": "11",
                                "概率": "1.34%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·启明",
                                "数量": "11",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "11",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "11",
                                "概率": "14.07%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "11",
                                "概率": "14.07%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "33",
                                "概率": "0.07%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·启明",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "创生启明符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "创生虚妄符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "33.47%"
                            },
                            {
                                "道具": "创生启明符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "创生虚妄符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "1.34%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "1",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "1",
                                "概率": "0.33%"
                            },
                            {
                                "道具": "创生暗夜符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生历史符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "13.39%"
                            },
                            {
                                "道具": "创生暗夜符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生历史符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "创生源流（Lv.1）自选宝箱",
                                "数量": "1",
                                "概率": "1.34%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·启明",
                                "数量": "1",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "1",
                                "概率": "35.50%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "1",
                                "概率": "14.08%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "1",
                                "概率": "14.08%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "3",
                                "概率": "0.07%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·启明",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "创生·启明",
                                "数量": "1",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "创生·虚妄",
                                "数量": "1",
                                "概率": "25.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【开斋鎏金派对】概率公布",
                date: "2025-03-31",
                show: false,
                description: "",
                outHeaders: ['普通拼图奖励概率', '鎏金拼图大奖概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "鎏金楼宇（友谊）",
                                "数量": "1",
                                "概率": "0.00382%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "300",
                                "概率": "0.38166%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "300",
                                "概率": "0.38166%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "100",
                                "概率": "3.81665%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "250",
                                "概率": "1.90832%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "200",
                                "概率": "1.90832%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "5",
                                "概率": "19.08324%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "11.44994%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "5",
                                "概率": "11.44994%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "50",
                                "概率": "11.44994%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "19.08324%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "19.08324%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "稀有宝藏类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "稀有宝藏类型": "至尊鎏金大奖",
                                "数量": "1",
                                "概率": "0.00003%"
                            },
                            {
                                "稀有宝藏类型": "传奇鎏金大奖",
                                "数量": "1",
                                "概率": "0.03028%"
                            },
                            {
                                "稀有宝藏类型": "传奇鎏金大奖",
                                "数量": "1",
                                "概率": "0.03028%"
                            },
                            {
                                "稀有宝藏类型": "瑰丽鎏金大奖",
                                "数量": "1",
                                "概率": "3.02847%"
                            },
                            {
                                "稀有宝藏类型": "瑰丽鎏金大奖",
                                "数量": "1",
                                "概率": "3.02847%"
                            },
                            {
                                "稀有宝藏类型": "瑰丽鎏金大奖",
                                "数量": "1",
                                "概率": "3.02847%"
                            },
                            {
                                "稀有宝藏类型": "珍藏鎏金大奖",
                                "数量": "1",
                                "概率": "30.28467%"
                            },
                            {
                                "稀有宝藏类型": "珍藏鎏金大奖",
                                "数量": "1",
                                "概率": "30.28467%"
                            },
                            {
                                "稀有宝藏类型": "珍藏鎏金大奖",
                                "数量": "1",
                                "概率": "30.28467%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2025-03-25",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.41%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "信仰花篮",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "生命女神·伊西丝碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "15",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "20",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "25",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "30",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "35",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "45",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【符文共鸣】【创生·源流】符文池概率更新",
                date: "2025-03-20",
                show: false,
                description: "",
                outHeaders: ['【符文共鸣】【创生·源流】符文池概率更新', '【符文共鸣】【天演·全盛】符文池概率更新', '【符文共鸣】【愤怒的酋长】符文池概率更新'],
                tables: [
                    {
                        "subHeaders": [
                            "符文类型",
                            "符文数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "符文类型": "创生·真实",
                                "符文数量": "1",
                                "概率": "15.78%"
                            },
                            {
                                "符文类型": "创生·真实",
                                "符文数量": "2",
                                "概率": "0.79%"
                            },
                            {
                                "符文类型": "创生·真实",
                                "符文数量": "3",
                                "概率": "0.08%"
                            },
                            {
                                "符文类型": "创生·真实",
                                "符文数量": "4",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "创生·未来",
                                "符文数量": "1",
                                "概率": "15.78%"
                            },
                            {
                                "符文类型": "创生·未来",
                                "符文数量": "2",
                                "概率": "0.79%"
                            },
                            {
                                "符文类型": "创生·未来",
                                "符文数量": "3",
                                "概率": "0.08%"
                            },
                            {
                                "符文类型": "创生·未来",
                                "符文数量": "4",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "1",
                                "概率": "15.78%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "2",
                                "概率": "0.79%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "4",
                                "概率": "0.08%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "6",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "1",
                                "概率": "15.78%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "2",
                                "概率": "0.79%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "4",
                                "概率": "0.08%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "6",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "1",
                                "概率": "15.78%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "2",
                                "概率": "0.79%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "4",
                                "概率": "0.08%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "6",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "1",
                                "概率": "15.78%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "2",
                                "概率": "0.79%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "4",
                                "概率": "0.08%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "6",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "符文类型",
                            "符文数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "1",
                                "概率": "12.25%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "2",
                                "概率": "6.13%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "4",
                                "概率": "1.23%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "6",
                                "概率": "0.12%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "1",
                                "概率": "12.25%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "2",
                                "概率": "6.13%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "4",
                                "概率": "1.23%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "6",
                                "概率": "0.12%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "1",
                                "概率": "12.25%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "2",
                                "概率": "6.13%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "4",
                                "概率": "1.23%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "6",
                                "概率": "0.12%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "1",
                                "概率": "12.25%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "2",
                                "概率": "6.13%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "4",
                                "概率": "1.23%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "6",
                                "概率": "0.12%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "1",
                                "概率": "6.13%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "2",
                                "概率": "3.06%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "4",
                                "概率": "1.23%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "8",
                                "概率": "0.12%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "1",
                                "概率": "6.13%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "2",
                                "概率": "3.06%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "4",
                                "概率": "1.23%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "8",
                                "概率": "0.12%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "符文类型",
                            "符文数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "符文类型": "嗜血",
                                "符文数量": "4",
                                "概率": "15.00%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "6",
                                "概率": "1.50%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "12",
                                "概率": "0.15%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "20",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "4",
                                "概率": "15.00%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "6",
                                "概率": "1.50%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "12",
                                "概率": "0.15%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "20",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "4",
                                "概率": "15.00%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "6",
                                "概率": "1.50%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "12",
                                "概率": "0.15%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "20",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "4",
                                "概率": "15.00%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "6",
                                "概率": "1.50%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "12",
                                "概率": "0.15%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "20",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "致残",
                                "符文数量": "4",
                                "概率": "15.00%"
                            },
                            {
                                "符文类型": "致残",
                                "符文数量": "6",
                                "概率": "1.50%"
                            },
                            {
                                "符文类型": "致残",
                                "符文数量": "12",
                                "概率": "0.15%"
                            },
                            {
                                "符文类型": "致残",
                                "符文数量": "20",
                                "概率": "0.02%"
                            },
                            {
                                "符文类型": "强攻",
                                "符文数量": "4",
                                "概率": "15.00%"
                            },
                            {
                                "符文类型": "强攻",
                                "符文数量": "6",
                                "概率": "1.50%"
                            },
                            {
                                "符文类型": "强攻",
                                "符文数量": "12",
                                "概率": "0.15%"
                            },
                            {
                                "符文类型": "强攻",
                                "符文数量": "20",
                                "概率": "0.02%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【春日惊喜盒】概率公布",
                date: "2025-03-13",
                show: false,
                description: "",
                outHeaders: ['惊喜盒奖池', '刮刮乐翻倍概率', '春神的祝福奖池（每抽取5次可触发）', '春神的祝福 触发概率（每抽取5次可触发）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "春日兑奖券",
                                "数量": "20",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "春日兑奖券",
                                "数量": "10",
                                "概率": "0.09%"
                            },
                            {
                                "道具": "春日兑奖券",
                                "数量": "8",
                                "概率": "1.86%"
                            },
                            {
                                "道具": "春日兑奖券",
                                "数量": "5",
                                "概率": "6.20%"
                            },
                            {
                                "道具": "春日兑奖券",
                                "数量": "4",
                                "概率": "18.61%"
                            },
                            {
                                "道具": "春日兑奖券",
                                "数量": "3",
                                "概率": "24.81%"
                            },
                            {
                                "道具": "春日兑奖券",
                                "数量": "2",
                                "概率": "6.20%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "数量": "8",
                                "概率": "9.31%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "150",
                                "概率": "9.31%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "40",
                                "概率": "9.31%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "120",
                                "概率": "9.31%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "4.96%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "70.32%"
                            },
                            {
                                "倍数": "2",
                                "概率": "28.13%"
                            },
                            {
                                "倍数": "5",
                                "概率": "1.41%"
                            },
                            {
                                "倍数": "8",
                                "概率": "0.14%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷影幻龙（永久）",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "始祖龙精晶",
                                "数量": "600",
                                "概率": "24.99%"
                            },
                            {
                                "道具": "双头龙精晶",
                                "数量": "600",
                                "概率": "24.99%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "5000",
                                "概率": "24.99%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "4200",
                                "概率": "24.99%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "项目",
                            "概率"
                        ],
                        "data": [
                            {
                                "项目": "触发概率",
                                "概率": "1.0%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2025-03-11",
                show: false,
                description: "",
                outHeaders: ['无畏怒焰伙伴池', '涌动之灵伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "无畏怒焰",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "涌动之灵",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】概率公布",
                date: "2025-03-07",
                show: false,
                description: "",
                outHeaders: ['遗迹探宝普通宝藏概率', '遗迹探宝稀有宝藏概率（不放回奖池的首次抽取概率）', '积分暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "金晶琥珀",
                                "数量": "3",
                                "概率": "0.1168%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "数量": "1",
                                "概率": "1.1682%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "数量": "20",
                                "概率": "8.1776%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "数量": "5",
                                "概率": "11.6822%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "50",
                                "概率": "11.6822%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "1",
                                "概率": "8.1776%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "11.6822%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "数量": "1",
                                "概率": "4.0888%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "8.1776%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "3",
                                "概率": "11.6822%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "11.6822%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "1",
                                "概率": "11.6822%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "稀有宝藏类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "稀有宝藏类型": "至尊稀有宝藏",
                                "数量": "1",
                                "概率": "0.0003%"
                            },
                            {
                                "稀有宝藏类型": "超级稀有宝藏",
                                "数量": "1",
                                "概率": "0.3012%"
                            },
                            {
                                "稀有宝藏类型": "超级稀有宝藏",
                                "数量": "1",
                                "概率": "0.3012%"
                            },
                            {
                                "稀有宝藏类型": "特级稀有宝藏",
                                "数量": "1",
                                "概率": "3.0120%"
                            },
                            {
                                "稀有宝藏类型": "特级稀有宝藏",
                                "数量": "1",
                                "概率": "3.0120%"
                            },
                            {
                                "稀有宝藏类型": "特级稀有宝藏",
                                "数量": "1",
                                "概率": "3.0120%"
                            },
                            {
                                "稀有宝藏类型": "高级稀有宝藏",
                                "数量": "1",
                                "概率": "30.1204%"
                            },
                            {
                                "稀有宝藏类型": "高级稀有宝藏",
                                "数量": "1",
                                "概率": "30.1204%"
                            },
                            {
                                "稀有宝藏类型": "高级稀有宝藏",
                                "数量": "1",
                                "概率": "30.1204%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "95.43%"
                            },
                            {
                                "倍数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "0.25%"
                            },
                            {
                                "倍数": "20",
                                "概率": "0.05%"
                            }
                        ]
                    }
                ]
            },


            {
                name: "【神秘小屋】获得道具概率公布",
                date: "2025-03-06",
                show: false,
                description: "",
                outHeaders: ['星空探索奖池（陨星结晶）', '星盘占卜奖池（陨星结晶）', '魔法师的赠礼奖池（陨星结晶）', '星空探索奖池（稀有伙伴结晶）', '星盘占卜奖池（稀有伙伴结晶）', '魔法师的赠礼奖池（稀有伙伴结晶）', '星空探索奖池（流星结晶）', '星盘占卜奖池（流星结晶）', '魔法师的赠礼奖池（流星结晶）', '星空探索奖池（普通伙伴结晶）', '星盘占卜奖池（普通伙伴结晶）', '魔法师的赠礼奖池（普通伙伴结晶）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "3",
                                "概率": "23.026%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "3",
                                "概率": "23.026%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "5",
                                "概率": "6.579%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "5",
                                "概率": "6.579%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "5",
                                "概率": "6.579%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "20",
                                "概率": "0.658%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "8",
                                "概率": "5.263%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "8",
                                "概率": "5.263%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "3",
                                "概率": "23.026%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法师的赠礼奖池",
                                "个数": "1",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "2",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "75",
                                "概率": "1.22%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "40",
                                "概率": "14.59%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "25",
                                "概率": "30.41%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "1",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "1",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "25",
                                "概率": "30.41%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "40",
                                "概率": "18.24%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "75",
                                "概率": "1.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "陨星结晶",
                                "个数": "3",
                                "概率": "17.79%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "8",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "7",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "6",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "20",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "6",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "7",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "8",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "3",
                                "概率": "17.79%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "6",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "6",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "30",
                                "概率": "1.83%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "6",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "12",
                                "概率": "7.33%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "50",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "12",
                                "概率": "5.86%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "12",
                                "概率": "5.86%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "30",
                                "概率": "1.83%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法师的赠礼奖池",
                                "个数": "1",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "4",
                                "概率": "0.61%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "2",
                                "概率": "0.86%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "80",
                                "概率": "14.67%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "50",
                                "概率": "30.56%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "2",
                                "概率": "0.86%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "2",
                                "概率": "0.86%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "50",
                                "概率": "30.56%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "80",
                                "概率": "18.33%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "2",
                                "概率": "0.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "6",
                                "概率": "17.79%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "10",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "14",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "12",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "35",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "12",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "14",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "10",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "6",
                                "概率": "17.79%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "流星结晶碎片",
                                "个数": "4",
                                "概率": "3.24%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "4",
                                "概率": "3.24%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "2",
                                "概率": "25.89%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "2",
                                "概率": "25.89%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "3",
                                "概率": "5.18%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "6",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "3",
                                "概率": "5.18%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "3",
                                "概率": "5.18%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "2",
                                "概率": "25.89%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法师的赠礼奖池",
                                "个数": "1",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "4",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "2",
                                "概率": "21.29%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "25",
                                "概率": "4.26%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "15",
                                "概率": "21.29%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "3",
                                "概率": "2.13%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "3",
                                "概率": "2.13%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "15",
                                "概率": "21.29%"
                            },
                            {
                                "道具": "流星结晶碎片",
                                "个数": "25",
                                "概率": "4.26%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "2",
                                "概率": "21.29%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "流星结晶",
                                "个数": "20",
                                "概率": "34.63%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "30",
                                "概率": "4.33%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "45",
                                "概率": "2.16%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "35",
                                "概率": "8.66%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "100",
                                "概率": "0.43%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "35",
                                "概率": "8.66%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "45",
                                "概率": "2.16%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "30",
                                "概率": "4.33%"
                            },
                            {
                                "道具": "流星结晶",
                                "个数": "20",
                                "概率": "34.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "10",
                                "概率": "25.89%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "10",
                                "概率": "25.89%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "10",
                                "概率": "25.89%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "15",
                                "概率": "5.18%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "15",
                                "概率": "5.18%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "50",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "20",
                                "概率": "3.24%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "20",
                                "概率": "3.24%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "15",
                                "概率": "5.18%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法师的赠礼奖池",
                                "个数": "1",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "400",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "75",
                                "概率": "21.42%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "150",
                                "概率": "4.76%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "75",
                                "概率": "21.42%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "200",
                                "概率": "1.19%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "200",
                                "概率": "1.19%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "75",
                                "概率": "21.42%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "150",
                                "概率": "4.76%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "75",
                                "概率": "21.42%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "800",
                                "概率": "30.30%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "2000",
                                "概率": "6.49%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "2500",
                                "概率": "4.33%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "1500",
                                "概率": "8.66%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "5000",
                                "概率": "0.43%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "1500",
                                "概率": "8.66%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "2500",
                                "概率": "4.33%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "2000",
                                "概率": "6.49%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "800",
                                "概率": "30.30%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】概率公布",
                date: "2025-02-24",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银宝箱-龙印 II', '白银宝箱-资源 III', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金宝箱-龙印 II', '黄金宝箱-资源 III'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "9000",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "15000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "20000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "20000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "15000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "9000",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "35000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "300",
                                "概率": "22.18%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "600",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "11.09%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "600",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "11.09%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "300",
                                "概率": "22.18%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "2000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "30",
                                "概率": "22.18%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "60",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "11.09%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "60",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "11.09%"
                            },
                            {
                                "道具": "白银宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "30",
                                "概率": "22.18%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "200",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "30.75%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "9.23%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3",
                                "概率": "13.84%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.001%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "900",
                                "概率": "15.15%"
                            },
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "1800",
                                "概率": "10.10%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "360",
                                "概率": "15.15%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "720",
                                "概率": "10.10%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "360",
                                "概率": "15.15%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "720",
                                "概率": "10.10%"
                            },
                            {
                                "道具": "冰龙之首（橙）",
                                "数量": "1",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "冰龙之牙（橙）",
                                "数量": "1",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "冰龙之翼（橙）",
                                "数量": "1",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "冰龙之爪（橙）",
                                "数量": "1",
                                "概率": "6.06%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "3.23%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "480",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "240",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "24.19%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "4.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "120000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "150000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "70000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "70000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "150000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "120000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "4500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "6000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "3000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "6000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "3000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "4500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "450",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "600",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "300",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "300",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "600",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印 II",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "450",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选XX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "1400",
                                "概率": "18.180%"
                            },
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "2800",
                                "概率": "9.090%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "550",
                                "概率": "18.180%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "1100",
                                "概率": "9.090%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "550",
                                "概率": "18.180%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "1100",
                                "概率": "9.090%"
                            },
                            {
                                "道具": "冰龙之首（紫）",
                                "数量": "1",
                                "概率": "4.550%"
                            },
                            {
                                "道具": "冰龙之牙（紫）",
                                "数量": "1",
                                "概率": "4.550%"
                            },
                            {
                                "道具": "冰龙之翼（紫）",
                                "数量": "1",
                                "概率": "4.550%"
                            },
                            {
                                "道具": "冰龙之爪（紫）",
                                "数量": "1",
                                "概率": "4.550%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "1000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "2000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "400",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "4",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2025-02-17",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "2",
                                "概率": "78.08%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "4",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "6",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "8",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "10",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.56%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "15.61%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "亡者天平-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "亡者天平-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "亡者天平-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "亡者天平-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "亡者天平-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "绿松石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱XI",
                                "数量": "2",
                                "概率": "73.49%"
                            },
                            {
                                "道具": "祭司法器自选宝箱XI",
                                "数量": "4",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "7.35%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "18.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "0.37%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "40",
                                "概率": "4.22%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "80",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "150",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "祭司法器自选宝箱XI",
                                "数量": "20",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "祭司法器自选宝箱XI",
                                "数量": "40",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "祭司法器自选宝箱XI",
                                "数量": "100",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "5",
                                "概率": "10.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【甜蜜射击】道具概率公布",
                date: "2025-02-14",
                show: false,
                description: "",
                outHeaders: ['甜蜜射击-基础奖池', '奖池道具翻倍概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "1 血精核",
                                "数量": "15",
                                "概率": "8.71%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "60",
                                "概率": "13.94%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "60",
                                "概率": "11.32%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "1.57%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "6.97%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "15",
                                "概率": "8.71%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "80",
                                "概率": "13.07%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "1",
                                "概率": "9.58%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "2",
                                "概率": "12.20%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "12.20%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "90.00%"
                            },
                            {
                                "倍数": "2",
                                "概率": "7.40%"
                            },
                            {
                                "倍数": "3",
                                "概率": "2.00%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.50%"
                            },
                            {
                                "倍数": "5",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【无畏怒焰降临】获得伙伴概率公布",
                date: "2025-02-11",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "无畏怒焰",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "无畏怒焰",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【秘境龙潭】概率公布",
                date: "2025-02-05",
                show: false,
                description: "",
                outHeaders: ['探秘奖池-暴龙精晶', '探秘奖池-剑龙精晶', '探秘奖池-双头龙精晶', '探秘奖池-始祖龙精晶', '祝福值暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祝福礼",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "10 暴龙精晶",
                                "数量": "3",
                                "概率": "3.97%"
                            },
                            {
                                "道具": "1 暴龙精晶",
                                "数量": "9",
                                "概率": "7.94%"
                            },
                            {
                                "道具": "1 暴龙精晶",
                                "数量": "6",
                                "概率": "39.68%"
                            },
                            {
                                "道具": "1 暴龙精晶",
                                "数量": "3",
                                "概率": "47.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祝福礼",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "10 剑龙精晶",
                                "数量": "3",
                                "概率": "3.97%"
                            },
                            {
                                "道具": "1 剑龙精晶",
                                "数量": "9",
                                "概率": "7.94%"
                            },
                            {
                                "道具": "1 剑龙精晶",
                                "数量": "6",
                                "概率": "39.68%"
                            },
                            {
                                "道具": "1 剑龙精晶",
                                "数量": "3",
                                "概率": "47.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祝福礼",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "10 双头龙精晶",
                                "数量": "2",
                                "概率": "3.97%"
                            },
                            {
                                "道具": "1 双头龙精晶",
                                "数量": "6",
                                "概率": "7.94%"
                            },
                            {
                                "道具": "1 双头龙精晶",
                                "数量": "4",
                                "概率": "39.68%"
                            },
                            {
                                "道具": "1 双头龙精晶",
                                "数量": "2",
                                "概率": "47.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祝福礼",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "10 始祖龙精晶",
                                "数量": "2",
                                "概率": "3.97%"
                            },
                            {
                                "道具": "1 始祖龙精晶",
                                "数量": "6",
                                "概率": "7.94%"
                            },
                            {
                                "道具": "1 始祖龙精晶",
                                "数量": "4",
                                "概率": "39.68%"
                            },
                            {
                                "道具": "1 始祖龙精晶",
                                "数量": "2",
                                "概率": "47.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "32.26%"
                            },
                            {
                                "倍数": "2",
                                "概率": "53.76%"
                            },
                            {
                                "倍数": "5",
                                "概率": "10.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "2.15%"
                            },
                            {
                                "倍数": "20",
                                "概率": "1.08%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】概率公布",
                date: "2025-02-01",
                show: false,
                description: "",
                outHeaders: ['混合奖池', '粉尘奖池', '碎片奖池', '结晶奖池', '混合大奖奖池', '粉尘大奖奖池', '碎片大奖奖池', '结晶大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "550",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "91000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "104000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "123500",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "700",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "6000",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "130000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "90000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "120000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "100000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "120000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "160000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "170000",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "5500",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3600",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4500",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "5000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "6800",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "6000",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "550",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "360",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "450",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "400",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "500",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "680",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "600",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1976000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "119600",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "32000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1976000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "2990000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "8190000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片",
                                "个数": "79950",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "119600",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "318500",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "个数": "8000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "11960",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "32000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【天陨秘宝】概率公布",
                date: "2025-01-31",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '秘宝奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "25",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "50",
                                "概率": "6.97%"
                            },
                            {
                                "道具名称": "2X",
                                "数量": "1",
                                "概率": "10.45%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "40",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "3X",
                                "数量": "1",
                                "概率": "5.23%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "25",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "40",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "5X",
                                "数量": "1",
                                "概率": "0.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "65",
                                "概率": "27.60%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "65",
                                "概率": "27.60%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "125",
                                "概率": "11.36%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "125",
                                "概率": "11.36%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "125",
                                "概率": "11.36%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "160",
                                "概率": "4.87%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "160",
                                "概率": "4.87%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "350",
                                "概率": "0.97%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祥蛇献瑞】道具概率公布",
                date: "2025-01-28",
                show: false,
                description: "",
                outHeaders: ['祥蛇献瑞参与奖励概率', '大奖奖励概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "大奖奖励",
                                "数量": "1",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "豹雪（友谊）",
                                "数量": "1",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "春节增益自选福袋",
                                "数量": "1",
                                "概率": "0.160%"
                            },
                            {
                                "道具": "春节伙伴自选福袋",
                                "数量": "5",
                                "概率": "0.820%"
                            },
                            {
                                "道具": "灵蛇迎春发展宝匣",
                                "数量": "3",
                                "概率": "8.170%"
                            },
                            {
                                "道具": "迎春金蛇币",
                                "数量": "5",
                                "概率": "49.000%"
                            },
                            {
                                "道具": "迎春金蛇币",
                                "数量": "10",
                                "概率": "24.500%"
                            },
                            {
                                "道具": "迎春金蛇币",
                                "数量": "20",
                                "概率": "4.080%"
                            },
                            {
                                "道具": "迎春金蛇币",
                                "数量": "30",
                                "概率": "1.630%"
                            },
                            {
                                "道具": "迎春金蛇币",
                                "数量": "50",
                                "概率": "0.160%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.820%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "3",
                                "概率": "0.820%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "4.900%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "4.900%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类型": "超级大奖",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "大奖类型": "一等奖",
                                "数量": "1",
                                "概率": "0.166%"
                            },
                            {
                                "大奖类型": "一等奖",
                                "数量": "1",
                                "概率": "0.166%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "16.611%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "16.611%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "16.611%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "16.611%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "16.611%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "16.611%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2025-01-20",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.41%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰花篮",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.62%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "亡者判官·阿努比斯碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "15",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "20",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "25",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "30",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "35",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "45",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【白金祝福季】获得道具概率公布",
                date: "2025-01-07",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黑曜翡翠",
                                "数量": "5",
                                "概率": "62.460%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "8",
                                "概率": "20.820%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "12",
                                "概率": "10.410%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "20",
                                "概率": "2.776%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "8",
                                "概率": "3.470%"
                            },
                            {
                                "道具": "太古黑曜水晶",
                                "数量": "10",
                                "概率": "0.056%"
                            },
                            {
                                "道具": "暗影魔魇（自选）",
                                "数量": "1",
                                "概率": "0.007%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】活动道具概率公布",
                date: "2024-12-30",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银宝箱 - 龙印', '白银宝箱-资源 III', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金宝箱 -龙印', '黄金宝箱-资源 III'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6000",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "12000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "18000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "18000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "12000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6000",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "30000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "240",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "480",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "960",
                                "概率": "10.62%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "480",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "960",
                                "概率": "10.62%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "240",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "2000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "24",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "48",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "96",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "96",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "48",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-龙印",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "24",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "200",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "30.75%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "9.23%"
                            },
                            {
                                "道具": "白银宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3",
                                "概率": "13.84%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.001%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "900",
                                "概率": "16.48%"
                            },
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "1800",
                                "概率": "10.99%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "360",
                                "概率": "16.48%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "720",
                                "概率": "10.99%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "360",
                                "概率": "16.48%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "720",
                                "概率": "10.99%"
                            },
                            {
                                "道具": "冰龙之首（橙）",
                                "数量": "1",
                                "概率": "4.40%"
                            },
                            {
                                "道具": "冰龙之牙（橙）",
                                "数量": "1",
                                "概率": "4.40%"
                            },
                            {
                                "道具": "冰龙之翼（橙）",
                                "数量": "1",
                                "概率": "4.40%"
                            },
                            {
                                "道具": "冰龙之爪（橙）",
                                "数量": "1",
                                "概率": "4.40%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "3.23%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "480",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "240",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "24.19%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "4.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "80000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "120000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "60000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "60000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "120000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "80000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "3600",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "5800",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "2400",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "5800",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "2400",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "3600",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "360",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "580",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "240",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "240",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "580",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-龙印",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "360",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选XIX",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "黄金宝箱-资源 III",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "传说五星自选 XXX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "1400",
                                "概率": "19.230%"
                            },
                            {
                                "道具": "1000 龙魄粉尘",
                                "数量": "2800",
                                "概率": "9.620%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "550",
                                "概率": "19.230%"
                            },
                            {
                                "道具": "100 龙魄碎片",
                                "数量": "1100",
                                "概率": "9.620%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "550",
                                "概率": "19.230%"
                            },
                            {
                                "道具": "10 龙魄结晶",
                                "数量": "1100",
                                "概率": "9.620%"
                            },
                            {
                                "道具": "冰龙之首（紫）",
                                "数量": "1",
                                "概率": "3.370%"
                            },
                            {
                                "道具": "冰龙之牙（紫）",
                                "数量": "1",
                                "概率": "3.370%"
                            },
                            {
                                "道具": "冰龙之翼（紫）",
                                "数量": "1",
                                "概率": "3.370%"
                            },
                            {
                                "道具": "冰龙之爪（紫）",
                                "数量": "1",
                                "概率": "3.370%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "1000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "2000",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "400",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "4",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【圣诞老人的礼物】活动概率公布",
                date: "2024-12-23",
                show: false,
                description: "",
                outHeaders: ['圣诞袜类型', '华丽圣诞袜奖池', '珍贵圣诞袜奖池', '精致圣诞袜奖池', '幸运值暴击倍数概率', '幸运值奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "华丽圣诞袜",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "珍贵圣诞袜",
                                "数量": "1",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "精致圣诞袜",
                                "数量": "1",
                                "概率": "60.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "极地星辉(友谊)",
                                "数量": "1",
                                "概率": "0.012%"
                            },
                            {
                                "道具": "冰刃峻龙碎片",
                                "数量": "10",
                                "概率": "3.614%"
                            },
                            {
                                "道具": "圣诞花环",
                                "数量": "15",
                                "概率": "12.047%"
                            },
                            {
                                "道具": "圣诞花环",
                                "数量": "10",
                                "概率": "84.327%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "雪橇赛手（友谊）",
                                "数量": "1",
                                "概率": "1.231%"
                            },
                            {
                                "道具": "冰刃峻龙碎片",
                                "数量": "5",
                                "概率": "0.308%"
                            },
                            {
                                "道具": "圣诞花环",
                                "数量": "5",
                                "概率": "49.231%"
                            },
                            {
                                "道具": "圣诞花环",
                                "数量": "4",
                                "概率": "49.231%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "冰刃峻龙碎片",
                                "数量": "3",
                                "概率": "0.654%"
                            },
                            {
                                "道具": "冰刃峻龙碎片",
                                "数量": "1",
                                "概率": "1.307%"
                            },
                            {
                                "道具": "圣诞花环",
                                "数量": "3",
                                "概率": "32.680%"
                            },
                            {
                                "道具": "圣诞花环",
                                "数量": "2",
                                "概率": "65.359%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "类型",
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "类型": "幸运值",
                                "倍数": "1",
                                "概率": "1.408%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "2",
                                "概率": "70.423%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "5",
                                "概率": "21.127%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "10",
                                "概率": "4.225%"
                            },
                            {
                                "类型": "幸运值",
                                "倍数": "20",
                                "概率": "2.817%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "湛蓝灯球",
                                "数量": "1",
                                "概率": "16.667%"
                            },
                            {
                                "道具": "火红灯球",
                                "数量": "1",
                                "概率": "16.667%"
                            },
                            {
                                "道具": "橙黄灯球",
                                "数量": "1",
                                "概率": "16.667%"
                            },
                            {
                                "道具": "亮紫灯球",
                                "数量": "1",
                                "概率": "16.667%"
                            },
                            {
                                "道具": "湛蓝灯球",
                                "数量": "2",
                                "概率": "8.333%"
                            },
                            {
                                "道具": "火红灯球",
                                "数量": "2",
                                "概率": "8.333%"
                            },
                            {
                                "道具": "橙黄灯球",
                                "数量": "2",
                                "概率": "8.333%"
                            },
                            {
                                "道具": "亮紫灯球",
                                "数量": "2",
                                "概率": "8.333%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【宝物探秘】获得道具概率公布",
                date: "2024-12-16",
                show: false,
                description: "",
                outHeaders: ['普通奖池1', '普通奖池2', '普通奖池3', '普通奖池4', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '【高级大奖】奖池概率', '【特级大奖】奖池概率', '【至尊大奖】奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷雾星尘",
                                "数量": "200",
                                "概率": "0.004%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "20",
                                "概率": "9.395%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "25",
                                "概率": "18.789%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "150",
                                "概率": "0.038%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "30",
                                "概率": "37.578%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "35",
                                "概率": "18.789%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "100",
                                "概率": "0.375%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "40",
                                "概率": "9.395%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "50",
                                "概率": "3.758%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "60",
                                "概率": "1.879%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法粉尘",
                                "数量": "180000",
                                "概率": "0.204%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "100000",
                                "概率": "10.181%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "110000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "190000",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "120000",
                                "概率": "40.724%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "130000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "200000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "140000",
                                "概率": "5.091%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "150000",
                                "概率": "2.036%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "160000",
                                "概率": "1.018%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法碎片",
                                "数量": "18000",
                                "概率": "0.204%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "10000",
                                "概率": "10.181%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "11000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "19000",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "12000",
                                "概率": "40.724%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "13000",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "20000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "14000",
                                "概率": "5.091%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "15000",
                                "概率": "2.036%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "16000",
                                "概率": "1.018%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "1800",
                                "概率": "0.204%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1000",
                                "概率": "10.181%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1100",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1900",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1200",
                                "概率": "40.724%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1300",
                                "概率": "20.362%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "2000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1400",
                                "概率": "5.091%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1500",
                                "概率": "2.036%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1600",
                                "概率": "1.018%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷雾宝物自选宝箱IV",
                                "数量": "1",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱III",
                                "数量": "1",
                                "概率": "0.060%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱II",
                                "数量": "1",
                                "概率": "0.590%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱I",
                                "数量": "1",
                                "概率": "5.900%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "100",
                                "概率": "59.000%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "200",
                                "概率": "5.900%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "300",
                                "概率": "0.590%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "500",
                                "概率": "18.000%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "1000",
                                "概率": "1.800%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "1500",
                                "概率": "0.180%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "600000",
                                "概率": "5.900%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "800000",
                                "概率": "1.470%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1000000",
                                "概率": "0.590%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷雾宝物自选宝箱V",
                                "数量": "1",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱IV",
                                "数量": "1",
                                "概率": "0.070%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱III",
                                "数量": "1",
                                "概率": "0.330%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱II",
                                "数量": "1",
                                "概率": "3.270%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "100",
                                "概率": "65.330%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "200",
                                "概率": "6.530%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "300",
                                "概率": "0.650%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "500",
                                "概率": "13.500%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "1000",
                                "概率": "1.360%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "2000",
                                "概率": "0.140%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "800000",
                                "概率": "6.530%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1000000",
                                "概率": "1.630%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1200000",
                                "概率": "0.650%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "迷雾宝物自选宝箱VI",
                                "数量": "1",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱V",
                                "数量": "1",
                                "概率": "0.070%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱IV",
                                "数量": "1",
                                "概率": "0.350%"
                            },
                            {
                                "道具": "迷雾宝物自选宝箱III",
                                "数量": "1",
                                "概率": "3.460%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "200",
                                "概率": "69.180%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "400",
                                "概率": "6.920%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "600",
                                "概率": "0.690%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "500",
                                "概率": "9.000%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "1000",
                                "概率": "0.900%"
                            },
                            {
                                "道具": "迷雾星尘",
                                "数量": "2000",
                                "概率": "0.090%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1200000",
                                "概率": "6.920%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1400000",
                                "概率": "1.720%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1600000",
                                "概率": "0.690%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2024-12-13",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "2",
                                "概率": "78.08%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "4",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "6",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "8",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "10",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.56%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "15.61%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "风暴权杖-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "绿松石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "星辰石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱X",
                                "数量": "2",
                                "概率": "73.49%"
                            },
                            {
                                "道具": "祭司法器自选宝箱X",
                                "数量": "4",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "7.35%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "18.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "0.37%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "40",
                                "概率": "4.22%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "80",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "150",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "祭司法器自选宝箱X",
                                "数量": "20",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "祭司法器自选宝箱X",
                                "数量": "40",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "祭司法器自选宝箱X",
                                "数量": "100",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "5",
                                "概率": "10.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】活动概率公布",
                date: "2024-12-03",
                show: false,
                description: "",
                outHeaders: ['普通奖池（普通时段）', '普通奖池（特殊时段）', '稀有奖池', '积分暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "40",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "10",
                                "概率": "13.40%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "5",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "50",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "100 血精石",
                                "个数": "3",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "龙鳞综合宝箱",
                                "个数": "3",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "个数": "1",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "外观金币",
                                "个数": "1",
                                "概率": "13.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "20",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "5",
                                "概率": "13.40%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "5",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "50",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "100 血精石",
                                "个数": "3",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "龙鳞综合宝箱",
                                "个数": "3",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "个数": "1",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "外观金币",
                                "个数": "1",
                                "概率": "13.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "冰川棱境（永久）",
                                "个数": "1",
                                "概率": "0.52%"
                            },
                            {
                                "道具": "传说五星自选 XXIX",
                                "个数": "1",
                                "概率": "1.31%"
                            },
                            {
                                "道具": "遗迹宝藏据点外观自选Ⅰ",
                                "个数": "1",
                                "概率": "6.54%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "个数": "50",
                                "概率": "9.16%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "10",
                                "概率": "3.93%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "5",
                                "概率": "9.16%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "5",
                                "概率": "23.56%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "个数": "3",
                                "概率": "22.25%"
                            },
                            {
                                "道具": "100 血精核",
                                "个数": "5",
                                "概率": "23.56%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "95.43%"
                            },
                            {
                                "倍数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "0.25%"
                            },
                            {
                                "倍数": "20",
                                "概率": "0.05%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【赛季挑战】获得道具概率公布",
                date: "2024-12-02",
                show: false,
                description: "",
                outHeaders: ['赛季宝箱概率', '超级寻宝概率(本概率为首次抽取概率，实际概率随奖池剩余奖励变化而浮动。)'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有五星自选 VI",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3700",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "37000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1500",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "37000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "7.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XXVIII",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "200",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "100",
                                "概率": "0.69%"
                            },
                            {
                                "道具": "行军特效碎片自选宝箱I",
                                "数量": "50",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "惊喜战争宝箱",
                                "数量": "1",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "40",
                                "概率": "1.78%"
                            },
                            {
                                "道具": "史诗五星自选 VI",
                                "数量": "1",
                                "概率": "1.39%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "40",
                                "概率": "1.94%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "6",
                                "概率": "65.33%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "35",
                                "概率": "14.06%"
                            },
                            {
                                "道具": "洗炼材料自选宝箱",
                                "数量": "22",
                                "概率": "6.54%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "6.45%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2024-11-29",
                show: false,
                description: "",
                outHeaders: ['涌动之灵伙伴池', '月刃荒鹫伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "涌动之灵",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "月刃荒鹫",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【喂养小火鸡】活动概率公布",
                date: "2024-11-27",
                show: false,
                description: "",
                outHeaders: ['普通养殖场奖励', '高级养殖场奖励'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "高级养殖场奖励",
                                "数量": "1",
                                "概率": "0.221%"
                            },
                            {
                                "道具": "琥珀神奇龟",
                                "数量": "1",
                                "概率": "0.221%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "10",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "1",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "4",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "10",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "8",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "1",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "数量": "5",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "10",
                                "概率": "11.062%"
                            },
                            {
                                "道具": "黄金龟碎片",
                                "数量": "10",
                                "概率": "11.062%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "感恩据点（永久）",
                                "个数": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "火鸡尾羽",
                                "个数": "150",
                                "概率": "0.119%"
                            },
                            {
                                "道具": "火鸡尾羽",
                                "个数": "100",
                                "概率": "0.398%"
                            },
                            {
                                "道具": "火鸡尾羽",
                                "个数": "50",
                                "概率": "6.366%"
                            },
                            {
                                "道具": "火鸡尾羽",
                                "个数": "20",
                                "概率": "17.506%"
                            },
                            {
                                "道具": "火鸡尾羽",
                                "个数": "10",
                                "概率": "19.893%"
                            },
                            {
                                "道具": "火鸡尾羽",
                                "个数": "5",
                                "概率": "15.914%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "个数": "10",
                                "概率": "7.957%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "个数": "120",
                                "概率": "7.957%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "1",
                                "概率": "7.957%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "180",
                                "概率": "7.957%"
                            },
                            {
                                "道具": "印记碎岩",
                                "个数": "120",
                                "概率": "7.957%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "个数": "1",
                                "概率": "0.016%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2024-11-20",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.35%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.61%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "8",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "风暴之神·赛特碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "15",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "20",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "25",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "30",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "35",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "45",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【玲珑秘骰】活动概率公布",
                date: "2024-11-14",
                show: false,
                description: "",
                outHeaders: ['印记碎岩初级奖池', '印记碎岩中级奖池', '印记碎岩高级奖池', '印记碎岩特级奖池', '印记碎岩至尊奖池', '兵装碎岩初级奖池', '兵装碎岩中级奖池', '兵装碎岩高级奖池', '兵装碎岩特级奖池', '兵装碎岩至尊奖池', '印记炉火初级奖池', '印记炉火中级奖池', '印记炉火高级奖池', '印记炉火特级奖池', '印记炉火至尊奖池', '兵装炉火初级奖池', '兵装炉火中级奖池', '兵装炉火高级奖池', '兵装炉火特级奖池', '兵装炉火至尊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "100",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "90",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "70",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "50",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "130",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "120",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "90",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "70",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "170",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "160",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "120",
                                "概率": "36.11%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "100",
                                "概率": "36.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "460",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "420",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "220",
                                "概率": "28.57%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "140",
                                "概率": "23.81%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "1440",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "1260",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "1080",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "900",
                                "概率": "65.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "100",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "90",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "70",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "50",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "130",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "120",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "90",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "70",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "170",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "160",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "120",
                                "概率": "36.11%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "100",
                                "概率": "36.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "460",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "420",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "220",
                                "概率": "28.57%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "140",
                                "概率": "23.81%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "1440",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "1260",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "1080",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "900",
                                "概率": "65.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记炉火",
                                "数量": "160",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "145",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "110",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "80",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记炉火",
                                "数量": "210",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "190",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "154",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "110",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记炉火",
                                "数量": "270",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "255",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "190",
                                "概率": "36.11%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "160",
                                "概率": "36.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记炉火",
                                "数量": "735",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "670",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "350",
                                "概率": "28.57%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "225",
                                "概率": "23.81%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记炉火",
                                "数量": "2305",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "2015",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "1730",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "1440",
                                "概率": "65.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装炉火",
                                "数量": "160",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "145",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "110",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "80",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装炉火",
                                "数量": "210",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "190",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "154",
                                "概率": "40.00%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "110",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装炉火",
                                "数量": "270",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "255",
                                "概率": "13.89%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "190",
                                "概率": "36.11%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "160",
                                "概率": "36.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装炉火",
                                "数量": "735",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "670",
                                "概率": "23.81%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "350",
                                "概率": "28.57%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "225",
                                "概率": "23.81%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装炉火",
                                "数量": "2305",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "2015",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "1730",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "1440",
                                "概率": "65.22%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙突破】概率更新",
                date: "2024-11-11",
                show: false,
                description: "",
                outHeaders: ['转盘奖励', '始祖龙鳞奖池', '双头龙鳞奖池', '剑龙鳞奖池', '暴龙鳞奖池', '三角龙鳞奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "6",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "6",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "9",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "12",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "25",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "2",
                                "概率": "31.62%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "4",
                                "概率": "31.62%"
                            },
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "5",
                                "概率": "31.62%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "6",
                                "概率": "0.40%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "5",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "3",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "10",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "9",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "6",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "5",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "4",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "3",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "10",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "5",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "20",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "18",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "13",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "10",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "8",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "5",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "14",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "6",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "26",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "24",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "16",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "14",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "10",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "6",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "20",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "10",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "40",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "35",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "25",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "20",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "15",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "10",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "40",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "20",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "80",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "70",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "50",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "40",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "30",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "20",
                                "概率": "30.86%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【涌动之灵降临】获得伙伴概率公布",
                date: "2024-11-05",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "涌动之灵",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "涌动之灵",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【万圣节南瓜派对】概率公布",
                date: "2024-11-01",
                show: false,
                description: "",
                outHeaders: ['普通奖励', '稀有奖励'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "道具数量",
                            "获得概率"
                        ],
                        "data": [
                            {
                                "道具名称": "太古神奇龟",
                                "道具数量": "1",
                                "获得概率": "0.04%"
                            },
                            {
                                "道具名称": "印记炉火",
                                "道具数量": "120",
                                "获得概率": "11.53%"
                            },
                            {
                                "道具名称": "兵装炉火",
                                "道具数量": "120",
                                "获得概率": "7.70%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "道具数量": "140",
                                "获得概率": "3.85%"
                            },
                            {
                                "道具名称": "2024万圣节巨龙自选宝箱",
                                "道具数量": "3",
                                "获得概率": "15.38%"
                            },
                            {
                                "道具名称": "2024万圣节伙伴自选宝箱",
                                "道具数量": "2",
                                "获得概率": "19.22%"
                            },
                            {
                                "道具名称": "2024万圣节发展自选宝箱",
                                "道具数量": "2",
                                "获得概率": "19.22%"
                            },
                            {
                                "道具名称": "洗炼滴露精华",
                                "道具数量": "4",
                                "获得概率": "11.53%"
                            },
                            {
                                "道具名称": "洗炼灵石碎片",
                                "道具数量": "4",
                                "获得概率": "11.53%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "道具数量",
                            "获得概率"
                        ],
                        "data": [
                            {
                                "道具名称": "捣蛋幽灵（友谊狂欢）",
                                "道具数量": "1",
                                "获得概率": "0.27%"
                            },
                            {
                                "道具名称": "巫师小屋(友谊)",
                                "道具数量": "1",
                                "获得概率": "13.48%"
                            },
                            {
                                "道具名称": "传说五星自选 XXIX",
                                "道具数量": "1",
                                "获得概率": "2.70%"
                            },
                            {
                                "道具名称": "魔法帽",
                                "道具数量": "100",
                                "获得概率": "2.70%"
                            },
                            {
                                "道具名称": "2024万圣节巨龙自选宝箱",
                                "道具数量": "30",
                                "获得概率": "26.95%"
                            },
                            {
                                "道具名称": "2024万圣节伙伴自选宝箱",
                                "道具数量": "24",
                                "获得概率": "26.95%"
                            },
                            {
                                "道具名称": "2024万圣节发展自选宝箱",
                                "道具数量": "24",
                                "获得概率": "26.95%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【先祖庇佑】道具概率公布",
                date: "2024-10-28",
                show: false,
                description: "",
                outHeaders: ['触发庇佑模式概率', '古老贝壳奖池', '发光贝壳奖池', '庇佑模式：龙印奖池', '庇佑模式：远古宝物奖池', '庇佑模式：装备', '庇佑模式：龙奖池', '庇佑模式：血精石奖池', '庇佑模式：龟奖池', '庇佑模式：神器&技能鲶鱼奖池', '庇佑模式：战纹奖池', '庇佑模式：BUFF奖池', '庇佑模式：宝石奖池', '庇佑模式：魔骨奖池', '庇佑模式：荣耀&魔法奖池', '庇佑模式：龙结晶'],
                tables: [
                    {
                        "subHeaders": [
                            "行为",
                            "概率"
                        ],
                        "data": [
                            {
                                "行为": "古老贝壳祈祷",
                                "概率": "3.33%"
                            },
                            {
                                "行为": "发光贝壳祈祷",
                                "概率": "20.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "发光贝壳",
                                "数量": "1",
                                "概率": "3.38%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "5.41%"
                            },
                            {
                                "道具": "蓝色祭司碎片",
                                "数量": "2",
                                "概率": "10.14%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "12",
                                "概率": "8.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "21.62%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "1",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "1",
                                "概率": "13.51%"
                            },
                            {
                                "道具": "500,000 象牙",
                                "数量": "1",
                                "概率": "12.16%"
                            },
                            {
                                "道具": "500,000 石头",
                                "数量": "1",
                                "概率": "12.16%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "2.30%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "24.14%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "10",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "8",
                                "概率": "5.75%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "4",
                                "概率": "8.62%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "17.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "8000",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "4000",
                                "概率": "10.99%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "22000",
                                "概率": "6.59%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "12000",
                                "概率": "24.18%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "6500",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "4800",
                                "概率": "10.99%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "3300",
                                "概率": "21.98%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "2400",
                                "概率": "21.98%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "50000",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "10000",
                                "概率": "19.54%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "100000",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "41500",
                                "概率": "32.57%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "12000",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "8000",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "6500",
                                "概率": "6.51%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "4000",
                                "概率": "32.57%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "数量": "5500",
                                "概率": "0.71%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "1800",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "18000",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "9000",
                                "概率": "35.71%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "3500",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "2200",
                                "概率": "3.57%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "1400",
                                "概率": "7.14%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "1000",
                                "概率": "35.71%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "6",
                                "概率": "9.52%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "31.72%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "14",
                                "概率": "1.59%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "7",
                                "概率": "17.44%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "1",
                                "概率": "39.65%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100 血精石",
                                "数量": "30",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "15",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "75",
                                "概率": "4.95%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "38",
                                "概率": "9.89%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "282",
                                "概率": "14.84%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "225",
                                "概率": "19.78%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "187",
                                "概率": "49.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "5",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "3",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "31.19%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "10",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "5",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "2",
                                "概率": "31.19%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "高级神器自选宝箱XⅥ",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "16",
                                "概率": "1.45%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "8",
                                "概率": "4.34%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "2",
                                "概率": "43.35%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "7.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "43.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "5",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "3.22%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "5",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "3",
                                "概率": "26.80%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "50",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "30",
                                "概率": "16.08%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "20",
                                "概率": "21.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "15%攻击削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%防御削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%生命削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%行军兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "集结兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%攻击加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%防御加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%生命加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "25%行军兵量增加",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天攻击加成",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天防御加成",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天和平守护",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "行军队列",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天反侦查",
                                "数量": "1",
                                "概率": "4.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100宝石",
                                "数量": "100",
                                "概率": "1.28%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "50",
                                "概率": "2.56%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "30",
                                "概率": "6.41%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "20",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "15",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "51.28%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔骨能耗减少",
                                "数量": "1",
                                "概率": "0.38%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "15",
                                "概率": "0.76%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "10",
                                "概率": "3.80%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "4",
                                "概率": "19.01%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "16",
                                "概率": "30.42%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "12",
                                "概率": "45.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀旗帜",
                                "数量": "2250",
                                "概率": "1.77%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "960",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "800",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "640",
                                "概率": "26.55%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "2250",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "960",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "800",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "640",
                                "概率": "26.55%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "32",
                                "概率": "0.17%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "16",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "32",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "16",
                                "概率": "3.48%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "12",
                                "概率": "6.96%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "8",
                                "概率": "17.39%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "69.57%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2024-10-21",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银宝箱 - 宝物', '白银宝箱-资源 II', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金宝箱 - 宝物', '黄金宝箱-资源 II'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XVII",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "4500",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "9000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "12000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "12000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "9000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "4500",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "24000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XVII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "450",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "900",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1200",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1200",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "900",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "450",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2400",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XVII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "45",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "90",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "120",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "120",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "90",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "45",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "240",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "至尊据点外观自选XVII",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "30.75%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5",
                                "概率": "23.06%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "9.23%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3",
                                "概率": "13.84%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.001%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "迷雾护腕（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾结晶（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾戒指（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾项链（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "3.23%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "120",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "240",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "24.19%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "4.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "60000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "100000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "35000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "35000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "100000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "60000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXIX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "10000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3500",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3500",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "10000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXIX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "600",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "350",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "350",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "600",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXIX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选XVIII",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "传说五星自选 XXIX",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "迷雾护腕（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾结晶6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾戒指6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾项链6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "800",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "1600",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【玲珑秘骰】活动概率公布",
                date: "2024-10-18",
                show: false,
                description: "",
                outHeaders: ['印记初级奖池', '印记中级奖池', '印记高级奖池', '印记特级奖池', '印记至尊奖池', '兵装初级奖池', '兵装中级奖池', '兵装高级奖池', '兵装特级奖池', '兵装至尊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "110",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "95",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "35",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "25",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "130",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "120",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "70",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "50",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "185",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "170",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "110",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "70",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "465",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "420",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "220",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "140",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "1440",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "1260",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "1080",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "900",
                                "概率": "65.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "110",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "95",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "35",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "25",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "130",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "120",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "70",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "50",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "185",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "170",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "110",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "70",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "465",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "420",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "220",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "140",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "1440",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "1260",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "1080",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "900",
                                "概率": "65.22%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【白金祝福季】获得道具概率公布",
                date: "2024-10-11",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黑曜翡翠",
                                "数量": "5",
                                "概率": "62.460%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "8",
                                "概率": "20.820%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "12",
                                "概率": "10.410%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "20",
                                "概率": "2.776%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "8",
                                "概率": "3.470%"
                            },
                            {
                                "道具": "太古黑曜水晶",
                                "数量": "10",
                                "概率": "0.056%"
                            },
                            {
                                "道具": "法老之翼（自选）",
                                "数量": "1",
                                "概率": "0.007%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2024-10-05",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "2",
                                "概率": "78.08%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "4",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "6",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "8",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "10",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.56%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "15.61%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "绿松石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "绿松石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "星辰石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱IX",
                                "数量": "2",
                                "概率": "73.49%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IX",
                                "数量": "4",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "7.35%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "18.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "0.37%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "40",
                                "概率": "4.22%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "80",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "150",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IX",
                                "数量": "20",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IX",
                                "数量": "40",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IX",
                                "数量": "100",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "5",
                                "概率": "10.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【丰收祈愿】获得道具概率公布",
                date: "2024-10-02",
                show: false,
                description: "",
                outHeaders: ['丰收祈愿参与奖励概率', '丰收祈愿大奖奖励概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "丰收祈愿大奖奖励",
                                "数量": "1",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "苍穹之光·典藏",
                                "数量": "1",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "战斗增益丰收宝箱",
                                "数量": "1",
                                "概率": "0.180%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "150",
                                "概率": "3.680%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "150",
                                "概率": "7.360%"
                            },
                            {
                                "道具": "碎岩炉火",
                                "数量": "175",
                                "概率": "7.360%"
                            },
                            {
                                "道具": "丰收金叶",
                                "数量": "5",
                                "概率": "36.810%"
                            },
                            {
                                "道具": "丰收金叶",
                                "数量": "8",
                                "概率": "18.400%"
                            },
                            {
                                "道具": "丰收金叶",
                                "数量": "10",
                                "概率": "3.680%"
                            },
                            {
                                "道具": "丰收金叶",
                                "数量": "20",
                                "概率": "0.370%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.840%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "1.840%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "9.200%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "9.200%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类型": "超级大奖",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "大奖类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "大奖类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "大奖类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "大奖类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "大奖类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            }
                        ]
                    }
                ]
            },


            {
                name: "【限定伙伴再临】概率更新",
                date: "2024-09-28",
                show: false,
                description: "",
                outHeaders: ['森之游侠伙伴池', '审判骑士伙伴池', '亡灵公主伙伴池', '深海恐兽伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【森之游侠】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【审判骑士】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【亡灵公主】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【深海恐兽】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【天陨秘宝】概率公布",
                date: "2024-09-26",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '秘宝奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "20",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "45",
                                "概率": "6.97%"
                            },
                            {
                                "道具名称": "2X",
                                "数量": "1",
                                "概率": "10.45%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "30",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "3X",
                                "数量": "1",
                                "概率": "5.23%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "20",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "30",
                                "概率": "19.16%"
                            },
                            {
                                "道具名称": "5X",
                                "数量": "1",
                                "概率": "0.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "60",
                                "概率": "23.74%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "60",
                                "概率": "23.74%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "60",
                                "概率": "23.74%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "120",
                                "概率": "9.78%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "120",
                                "概率": "9.78%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "155",
                                "概率": "4.19%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "155",
                                "概率": "4.19%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "300",
                                "概率": "0.84%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2024-09-23",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.35%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.61%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "8",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "丰饶之神·哈索尔碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "月神·托特碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "15",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "20",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "25",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "30",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "35",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "45",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【寻味中秋】概率更新",
                date: "2024-09-16",
                show: false,
                description: "",
                outHeaders: ['奖池奖励'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "月球兔宝（永久）",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "月球兔宝碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "月球兔宝碎片",
                                "数量": "5",
                                "概率": "3.21%"
                            },
                            {
                                "道具": "月球兔宝碎片",
                                "数量": "1",
                                "概率": "4.01%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "50",
                                "概率": "0.60%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "30",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "20",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "10",
                                "概率": "0.30%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "7",
                                "概率": "14.03%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "5",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "3",
                                "概率": "4.01%"
                            },
                            {
                                "道具": "团圆月饼",
                                "数量": "1",
                                "概率": "24.05%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "100",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "100",
                                "概率": "5.01%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "100",
                                "概率": "16.03%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "1",
                                "概率": "6.01%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "1.50%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "4.01%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "6.01%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "2",
                                "概率": "4.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙突破】概率更新",
                date: "2024-09-14",
                show: false,
                description: "",
                outHeaders: ['转盘奖励', '始祖龙鳞奖池', '双头龙鳞奖池', '剑龙鳞奖池', '暴龙鳞奖池', '三角龙鳞奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "5",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "5",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "7",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "10",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "20",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "1",
                                "概率": "31.62%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "3",
                                "概率": "31.62%"
                            },
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "4",
                                "概率": "31.62%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "5",
                                "概率": "0.40%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "4",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "2",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "8",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "7",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "5",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "4",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "3",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "2",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "8",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "4",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "16",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "14",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "10",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "8",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "6",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "4",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "11",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 剑龙鳞",
                                "数量": "5",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "21",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "19",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "13",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "11",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "8",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 剑龙鳞",
                                "数量": "5",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "16",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "8",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "32",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "28",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "20",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "16",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "12",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "8",
                                "概率": "30.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "32",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "16",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "64",
                                "概率": "0.62%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "56",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "40",
                                "概率": "3.09%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "32",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "24",
                                "概率": "30.86%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "16",
                                "概率": "30.86%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【装备寻宝】获得道具概率公布",
                date: "2024-09-13",
                show: false,
                description: "",
                outHeaders: ['综合奖池', '矿粉奖池', '矿石奖池', '结晶奖池', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '大奖类别概率', '【高级大奖】奖池概率', '【特级大奖】奖池概率', '【至尊大奖】奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿粉",
                                "个数": "31250",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "21875",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "18750",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "3440",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2500",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2190",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "375",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "280",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "250",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "220",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿粉",
                                "个数": "31250",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "21875",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "18750",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "34375",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "25000",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "21875",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "37500",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "28125",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "25000",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "21875",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿石",
                                "个数": "3125",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2190",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "1875",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "3440",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2500",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2190",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "3750",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2815",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2500",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2190",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "个数": "310",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "220",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "190",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "345",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "250",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "220",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "375",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "280",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "250",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "220",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "0.80%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "稀有",
                                "概率": "0.10%"
                            },
                            {
                                "奖池类型": "普通",
                                "概率": "99.90%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类别",
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类别": "稀有",
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "100.00%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "1.10%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "310",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "250",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "190",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "125",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "3125",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "2500",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "1875",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "1250",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "31250",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "25000",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "18750",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "12500",
                                "概率": "13.74%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类别",
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类别": "稀有",
                                "道具": "5级装备",
                                "数量": "1",
                                "概率": "100.00%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "1.10%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "780",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "625",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "470",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "310",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "7810",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "6250",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "4690",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "3125",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "78125",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "62500",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "46875",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "31250",
                                "概率": "13.74%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类别",
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类别": "稀有",
                                "道具": "6级装备",
                                "数量": "1",
                                "概率": "100.00%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "1.10%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "1960",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "1560",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "1175",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "780",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "19530",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "15625",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "11720",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "7810",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "195310",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "156250",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "117190",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "78125",
                                "概率": "13.74%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】活动概率公布",
                date: "2024-09-11",
                show: false,
                description: "",
                outHeaders: ['普通奖池（普通时段）', '普通奖池（特殊时段）', '稀有奖池', '积分暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "40",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "10",
                                "概率": "13.40%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "5",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "50",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "100 血精石",
                                "个数": "2",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "个数": "1",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "龙鳞综合宝箱",
                                "个数": "3",
                                "概率": "13.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "20",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "银辉琥珀",
                                "个数": "5",
                                "概率": "13.40%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "5",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "50",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "100 血精石",
                                "个数": "2",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "个数": "1",
                                "概率": "13.00%"
                            },
                            {
                                "道具": "龙鳞综合宝箱",
                                "个数": "3",
                                "概率": "13.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燎原陨火（永久）",
                                "个数": "1",
                                "概率": "0.44%"
                            },
                            {
                                "道具": "传说五星自选 XXVIII",
                                "个数": "1",
                                "概率": "1.09%"
                            },
                            {
                                "道具": "遗迹宝藏据点外观自选Ⅰ",
                                "个数": "1",
                                "概率": "6.56%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "个数": "50",
                                "概率": "5.47%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "10",
                                "概率": "3.28%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "5",
                                "概率": "7.66%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "5",
                                "概率": "21.88%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "个数": "3",
                                "概率": "27.35%"
                            },
                            {
                                "道具": "外观金币",
                                "个数": "5",
                                "概率": "26.26%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "95.43%"
                            },
                            {
                                "倍数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "0.25%"
                            },
                            {
                                "倍数": "20",
                                "概率": "0.05%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂野狩猎】狩猎猛犸象概率公布",
                date: "2024-09-06",
                show: false,
                description: "",
                outHeaders: ['狂野模式狩猎奖池', '狂野模式灵魂宝箱奖池', '普通模式狩猎奖池', '普通模式灵魂宝箱奖池', '最后一击额外奖励（必得雷神祝福油）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·暗夜",
                                "数量": "11",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "11",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "2",
                                "概率": "40.21%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "2",
                                "概率": "40.21%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "5",
                                "概率": "2.01%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "5",
                                "概率": "2.01%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "11",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "11",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "2",
                                "概率": "6.70%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "2",
                                "概率": "6.70%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "5",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "5",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "天演全盛（Lv.1）自选宝箱",
                                "数量": "11",
                                "概率": "0.66%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·暗夜",
                                "数量": "11",
                                "概率": "42.64%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "11",
                                "概率": "42.64%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "11",
                                "概率": "6.94%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "11",
                                "概率": "6.94%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "22",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "33",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "33",
                                "概率": "0.07%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·暗夜",
                                "数量": "1",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "1",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "创生暗夜符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "40.21%"
                            },
                            {
                                "道具": "创生历史符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "40.21%"
                            },
                            {
                                "道具": "创生暗夜符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "2.01%"
                            },
                            {
                                "道具": "创生历史符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "2.01%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "1",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "1",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生真实符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "6.70%"
                            },
                            {
                                "道具": "创生未来符文-Lv. 1碎片",
                                "数量": "2",
                                "概率": "6.70%"
                            },
                            {
                                "道具": "创生真实符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "创生未来符文-Lv. 1碎片",
                                "数量": "5",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "天演全盛（Lv.1）自选宝箱",
                                "数量": "1",
                                "概率": "0.66%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·暗夜",
                                "数量": "1",
                                "概率": "42.64%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "1",
                                "概率": "42.64%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "1",
                                "概率": "6.94%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "1",
                                "概率": "6.94%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "2",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "创生·真实",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "创生·未来",
                                "数量": "3",
                                "概率": "0.07%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "创生·暗夜",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "创生·暗夜",
                                "数量": "1",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "创生·历史",
                                "数量": "1",
                                "概率": "25.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2024-09-02",
                show: false,
                description: "",
                outHeaders: ['月刃荒鹫伙伴池', '森之游侠伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "月刃荒鹫",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "森之游侠",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙复制】获得道具概率公布",
                date: "2024-08-27",
                show: false,
                description: "",
                outHeaders: ['三角龙奖池', '双头龙奖池', '额外奖励奖池', '暴龙奖池', '始祖龙奖池', '剑龙奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "三角龙碎片",
                                "数量": "7",
                                "概率": "67.86%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "14",
                                "概率": "22.62%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "21",
                                "概率": "9.05%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "36",
                                "概率": "0.45%"
                            },
                            {
                                "道具": "三角龙",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "3",
                                "概率": "56.62%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "7",
                                "概率": "31.85%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "11",
                                "概率": "10.62%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "16",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.04%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "4",
                                "概率": "6.23%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "8",
                                "概率": "12.46%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "30",
                                "概率": "9.35%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "4",
                                "概率": "24.92%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "20",
                                "概率": "12.46%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "34.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "暴龙碎片",
                                "数量": "4",
                                "概率": "46.84%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "10",
                                "概率": "42.31%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "16",
                                "概率": "9.07%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "24",
                                "概率": "1.75%"
                            },
                            {
                                "道具": "暴龙",
                                "数量": "1",
                                "概率": "0.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "2",
                                "概率": "70.78%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "4",
                                "概率": "23.59%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "7",
                                "概率": "5.50%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "12",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.01%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "剑龙碎片",
                                "数量": "3",
                                "概率": "54.68%"
                            },
                            {
                                "道具": "剑龙碎片",
                                "数量": "5",
                                "概率": "30.76%"
                            },
                            {
                                "道具": "剑龙碎片",
                                "数量": "10",
                                "概率": "13.67%"
                            },
                            {
                                "道具": "剑龙碎片",
                                "数量": "15",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "剑龙",
                                "数量": "1",
                                "概率": "0.03%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】活动概率公布",
                date: "2024-08-27",
                show: false,
                description: "",
                outHeaders: ['混合奖池', '粉尘奖池', '碎片奖池', '结晶奖池', '混合大奖奖池', '粉尘大奖奖池', '碎片大奖奖池', '结晶大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "420",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "70000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "80000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "95000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "520",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4400",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "100000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "65000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "85000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "75000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "90000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "120000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "130000",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4200",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2600",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3400",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3800",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "5000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4600",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "420",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "260",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "340",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "300",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "380",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "500",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "460",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1520000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "92000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "25000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1520000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "2300000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "6300000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片",
                                "个数": "61500",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "92000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "245000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "个数": "6150",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "9200",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "25000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2024-08-20",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "2",
                                "概率": "78.08%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "4",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "6",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "8",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "10",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.56%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "15.61%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "星辰石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "星辰石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱VIII",
                                "数量": "2",
                                "概率": "73.49%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VIII",
                                "数量": "4",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "7.35%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "18.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "0.37%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "40",
                                "概率": "4.22%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "80",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "150",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VIII",
                                "数量": "20",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VIII",
                                "数量": "40",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VIII",
                                "数量": "100",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "5",
                                "概率": "10.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2024-08-20",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银宝箱 - 宝物', '白银宝箱-资源 II', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金宝箱 - 宝物', '黄金宝箱-资源 II'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XV",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "3500",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "6000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "6000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "3500",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XV",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "350",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "600",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "600",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "350",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XV",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "35",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "60",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "60",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "35",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选XV",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "21.96%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "19.77%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5",
                                "概率": "21.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "16.47%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3",
                                "概率": "19.77%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.001%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "迷雾护腕（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾结晶（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾戒指（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾项链（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "3.23%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "120",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "240",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "24.19%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "4.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XⅥ",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "45000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "65000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "20000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "20000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "65000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "45000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXVIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XⅥ",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6500",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6500",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXVIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XⅥ",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "450",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "650",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "200",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "200",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "650",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "450",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXVIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选XⅥ",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "传说五星自选 XXVIII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "迷雾护腕（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾结晶6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾戒指6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾项链6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "800",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "1600",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【月刃荒鹫降临】获得伙伴概率公布",
                date: "2024-08-06",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "月刃荒鹫",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "月刃荒鹫",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【夏日音乐节】概率公布",
                date: "2024-07-31",
                show: false,
                description: "",
                outHeaders: ['音乐节参与奖励概率', '音乐节大奖奖励概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "音乐节大奖奖励",
                                "数量": "1",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "柯吉（永久）",
                                "数量": "1",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "周年战斗增益自选宝箱",
                                "数量": "1",
                                "概率": "0.180%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "150",
                                "概率": "3.680%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "150",
                                "概率": "7.360%"
                            },
                            {
                                "道具": "碎岩炉火",
                                "数量": "150",
                                "概率": "7.360%"
                            },
                            {
                                "道具": "炽夏酷饮",
                                "数量": "5",
                                "概率": "36.810%"
                            },
                            {
                                "道具": "炽夏酷饮",
                                "数量": "8",
                                "概率": "18.400%"
                            },
                            {
                                "道具": "炽夏酷饮",
                                "数量": "10",
                                "概率": "3.680%"
                            },
                            {
                                "道具": "炽夏酷饮",
                                "数量": "20",
                                "概率": "0.370%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.840%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "1.840%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "9.200%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "9.200%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类型",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类型": "超级大奖",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "大奖类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "大奖类型": "一等奖",
                                "数量": "1",
                                "概率": "0.301%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "大奖类型": "二等奖",
                                "数量": "1",
                                "概率": "3.012%"
                            },
                            {
                                "大奖类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "大奖类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            },
                            {
                                "大奖类型": "三等奖",
                                "数量": "1",
                                "概率": "30.120%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】概率公布",
                date: "2024-07-28",
                show: false,
                description: "",
                outHeaders: ['混合奖池', '粉尘奖池', '碎片奖池', '结晶奖池', '混合大奖奖池', '粉尘大奖奖池', '碎片大奖奖池', '结晶大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "420",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "70000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "80000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "95000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "520",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4400",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "100000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "65000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "85000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "75000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "90000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "120000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "130000",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4200",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2600",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3400",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3800",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "5000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4600",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "420",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "260",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "340",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "300",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "380",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "500",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "460",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1520000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "92000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "25000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1520000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "2300000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "6300000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片",
                                "个数": "61500",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "92000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "245000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "个数": "6150",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "9200",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "25000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2024-07-22",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.35%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.61%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.20%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "5",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.10%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.02%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "8",
                                "概率": "4.41%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "天空之神·努特碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "月神·托特碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "月神·托特碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "9",
                                "概率": "97.00%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "12",
                                "概率": "2.25%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "15",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "18",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "22",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "27",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "15",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "20",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "25",
                                "概率": "7.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "30",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "35",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱IV",
                                "数量": "45",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【白金祝福季】获得道具概率公布",
                date: "2024-07-15",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黑曜翡翠",
                                "数量": "5",
                                "概率": "62.460%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "8",
                                "概率": "20.820%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "12",
                                "概率": "10.410%"
                            },
                            {
                                "道具": "黑曜翡翠",
                                "数量": "20",
                                "概率": "2.776%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "8",
                                "概率": "3.470%"
                            },
                            {
                                "道具": "太古黑曜水晶",
                                "数量": "10",
                                "概率": "0.056%"
                            },
                            {
                                "道具": "神弓巫女（自选）",
                                "数量": "1",
                                "概率": "0.007%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2024-06-29",
                show: false,
                description: "",
                outHeaders: ['审判骑士伙伴池', '亡灵公主伙伴池', '深海恐兽伙伴池', '魅影刺客伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【审判骑士】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【亡灵公主】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【深海恐兽】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【魅影刺客】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2024-06-28",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "2",
                                "概率": "78.08%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "4",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "6",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "8",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "10",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "1.56%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "15.61%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "莎草纸卷轴-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "1",
                                "概率": "82.16%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "3",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "5",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "10",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "16.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱VII",
                                "数量": "2",
                                "概率": "73.49%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VII",
                                "数量": "4",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "1",
                                "概率": "7.35%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "2",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "18.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "0.37%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "苏生结晶",
                                "数量": "40",
                                "概率": "4.22%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "80",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "苏生结晶",
                                "数量": "150",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VII",
                                "数量": "20",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VII",
                                "数量": "40",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VII",
                                "数量": "100",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "5",
                                "概率": "10.55%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-秩序铭文宝箱",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "42.24%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祖先庇佑】道具概率公布",
                date: "2024-06-28",
                show: false,
                description: "",
                outHeaders: ['触发庇佑模式概率', '古老贝壳奖池', '发光贝壳奖池', '庇佑模式：龙印奖池', '庇佑模式：远古宝物奖池', '庇佑模式：装备', '庇佑模式：龙奖池', '庇佑模式：血精石奖池', '庇佑模式：龟奖池', '庇佑模式：神器&技能鲶鱼奖池', '庇佑模式：战纹奖池', '庇佑模式：BUFF奖池', '庇佑模式：宝石奖池', '庇佑模式：魔骨奖池', '庇佑模式：荣耀&魔法奖池', '庇佑模式：龙结晶'],
                tables: [
                    {
                        "subHeaders": [
                            "行为",
                            "概率"
                        ],
                        "data": [
                            {
                                "行为": "古老贝壳祈祷",
                                "概率": "3.33%"
                            },
                            {
                                "行为": "发光贝壳祈祷",
                                "概率": "20.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "发光贝壳",
                                "数量": "1",
                                "概率": "3.38%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "5.41%"
                            },
                            {
                                "道具": "蓝色祭司碎片",
                                "数量": "2",
                                "概率": "10.14%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "12",
                                "概率": "8.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "21.62%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "1",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "1",
                                "概率": "13.51%"
                            },
                            {
                                "道具": "500,000 象牙",
                                "数量": "1",
                                "概率": "12.16%"
                            },
                            {
                                "道具": "500,000 石头",
                                "数量": "1",
                                "概率": "12.16%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "2.30%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "24.14%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "10",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "8",
                                "概率": "5.75%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "4",
                                "概率": "8.62%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "17.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "6700",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "3000",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "18750",
                                "概率": "5.94%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "11250",
                                "概率": "21.78%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "4500",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "3000",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "2250",
                                "概率": "19.80%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "1500",
                                "概率": "29.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "20000",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "4000",
                                "概率": "19.54%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "40000",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "16600",
                                "概率": "32.57%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "4600",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "3200",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "2600",
                                "概率": "6.51%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "1600",
                                "概率": "32.57%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "数量": "4400",
                                "概率": "0.71%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "1440",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "14400",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "7200",
                                "概率": "35.71%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "2800",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "1800",
                                "概率": "3.57%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "1200",
                                "概率": "7.14%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "800",
                                "概率": "35.71%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "6",
                                "概率": "9.52%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "31.72%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "14",
                                "概率": "1.59%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "7",
                                "概率": "17.44%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "1",
                                "概率": "39.65%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100 血精石",
                                "数量": "30",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "15",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "75",
                                "概率": "4.95%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "38",
                                "概率": "9.89%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "282",
                                "概率": "14.84%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "225",
                                "概率": "19.78%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "187",
                                "概率": "49.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "5",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "3",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "31.19%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "10",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "5",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "2",
                                "概率": "31.19%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "高级神器自选宝箱XV",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "16",
                                "概率": "1.45%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "8",
                                "概率": "4.34%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "2",
                                "概率": "43.35%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "7.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "43.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "5",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "3.22%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "4",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "26.80%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "20",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "12",
                                "概率": "16.08%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "8",
                                "概率": "21.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "15%攻击削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%防御削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%生命削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%行军兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "集结兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%攻击加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%防御加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%生命加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "25%行军兵量增加",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天攻击加成",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天防御加成",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天和平守护",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "行军队列",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天反侦查",
                                "数量": "1",
                                "概率": "4.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100宝石",
                                "数量": "100",
                                "概率": "1.28%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "50",
                                "概率": "2.56%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "30",
                                "概率": "6.41%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "20",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "15",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "51.28%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔骨能耗减少",
                                "数量": "1",
                                "概率": "0.38%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "10",
                                "概率": "0.76%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "5",
                                "概率": "3.80%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "2",
                                "概率": "19.01%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "8",
                                "概率": "30.42%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "6",
                                "概率": "45.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀旗帜",
                                "数量": "980",
                                "概率": "1.77%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "420",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "350",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "280",
                                "概率": "26.55%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "980",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "420",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "350",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "280",
                                "概率": "26.55%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "16",
                                "概率": "0.17%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "8",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "16",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "8",
                                "概率": "3.48%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "6",
                                "概率": "6.96%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "17.39%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "2",
                                "概率": "69.57%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【玲珑秘骰】活动概率公布",
                date: "2024-06-24",
                show: false,
                description: "",
                outHeaders: ['印记初级奖池', '印记中级奖池', '印记高级奖池', '印记特级奖池', '印记至尊奖池', '兵装初级奖池', '兵装中级奖池', '兵装高级奖池', '兵装特级奖池', '兵装至尊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "110",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "95",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "35",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "25",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "130",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "120",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "70",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "50",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "185",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "170",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "110",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "70",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "310",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "280",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "145",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "95",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "960",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "840",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "720",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "600",
                                "概率": "65.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "110",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "95",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "35",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "25",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "130",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "120",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "70",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "50",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "185",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "170",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "110",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "70",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "310",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "280",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "145",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "95",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "960",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "840",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "720",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "600",
                                "概率": "65.22%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】活动概率公布",
                date: "2024-06-14",
                show: false,
                description: "",
                outHeaders: ['混合奖池', '粉尘奖池', '碎片奖池', '结晶奖池', '混合大奖奖池', '粉尘大奖奖池', '碎片大奖奖池', '结晶大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "350",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "55000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "65000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2400",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "75000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "360",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3600",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "80000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "50000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "65000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "60000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "75000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "100000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "90000",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3200",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2600",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2400",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3600",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "320",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "200",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "260",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "240",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "300",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "400",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "360",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1250000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "75000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "20000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1250000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1875000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "5000000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片",
                                "个数": "50000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "75000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "200000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "个数": "5000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "7500",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "20000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【天陨秘宝】概率公布",
                date: "2024-06-13",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '秘宝奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "15",
                                "概率": "18.15%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "40",
                                "概率": "9.90%"
                            },
                            {
                                "道具名称": "2X",
                                "数量": "2",
                                "概率": "9.90%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "30",
                                "概率": "18.15%"
                            },
                            {
                                "道具名称": "3X",
                                "数量": "3",
                                "概率": "6.60%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "15",
                                "概率": "18.15%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "30",
                                "概率": "18.15%"
                            },
                            {
                                "道具名称": "4X",
                                "数量": "4",
                                "概率": "0.99%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "50",
                                "概率": "23.38%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "50",
                                "概率": "23.38%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "50",
                                "概率": "23.38%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "100",
                                "概率": "10.79%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "100",
                                "概率": "10.79%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "150",
                                "概率": "3.60%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "150",
                                "概率": "3.60%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "250",
                                "概率": "1.08%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【苍龙灵域】概率更新",
                date: "2024-06-10",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '转盘奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "转盘奖池",
                                "个数": "-",
                                "概率": "2.26%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "20",
                                "概率": "0.28%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "15",
                                "概率": "1.41%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "10",
                                "概率": "2.82%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "5",
                                "概率": "4.23%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "4",
                                "概率": "5.64%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "3",
                                "概率": "11.28%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "2",
                                "概率": "14.10%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "1",
                                "概率": "15.51%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "10",
                                "概率": "8.46%"
                            },
                            {
                                "道具": "100 血精石",
                                "个数": "1",
                                "概率": "5.64%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "3",
                                "概率": "1.13%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "5",
                                "概率": "9.87%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "3",
                                "概率": "8.46%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "1",
                                "概率": "2.82%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "时光宝箱",
                                "个数": "5",
                                "概率": "5.64%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "星宿苍龙",
                                "个数": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "灵玉苍珠",
                                "个数": "200",
                                "概率": "0.41%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "个数": "400",
                                "概率": "16.52%"
                            },
                            {
                                "道具": "碎岩炉火",
                                "个数": "800",
                                "概率": "16.52%"
                            },
                            {
                                "道具": "印记碎岩",
                                "个数": "400",
                                "概率": "16.52%"
                            },
                            {
                                "道具": "印记炉火",
                                "个数": "800",
                                "概率": "16.52%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "个数": "400",
                                "概率": "16.52%"
                            },
                            {
                                "道具": "兵装炉火",
                                "个数": "800",
                                "概率": "16.52%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "40",
                                "概率": "0.41%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2024-06-07",
                show: false,
                description: "",
                outHeaders: ['森之游侠伙伴池', '审判骑士伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "森之游侠",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "审判骑士",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【装备寻宝】获得道具概率公布",
                date: "2024-06-04",
                show: false,
                description: "",
                outHeaders: ['综合奖池', '矿粉奖池', '矿石奖池', '结晶奖池', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '大奖类别概率', '【高级大奖】奖池概率', '【特级大奖】奖池概率', '【至尊大奖】奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿粉",
                                "个数": "25000",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "17500",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "15000",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2750",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2000",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "1750",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "300",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "225",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "200",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "175",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿粉",
                                "个数": "25000",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "17500",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "15000",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "27500",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "20000",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "17500",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "30000",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "22500",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "20000",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿粉",
                                "个数": "17500",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿石",
                                "个数": "2500",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "1750",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "1500",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2750",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2000",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "1750",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "3000",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2250",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "2000",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石矿石",
                                "个数": "1750",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "个数": "250",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "175",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "150",
                                "概率": "19.27%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "275",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "200",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "175",
                                "概率": "15.41%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "300",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "225",
                                "概率": "9.63%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "200",
                                "概率": "11.56%"
                            },
                            {
                                "道具": "青石结晶",
                                "个数": "175",
                                "概率": "15.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "0.80%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "稀有",
                                "概率": "0.10%"
                            },
                            {
                                "奖池类型": "普通",
                                "概率": "99.90%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类别",
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类别": "稀有",
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "100.00%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "1.10%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "250",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "200",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "150",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "100",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "2500",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "2000",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "25000",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "20000",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "15000",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "10000",
                                "概率": "13.74%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类别",
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类别": "稀有",
                                "道具": "5级装备",
                                "数量": "1",
                                "概率": "100.00%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "1.10%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "500",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "400",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "300",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "200",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "5000",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "4000",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "3000",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "2000",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "50000",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "40000",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "30000",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "20000",
                                "概率": "13.74%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "大奖类别",
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "大奖类别": "稀有",
                                "道具": "6级装备",
                                "数量": "1",
                                "概率": "100.00%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "1.10%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "1000",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "800",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "600",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石结晶",
                                "数量": "400",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "10000",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "8000",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "6000",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿石",
                                "数量": "4000",
                                "概率": "13.74%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "100000",
                                "概率": "2.75%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "80000",
                                "概率": "5.49%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "60000",
                                "概率": "10.99%"
                            },
                            {
                                "大奖类别": "普通",
                                "道具": "青石矿粉",
                                "数量": "40000",
                                "概率": "13.74%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2024-06-03",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银宝箱 - 宝物', '白银宝箱-资源 II', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金宝箱 - 宝物', '黄金宝箱-资源 II'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选X",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "3500",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "6000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "6000",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "3500",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选X",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "350",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "600",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "600",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "350",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选X",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "35",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "60",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "12.74%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "60",
                                "概率": "15.93%"
                            },
                            {
                                "道具": "白银宝箱-宝物",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "35",
                                "概率": "21.24%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "0.11%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "至尊据点外观自选X",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "21.96%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "19.77%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5",
                                "概率": "21.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "16.47%"
                            },
                            {
                                "道具": "白银宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3",
                                "概率": "19.77%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.001%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "1200",
                                "概率": "18.87%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "2400",
                                "概率": "9.43%"
                            },
                            {
                                "道具": "迷雾护腕（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾结晶（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾戒指（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            },
                            {
                                "道具": "迷雾项链（橙）",
                                "数量": "1",
                                "概率": "3.77%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "3.23%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "120",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "240",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "16.13%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "24.19%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "4.84%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "4.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIV",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "45000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "65000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "20000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "20000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "65000",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "45000",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXVII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIV",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6500",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2000",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6500",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4500",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXVII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIV",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "450",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "650",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "200",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "200",
                                "概率": "19.96%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "650",
                                "概率": "16.64%"
                            },
                            {
                                "道具": "黄金宝箱-宝物",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "450",
                                "概率": "13.31%"
                            },
                            {
                                "道具": "传说五星自选 XXVII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选XIV",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.96%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.16%"
                            },
                            {
                                "道具": "黄金宝箱-资源 II",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.80%"
                            },
                            {
                                "道具": "传说五星自选 XXVII",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "1000 魔法粉尘",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "100 魔法碎片",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "1200",
                                "概率": "18.870%"
                            },
                            {
                                "道具": "10 魔法结晶",
                                "数量": "2400",
                                "概率": "9.430%"
                            },
                            {
                                "道具": "迷雾护腕（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾结晶6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾戒指6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            },
                            {
                                "道具": "迷雾项链6（紫）",
                                "数量": "1",
                                "概率": "3.770%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "800",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "1600",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【玲珑秘骰】获得道具概率公布",
                date: "2024-05-31",
                show: false,
                description: "",
                outHeaders: ['印记初级奖池', '印记中级奖池', '印记高级奖池', '印记特级奖池', '印记至尊奖池', '兵装初级奖池', '兵装中级奖池', '兵装高级奖池', '兵装特级奖池', '兵装至尊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "90",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "80",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "30",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "20",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "110",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "100",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "60",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "40",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "155",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "140",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "90",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "60",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "255",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "230",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "120",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "80",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "800",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "700",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "600",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "500",
                                "概率": "65.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "90",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "80",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "30",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "20",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "110",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "100",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "60",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "40",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "155",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "140",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "90",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "60",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "255",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "230",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "120",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "兵装炉火",
                                "数量": "80",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵装碎岩",
                                "数量": "800",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "700",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "600",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "兵装碎岩",
                                "数量": "500",
                                "概率": "65.22%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】活动概率公布",
                date: "2024-05-25",
                show: false,
                description: "",
                outHeaders: ['混合奖池', '粉尘奖池', '碎片奖池', '结晶奖池', '混合大奖奖池', '粉尘大奖奖池', '碎片大奖奖池', '结晶大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "350",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "55000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "65000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2400",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "75000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "360",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3600",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "80000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "50000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "65000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "60000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "75000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "100000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "90000",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3200",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2000",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2600",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "2400",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "4000",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "3600",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "初级六星龙印随机箱",
                                "个数": "1",
                                "概率": "6.33%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "320",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "200",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "中级六星龙印随机箱",
                                "个数": "1",
                                "概率": "4.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "260",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "240",
                                "概率": "7.91%"
                            },
                            {
                                "道具": "高级六星龙印随机箱",
                                "个数": "1",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "300",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "400",
                                "概率": "15.82%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "360",
                                "概率": "15.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1250000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "75000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "20000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1250000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "1875000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "个数": "5000000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片",
                                "个数": "50000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "75000",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "个数": "200000",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "个数": "5000",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "7500",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "个数": "20000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】活动概率公布",
                date: "2024-05-22",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '稀有奖池', '积分暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.68%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.41%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "5",
                                "概率": "9.75%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "30",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "10",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "个数": "2",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "170",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "个数": "1",
                                "概率": "11.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "时空梦魇（永久）",
                                "个数": "1",
                                "概率": "0.44%"
                            },
                            {
                                "道具": "传说五星自选 XXVI",
                                "个数": "1",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "不朽的据点外观自选V",
                                "个数": "1",
                                "概率": "6.64%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "10",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "个数": "1",
                                "概率": "5.53%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "5",
                                "概率": "7.74%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "5",
                                "概率": "19.36%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "200",
                                "概率": "27.65%"
                            },
                            {
                                "道具": "10 血精石",
                                "个数": "120",
                                "概率": "27.65%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "95.43%"
                            },
                            {
                                "倍数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "0.25%"
                            },
                            {
                                "倍数": "20",
                                "概率": "0.05%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幸运魔法】活动概率公布",
                date: "2024-05-21",
                show: false,
                description: "",
                outHeaders: ['奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "技能鲶鱼",
                                "个数": "1",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "酋长希拉战纹宝箱",
                                "个数": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "酋长猫战纹宝箱",
                                "个数": "2",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "2",
                                "概率": "6.25%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "6.25%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "个数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "个数": "1",
                                "概率": "3.52%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "个数": "4",
                                "概率": "9.25%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "个数": "3",
                                "概率": "5.58%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "个数": "1",
                                "概率": "4.82%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "3",
                                "概率": "4.98%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "个数": "1",
                                "概率": "1.72%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "个数": "18",
                                "概率": "4.72%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "个数": "1",
                                "概率": "1.70%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "个数": "60",
                                "概率": "1.70%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "个数": "5",
                                "概率": "6.25%"
                            },
                            {
                                "道具": "外观金币",
                                "个数": "2",
                                "概率": "6.25%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "个数": "1",
                                "概率": "2.62%"
                            },
                            {
                                "道具": "高级伙伴结晶",
                                "个数": "10",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "250",
                                "概率": "6.69%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "100",
                                "概率": "4.98%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "个数": "2",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "个数": "2",
                                "概率": "2.86%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "个数": "25",
                                "概率": "2.86%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "20",
                                "概率": "2.28%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "5",
                                "概率": "3.28%"
                            },
                            {
                                "道具": "3倍奖励",
                                "个数": "1",
                                "概率": "3.49%"
                            },
                            {
                                "道具": "5倍奖励",
                                "个数": "1",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "自选大奖",
                                "个数": "1",
                                "概率": "0.31%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【森之游侠降临】获得伙伴概率公布",
                date: "2024-05-07",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "森之游侠",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "森之游侠",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器返场】道具概率公布",
                date: "2024-05-04",
                show: false,
                description: "",
                outHeaders: ['各类型道具出现的概率'],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "普通奖励",
                                "概率": "88.50%"
                            },
                            {
                                "奖励": "高级奖励",
                                "概率": "10.62%"
                            },
                            {
                                "奖励": "珍稀奖励",
                                "概率": "0.88%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【玲珑秘骰】获得道具概率公布",
                date: "2024-04-22",
                show: false,
                description: "",
                outHeaders: ['奖池类型', '初级奖池', '中级奖池', '高级奖池', '特级奖池', '至尊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "初级奖池",
                                "概率": "23.40%"
                            },
                            {
                                "奖池": "中级奖池",
                                "概率": "43.80%"
                            },
                            {
                                "奖池": "高级奖池",
                                "概率": "23.40%"
                            },
                            {
                                "奖池": "特级奖池",
                                "概率": "7.80%"
                            },
                            {
                                "奖池": "至尊奖池",
                                "概率": "1.60%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "90",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "80",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "30",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "20",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "110",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "100",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "60",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "40",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "155",
                                "概率": "23.53%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "140",
                                "概率": "35.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "90",
                                "概率": "14.71%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "60",
                                "概率": "26.47%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "255",
                                "概率": "21.43%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "230",
                                "概率": "39.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "120",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "印记炉火",
                                "数量": "80",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "印记碎岩",
                                "数量": "800",
                                "概率": "2.17%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "700",
                                "概率": "10.87%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "600",
                                "概率": "21.74%"
                            },
                            {
                                "道具": "印记碎岩",
                                "数量": "500",
                                "概率": "65.22%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2024-04-18",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火结晶",
                                "数量": "2",
                                "概率": "69.10%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "4",
                                "概率": "6.91%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "6",
                                "概率": "1.38%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "8",
                                "概率": "0.35%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "10",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "15",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "1.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.91%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "13.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "2",
                                "概率": "3.65%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "女娲补天石-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "14.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "2",
                                "概率": "3.65%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "14.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "2",
                                "概率": "3.65%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "数量": "4",
                                "概率": "14.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱VI",
                                "数量": "3",
                                "概率": "42.74%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VI",
                                "数量": "6",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "8.55%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "2",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "42.74%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "4.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火结晶",
                                "数量": "40",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "80",
                                "概率": "0.75%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "150",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VI",
                                "数量": "20",
                                "概率": "37.48%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VI",
                                "数量": "40",
                                "概率": "0.75%"
                            },
                            {
                                "道具": "祭司法器自选宝箱VI",
                                "数量": "100",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "5",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "10",
                                "概率": "0.75%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "37.48%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.07%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙祈愿】获得道具概率公布",
                date: "2024-04-12",
                show: false,
                description: "",
                outHeaders: ['始祖龙普通奖池概率公布', '双头龙普通奖池概率公布', '暴龙普通奖池概率公布', '血精石普通奖池概率公布', '龙结晶普通奖池概率公布', '龙秘果普通奖池概率公布', '珍稀转盘奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "7",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "5",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "3",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "2",
                                "概率": "48.64%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "48.64%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "10",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "7",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "4",
                                "概率": "2.24%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "3",
                                "概率": "43.77%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "2",
                                "概率": "43.77%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "暴龙碎片",
                                "数量": "30",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "21",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "15",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "9",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "6",
                                "概率": "48.64%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "3",
                                "概率": "48.64%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 血精石",
                                "数量": "88",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "60",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "45",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "24",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "17",
                                "概率": "45.72%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "10",
                                "概率": "45.72%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "15",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "10",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "30",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "15",
                                "概率": "1.46%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "12",
                                "概率": "46.69%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "7",
                                "概率": "46.69%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙秘果",
                                "数量": "1500",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "1000",
                                "概率": "0.19%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "750",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "375",
                                "概率": "1.46%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "300",
                                "概率": "46.69%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "175",
                                "概率": "46.69%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "转盘奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "转盘奖励": "超级大奖",
                                "概率": "2.00%"
                            },
                            {
                                "转盘奖励": "次级大奖",
                                "概率": "5.00%"
                            },
                            {
                                "转盘奖励": "三级大奖",
                                "概率": "93.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2024-04-09",
                show: false,
                description: "",
                outHeaders: ['嗜血猎手伙伴池', '龙吟征战者伙伴池', '精灵王子伙伴池', '援琴女神伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【嗜血猎手】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【龙吟征战者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【精灵王子】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【援琴女神】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【寻宝之路】获得道具概率公布",
                date: "2024-04-08",
                show: false,
                description: "",
                outHeaders: ['宝箱类型', '华丽的宝箱奖池', '珍贵的宝箱奖池', '精致的宝箱奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "华丽的宝箱",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "珍贵的宝箱",
                                "数量": "1",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "精致的宝箱",
                                "数量": "1",
                                "概率": "60.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "沙漠风情",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "80",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "64",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "52",
                                "概率": "3.14%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "48",
                                "概率": "10.10%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "40",
                                "概率": "64.50%"
                            },
                            {
                                "道具": "庆典战斗增益宝箱",
                                "数量": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "庆典巨龙材料宝箱",
                                "数量": "3",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "庆典伙伴材料宝箱",
                                "数量": "3",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "鹰击长空（友谊）",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "40",
                                "概率": "0.29%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "32",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "28",
                                "概率": "4.50%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "24",
                                "概率": "10.70%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "20",
                                "概率": "53.50%"
                            },
                            {
                                "道具": "庆典巨龙材料宝箱",
                                "数量": "2",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "庆典伙伴材料宝箱",
                                "数量": "2",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "3",
                                "概率": "2.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "弯月圣物",
                                "数量": "20",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "16",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "14",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "12",
                                "概率": "11.10%"
                            },
                            {
                                "道具": "弯月圣物",
                                "数量": "10",
                                "概率": "75.50%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "100",
                                "概率": "2.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【许愿时刻】道具概率公布",
                date: "2024-04-04",
                show: false,
                description: "",
                outHeaders: ['各类型道具出现的概率'],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "普通奖励",
                                "概率": "76.10%"
                            },
                            {
                                "奖励": "高级奖励",
                                "概率": "22.83%"
                            },
                            {
                                "奖励": "珍稀奖励",
                                "概率": "1.07%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2024-04-01",
                show: false,
                description: "",
                outHeaders: ['白银转盘奖池A', '白银转盘奖池B', '白银转盘奖池C', '白银转盘奖池D', '白银宝箱 - 装备', '白银宝箱 - 资源', '黄金转盘奖池A', '黄金转盘奖池B', '黄金转盘奖池C', '黄金转盘奖池D', '黄金宝箱 - 装备', '黄金宝箱 - 资源'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "至尊据点外观自选IX",
                                "数量": "1",
                                "概率": "0.0021%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "800",
                                "概率": "21.2400%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "1600",
                                "概率": "15.9300%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "4000",
                                "概率": "12.7440%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "4000",
                                "概率": "12.7440%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "1600",
                                "概率": "15.9300%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "800",
                                "概率": "21.2400%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "10000",
                                "概率": "0.1062%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "至尊据点外观自选IX",
                                "数量": "1",
                                "概率": "0.0021%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "80",
                                "概率": "21.2400%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "160",
                                "概率": "15.9300%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "400",
                                "概率": "12.7440%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "400",
                                "概率": "12.7440%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "160",
                                "概率": "15.9300%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "80",
                                "概率": "21.2400%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "0.1062%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "至尊据点外观自选IX",
                                "数量": "1",
                                "概率": "0.0021%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "8",
                                "概率": "21.2400%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "16",
                                "概率": "15.9300%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "40",
                                "概率": "12.7440%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "40",
                                "概率": "12.7440%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "16",
                                "概率": "15.9300%"
                            },
                            {
                                "道具": "白银宝箱-装备",
                                "数量": "1",
                                "概率": "0.0159%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "8",
                                "概率": "21.2400%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "100",
                                "概率": "0.1062%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱-资源",
                                "数量": "1",
                                "概率": "0.0154%"
                            },
                            {
                                "道具": "至尊据点外观自选IX",
                                "数量": "1",
                                "概率": "0.0022%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.0110%"
                            },
                            {
                                "道具": "白银宝箱-资源",
                                "数量": "1",
                                "概率": "0.0154%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "21.9614%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "19.7652%"
                            },
                            {
                                "道具": "白银宝箱-资源",
                                "数量": "1",
                                "概率": "0.0154%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "5",
                                "概率": "21.9614%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "16.4710%"
                            },
                            {
                                "道具": "白银宝箱-资源",
                                "数量": "1",
                                "概率": "0.0154%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "3",
                                "概率": "19.7652%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0011%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "1200",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "2400",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "1200",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "2400",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "1200",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "2400",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "橙晶头盔（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            },
                            {
                                "道具": "橙晶项链（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            },
                            {
                                "道具": "橙晶胸甲（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            },
                            {
                                "道具": "橙晶臂铠（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            },
                            {
                                "道具": "橙晶腿甲（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            },
                            {
                                "道具": "橙晶战靴（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            },
                            {
                                "道具": "橙晶剑（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            },
                            {
                                "道具": "橙晶盾牌（橙）",
                                "数量": "1",
                                "概率": "3.13%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "40",
                                "概率": "11.76%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "80",
                                "概率": "8.82%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "120",
                                "概率": "11.76%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "240",
                                "概率": "11.76%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "200",
                                "概率": "11.76%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "40",
                                "概率": "8.82%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "8.82%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "40",
                                "概率": "8.82%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "30",
                                "概率": "8.82%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "30",
                                "概率": "8.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.027%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15000",
                                "概率": "13.309%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "12000",
                                "概率": "16.637%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "8000",
                                "概率": "19.964%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "8000",
                                "概率": "19.964%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "12000",
                                "概率": "16.637%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15000",
                                "概率": "13.309%"
                            },
                            {
                                "道具": "传说五星自选 XXVI",
                                "数量": "1",
                                "概率": "0.020%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.027%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "13.309%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1200",
                                "概率": "16.637%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "800",
                                "概率": "19.964%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "800",
                                "概率": "19.964%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1200",
                                "概率": "16.637%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "13.309%"
                            },
                            {
                                "道具": "传说五星自选 XXVI",
                                "数量": "1",
                                "概率": "0.020%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.027%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "150",
                                "概率": "13.309%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "120",
                                "概率": "16.637%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "80",
                                "概率": "19.964%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "80",
                                "概率": "19.964%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "120",
                                "概率": "16.637%"
                            },
                            {
                                "道具": "黄金宝箱-装备",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "150",
                                "概率": "13.309%"
                            },
                            {
                                "道具": "传说五星自选 XXVI",
                                "数量": "1",
                                "概率": "0.020%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱-资源",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "至尊据点外观自选XIII",
                                "数量": "1",
                                "概率": "0.025%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "18.955%"
                            },
                            {
                                "道具": "黄金宝箱-资源",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "15.164%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "15.796%"
                            },
                            {
                                "道具": "黄金宝箱-资源",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "12",
                                "概率": "18.955%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "15.164%"
                            },
                            {
                                "道具": "黄金宝箱-资源",
                                "数量": "1",
                                "概率": "0.032%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "6",
                                "概率": "15.796%"
                            },
                            {
                                "道具": "传说五星自选 XXVI",
                                "数量": "1",
                                "概率": "0.019%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "1200",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "1000 青石矿粉",
                                "数量": "2400",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "1200",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "100 青石矿石",
                                "数量": "2400",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "1200",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "10 青石结晶",
                                "数量": "2400",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "橙晶头盔6",
                                "数量": "1",
                                "概率": "3.130%"
                            },
                            {
                                "道具": "橙晶项链6",
                                "数量": "1",
                                "概率": "3.130%"
                            },
                            {
                                "道具": "橙晶胸甲6",
                                "数量": "1",
                                "概率": "3.130%"
                            },
                            {
                                "道具": "橙晶臂铠6",
                                "数量": "1",
                                "概率": "3.130%"
                            },
                            {
                                "道具": "橙晶腿甲6",
                                "数量": "1",
                                "概率": "3.130%"
                            },
                            {
                                "道具": "橙晶战靴6",
                                "数量": "1",
                                "概率": "3.130%"
                            },
                            {
                                "道具": "橙晶剑6",
                                "数量": "1",
                                "概率": "3.130%"
                            },
                            {
                                "道具": "橙晶盾牌6",
                                "数量": "1",
                                "概率": "3.130%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "12.500%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "800",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "数量": "1600",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.000%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "200",
                                "概率": "7.500%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "200",
                                "概率": "7.500%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2024-03-19",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.37%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "4",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "2",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "4.46%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "2.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "11.14%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "2.23%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "11.14%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "4.46%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "11.14%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "11.14%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "4.46%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.23%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "2.23%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "2.23%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "10",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "外观金币碎片",
                                "数量": "5",
                                "概率": "2.23%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "20",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "16",
                                "概率": "11.14%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "8",
                                "概率": "4.46%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "6",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "大地女神·女娲碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "冥司之神·酆都大帝碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "6",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "8",
                                "概率": "28.20%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "10",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "12",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "15",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "兵神·蚩尤碎片",
                                "数量": "18",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "20",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "25",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "30",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "40",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "50",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "60",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "40",
                                "概率": "50.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "45",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "50",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "60",
                                "概率": "1.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "70",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "75",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂欢返场】获得伙伴概率公布",
                date: "2024-03-09",
                show: false,
                description: "",
                outHeaders: ['审判骑士伙伴池', '嗜血猎手伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "审判骑士",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "嗜血猎手",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【宝物探秘】获得道具概率公布",
                date: "2024-03-06",
                show: false,
                description: "",
                outHeaders: ['普通奖池1', '普通奖池2', '普通奖池3', '普通奖池4', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '【高级大奖】奖池概率', '【特级大奖】奖池概率', '【至尊大奖】奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "1000",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "500",
                                "概率": "29.910%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "50000",
                                "概率": "4.990%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "10000",
                                "概率": "0.160%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "5000",
                                "概率": "4.990%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6000",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "100000",
                                "概率": "0.060%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "700",
                                "概率": "19.960%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "7000",
                                "概率": "19.960%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "70000",
                                "概率": "9.980%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法粉尘",
                                "数量": "80000",
                                "概率": "0.200%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "60000",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "40000",
                                "概率": "4.980%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "90000",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "50000",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "45000",
                                "概率": "4.980%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "100000",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "55000",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "70000",
                                "概率": "39.910%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "65000",
                                "概率": "19.960%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法碎片",
                                "数量": "8000",
                                "概率": "0.200%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6000",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4000",
                                "概率": "4.980%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "9000",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "5000",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4500",
                                "概率": "4.980%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "10000",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "5500",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "7000",
                                "概率": "39.910%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "6500",
                                "概率": "19.960%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "800",
                                "概率": "0.200%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "600",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "400",
                                "概率": "4.980%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "900",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "500",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "450",
                                "概率": "4.980%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1000",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "550",
                                "概率": "9.980%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "700",
                                "概率": "39.910%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "650",
                                "概率": "19.960%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.159%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.440%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.280%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "350",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3500",
                                "概率": "1.780%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "35000",
                                "概率": "7.110%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "300",
                                "概率": "0.360%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3000",
                                "概率": "17.730%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "30000",
                                "概率": "71.100%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.163%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.525%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.520%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "400",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4000",
                                "概率": "1.770%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "40000",
                                "概率": "7.080%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "350",
                                "概率": "0.350%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3500",
                                "概率": "17.710%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "35000",
                                "概率": "70.840%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "5级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.200%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.632%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.915%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "500",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "5000",
                                "概率": "1.760%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "50000",
                                "概率": "7.040%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "400",
                                "概率": "17.610%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4000",
                                "概率": "70.450%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "40000",
                                "概率": "0.350%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2024-03-04",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火结晶",
                                "数量": "2",
                                "概率": "69.10%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "4",
                                "概率": "6.91%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "6",
                                "概率": "1.38%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "8",
                                "概率": "0.35%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "10",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "15",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "1.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.91%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "13.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "2",
                                "概率": "3.66%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "酆都旒冕-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "14.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "2",
                                "概率": "3.66%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "14.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "2",
                                "概率": "3.66%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "14.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱V",
                                "数量": "3",
                                "概率": "42.74%"
                            },
                            {
                                "道具": "祭司法器自选宝箱V",
                                "数量": "6",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "8.55%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "2",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "42.74%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "4.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火结晶",
                                "数量": "40",
                                "概率": "16.24%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "80",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "150",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "祭司法器自选宝箱V",
                                "数量": "20",
                                "概率": "32.49%"
                            },
                            {
                                "道具": "祭司法器自选宝箱V",
                                "数量": "40",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "祭司法器自选宝箱V",
                                "数量": "100",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "5",
                                "概率": "16.24%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "10",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "20",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "32.49%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.06%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【青魂金影降临】获得道具概率公布",
                date: "2024-03-01",
                show: false,
                description: "",
                outHeaders: ['寻龙奖励概率', '稀有寻龙奖励概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有寻龙奖励",
                                "数量": "1",
                                "概率": "0.043%"
                            },
                            {
                                "道具": "紫晶远古龟",
                                "数量": "1",
                                "概率": "0.213%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "5",
                                "概率": "1.914%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "5",
                                "概率": "17.014%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "16",
                                "概率": "17.014%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "135",
                                "概率": "17.014%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "100",
                                "概率": "17.014%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "2",
                                "概率": "17.014%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "2",
                                "概率": "4.254%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "5",
                                "概率": "4.254%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "6",
                                "概率": "4.254%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青魂金影（友谊）",
                                "数量": "1",
                                "概率": "0.09%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "70",
                                "概率": "5.32%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "750",
                                "概率": "15.94%"
                            },
                            {
                                "道具": "惊喜战争宝箱",
                                "数量": "1",
                                "概率": "0.53%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "15.94%"
                            },
                            {
                                "道具": "100 始祖龙鳞",
                                "数量": "5",
                                "概率": "8.50%"
                            },
                            {
                                "道具": "传说五星自选 XXV",
                                "数量": "1",
                                "概率": "0.53%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "20",
                                "概率": "47.83%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "12500",
                                "概率": "5.32%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祖先庇佑】道具概率公布",
                date: "2024-02-29",
                show: false,
                description: "",
                outHeaders: ['触发庇佑模式概率', '古老贝壳奖池', '发光贝壳奖池', '庇佑模式：龙印奖池', '庇佑模式：远古宝物奖池', '庇佑模式：装备', '庇佑模式：龙奖池', '庇佑模式：血精石奖池', '庇佑模式：龟奖池', '庇佑模式：神器&技能鲶鱼奖池', '庇佑模式：战纹奖池', '庇佑模式：BUFF奖池', '庇佑模式：宝石奖池', '庇佑模式：魔骨奖池', '庇佑模式：荣耀&魔法奖池', '庇佑模式：龙结晶'],
                tables: [
                    {
                        "subHeaders": [
                            "行为",
                            "概率"
                        ],
                        "data": [
                            {
                                "行为": "古老贝壳祈祷",
                                "概率": "3.33%"
                            },
                            {
                                "行为": "发光贝壳祈祷",
                                "概率": "20.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "发光贝壳",
                                "数量": "1",
                                "概率": "3.38%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "5.41%"
                            },
                            {
                                "道具": "蓝色祭司碎片",
                                "数量": "2",
                                "概率": "10.14%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "12",
                                "概率": "8.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "21.62%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "1",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "1",
                                "概率": "13.51%"
                            },
                            {
                                "道具": "500,000 象牙",
                                "数量": "1",
                                "概率": "12.16%"
                            },
                            {
                                "道具": "500,000 石头",
                                "数量": "1",
                                "概率": "12.16%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "2.30%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "24.14%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "10",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "8",
                                "概率": "5.75%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "4",
                                "概率": "8.62%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "17.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "2700",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "1200",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "7500",
                                "概率": "5.94%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "4500",
                                "概率": "21.78%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "1800",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "1200",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "900",
                                "概率": "19.80%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "600",
                                "概率": "29.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "10000",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "2000",
                                "概率": "19.54%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "20000",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "8300",
                                "概率": "32.57%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "2300",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "1600",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "1300",
                                "概率": "6.51%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "800",
                                "概率": "32.57%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "数量": "2200",
                                "概率": "0.71%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "720",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "7200",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "3600",
                                "概率": "35.71%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "1400",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "900",
                                "概率": "3.57%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "600",
                                "概率": "7.14%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "400",
                                "概率": "35.71%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "6",
                                "概率": "9.52%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "31.72%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "14",
                                "概率": "1.59%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "7",
                                "概率": "17.44%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "1",
                                "概率": "39.65%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100 血精石",
                                "数量": "30",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "15",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "75",
                                "概率": "4.95%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "38",
                                "概率": "9.89%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "282",
                                "概率": "14.84%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "225",
                                "概率": "19.78%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "187",
                                "概率": "49.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "5",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "3",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "31.19%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "10",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "5",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "2",
                                "概率": "31.19%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "高级神器自选宝箱XV",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "16",
                                "概率": "1.45%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "8",
                                "概率": "4.34%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "2",
                                "概率": "43.35%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "7.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "43.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "5",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "3.22%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "4",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "26.80%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "20",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "12",
                                "概率": "16.08%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "8",
                                "概率": "21.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "15%攻击削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%防御削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%生命削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%行军兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "集结兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%攻击加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%防御加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%生命加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "25%行军兵量增加",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天攻击加成",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天防御加成",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天和平守护",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "行军队列",
                                "数量": "1",
                                "概率": "15.99%"
                            },
                            {
                                "道具": "1天反侦查",
                                "数量": "1",
                                "概率": "4.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100宝石",
                                "数量": "100",
                                "概率": "1.28%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "50",
                                "概率": "2.56%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "30",
                                "概率": "6.41%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "20",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "15",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "51.28%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔骨能耗减少",
                                "数量": "1",
                                "概率": "0.38%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "10",
                                "概率": "0.76%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "5",
                                "概率": "3.80%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "2",
                                "概率": "19.01%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "8",
                                "概率": "30.42%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "6",
                                "概率": "45.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀旗帜",
                                "数量": "980",
                                "概率": "1.77%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "420",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "350",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "280",
                                "概率": "26.55%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "980",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "420",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "350",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "280",
                                "概率": "26.55%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "16",
                                "概率": "0.17%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "8",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "16",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "8",
                                "概率": "3.48%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "6",
                                "概率": "6.96%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "17.39%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "2",
                                "概率": "69.57%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【审判骑士降临】获得伙伴概率公布",
                date: "2024-02-20",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "审判骑士",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "审判骑士",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】概率公布",
                date: "2024-02-19",
                show: false,
                description: "",
                outHeaders: ['结晶奖池', '法器奖池1', '法器奖池2', '法器奖池3', '法器神秘奖池', '大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火结晶",
                                "数量": "2",
                                "概率": "69.10%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "4",
                                "概率": "6.91%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "6",
                                "概率": "1.38%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "8",
                                "概率": "0.35%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "10",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "15",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "1.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.91%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "13.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "2",
                                "概率": "3.66%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "蚩尤战斧-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "14.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "2",
                                "概率": "3.66%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "轩辕神剑-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "14.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "嫦娥金绫-碎片",
                                "数量": "1",
                                "概率": "73.13%"
                            },
                            {
                                "道具": "嫦娥金绫-碎片",
                                "数量": "2",
                                "概率": "3.66%"
                            },
                            {
                                "道具": "嫦娥金绫-碎片",
                                "数量": "3",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "嫦娥金绫-碎片",
                                "数量": "5",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "嫦娥金绫-碎片",
                                "数量": "10",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.73%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.31%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "14.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "祭司法器自选宝箱IV",
                                "数量": "3",
                                "概率": "42.74%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IV",
                                "数量": "6",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "8.55%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "2",
                                "概率": "0.85%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "42.74%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "4.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火结晶",
                                "数量": "40",
                                "概率": "16.24%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "80",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "150",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IV",
                                "数量": "20",
                                "概率": "32.49%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IV",
                                "数量": "40",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "祭司法器自选宝箱IV",
                                "数量": "100",
                                "概率": "0.13%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "5",
                                "概率": "16.24%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "10",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "20",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "5",
                                "概率": "32.49%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "10",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "0.06%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】概率公布",
                date: "2024-02-13",
                show: false,
                description: "",
                outHeaders: ['龙印寻宝'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄粉尘",
                                "数量": "78125",
                                "概率": "27.15%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "50000",
                                "概率": "27.15%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "62500",
                                "概率": "27.15%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "75000",
                                "概率": "13.58%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "100000",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "3000",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "125000",
                                "概率": "0.68%"
                            },
                            {
                                "道具": "六星龙印随机宝箱",
                                "数量": "2",
                                "概率": "0.68%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "5000",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "500",
                                "概率": "0.08%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【浇灌玫瑰】概率公布",
                date: "2024-02-13",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '稀有奖池', '玫瑰翻牌概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魅力玫瑰",
                                "个数": "1",
                                "概率": "24.59%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "5",
                                "概率": "13.66%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "10",
                                "概率": "19.13%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "个数": "5",
                                "概率": "5.46%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "个数": "5",
                                "概率": "2.73%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "个数": "10",
                                "概率": "2.73%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "个数": "1",
                                "概率": "2.73%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "个数": "2",
                                "概率": "1.37%"
                            },
                            {
                                "道具": "太古龟碎片",
                                "个数": "5",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "20",
                                "概率": "12.30%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "个数": "5",
                                "概率": "0.82%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "个数": "1",
                                "概率": "13.66%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天陨碎岩",
                                "个数": "25",
                                "概率": "0.27100271"
                            },
                            {
                                "道具": "碎岩炉火",
                                "个数": "50",
                                "概率": "0.27100271"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "20",
                                "概率": "0.108401084"
                            },
                            {
                                "道具": "洗炼滴露",
                                "个数": "1",
                                "概率": "0.108401084"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "5",
                                "概率": "0.162601626"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "0.00406504065"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "3",
                                "概率": "0.006775067751"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "0.06775067751"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "数量": "一支玫瑰",
                                "概率": "41.95%"
                            },
                            {
                                "数量": "两支玫瑰",
                                "概率": "13.68%"
                            },
                            {
                                "数量": "三支玫瑰",
                                "概率": "1.49%"
                            },
                            {
                                "数量": "没有玫瑰",
                                "概率": "42.88%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【野蛮挑战宝箱】概率公布",
                date: "2024-02-12",
                show: false,
                description: "",
                outHeaders: ['普通奖励', '高级奖励', '超级大奖'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法粉尘",
                                "数量": "15000",
                                "概率": "12.12%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1500",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "12.12%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "11250",
                                "概率": "12.12%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1125",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "3.03%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "50",
                                "概率": "12.12%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "25",
                                "概率": "6.06%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "8",
                                "概率": "12.12%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "4",
                                "概率": "6.06%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "洗炼灵石",
                                "数量": "100",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "50",
                                "概率": "7.41%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "10",
                                "概率": "14.81%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "5",
                                "概率": "37.04%"
                            },
                            {
                                "道具": "迷雾护腕（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "迷雾结晶（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "迷雾戒指（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "迷雾项链（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "冰龙之首（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "冰龙之牙（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "冰龙之翼（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "冰龙之爪（绿）",
                                "数量": "1",
                                "概率": "3.70%"
                            },
                            {
                                "道具": "橙晶头盔（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "橙晶项链（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "橙晶胸甲（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "橙晶臂铠（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "橙晶腿甲（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "橙晶战靴（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "橙晶剑（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "橙晶盾牌（白）",
                                "数量": "1",
                                "概率": "0.93%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XXV",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "不朽的据点外观自选",
                                "数量": "1",
                                "概率": "4.59%"
                            },
                            {
                                "道具": "鸿蒙主宰者",
                                "数量": "1",
                                "概率": "0.46%"
                            },
                            {
                                "道具": "远古守护（永久）",
                                "数量": "1",
                                "概率": "0.92%"
                            },
                            {
                                "道具": "迷雾护腕（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "迷雾结晶（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "迷雾戒指（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "迷雾项链（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "冰龙之首（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "冰龙之牙（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "冰龙之翼（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "冰龙之爪（闪紫）",
                                "数量": "1",
                                "概率": "9.17%"
                            },
                            {
                                "道具": "橙晶头盔（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "橙晶项链（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "橙晶胸甲（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "橙晶臂铠（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "橙晶腿甲（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "橙晶战靴（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "橙晶剑（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            },
                            {
                                "道具": "橙晶盾牌（紫）",
                                "数量": "1",
                                "概率": "2.29%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【金龙献瑞】获得道具概率公布",
                date: "2024-02-09",
                show: false,
                description: "",
                outHeaders: ['金龙献瑞概率公布', '龙魂大奖概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "单组数量",
                            "组数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魂大奖",
                                "单组数量": "1",
                                "组数": "1",
                                "概率": "0.030%"
                            },
                            {
                                "道具": "琥珀神奇龟",
                                "单组数量": "1",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "单组数量": "100",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "单组数量": "11",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "单组数量": "5",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "远古蛮石",
                                "单组数量": "16",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "单组数量": "1",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "单组数量": "1",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "血精石",
                                "单组数量": "135",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "洗炼滴露精华",
                                "单组数量": "8",
                                "组数": "5",
                                "概率": "9.997%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "单组数量": "1",
                                "组数": "5",
                                "概率": "9.997%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "自选大奖",
                                "数量": "/",
                                "概率": "0.706%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "1000",
                                "概率": "19.86%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "70",
                                "概率": "19.86%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "85",
                                "概率": "19.86%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "数量": "300",
                                "概率": "19.86%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "35",
                                "概率": "19.86%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】活动概率公布",
                date: "2024-02-06",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '稀有奖池', '积分暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.68%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.41%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "5",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "150",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "5",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "20",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "个数": "1",
                                "概率": "9.75%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "烟雨青瓷（永久）",
                                "个数": "1",
                                "概率": "0.44%"
                            },
                            {
                                "道具": "传说五星自选 XXV",
                                "个数": "1",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "不朽的据点外观自选V",
                                "个数": "1",
                                "概率": "6.64%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "10",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "个数": "1",
                                "概率": "5.53%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "5",
                                "概率": "7.74%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "5",
                                "概率": "19.36%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "150",
                                "概率": "27.65%"
                            },
                            {
                                "道具": "10 血精石",
                                "个数": "110",
                                "概率": "27.65%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "95.43%"
                            },
                            {
                                "倍数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "0.25%"
                            },
                            {
                                "倍数": "20",
                                "概率": "0.05%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙复制】获得道具概率公布",
                date: "2024-02-06",
                show: false,
                description: "",
                outHeaders: ['三角龙奖池', '双头龙奖池', '额外奖励奖池', '暴龙奖池', '始祖龙奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "三角龙碎片",
                                "数量": "7",
                                "概率": "67.86%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "14",
                                "概率": "22.62%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "21",
                                "概率": "9.05%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "36",
                                "概率": "0.45%"
                            },
                            {
                                "道具": "三角龙",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "3",
                                "概率": "56.62%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "7",
                                "概率": "31.85%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "11",
                                "概率": "10.62%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "16",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.04%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "4",
                                "概率": "6.23%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "8",
                                "概率": "12.46%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "30",
                                "概率": "9.35%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "4",
                                "概率": "24.92%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "20",
                                "概率": "12.46%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "34.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "暴龙碎片",
                                "数量": "4",
                                "概率": "46.84%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "10",
                                "概率": "42.31%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "16",
                                "概率": "9.07%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "24",
                                "概率": "1.75%"
                            },
                            {
                                "道具": "暴龙",
                                "数量": "1",
                                "概率": "0.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "2",
                                "概率": "70.78%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "4",
                                "概率": "23.59%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "7",
                                "概率": "5.50%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "12",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【钓鱼】概率公布",
                date: "2024-02-05",
                show: false,
                description: "",
                outHeaders: ['普通鱼饵', '高级鱼饵'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "普通鱼点概率",
                            "稀有鱼点概率"
                        ],
                        "data": [
                            {
                                "道具名称": "河鲈",
                                "普通鱼点概率": "20.00%",
                                "稀有鱼点概率": "8.36%"
                            },
                            {
                                "道具名称": "鲤鱼",
                                "普通鱼点概率": "15.00%",
                                "稀有鱼点概率": "6.26%"
                            },
                            {
                                "道具名称": "黄金神奇龟",
                                "普通鱼点概率": "7.00%",
                                "稀有鱼点概率": "2.92%"
                            },
                            {
                                "道具名称": "生活垃圾",
                                "普通鱼点概率": "10.00%",
                                "稀有鱼点概率": "4.17%"
                            },
                            {
                                "道具名称": "鲶鱼",
                                "普通鱼点概率": "20.40%",
                                "稀有鱼点概率": "8.53%"
                            },
                            {
                                "道具名称": "狗鱼",
                                "普通鱼点概率": "10.00%",
                                "稀有鱼点概率": "4.17%"
                            },
                            {
                                "道具名称": "金鲤鱼",
                                "普通鱼点概率": "1.00%",
                                "稀有鱼点概率": "0.41%"
                            },
                            {
                                "道具名称": "水藻",
                                "普通鱼点概率": "6.00%",
                                "稀有鱼点概率": "2.50%"
                            },
                            {
                                "道具名称": "贝壳",
                                "普通鱼点概率": "3.74%",
                                "稀有鱼点概率": "30.02%"
                            },
                            {
                                "道具名称": "锯鳐",
                                "普通鱼点概率": "3.50%",
                                "稀有鱼点概率": "1.46%"
                            },
                            {
                                "道具名称": "龙鳗",
                                "普通鱼点概率": "2.50%",
                                "稀有鱼点概率": "1.04%"
                            },
                            {
                                "道具名称": "远古神奇龟",
                                "普通鱼点概率": "0.06%",
                                "稀有鱼点概率": "0.02%"
                            },
                            {
                                "道具名称": "大酋长的夜壶",
                                "普通鱼点概率": "0.30%",
                                "稀有鱼点概率": "0.12%"
                            },
                            {
                                "道具名称": "沉重的贝壳",
                                "普通鱼点概率": "0.50%",
                                "稀有鱼点概率": "30.02%"
                            },
                            {
                                "道具名称": "幼年上龙",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "独眼鲨",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "鲸鱼",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "鲶鱼人圣物",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "蚌王",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "普通鱼点概率",
                            "稀有鱼点概率"
                        ],
                        "data": [
                            {
                                "道具名称": "河鲈",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "鲤鱼",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "黄金神奇龟",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "生活垃圾",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "鲶鱼",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "狗鱼",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "金鲤鱼",
                                "普通鱼点概率": "10.00%",
                                "稀有鱼点概率": "8.79%"
                            },
                            {
                                "道具名称": "水藻",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "贝壳",
                                "普通鱼点概率": "0.00%",
                                "稀有鱼点概率": "0.00%"
                            },
                            {
                                "道具名称": "锯鳐",
                                "普通鱼点概率": "25.00%",
                                "稀有鱼点概率": "21.98%"
                            },
                            {
                                "道具名称": "龙鳗",
                                "普通鱼点概率": "25.00%",
                                "稀有鱼点概率": "21.98%"
                            },
                            {
                                "道具名称": "远古神奇龟",
                                "普通鱼点概率": "4.00%",
                                "稀有鱼点概率": "3.51%"
                            },
                            {
                                "道具名称": "大酋长的夜壶",
                                "普通鱼点概率": "7.00%",
                                "稀有鱼点概率": "6.15%"
                            },
                            {
                                "道具名称": "沉重的贝壳",
                                "普通鱼点概率": "6.00%",
                                "稀有鱼点概率": "15.02%"
                            },
                            {
                                "道具名称": "幼年上龙",
                                "普通鱼点概率": "15.00%",
                                "稀有鱼点概率": "13.19%"
                            },
                            {
                                "道具名称": "独眼鲨",
                                "普通鱼点概率": "3.50%",
                                "稀有鱼点概率": "3.07%"
                            },
                            {
                                "道具名称": "鲸鱼",
                                "普通鱼点概率": "0.02%",
                                "稀有鱼点概率": "0.02%"
                            },
                            {
                                "道具名称": "鲶鱼人圣物",
                                "普通鱼点概率": "1.48%",
                                "稀有鱼点概率": "1.29%"
                            },
                            {
                                "道具名称": "蚌王",
                                "普通鱼点概率": "3.00%",
                                "稀有鱼点概率": "5.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【赛季挑战】获得道具概率公布",
                date: "2024-01-01",
                show: false,
                description: "",
                outHeaders: ['赛季宝箱概率', '超级寻宝概率(本概率为首次抽取概率，实际概率随奖池剩余奖励变化而浮动。)'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有五星自选III",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3700",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "37000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1500",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "37000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "7.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XXV",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "120",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "170",
                                "概率": "0.69%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "150",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "80",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "20",
                                "概率": "1.78%"
                            },
                            {
                                "道具": "史诗五星自选",
                                "数量": "1",
                                "概率": "1.39%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "50",
                                "概率": "1.94%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "20",
                                "概率": "65.33%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "10",
                                "概率": "14.06%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "20",
                                "概率": "6.54%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "6.45%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2024-01-22",
                show: false,
                description: "",
                outHeaders: ['白银转盘概率公布', '白银宝箱XV概率公布', '黄金转盘概率公布', '黄金宝箱XV概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱XV",
                                "数量": "1",
                                "概率": "0.0144%"
                            },
                            {
                                "道具": "至尊据点外观自选IX",
                                "数量": "1",
                                "概率": "0.0019%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "2500",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "5000",
                                "概率": "11.5304%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "100",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "200",
                                "概率": "10.5695%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "4000",
                                "概率": "25.9433%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0019%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "50",
                                "概率": "5.45%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "80",
                                "概率": "5.45%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "30",
                                "概率": "5.45%"
                            },
                            {
                                "道具": "荣耀自选宝箱",
                                "数量": "400",
                                "概率": "9.09%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "4",
                                "概率": "9.09%"
                            },
                            {
                                "道具": "橙晶头盔（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "橙晶项链（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "橙晶胸甲（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "橙晶臂铠（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "橙晶腿甲（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "橙晶战靴（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "橙晶剑（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "橙晶盾牌（橙）",
                                "数量": "1",
                                "概率": "7.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱XV",
                                "数量": "1",
                                "概率": "0.036%"
                            },
                            {
                                "道具": "至尊据点外观自选XII",
                                "数量": "1",
                                "概率": "0.028%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "2000",
                                "概率": "21.311%"
                            },
                            {
                                "道具": "黄金宝箱XV",
                                "数量": "1",
                                "概率": "0.036%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "4.618%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "80",
                                "概率": "17.760%"
                            },
                            {
                                "道具": "黄金宝箱XV",
                                "数量": "1",
                                "概率": "0.036%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "60",
                                "概率": "21.311%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "17.049%"
                            },
                            {
                                "道具": "黄金宝箱XV",
                                "数量": "1",
                                "概率": "0.036%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "2500",
                                "概率": "17.760%"
                            },
                            {
                                "道具": "传说五星自选 XXIV",
                                "数量": "1",
                                "概率": "0.021%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "7.140%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "8.480%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "4",
                                "概率": "7.590%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "4",
                                "概率": "7.590%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "4",
                                "概率": "7.590%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "5.800%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "100",
                                "概率": "13.840%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "13.390%"
                            },
                            {
                                "道具": "橙晶头盔6",
                                "数量": "1",
                                "概率": "3.570%"
                            },
                            {
                                "道具": "橙晶项链6",
                                "数量": "1",
                                "概率": "3.570%"
                            },
                            {
                                "道具": "橙晶胸甲6",
                                "数量": "1",
                                "概率": "3.570%"
                            },
                            {
                                "道具": "橙晶臂铠6",
                                "数量": "1",
                                "概率": "3.570%"
                            },
                            {
                                "道具": "橙晶腿甲6",
                                "数量": "1",
                                "概率": "3.570%"
                            },
                            {
                                "道具": "橙晶战靴6",
                                "数量": "1",
                                "概率": "3.570%"
                            },
                            {
                                "道具": "橙晶剑6",
                                "数量": "1",
                                "概率": "3.570%"
                            },
                            {
                                "道具": "橙晶盾牌6",
                                "数量": "1",
                                "概率": "3.570%"
                            }
                        ]
                    }
                ]
            },

            // {
            //     name: "【天陨秘宝】概率公布",
            //     date: "2024-01-19",
            //     show: false,
            //     description: "",
            //     outHeaders: ['普通奖池', '秘宝奖池'],
            //     tables: [
            //         {
            //             "subHeaders": [
            //                 "道具名称",
            //                 "数量",
            //                 "概率"
            //             ],
            //             "data": [
            //                 {
            //                     "道具名称": "碎岩炉火",
            //                     "数量": "10",
            //                     "概率": "15.21%"
            //                 },
            //                 {
            //                     "道具名称": "碎岩炉火",
            //                     "数量": "40",
            //                     "概率": "11.41%"
            //                 },
            //                 {
            //                     "道具名称": "2X",
            //                     "数量": "1",
            //                     "概率": "11.41%"
            //                 },
            //                 {
            //                     "道具名称": "碎岩炉火",
            //                     "数量": "20",
            //                     "概率": "20.91%"
            //                 },
            //                 {
            //                     "道具名称": "3X",
            //                     "数量": "1",
            //                     "概率": "7.60%"
            //                 },
            //                 {
            //                     "道具名称": "碎岩炉火",
            //                     "数量": "40",
            //                     "概率": "11.41%"
            //                 },
            //                 {
            //                     "道具名称": "碎岩炉火",
            //                     "数量": "20",
            //                     "概率": "20.91%"
            //                 },
            //                 {
            //                     "道具名称": "4X",
            //                     "数量": "1",
            //                     "概率": "1.14%"
            //                 }
            //             ]
            //         },
            //         {
            //             "subHeaders": [
            //                 "道具名称",
            //                 "数量",
            //                 "概率"
            //             ],
            //             "data": [
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "35",
            //                     "概率": "21.67%"
            //                 },
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "35",
            //                     "概率": "21.67%"
            //                 },
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "35",
            //                     "概率": "21.67%"
            //                 },
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "75",
            //                     "概率": "11.67%"
            //                 },
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "75",
            //                     "概率": "11.67%"
            //                 },
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "100",
            //                     "概率": "5.00%"
            //                 },
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "100",
            //                     "概率": "5.00%"
            //                 },
            //                 {
            //                     "道具名称": "天陨碎岩",
            //                     "数量": "180",
            //                     "概率": "1.67%"
            //                 }
            //             ]
            //         }
            //     ]
            // },

            // {
            //     name: "【符文共鸣】天演·始动符文池概率",
            //     date: "2024-01-17",
            //     show: false,
            //     description: "",
            //     outHeaders: ['【符文共鸣】天演·始动符文池概率更新'],
            //     tables: [
            //         {
            //             "subHeaders": [
            //                 "符文类型",
            //                 "符文数量",
            //                 "概率"
            //             ],
            //             "data": [
            //                 {
            //                     "符文类型": "天演·嗜血",
            //                     "符文数量": "1",
            //                     "概率": "30.12%"
            //                 },
            //                 {
            //                     "符文类型": "天演·嗜血",
            //                     "符文数量": "2",
            //                     "概率": "3.01%"
            //                 },
            //                 {
            //                     "符文类型": "天演·嗜血",
            //                     "符文数量": "4",
            //                     "概率": "0.30%"
            //                 },
            //                 {
            //                     "符文类型": "天演·嗜血",
            //                     "符文数量": "6",
            //                     "概率": "0.15%"
            //                 },
            //                 {
            //                     "符文类型": "天演·重击",
            //                     "符文数量": "1",
            //                     "概率": "30.12%"
            //                 },
            //                 {
            //                     "符文类型": "天演·重击",
            //                     "符文数量": "2",
            //                     "概率": "3.01%"
            //                 },
            //                 {
            //                     "符文类型": "天演·重击",
            //                     "符文数量": "4",
            //                     "概率": "0.30%"
            //                 },
            //                 {
            //                     "符文类型": "天演·重击",
            //                     "符文数量": "6",
            //                     "概率": "0.15%"
            //                 },
            //                 {
            //                     "符文类型": "天演·天火",
            //                     "符文数量": "1",
            //                     "概率": "12.05%"
            //                 },
            //                 {
            //                     "符文类型": "天演·天火",
            //                     "符文数量": "2",
            //                     "概率": "0.75%"
            //                 },
            //                 {
            //                     "符文类型": "天演·天火",
            //                     "符文数量": "4",
            //                     "概率": "0.15%"
            //                 },
            //                 {
            //                     "符文类型": "天演·天火",
            //                     "符文数量": "6",
            //                     "概率": "0.06%"
            //                 },
            //                 {
            //                     "符文类型": "天演·战吼",
            //                     "符文数量": "1",
            //                     "概率": "12.05%"
            //                 },
            //                 {
            //                     "符文类型": "天演·战吼",
            //                     "符文数量": "2",
            //                     "概率": "0.75%"
            //                 },
            //                 {
            //                     "符文类型": "天演·战吼",
            //                     "符文数量": "4",
            //                     "概率": "0.15%"
            //                 },
            //                 {
            //                     "符文类型": "天演·战吼",
            //                     "符文数量": "6",
            //                     "概率": "0.06%"
            //                 },
            //                 {
            //                     "符文类型": "天演·强攻",
            //                     "符文数量": "1",
            //                     "概率": "3.01%"
            //                 },
            //                 {
            //                     "符文类型": "天演·强攻",
            //                     "符文数量": "2",
            //                     "概率": "0.30%"
            //                 },
            //                 {
            //                     "符文类型": "天演·强攻",
            //                     "符文数量": "4",
            //                     "概率": "0.06%"
            //                 },
            //                 {
            //                     "符文类型": "天演·强攻",
            //                     "符文数量": "6",
            //                     "概率": "0.03%"
            //                 },
            //                 {
            //                     "符文类型": "天演·致残",
            //                     "符文数量": "1",
            //                     "概率": "3.01%"
            //                 },
            //                 {
            //                     "符文类型": "天演·致残",
            //                     "符文数量": "2",
            //                     "概率": "0.30%"
            //                 },
            //                 {
            //                     "符文类型": "天演·致残",
            //                     "符文数量": "4",
            //                     "概率": "0.06%"
            //                 },
            //                 {
            //                     "符文类型": "天演·致残",
            //                     "符文数量": "6",
            //                     "概率": "0.03%"
            //                 }
            //             ]
            //         }
            //     ]
            // },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2024-01-11",
                show: false,
                description: "",
                outHeaders: ['亡灵公主伙伴池', '深海恐兽伙伴池', '魅影刺客伙伴池', '虎王巴布伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【亡灵公主】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【深海恐兽】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【魅影刺客】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【虎王巴布】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】概率公布",
                date: "2024-01-02",
                show: false,
                description: "",
                outHeaders: ['【龙印寻宝】概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片*2700",
                                "数量": "22",
                                "概率": "9.59%"
                            },
                            {
                                "道具": "龙魄结晶*270",
                                "数量": "20",
                                "概率": "9.59%"
                            },
                            {
                                "道具": "龙魄碎片*1600",
                                "数量": "20",
                                "概率": "15.97%"
                            },
                            {
                                "道具": "龙魄结晶*160",
                                "数量": "12",
                                "概率": "17.57%"
                            },
                            {
                                "道具": "龙魄碎片*1200",
                                "数量": "10",
                                "概率": "15.97%"
                            },
                            {
                                "道具": "龙魄结晶*120",
                                "数量": "10",
                                "概率": "12.78%"
                            },
                            {
                                "道具": "龙魄碎片*600",
                                "数量": "18",
                                "概率": "8.79%"
                            },
                            {
                                "道具": "龙魄结晶*60",
                                "数量": "18",
                                "概率": "8.79%"
                            },
                            {
                                "道具": "五星龙印特级随机宝箱*1",
                                "数量": "1",
                                "概率": "0.45%"
                            },
                            {
                                "道具": "五星龙印自选宝箱 I*1",
                                "数量": "1",
                                "概率": "0.30%"
                            },
                            {
                                "道具": "五星龙印自选宝箱 II*1",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "五星龙印自选宝箱 III*1",
                                "数量": "1",
                                "概率": "0.06%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【新年许愿】道具概率公",
                date: "2024-01-02",
                show: false,
                description: "",
                outHeaders: ['各类型道具出现的概率'],
                tables: [
                    {
                        "subHeaders": [
                            "普通奖励",
                            "76.10%"
                        ],
                        "data": [
                            {
                                "普通奖励": "高级奖励",
                                "76.10%": "22.83%"
                            },
                            {
                                "普通奖励": "珍稀奖励",
                                "76.10%": "1.07%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【嗜血猎手降临】获得伙伴概率公布",
                date: "2023-12-26",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "嗜血猎手",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "嗜血猎手",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【法器占卜】获得道具概率公布",
                date: "2023-12-21",
                show: false,
                description: "",
                outHeaders: ['法器奖池', '结晶奖池', '法器惊喜奖池', '神秘大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "神农法杖-碎片",
                                "数量": "1",
                                "概率": "73.390%"
                            },
                            {
                                "道具": "神农法杖-碎片",
                                "数量": "2",
                                "概率": "3.670%"
                            },
                            {
                                "道具": "神农法杖-碎片",
                                "数量": "3",
                                "概率": "0.370%"
                            },
                            {
                                "道具": "神农法杖-碎片",
                                "数量": "5",
                                "概率": "0.070%"
                            },
                            {
                                "道具": "神农法杖-碎片",
                                "数量": "10",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "0.370%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "7.34%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "3",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "14.68%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "燧火结晶",
                                "数量": "2",
                                "概率": "69.100%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "4",
                                "概率": "6.910%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "6",
                                "概率": "1.380%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "8",
                                "概率": "0.350%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "10",
                                "概率": "0.140%"
                            },
                            {
                                "道具": "燧火结晶",
                                "数量": "15",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "1.38%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "1",
                                "概率": "6.91%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "3",
                                "概率": "13.82%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "神农法杖-碎片",
                                "数量": "3",
                                "概率": "42.740%"
                            },
                            {
                                "道具": "神农法杖-碎片",
                                "数量": "6",
                                "概率": "0.850%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "1",
                                "概率": "8.550%"
                            },
                            {
                                "道具": "史诗-混沌铭文宝箱",
                                "数量": "2",
                                "概率": "0.850%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "2",
                                "概率": "42.740%"
                            },
                            {
                                "道具": "洗炼滴露",
                                "数量": "4",
                                "概率": "4.270%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "燧火结晶",
                            "40",
                            "37.89%"
                        ],
                        "data": [
                            {
                                "燧火结晶": "燧火结晶",
                                "40": "80",
                                "37.89%": "0.38%"
                            },
                            {
                                "燧火结晶": "燧火结晶",
                                "40": "150",
                                "37.89%": "0.04%"
                            },
                            {
                                "燧火结晶": "神农法杖-碎片",
                                "40": "20",
                                "37.89%": "37.89%"
                            },
                            {
                                "燧火结晶": "神农法杖-碎片",
                                "40": "40",
                                "37.89%": "0.38%"
                            },
                            {
                                "燧火结晶": "神农法杖-碎片",
                                "40": "100",
                                "37.89%": "0.08%"
                            },
                            {
                                "燧火结晶": "史诗-混沌铭文宝箱",
                                "40": "5",
                                "37.89%": "3.79%"
                            },
                            {
                                "燧火结晶": "史诗-混沌铭文宝箱",
                                "40": "10",
                                "37.89%": "0.38%"
                            },
                            {
                                "燧火结晶": "史诗-混沌铭文宝箱",
                                "40": "20",
                                "37.89%": "0.00%"
                            },
                            {
                                "燧火结晶": "洗炼滴露",
                                "40": "5",
                                "37.89%": "18.95%"
                            },
                            {
                                "燧火结晶": "洗炼滴露",
                                "40": "10",
                                "37.89%": "0.19%"
                            },
                            {
                                "燧火结晶": "洗炼滴露",
                                "40": "50",
                                "37.89%": "0.04%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【伙伴祝福】获得道具概率公布",
                date: "2023-12-19",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "太古黑曜水晶",
                                "数量": "5",
                                "概率": "0.056%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "8",
                                "概率": "3.378%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "5",
                                "概率": "20.552%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "3",
                                "概率": "28.154%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "2",
                                "概率": "14.077%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "1",
                                "概率": "33.784%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【天陨秘宝】概率公布",
                date: "2023-12-13",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '秘宝奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "20",
                                "概率": "21.13%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "80",
                                "概率": "17.61%"
                            },
                            {
                                "道具名称": "2X",
                                "数量": "1",
                                "概率": "11.62%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "40",
                                "概率": "19.37%"
                            },
                            {
                                "道具名称": "3X",
                                "数量": "1",
                                "概率": "8.10%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "100",
                                "概率": "8.80%"
                            },
                            {
                                "道具名称": "碎岩炉火",
                                "数量": "60",
                                "概率": "12.32%"
                            },
                            {
                                "道具名称": "4X",
                                "数量": "1",
                                "概率": "1.06%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "20",
                                "概率": "21.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "20",
                                "概率": "21.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "20",
                                "概率": "21.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "40",
                                "概率": "11.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "40",
                                "概率": "11.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "80",
                                "概率": "5.00%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "80",
                                "概率": "5.00%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "150",
                                "概率": "1.67%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙甲深渊】获得道具概率公布",
                date: "2023-12-11",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '“龙甲转盘”奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙甲转盘",
                                "数量": "1",
                                "概率": "2.41%"
                            },
                            {
                                "道具": "紫晶远古龟",
                                "数量": "1",
                                "概率": "0.48%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "20",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "15",
                                "概率": "0.48%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "10",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "8",
                                "概率": "2.41%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "6",
                                "概率": "4.82%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "4",
                                "概率": "9.65%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "2",
                                "概率": "15.44%"
                            },
                            {
                                "道具": "怒火龙石",
                                "数量": "1",
                                "概率": "24.12%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "2",
                                "概率": "7.24%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "2",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.41%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "12",
                                "概率": "7.24%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "7.24%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "3",
                                "概率": "7.24%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "3",
                                "概率": "7.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "雷铠狂龙",
                                "个数": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "个数": "100",
                                "概率": "4.21%"
                            },
                            {
                                "道具": "碎岩炉火",
                                "个数": "600",
                                "概率": "14.03%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "5",
                                "概率": "14.03%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "个数": "400",
                                "概率": "14.03%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "100",
                                "概率": "21.04%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "3",
                                "概率": "14.03%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "350",
                                "概率": "16.83%"
                            },
                            {
                                "道具": "怒火龙石",
                                "个数": "80",
                                "概率": "1.68%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【神秘小屋】获得道具概率公布",
                date: "2023-12-08",
                show: false,
                description: "",
                outHeaders: ['星空探索奖池', '星盘占卜奖池', '魔法师的赠礼奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "10",
                                "概率": "20.588%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "3",
                                "概率": "25.735%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "15",
                                "概率": "7.353%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "10",
                                "概率": "5.882%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "20",
                                "概率": "5.882%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "8",
                                "概率": "7.353%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "50",
                                "概率": "2.206%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "5",
                                "概率": "20.588%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "30",
                                "概率": "4.412%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法师的赠礼奖池",
                                "个数": "1",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "2",
                                "概率": "0.78%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "75",
                                "概率": "4.86%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "15",
                                "概率": "15.55%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "45",
                                "概率": "19.44%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "25",
                                "概率": "15.55%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "60",
                                "概率": "11.66%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "1",
                                "概率": "1.17%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "20",
                                "概率": "14.58%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "30",
                                "概率": "14.58%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "陨星结晶",
                                "个数": "3",
                                "概率": "17.79%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "8",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "7",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "6",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "20",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "6",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "7",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "8",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "3",
                                "概率": "17.79%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【符文共鸣】天演·全盛符文池概率更新",
                date: "2023-12-08",
                show: false,
                description: "",
                outHeaders: ['【符文共鸣】天演·始动符文池概率更新'],
                tables: [
                    {
                        "subHeaders": [
                            "符文类型",
                            "符文数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "1",
                                "概率": "2.22%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "2",
                                "概率": "1.67%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "4",
                                "概率": "1.11%"
                            },
                            {
                                "符文类型": "天演·嗜血",
                                "符文数量": "6",
                                "概率": "0.56%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "1",
                                "概率": "2.22%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "2",
                                "概率": "1.67%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "4",
                                "概率": "1.11%"
                            },
                            {
                                "符文类型": "天演·重击",
                                "符文数量": "6",
                                "概率": "0.56%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "1",
                                "概率": "2.22%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "2",
                                "概率": "3.33%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "4",
                                "概率": "4.44%"
                            },
                            {
                                "符文类型": "天演·天火",
                                "符文数量": "6",
                                "概率": "1.11%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "1",
                                "概率": "2.22%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "2",
                                "概率": "3.33%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "4",
                                "概率": "4.44%"
                            },
                            {
                                "符文类型": "天演·战吼",
                                "符文数量": "6",
                                "概率": "1.11%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "1",
                                "概率": "16.67%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "2",
                                "概率": "8.89%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "4",
                                "概率": "6.67%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "6",
                                "概率": "1.11%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "1",
                                "概率": "16.67%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "2",
                                "概率": "8.89%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "4",
                                "概率": "6.67%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "6",
                                "概率": "1.11%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2023-11-27",
                show: false,
                description: "",
                outHeaders: ['白银转盘概率公布', '白银宝箱XIV概率公布', '黄金转盘概率公布', '黄金宝箱XIV概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0144%"
                            },
                            {
                                "道具": "至尊据点外观自选X",
                                "数量": "1",
                                "概率": "0.0019%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "2500",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "11.5304%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "100",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "200",
                                "概率": "10.5695%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "4000",
                                "概率": "25.9433%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0019%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "50",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "80",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "30",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "荣耀自选宝箱",
                                "数量": "400",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "4",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "黑龙之首（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "黑龙之牙（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "黑龙之翼（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "黑龙之爪（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "至尊据点外观自选XI",
                                "数量": "1",
                                "概率": "0.028%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "20.794%"
                            },
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "17.329%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "80",
                                "概率": "17.329%"
                            },
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "50",
                                "概率": "13.863%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1600",
                                "概率": "16.636%"
                            },
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "160",
                                "概率": "13.863%"
                            },
                            {
                                "道具": "传说五星自选 XXI",
                                "数量": "1",
                                "概率": "0.021%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "8.330%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "9.900%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "6.770%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "100",
                                "概率": "16.150%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.630%"
                            },
                            {
                                "道具": "黑龙之首（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "黑龙之牙（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "黑龙之翼（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "黑龙之爪（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【感恩节狩猎火鸡】概率公布",
                date: "2023-11-23",
                show: false,
                description: "",
                outHeaders: ['普通奖池（暴躁的火鸡）', '稀有奖池（虚弱的火鸡）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "道具数量",
                            "获得概率"
                        ],
                        "data": [
                            {
                                "道具名称": "火鸡侦察守卫自选",
                                "道具数量": "1",
                                "获得概率": "0.30%"
                            },
                            {
                                "道具名称": "紫晶远古龟",
                                "道具数量": "1",
                                "获得概率": "0.59%"
                            },
                            {
                                "道具名称": "技能鲶鱼礼盒",
                                "道具数量": "1",
                                "获得概率": "1.48%"
                            },
                            {
                                "道具名称": "酋长战纹宝箱",
                                "道具数量": "1",
                                "获得概率": "2.96%"
                            },
                            {
                                "道具名称": "稀有伙伴结晶",
                                "道具数量": "1",
                                "获得概率": "11.83%"
                            },
                            {
                                "道具名称": "紫晶神奇龟",
                                "道具数量": "1",
                                "获得概率": "11.83%"
                            },
                            {
                                "道具名称": "远古蛮石",
                                "道具数量": "10",
                                "获得概率": "11.83%"
                            },
                            {
                                "道具名称": "洗炼灵石",
                                "道具数量": "1",
                                "获得概率": "11.83%"
                            },
                            {
                                "道具名称": "稀有召唤石",
                                "道具数量": "2",
                                "获得概率": "11.83%"
                            },
                            {
                                "道具名称": "10 血精石",
                                "道具数量": "8",
                                "获得概率": "11.83%"
                            },
                            {
                                "道具名称": "龙鳞自选宝箱",
                                "道具数量": "4",
                                "获得概率": "11.83%"
                            },
                            {
                                "道具名称": "荣耀资源自选宝箱",
                                "道具数量": "1",
                                "获得概率": "11.83%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "道具数量",
                            "获得概率"
                        ],
                        "data": [
                            {
                                "道具名称": "传说五星自选 XXII",
                                "道具数量": "1",
                                "获得概率": "0.07%"
                            },
                            {
                                "道具名称": "火鸡聚会（感恩）",
                                "道具数量": "1",
                                "获得概率": "0.07%"
                            },
                            {
                                "道具名称": "技能鲶鱼",
                                "道具数量": "1",
                                "获得概率": "0.70%"
                            },
                            {
                                "道具名称": "陨星结晶",
                                "道具数量": "2",
                                "获得概率": "15.66%"
                            },
                            {
                                "道具名称": "洗炼灵石",
                                "道具数量": "3",
                                "获得概率": "20.88%"
                            },
                            {
                                "道具名称": "远古蛮石",
                                "道具数量": "30",
                                "获得概率": "20.88%"
                            },
                            {
                                "道具名称": "10 血精石",
                                "道具数量": "4",
                                "获得概率": "20.88%"
                            },
                            {
                                "道具名称": "龙鳞自选宝箱",
                                "道具数量": "15",
                                "获得概率": "20.88%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2023-11-16",
                show: false,
                description: "",
                outHeaders: ['龙吟征战者伙伴池', '精灵王子伙伴池', '援琴女神伙伴池', '人鱼塞壬伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【龙吟征战者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【精灵王子】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【援琴女神】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【人鱼塞壬】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【天陨秘宝】概率公布",
                date: "2023-11-08",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '秘宝奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "1小时加速",
                                "数量": "5",
                                "概率": "21.13%"
                            },
                            {
                                "道具名称": "资源自选宝箱",
                                "数量": "2",
                                "概率": "17.61%"
                            },
                            {
                                "道具名称": "2X",
                                "数量": "1",
                                "概率": "11.62%"
                            },
                            {
                                "道具名称": "100宝石",
                                "数量": "1",
                                "概率": "19.37%"
                            },
                            {
                                "道具名称": "3X",
                                "数量": "1",
                                "概率": "8.10%"
                            },
                            {
                                "道具名称": "100宝石",
                                "数量": "3",
                                "概率": "8.80%"
                            },
                            {
                                "道具名称": "3小时加速",
                                "数量": "4",
                                "概率": "12.32%"
                            },
                            {
                                "道具名称": "4X",
                                "数量": "1",
                                "概率": "1.06%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "20",
                                "概率": "21.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "20",
                                "概率": "21.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "20",
                                "概率": "21.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "40",
                                "概率": "11.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "40",
                                "概率": "11.67%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "80",
                                "概率": "5.00%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "80",
                                "概率": "5.00%"
                            },
                            {
                                "道具名称": "天陨碎岩",
                                "数量": "150",
                                "概率": "1.67%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祖先庇佑】道具概率公布",
                date: "2023-11-04",
                show: false,
                description: "",
                outHeaders: ['触发庇佑模式概率', '古老贝壳奖池', '发光贝壳奖池', '庇佑模式：龙印奖池', '庇佑模式：远古宝物奖池', '庇佑模式：装备', '庇佑模式：龙奖池', '庇佑模式：血精石奖池', '庇佑模式：龟奖池', '庇佑模式：神器&技能鲶鱼奖池', '庇佑模式：战纹奖池', '庇佑模式：BUFF奖池', '庇佑模式：宝石奖池', '庇佑模式：魔骨奖池', '庇佑模式：荣耀&魔法奖池', '庇佑模式：龙结晶'],
                tables: [
                    {
                        "subHeaders": [
                            "行为",
                            "概率"
                        ],
                        "data": [
                            {
                                "行为": "古老贝壳祈祷",
                                "概率": "3.33%"
                            },
                            {
                                "行为": "发光贝壳祈祷",
                                "概率": "20.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "发光贝壳",
                                "数量": "1",
                                "概率": "3.38%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "5.41%"
                            },
                            {
                                "道具": "蓝色祭司碎片",
                                "数量": "2",
                                "概率": "10.14%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "8.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "2",
                                "概率": "21.62%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "1",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "1",
                                "概率": "13.51%"
                            },
                            {
                                "道具": "500,000 象牙",
                                "数量": "1",
                                "概率": "12.16%"
                            },
                            {
                                "道具": "500,000 石头",
                                "数量": "1",
                                "概率": "12.15%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "2.30%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "8",
                                "概率": "24.14%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "8",
                                "概率": "5.75%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "4",
                                "概率": "8.62%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "17.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "2700",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "1200",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "7500",
                                "概率": "5.94%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "4500",
                                "概率": "21.78%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "1800",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "1200",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "900",
                                "概率": "19.80%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "600",
                                "概率": "29.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "8100",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "1620",
                                "概率": "19.54%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "16200",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6750",
                                "概率": "32.57%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "1890",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "1350",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "1080",
                                "概率": "6.51%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "675",
                                "概率": "32.57%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "数量": "1530",
                                "概率": "0.71%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "510",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "5100",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "2550",
                                "概率": "35.71%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "1020",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "680",
                                "概率": "3.57%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "425",
                                "概率": "7.14%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "255",
                                "概率": "35.71%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "5",
                                "概率": "7.57%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "37.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "10",
                                "概率": "1.51%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "5",
                                "概率": "15.14%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "1",
                                "概率": "37.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100 血精石",
                                "数量": "16",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "8",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "40",
                                "概率": "4.95%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "20",
                                "概率": "9.89%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "150",
                                "概率": "14.84%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "120",
                                "概率": "19.78%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "100",
                                "概率": "49.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "5",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "3",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "31.19%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "10",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "5",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "2",
                                "概率": "31.19%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "高级神器自选宝箱XXIII",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "8",
                                "概率": "1.45%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "4",
                                "概率": "4.34%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "2",
                                "概率": "43.35%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "7.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "43.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "5",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "3.22%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "4",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "26.80%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "20",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "12",
                                "概率": "16.08%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "8",
                                "概率": "21.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "15%攻击削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%防御削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%生命削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%行军兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "集结兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%攻击加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%防御加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%生命加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "25%行军兵量增加",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天攻击加成",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天防御加成",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天和平守护",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "行军队列",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天反侦查",
                                "数量": "1",
                                "概率": "4.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100宝石",
                                "数量": "100",
                                "概率": "1.28%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "50",
                                "概率": "2.56%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "30",
                                "概率": "6.41%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "20",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "15",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "51.28%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔骨能耗减少",
                                "数量": "1",
                                "概率": "0.38%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "10",
                                "概率": "0.76%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "5",
                                "概率": "3.80%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "2",
                                "概率": "19.01%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "8",
                                "概率": "30.42%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "6",
                                "概率": "45.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀旗帜",
                                "数量": "700",
                                "概率": "1.77%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "300",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "250",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "200",
                                "概率": "26.55%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "700",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "300",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "250",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "200",
                                "概率": "26.55%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "8",
                                "概率": "0.17%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "4",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "8",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "3.48%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "3",
                                "概率": "6.96%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "2",
                                "概率": "17.39%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "1",
                                "概率": "69.57%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【亡灵公主降临】获得伙伴概率公布",
                date: "2023-10-31",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "亡灵公主",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "亡灵公主",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【万圣节南瓜派对】概率公布",
                date: "2023-10-28",
                show: false,
                description: "",
                outHeaders: ['普通奖励', '稀有奖励'],
                tables: [
                    {
                        "subHeaders": [
                            "道具名称",
                            "道具数量",
                            "获得概率"
                        ],
                        "data": [
                            {
                                "道具名称": "技能鲶鱼礼盒",
                                "道具数量": "1",
                                "获得概率": "2.45%"
                            },
                            {
                                "道具名称": "龙鳞自选宝箱",
                                "道具数量": "5",
                                "获得概率": "7.36%"
                            },
                            {
                                "道具名称": "龙碎片自选宝箱",
                                "道具数量": "1",
                                "获得概率": "3.68%"
                            },
                            {
                                "道具名称": "稀有伙伴结晶",
                                "道具数量": "1",
                                "获得概率": "10.43%"
                            },
                            {
                                "道具名称": "10 血精石",
                                "道具数量": "5",
                                "获得概率": "10.43%"
                            },
                            {
                                "道具名称": "紫晶神奇龟",
                                "道具数量": "1",
                                "获得概率": "11.04%"
                            },
                            {
                                "道具名称": "酋长战纹宝箱",
                                "道具数量": "1",
                                "获得概率": "5.52%"
                            },
                            {
                                "道具名称": "洗炼灵石礼袋",
                                "道具数量": "3",
                                "获得概率": "8.59%"
                            },
                            {
                                "道具名称": "稀有召唤石",
                                "道具数量": "5",
                                "获得概率": "7.36%"
                            },
                            {
                                "道具名称": "荣耀资源自选宝箱",
                                "道具数量": "1",
                                "获得概率": "11.04%"
                            },
                            {
                                "道具名称": "1天加速",
                                "道具数量": "1",
                                "获得概率": "11.04%"
                            },
                            {
                                "道具名称": "100宝石",
                                "道具数量": "5",
                                "获得概率": "11.04%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具名称",
                            "道具数量",
                            "获得概率"
                        ],
                        "data": [
                            {
                                "道具名称": "南瓜魔灵",
                                "道具数量": "1",
                                "获得概率": "0.17%"
                            },
                            {
                                "道具名称": "万圣奇遇（高级）",
                                "道具数量": "1",
                                "获得概率": "8.67%"
                            },
                            {
                                "道具名称": "不朽的据点外观自选V",
                                "道具数量": "1",
                                "获得概率": "0.17%"
                            },
                            {
                                "道具名称": "紫晶太古龟",
                                "道具数量": "1",
                                "获得概率": "0.87%"
                            },
                            {
                                "道具名称": "洗炼灵石",
                                "道具数量": "50",
                                "获得概率": "20.80%"
                            },
                            {
                                "道具名称": "陨星结晶",
                                "道具数量": "10",
                                "获得概率": "17.33%"
                            },
                            {
                                "道具名称": "远古蛮石",
                                "道具数量": "50",
                                "获得概率": "26.00%"
                            },
                            {
                                "道具名称": "100 血精石",
                                "道具数量": "5",
                                "获得概率": "26.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【琥珀神奇龟】概率公布",
                date: "2023-10-19",
                show: false,
                description: "",
                outHeaders: ['琥珀神奇龟'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "5星伙伴",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】概率公布",
                date: "2023-10-19",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '稀有奖池', '积分暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.68%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.41%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "80",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "个数": "2",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "4",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "10",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "个数": "1",
                                "概率": "9.75%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "风暴之眼（永久）",
                                "个数": "1",
                                "概率": "0.44%"
                            },
                            {
                                "道具": "传说五星自选 XXII",
                                "个数": "1",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "不朽的据点外观自选V",
                                "个数": "1",
                                "概率": "6.64%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "10",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "个数": "1",
                                "概率": "5.53%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "5",
                                "概率": "7.74%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "5",
                                "概率": "19.36%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "90",
                                "概率": "27.65%"
                            },
                            {
                                "道具": "10 血精石",
                                "个数": "60",
                                "概率": "27.65%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "95.43%"
                            },
                            {
                                "倍数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "0.25%"
                            },
                            {
                                "倍数": "20",
                                "概率": "0.05%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【占卜赞歌】概率公布",
                date: "2023-10-17",
                show: false,
                description: "",
                outHeaders: ['普通奖励', '特殊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "占卜秘钥",
                                "数量": "1",
                                "概率": "8.57%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "0.52%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "3",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "5.19%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "9.09%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "31.16%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "2",
                                "概率": "41.55%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XXII",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "20",
                                "概率": "0.44%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "50",
                                "概率": "0.09%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "3",
                                "概率": "26.40%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.44%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "3",
                                "概率": "6.60%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "10",
                                "概率": "22.00%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "4",
                                "概率": "43.99%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【宝物探秘】获得道具概率公布",
                date: "2023-10-10",
                show: false,
                description: "",
                outHeaders: ['普通奖池1', '普通奖池2', '普通奖池3', '普通奖池4', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '【高级大奖】奖池概率', '【特级大奖】奖池概率', '【至尊大奖】奖池概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "600",
                                "概率": "0.010%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "300",
                                "概率": "0.200%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "40000",
                                "概率": "19.530%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6000",
                                "概率": "0.020%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3000",
                                "概率": "29.290%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4000",
                                "概率": "0.960%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "60000",
                                "概率": "0.200%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "30000",
                                "概率": "29.290%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "50000",
                                "概率": "0.970%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "19.530%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法粉尘",
                                "数量": "50000",
                                "概率": "0.198%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "36000",
                                "概率": "5.866%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "30000",
                                "概率": "39.126%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "55000",
                                "概率": "0.024%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "32000",
                                "概率": "19.574%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "34000",
                                "概率": "9.782%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "60000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "38000",
                                "概率": "3.906%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "40000",
                                "概率": "1.962%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "19.560%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法碎片",
                                "数量": "5000",
                                "概率": "0.198%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3600",
                                "概率": "5.866%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3000",
                                "概率": "39.126%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "5500",
                                "概率": "0.024%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3200",
                                "概率": "19.574%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3400",
                                "概率": "9.782%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6000",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3800",
                                "概率": "3.906%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "4000",
                                "概率": "1.962%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "19.560%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "500",
                                "概率": "0.198%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "360",
                                "概率": "5.866%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "300",
                                "概率": "39.126%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "550",
                                "概率": "0.024%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "320",
                                "概率": "19.574%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "340",
                                "概率": "9.782%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "600",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "380",
                                "概率": "3.906%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "400",
                                "概率": "1.962%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "19.560%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.159%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.440%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.280%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "320",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3200",
                                "概率": "1.780%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "32000",
                                "概率": "7.110%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "300",
                                "概率": "0.360%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3000",
                                "概率": "17.730%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "30000",
                                "概率": "71.100%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.163%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.525%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.520%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "320",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3200",
                                "概率": "1.770%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "32000",
                                "概率": "7.080%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "300",
                                "概率": "0.350%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3000",
                                "概率": "17.710%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "30000",
                                "概率": "70.840%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "5级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.200%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.632%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.915%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "320",
                                "概率": "0.040%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3200",
                                "概率": "1.760%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "32000",
                                "概率": "7.040%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "300",
                                "概率": "17.610%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "3000",
                                "概率": "70.450%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "30000",
                                "概率": "0.350%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2023-10-02",
                show: false,
                description: "",
                outHeaders: ['白银转盘概率公布', '白银宝箱XIV概率公布', '黄金转盘概率公布', '黄金宝箱XIV概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0144%"
                            },
                            {
                                "道具": "至尊据点外观自选IX",
                                "数量": "1",
                                "概率": "0.0019%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "2500",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "11.5304%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "100",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "200",
                                "概率": "10.5695%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "17.2956%"
                            },
                            {
                                "道具": "白银宝箱XIV",
                                "数量": "1",
                                "概率": "0.0173%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "4000",
                                "概率": "25.9433%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0019%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "50",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "80",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "30",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "荣耀自选宝箱",
                                "数量": "400",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "4",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "黑龙之首4",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "黑龙之牙4",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "黑龙之翼4",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "黑龙之爪4",
                                "数量": "1",
                                "概率": "10.26%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "至尊据点外观自选X",
                                "数量": "1",
                                "概率": "0.028%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "20.794%"
                            },
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "17.329%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "80",
                                "概率": "17.329%"
                            },
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "50",
                                "概率": "13.863%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1600",
                                "概率": "16.636%"
                            },
                            {
                                "道具": "黄金宝箱XIV",
                                "数量": "1",
                                "概率": "0.035%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "160",
                                "概率": "13.863%"
                            },
                            {
                                "道具": "传说五星自选 XXI",
                                "数量": "1",
                                "概率": "0.021%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "8.330%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "9.900%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "6.770%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "100",
                                "概率": "16.150%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.630%"
                            },
                            {
                                "道具": "黑龙之首6",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "黑龙之牙6",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "黑龙之翼6",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "黑龙之爪6",
                                "数量": "1",
                                "概率": "4.170%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【秋日探险】获得道具概率公布",
                date: "2023-09-30",
                show: false,
                description: "",
                outHeaders: ['普通奖励', '幸运大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "幸运大奖奖池",
                                "个数": "1",
                                "概率": "2.34%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "5",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "30",
                                "概率": "4.68%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "0.58%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "3",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "洗炼灵石礼袋",
                                "个数": "8",
                                "概率": "2.34%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "40",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "15",
                                "概率": "4.68%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "5",
                                "概率": "5.26%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "80",
                                "概率": "9.36%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "8",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "10",
                                "概率": "11.70%"
                            },
                            {
                                "道具": "洗炼灵石礼袋",
                                "个数": "4",
                                "概率": "4.68%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "10",
                                "概率": "5.85%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "8",
                                "概率": "1.75%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "个数": "1",
                                "概率": "0.006%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "个数": "100",
                                "概率": "5.615%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "50",
                                "概率": "33.687%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "200",
                                "概率": "56.145%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "50",
                                "概率": "4.492%"
                            },
                            {
                                "道具": "秋日赞歌钻石（永久）",
                                "个数": "1",
                                "概率": "0.056%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2023-09-28",
                show: false,
                description: "",
                outHeaders: ['深海恐兽伙伴池', '魅影刺客伙伴池', '行者伙伴池', '血咒怨灵伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【深海恐兽】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【魅影刺客】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【行者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【血咒怨灵】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2023-09-27",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "2.11%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.21%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "紫色祭司碎片",
                                "数量": "1",
                                "概率": "0.35%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "0.87%"
                            },
                            {
                                "道具": "酋长猫头鹰战纹宝箱",
                                "数量": "1",
                                "概率": "0.87%"
                            },
                            {
                                "道具": "酋长猫战纹宝箱",
                                "数量": "1",
                                "概率": "0.87%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "17.31%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "12",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "13.85%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "6.93%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "13.85%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "3天加速",
                                "数量": "2",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "3",
                                "概率": "1.73%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "0.87%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "0.87%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "8",
                                "概率": "1.73%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "3.46%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "数量": "1",
                                "概率": "1.73%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "2",
                                "概率": "0.87%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "0.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "6",
                                "概率": "4.15%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "7",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "8",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "10",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "黄帝·轩辕碎片",
                                "数量": "15",
                                "概率": "0.05%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "6",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "8",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "10",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "12",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "14",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "16",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "24",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "25",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "30",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "35",
                                "概率": "7.70%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "40",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "50",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "75",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "25",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "30",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "35",
                                "概率": "7.70%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "40",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "50",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "75",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【神秘小屋】获得道具概率公布",
                date: "2023-09-16",
                show: false,
                description: "",
                outHeaders: ['星空探索奖池', '星盘占卜奖池', '魔法师的赠礼奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金龟碎片",
                                "个数": "10",
                                "概率": "13.652%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "10",
                                "概率": "8.191%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "10",
                                "概率": "16.382%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "20",
                                "概率": "6.826%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "15",
                                "概率": "10.922%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "5",
                                "概率": "13.652%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "30",
                                "概率": "4.437%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "3",
                                "概率": "17.747%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "20",
                                "概率": "8.191%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法师的赠礼奖池",
                                "个数": "1",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "1",
                                "概率": "1.70%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "40",
                                "概率": "15.30%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "个数": "80",
                                "概率": "14.87%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "60",
                                "概率": "8.50%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "40",
                                "概率": "15.30%"
                            },
                            {
                                "道具": "陨星结晶碎片",
                                "个数": "20",
                                "概率": "15.30%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "2",
                                "概率": "1.70%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "个数": "45",
                                "概率": "10.20%"
                            },
                            {
                                "道具": "稀有伙伴结晶碎片",
                                "个数": "80",
                                "概率": "15.30%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "陨星结晶",
                                "个数": "3",
                                "概率": "17.79%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "8",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "7",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "6",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "20",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "6",
                                "概率": "14.23%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "7",
                                "概率": "10.68%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "8",
                                "概率": "7.12%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "3",
                                "概率": "17.79%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【装备寻宝】获得道具概率公布",
                date: "2023-09-15",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '【高级大奖】奖池概率', '【特级大奖】奖池', '【至尊大奖】奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "5.33%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "5000",
                                "概率": "18.67%"
                            },
                            {
                                "道具": "五星装备随机宝箱",
                                "数量": "1",
                                "概率": "0.53%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "300",
                                "概率": "17.87%"
                            },
                            {
                                "道具": "装备材料自选宝箱",
                                "数量": "1",
                                "概率": "5.33%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "300",
                                "概率": "21.33%"
                            },
                            {
                                "道具": "五星装备自选宝箱",
                                "数量": "1",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "10000",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "18.67%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "15",
                                "概率": "8.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1540",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1230",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "770",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "460",
                                "概率": "4.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15400",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "12300",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "7700",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "4600",
                                "概率": "13.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "2300",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1540",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1230",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "770",
                                "概率": "4.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "23100",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "1540",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "12300",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "7700",
                                "概率": "13.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "310",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "230",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "230",
                                "概率": "12.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "120",
                                "概率": "13.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "2310",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "1540",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "23100",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15400",
                                "概率": "22.50%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【蛮石宝藏】概率公布",
                date: "2023-09-13",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布', '单抽连线概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "远古蛮石",
                                "数量": "1",
                                "概率": "38.89%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "2",
                                "概率": "16.67%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "3",
                                "概率": "5.56%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "3",
                                "概率": "5.56%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "1",
                                "概率": "33.33%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "活动",
                            "概率"
                        ],
                        "data": [
                            {
                                "活动": "单抽连线概率",
                                "概率": "0.10304%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【赛季挑战】获得道具概率公布",
                date: "2023-09-11",
                show: false,
                description: "",
                outHeaders: ['赛季宝箱概率', '超级寻宝概率(本概率为首次抽取概率，实际概率随奖池剩余奖励变化而浮动。)'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "高级神器自选宝箱",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1500",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "7500",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "750",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "15000",
                                "概率": "16.36%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "7.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XXII",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "120",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "龙鳞自选宝箱",
                                "数量": "1100",
                                "概率": "0.69%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "150",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "80",
                                "概率": "0.97%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "20",
                                "概率": "1.78%"
                            },
                            {
                                "道具": "史诗五星自选",
                                "数量": "1",
                                "概率": "1.39%"
                            },
                            {
                                "道具": "集结自选宝箱",
                                "数量": "2",
                                "概率": "1.94%"
                            },
                            {
                                "道具": "龙碎片自选宝箱",
                                "数量": "1",
                                "概率": "65.33%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "10",
                                "概率": "14.06%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "20",
                                "概率": "6.54%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "6.45%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幸运魔法】概率公布",
                date: "2023-09-09",
                show: false,
                description: "",
                outHeaders: ['普通奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "1.85%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.18%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "1",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "酋长希拉战纹宝箱",
                                "数量": "1",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "酋长猫战纹宝箱",
                                "数量": "1",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "9.08%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "9.08%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "3",
                                "概率": "3.99%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "3.99%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "3.99%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "4",
                                "概率": "10.99%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "2",
                                "概率": "5.45%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "1",
                                "概率": "5.45%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "2",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "3.63%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.09%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "20",
                                "概率": "3.63%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "数量": "2",
                                "概率": "1.09%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "50",
                                "概率": "1.09%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "4",
                                "概率": "3.63%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "2",
                                "概率": "3.63%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "3.63%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "1.82%"
                            },
                            {
                                "道具": "高级伙伴结晶",
                                "数量": "1",
                                "概率": "0.91%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "180",
                                "概率": "5.45%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "100",
                                "概率": "5.45%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "数量": "1",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "2",
                                "概率": "1.82%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "30",
                                "概率": "1.82%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "2.90%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "2.90%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祖先庇佑】道具概率公布",
                date: "2023-09-08",
                show: false,
                description: "",
                outHeaders: ['触发庇佑模式概率', '古老贝壳奖池', '发光贝壳奖池', '庇佑模式：龙印奖池', '庇佑模式：远古宝物奖池', '庇佑模式：装备', '庇佑模式：龙奖池', '庇佑模式：血精石奖池', '庇佑模式：龟奖池', '庇佑模式：神器&技能鲶鱼奖池', '庇佑模式：战纹奖池', '庇佑模式：BUFF奖池', '庇佑模式：宝石奖池', '庇佑模式：魔骨奖池', '庇佑模式：荣耀&魔法奖池', '庇佑模式：龙结晶'],
                tables: [
                    {
                        "subHeaders": [
                            "行为",
                            "概率"
                        ],
                        "data": [
                            {
                                "行为": "古老贝壳祈祷",
                                "概率": "3.33%"
                            },
                            {
                                "行为": "发光贝壳祈祷",
                                "概率": "20.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "发光贝壳",
                                "数量": "1",
                                "概率": "3.38%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "5.41%"
                            },
                            {
                                "道具": "蓝色祭司碎片",
                                "数量": "2",
                                "概率": "10.14%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "8.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "2",
                                "概率": "21.62%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "1",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "1",
                                "概率": "13.51%"
                            },
                            {
                                "道具": "500,000 象牙",
                                "数量": "1",
                                "概率": "12.16%"
                            },
                            {
                                "道具": "500,000 石头",
                                "数量": "1",
                                "概率": "12.15%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "2.30%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "8",
                                "概率": "24.14%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "8",
                                "概率": "5.75%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "4",
                                "概率": "8.62%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "17.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "900",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "400",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "2500",
                                "概率": "5.94%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1500",
                                "概率": "21.78%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "600",
                                "概率": "1.98%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "400",
                                "概率": "9.90%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "300",
                                "概率": "19.80%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "200",
                                "概率": "29.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "3000",
                                "概率": "0.65%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "600",
                                "概率": "19.54%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "6000",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2500",
                                "概率": "32.57%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "700",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "500",
                                "概率": "3.26%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "400",
                                "概率": "6.51%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "250",
                                "概率": "32.57%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "数量": "900",
                                "概率": "0.71%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "300",
                                "概率": "14.29%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "3000",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "35.71%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "600",
                                "概率": "1.43%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "400",
                                "概率": "3.57%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "250",
                                "概率": "7.14%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "150",
                                "概率": "35.71%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "5",
                                "概率": "7.57%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "37.84%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "10",
                                "概率": "1.51%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "5",
                                "概率": "15.14%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "1",
                                "概率": "37.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100 血精石",
                                "数量": "16",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "8",
                                "概率": "0.99%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "40",
                                "概率": "4.95%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "20",
                                "概率": "9.89%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "150",
                                "概率": "14.84%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "120",
                                "概率": "19.78%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "100",
                                "概率": "49.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "5",
                                "概率": "1.95%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "3",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "31.19%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "10",
                                "概率": "3.90%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "5",
                                "概率": "15.60%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "2",
                                "概率": "31.19%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "高级神器自选宝箱Ⅻ",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "8",
                                "概率": "1.45%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "4",
                                "概率": "4.34%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "2",
                                "概率": "43.35%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "7.23%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "43.35%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "5",
                                "概率": "0.32%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "3.22%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "4",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "26.80%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "20",
                                "概率": "10.72%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "12",
                                "概率": "16.08%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "8",
                                "概率": "21.44%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "15%攻击削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%防御削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "15%生命削弱",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%行军兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "集结兵量增加",
                                "数量": "1",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "50%攻击加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%防御加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "50%生命加成",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "25%行军兵量增加",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天攻击加成",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天防御加成",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天和平守护",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "行军队列",
                                "数量": "1",
                                "概率": "15.98%"
                            },
                            {
                                "道具": "1天反侦查",
                                "数量": "1",
                                "概率": "4.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100宝石",
                                "数量": "100",
                                "概率": "1.28%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "50",
                                "概率": "2.56%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "30",
                                "概率": "6.41%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "20",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "15",
                                "概率": "25.64%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "51.28%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔骨能耗减少",
                                "数量": "1",
                                "概率": "0.38%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "10",
                                "概率": "0.76%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "5",
                                "概率": "3.80%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "2",
                                "概率": "19.01%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "8",
                                "概率": "30.42%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "6",
                                "概率": "45.63%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀旗帜",
                                "数量": "700",
                                "概率": "1.77%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "300",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "250",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "200",
                                "概率": "26.55%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "700",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "300",
                                "概率": "8.85%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "250",
                                "概率": "13.27%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "200",
                                "概率": "26.55%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "8",
                                "概率": "0.17%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "4",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "8",
                                "概率": "1.74%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "3.48%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "3",
                                "概率": "6.96%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "2",
                                "概率": "17.39%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "1",
                                "概率": "69.57%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙吟征战者降临】获得伙伴概率公布",
                date: "2023-09-05",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "龙吟征战者",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "龙吟征战者",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙复制】获得道具概率公布",
                date: "2023-09-01",
                show: false,
                description: "",
                outHeaders: ['三角龙奖池', '暴龙奖池', '双头龙奖池', '始祖龙奖池', '额外奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "三角龙碎片",
                                "数量": "3",
                                "概率": "67.86%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "6",
                                "概率": "22.62%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "9",
                                "概率": "9.05%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "15",
                                "概率": "0.45%"
                            },
                            {
                                "道具": "三角龙",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "暴龙碎片",
                                "数量": "2",
                                "概率": "46.84%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "5",
                                "概率": "42.31%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "8",
                                "概率": "9.07%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "12",
                                "概率": "1.75%"
                            },
                            {
                                "道具": "暴龙",
                                "数量": "1",
                                "概率": "0.03%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "2",
                                "概率": "56.62%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "5",
                                "概率": "31.85%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "8",
                                "概率": "10.62%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "12",
                                "概率": "0.88%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.04%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "2",
                                "概率": "70.78%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "3",
                                "概率": "23.59%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "6",
                                "概率": "5.50%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "10",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.01%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "34.27%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "4",
                                "概率": "24.92%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "8",
                                "概率": "12.46%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "20",
                                "概率": "12.46%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "30",
                                "概率": "9.35%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "4",
                                "概率": "6.23%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "0.31%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【七夕相印莲鲤】概率公布",
                date: "2023-08-22",
                show: false,
                description: "",
                outHeaders: ['奖池道具获得概率', '奖池道具翻倍概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶远古龟",
                                "个数": "1",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "2.33%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "11.66%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "12",
                                "概率": "11.66%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "1",
                                "概率": "11.66%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "80",
                                "概率": "11.66%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "个数": "1",
                                "概率": "9.32%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "个数": "2",
                                "概率": "9.32%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "个数": "4",
                                "概率": "9.32%"
                            },
                            {
                                "道具": "1天加速",
                                "个数": "3",
                                "概率": "9.32%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "10",
                                "概率": "9.32%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "90.00%"
                            },
                            {
                                "倍数": "2",
                                "概率": "7.40%"
                            },
                            {
                                "倍数": "3",
                                "概率": "2.00%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.50%"
                            },
                            {
                                "倍数": "5",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幽影骸龙降临】获得道具概率公布",
                date: "2023-08-21",
                show: false,
                description: "",
                outHeaders: ['寻龙奖励概率', '稀有寻龙奖励概率（不放回奖池的首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有寻龙奖励",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "紫晶远古龟",
                                "数量": "1",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "3",
                                "概率": "0.89%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "3",
                                "概率": "17.02%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "5",
                                "概率": "17.02%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "5",
                                "概率": "17.02%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "10.22%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "1",
                                "概率": "13.62%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "1",
                                "概率": "10.22%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "1",
                                "概率": "6.81%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "1",
                                "概率": "6.81%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "幽影骸龙（友谊）",
                                "数量": "1",
                                "概率": "0.09%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "400",
                                "概率": "17.92%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "50",
                                "概率": "3.58%"
                            },
                            {
                                "道具": "传说五星自选 XXII",
                                "数量": "1",
                                "概率": "0.45%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "16",
                                "概率": "22.40%"
                            },
                            {
                                "道具": "100 双头龙鳞",
                                "数量": "1",
                                "概率": "26.88%"
                            },
                            {
                                "道具": "天陨碎岩",
                                "数量": "12500",
                                "概率": "1.79%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "17.92%"
                            },
                            {
                                "道具": "100 始祖龙鳞",
                                "数量": "6",
                                "概率": "8.96%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2023-08-07",
                show: false,
                description: "",
                outHeaders: ['白银转盘概率公布', '白银宝箱XIII概率公布', '黄金转盘概率公布', '黄金宝箱XII概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱XIII",
                                "数量": "1",
                                "概率": "0.0144%"
                            },
                            {
                                "道具": "至尊据点外观自选VII",
                                "数量": "1",
                                "概率": "0.0010%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1000",
                                "概率": "17.2972%"
                            },
                            {
                                "道具": "白银宝箱XIII",
                                "数量": "1",
                                "概率": "0.0144%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "2000",
                                "概率": "11.5315%"
                            },
                            {
                                "道具": "黄金龟碎片",
                                "数量": "10",
                                "概率": "17.2972%"
                            },
                            {
                                "道具": "白银宝箱XIII",
                                "数量": "1",
                                "概率": "0.0144%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "50",
                                "概率": "10.5705%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "17.2972%"
                            },
                            {
                                "道具": "白银宝箱XIII",
                                "数量": "1",
                                "概率": "0.0144%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "1500",
                                "概率": "25.9458%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0019%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙碎片",
                                "数量": "50",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "80",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "30",
                                "概率": "7.69%"
                            },
                            {
                                "道具": "荣耀自选宝箱",
                                "数量": "400",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "4",
                                "概率": "12.82%"
                            },
                            {
                                "道具": "赤血护腕（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "赤血结晶（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "赤血戒指（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            },
                            {
                                "道具": "赤血项链（橙）",
                                "数量": "1",
                                "概率": "10.26%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱XIII",
                                "数量": "1",
                                "概率": "0.038%"
                            },
                            {
                                "道具": "至尊据点外观自选VIII",
                                "数量": "1",
                                "概率": "0.009%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "700",
                                "概率": "28.254%"
                            },
                            {
                                "道具": "黄金宝箱XIII",
                                "数量": "1",
                                "概率": "0.038%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "23.545%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "70",
                                "概率": "18.836%"
                            },
                            {
                                "道具": "黄金宝箱XIII",
                                "数量": "1",
                                "概率": "0.038%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "50",
                                "概率": "0.942%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1400",
                                "概率": "22.603%"
                            },
                            {
                                "道具": "黄金宝箱XIII",
                                "数量": "1",
                                "概率": "0.038%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "10",
                                "概率": "5.651%"
                            },
                            {
                                "道具": "传说五星自选 XXI",
                                "数量": "1",
                                "概率": "0.009%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "8.330%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "9.900%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "4",
                                "概率": "8.850%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "6.770%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "80",
                                "概率": "16.150%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "800",
                                "概率": "15.630%"
                            },
                            {
                                "道具": "赤血护腕（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "赤血结晶（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "赤血戒指（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            },
                            {
                                "道具": "赤血项链（闪紫）",
                                "数量": "1",
                                "概率": "4.170%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2023-08-04",
                show: false,
                description: "",
                outHeaders: ['精灵王子伙伴池', '援琴女神伙伴池', '烈焰剑魔伙伴池', '泰坦古克伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【精灵王子】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【援琴女神】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【烈焰剑魔】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【泰坦古克】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2023-08-01",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D', '大奖奖池E'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "3.61%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "紫色祭司碎片",
                                "数量": "1",
                                "概率": "0.59%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "5.92%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "1.48%"
                            },
                            {
                                "道具": "酋长猫头鹰战纹宝箱",
                                "数量": "1",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "酋长猫战纹宝箱",
                                "数量": "1",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "15",
                                "概率": "8.89%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "10",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "8",
                                "概率": "8.89%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "6",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "4",
                                "概率": "8.89%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "5.92%"
                            },
                            {
                                "道具": "3天加速",
                                "数量": "2",
                                "概率": "5.92%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "3",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "1.48%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "5.92%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "5.92%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "1.48%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "8",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "5.92%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "数量": "1",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "2",
                                "概率": "1.48%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "0.59%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "1",
                                "概率": "0.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "5",
                                "概率": "95.00%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "6",
                                "概率": "3.20%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "月宫仙子·嫦娥碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "5",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "6",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "炎帝·神农碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "8",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "10",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "12",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "14",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "16",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "24",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黎明女神·厄俄斯碎片",
                                "数量": "25",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "黎明女神·厄俄斯碎片",
                                "数量": "30",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "黎明女神·厄俄斯碎片",
                                "数量": "35",
                                "概率": "7.70%"
                            },
                            {
                                "道具": "黎明女神·厄俄斯碎片",
                                "数量": "40",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "黎明女神·厄俄斯碎片",
                                "数量": "50",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "黎明女神·厄俄斯碎片",
                                "数量": "75",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "25",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "30",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "35",
                                "概率": "7.70%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "40",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "50",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "75",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定宠物降临】概率公布",
                date: "2023-07-28",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '稀有奖池（首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "蛮小七（永久）",
                                "个数": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "1",
                                "概率": "0.29%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "个数": "5",
                                "概率": "14.66%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "个数": "10",
                                "概率": "14.66%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "10",
                                "概率": "8.80%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "100",
                                "概率": "14.66%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "8.80%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "2",
                                "概率": "5.86%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "个数": "3",
                                "概率": "8.80%"
                            },
                            {
                                "道具": "1天加速",
                                "个数": "4",
                                "概率": "8.80%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "10",
                                "概率": "14.66%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "蛮小七（友谊）",
                                "个数": "1",
                                "概率": "1.02%"
                            },
                            {
                                "道具": "神秘马戏团（友谊）",
                                "个数": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "200",
                                "概率": "11.23%"
                            },
                            {
                                "道具": "传说五星自选 XXI",
                                "个数": "1",
                                "概率": "0.41%"
                            },
                            {
                                "道具": "100 血精石",
                                "个数": "20",
                                "概率": "12.25%"
                            },
                            {
                                "道具": "陨星结晶",
                                "个数": "100",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "100 始祖龙鳞",
                                "个数": "1",
                                "概率": "13.68%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "个数": "1",
                                "概率": "10.21%"
                            },
                            {
                                "道具": "100 双头龙鳞",
                                "个数": "1",
                                "概率": "51.08%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂野狩猎】狩猎猛犸象概率公布",
                date: "2023-07-24",
                show: false,
                description: "",
                outHeaders: ['狂野模式狩猎奖池', '狂野模式灵魂宝箱奖池', '普通模式狩猎奖池', '普通模式灵魂宝箱奖池', '最后一击额外奖励（必得雷神祝福油）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "1",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "1",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "天演·强攻符文-Lv.1",
                                "数量": "1",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "天演·致残符文-Lv.1",
                                "数量": "1",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "18.00%"
                            },
                            {
                                "道具": "8小时训练加速",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "8小时研究加速",
                                "数量": "1",
                                "概率": "9.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "11",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "11",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "22",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "22",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "33",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "33",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "1",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "1",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "天演·强攻符文-Lv.1",
                                "数量": "1",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "天演·致残符文-Lv.1",
                                "数量": "1",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "18.00%"
                            },
                            {
                                "道具": "8小时训练加速",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "8小时研究加速",
                                "数量": "1",
                                "概率": "9.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "1",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "1",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "2",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "2",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "3",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "3",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天演·嗜血符文-Lv.1",
                                "数量": "1",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天演·重击符文-Lv.1",
                                "数量": "1",
                                "概率": "25.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】概率公布",
                date: "2023-07-21",
                show: false,
                description: "",
                outHeaders: ['【龙印寻宝】概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄碎片*600",
                                "数量": "22",
                                "概率": "19.78%"
                            },
                            {
                                "道具": "龙魄碎片*900",
                                "数量": "20",
                                "概率": "16.19%"
                            },
                            {
                                "道具": "龙魄结晶*100",
                                "数量": "20",
                                "概率": "8.99%"
                            },
                            {
                                "道具": "龙魄碎片*1200",
                                "数量": "12",
                                "概率": "10.79%"
                            },
                            {
                                "道具": "龙魄碎片*1500",
                                "数量": "10",
                                "概率": "7.19%"
                            },
                            {
                                "道具": "龙魄结晶*150",
                                "数量": "10",
                                "概率": "3.60%"
                            },
                            {
                                "道具": "100宝石*5",
                                "数量": "18",
                                "概率": "14.39%"
                            },
                            {
                                "道具": "1小时加速*10",
                                "数量": "18",
                                "概率": "17.99%"
                            },
                            {
                                "道具": "五星龙印特级随机宝箱*1",
                                "数量": "1",
                                "概率": "0.51%"
                            },
                            {
                                "道具": "五星龙印自选宝箱I*1",
                                "数量": "1",
                                "概率": "0.34%"
                            },
                            {
                                "道具": "五星龙印自选宝箱II*1",
                                "数量": "1",
                                "概率": "0.17%"
                            },
                            {
                                "道具": "五星龙印自选宝箱III*1",
                                "数量": "1",
                                "概率": "0.07%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幸运魔法】概率公布",
                date: "2023-07-13",
                show: false,
                description: "",
                outHeaders: ['普通奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "2.81%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "酋长希拉战纹宝箱",
                                "数量": "1",
                                "概率": "1.18%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "2",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "5",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "5",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "7.07%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "1",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "8",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "40",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "5",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "4",
                                "概率": "7.07%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "2",
                                "概率": "7.07%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "1",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "3",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "3天加速",
                                "数量": "3",
                                "概率": "1.18%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "5",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "4",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "20",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "数量": "1",
                                "概率": "1.18%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "1",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "2",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "高级资源自选宝箱",
                                "数量": "1",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "150",
                                "概率": "4.71%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "数量": "2",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "2",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "50",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "2.36%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【深海恐兽降临】获得伙伴概率公布",
                date: "2023-07-10",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "深海恐兽",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "深海恐兽",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】活动概率公布",
                date: "2023-06-27",
                show: false,
                description: "",
                outHeaders: ['普通奖池：', '稀有奖池（首次抽取概率）'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "紫晶远古龟",
                                "个数": "1",
                                "概率": "0.86%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "2.19%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "2.19%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "10.93%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "10",
                                "概率": "10.93%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "个数": "10",
                                "概率": "10.93%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "90",
                                "概率": "10.93%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "个数": "2",
                                "概率": "7.10%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "个数": "2",
                                "概率": "10.93%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "个数": "4",
                                "概率": "10.93%"
                            },
                            {
                                "道具": "1天加速",
                                "个数": "3",
                                "概率": "10.93%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "10",
                                "概率": "10.93%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有自选大奖II",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "稀有自选大奖I-1",
                                "概率": "32.79%"
                            },
                            {
                                "道具": "稀有自选大奖I-2",
                                "概率": "32.79%"
                            },
                            {
                                "道具": "稀有自选大奖I-3",
                                "概率": "32.79%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【粽香料理】获得道具概率公布",
                date: "2023-06-20",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率', '盛宴奖池概率（盛宴奖池为不放回奖池）', '稀有奖池1', '稀有奖池2', '稀有奖池3'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "香粽",
                                "数量": "15",
                                "概率": "3.00%"
                            },
                            {
                                "道具": "香粽",
                                "数量": "10",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "香粽",
                                "数量": "5",
                                "概率": "12.00%"
                            },
                            {
                                "道具": "香粽",
                                "数量": "3",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "3",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "1",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "1",
                                "概率": "7.00%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "3",
                                "概率": "7.00%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "3",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "3",
                                "概率": "11.00%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "5",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "子奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "子奖池": "稀有奖池1",
                                "概率": "0.38%"
                            },
                            {
                                "子奖池": "稀有奖池2",
                                "概率": "1.92%"
                            },
                            {
                                "子奖池": "稀有奖池2",
                                "概率": "1.92%"
                            },
                            {
                                "子奖池": "稀有奖池3",
                                "概率": "19.16%"
                            },
                            {
                                "子奖池": "稀有奖池3",
                                "概率": "19.16%"
                            },
                            {
                                "子奖池": "稀有奖池3",
                                "概率": "19.16%"
                            },
                            {
                                "子奖池": "稀有奖池3",
                                "概率": "19.16%"
                            },
                            {
                                "子奖池": "稀有奖池3",
                                "概率": "19.16%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "出现概率"
                        ],
                        "data": [
                            {
                                "道具": "碧波龙舟",
                                "数量": "1",
                                "出现概率": "33.33%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "出现概率": "33.33%"
                            },
                            {
                                "道具": "香粽",
                                "数量": "300",
                                "出现概率": "33.33%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "出现概率"
                        ],
                        "data": [
                            {
                                "道具": "香粽",
                                "数量": "100",
                                "出现概率": "16.67%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "100",
                                "出现概率": "16.67%"
                            },
                            {
                                "道具": "陨星结晶",
                                "数量": "5",
                                "出现概率": "16.67%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "10",
                                "出现概率": "16.67%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "数量": "2",
                                "出现概率": "16.67%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "1000",
                                "出现概率": "16.67%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "出现概率"
                        ],
                        "data": [
                            {
                                "道具": "香粽",
                                "数量": "50",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "数量": "1",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "10",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "20",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "25",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "3",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "5",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "30",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "50%攻击加成",
                                "数量": "1",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "50%防御加成",
                                "数量": "1",
                                "出现概率": "9.09%"
                            },
                            {
                                "道具": "50%生命加成",
                                "数量": "1",
                                "出现概率": "9.09%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【蛮石宝藏】概率公布",
                date: "2023-06-13",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布', '单抽连线概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "远古蛮石",
                                "数量": "1",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "1",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "2",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "3",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "2",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "活动",
                            "概率"
                        ],
                        "data": [
                            {
                                "活动": "单抽连线概率",
                                "概率": "0.123%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2023-06-12",
                show: false,
                description: "",
                outHeaders: ['白银转盘概率公布', '白银宝箱XII概率公布', '黄金转盘概率公布', '黄金宝箱XII概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "至尊据点外观自选Ⅵ",
                                "数量": "1",
                                "概率": "0.0010%"
                            },
                            {
                                "道具": "黄金龟碎片",
                                "数量": "10",
                                "概率": "24.7471%"
                            },
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "荣耀自选宝箱",
                                "数量": "1",
                                "概率": "11.4217%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "1",
                                "概率": "22.8434%"
                            },
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "2",
                                "概率": "9.5181%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "23.7952%"
                            },
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "5",
                                "概率": "7.6145%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0019%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "50",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "80",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "8.75%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "30",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "400",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "800",
                                "概率": "11.25%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "10",
                                "概率": "21.25%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "50",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "50",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "20",
                                "概率": "2.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选VII",
                                "数量": "1",
                                "概率": "0.008%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "12.533%"
                            },
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "29.245%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "25",
                                "概率": "25.067%"
                            },
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "100",
                                "概率": "1.671%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "10",
                                "概率": "25.485%"
                            },
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "45",
                                "概率": "5.849%"
                            },
                            {
                                "道具": "传说五星自选 XX",
                                "数量": "1",
                                "概率": "0.008%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "80",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "100",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "80",
                                "概率": "18.00%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "10",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2023-06-09",
                show: false,
                description: "",
                outHeaders: ['魅影刺客伙伴池', '行者伙伴池', '虎王巴布伙伴池', '人鱼塞壬伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【魅影刺客】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【行者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【虎王巴布】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【人鱼塞壬】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【远古寻宝】获得道具概率公布",
                date: "2023-06-05",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '特殊奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "五星宝物碎片高级宝箱",
                                "数量": "1",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "五星宝物碎片宝箱",
                                "数量": "1",
                                "概率": "1.12%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "60",
                                "概率": "11.25%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "80",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "1.12%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "600",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "800",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "5.65%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "6000",
                                "概率": "0.22%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "8000",
                                "概率": "1.12%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "0.56%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "4",
                                "概率": "5.62%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "15",
                                "概率": "5.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "五星宝物自选宝箱VI",
                                "数量": "1",
                                "概率": "0.001%"
                            },
                            {
                                "道具": "五星宝物自选宝箱V",
                                "数量": "1",
                                "概率": "0.002%"
                            },
                            {
                                "道具": "五星宝物自选宝箱IV",
                                "数量": "1",
                                "概率": "0.017%"
                            },
                            {
                                "道具": "五星宝物自选宝箱III",
                                "数量": "1",
                                "概率": "0.110%"
                            },
                            {
                                "道具": "五星宝物自选宝箱II",
                                "数量": "1",
                                "概率": "0.430%"
                            },
                            {
                                "道具": "五星宝物自选宝箱I",
                                "数量": "1",
                                "概率": "2.140%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "100",
                                "概率": "12.860%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "150",
                                "概率": "42.860%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "12.860%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1500",
                                "概率": "25.720%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "0.860%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "15000",
                                "概率": "2.140%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙突破活动】获得道具概率公布",
                date: "2023-06-03",
                show: false,
                description: "",
                outHeaders: ['普通模式触发转盘奖励概率', '积分获得方式', '普通模式奖励', '转盘奖励', '超级描绘奖励-始祖龙鳞奖池', '超级描绘奖励-双头龙鳞奖池', '超级描绘奖励-暴龙鳞奖池', '超级描绘奖励-三角龙鳞奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "描绘1次触发转盘概率",
                                "概率": "5.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "方式",
                            "积分"
                        ],
                        "data": [
                            {
                                "方式": "普通描绘1次获得积分",
                                "积分": "1分"
                            },
                            {
                                "方式": "触发转盘获得额外积分",
                                "积分": "10分-20分（初始为10分，每触发1次转盘，额外积分基数增加1分，20分封顶）"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "2",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "4",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "2",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "8",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "4",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "16",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "8",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "9",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "3",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "3",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "2",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "1",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "4",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "2",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "8",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "4",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "16",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "8",
                                "概率": "12.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 始祖龙鳞",
                                "数量": "1",
                                "概率": "2.000%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "8",
                                "概率": "3.000%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "6",
                                "概率": "5.000%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "5",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "4",
                                "概率": "12.000%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "3",
                                "概率": "18.000%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "2",
                                "概率": "20.000%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "数量": "1",
                                "概率": "30.000%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "2",
                                "概率": "2.000%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "16",
                                "概率": "3.000%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "12",
                                "概率": "5.000%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "10",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "8",
                                "概率": "12.000%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "6",
                                "概率": "18.000%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "4",
                                "概率": "20.000%"
                            },
                            {
                                "道具": "1 双头龙鳞",
                                "数量": "2",
                                "概率": "30.000%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "4",
                                "概率": "2.000%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "32",
                                "概率": "3.000%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "24",
                                "概率": "5.000%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "20",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "16",
                                "概率": "12.000%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "12",
                                "概率": "18.000%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "8",
                                "概率": "20.000%"
                            },
                            {
                                "道具": "1 暴龙鳞",
                                "数量": "4",
                                "概率": "30.000%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "8",
                                "概率": "2.000%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "64",
                                "概率": "3.000%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "48",
                                "概率": "5.000%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "40",
                                "概率": "10.000%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "32",
                                "概率": "12.000%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "24",
                                "概率": "18.000%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "16",
                                "概率": "20.000%"
                            },
                            {
                                "道具": "1 三角龙鳞",
                                "数量": "8",
                                "概率": "30.000%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】获得道具概率公布",
                date: "2023-05-26",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '触发大奖奖池概率', '抽取次数-概率变化', '宝箱大奖奖池概率-高级奖池', '宝箱大奖奖池概率-特级奖池', '宝箱大奖奖池概率-至尊奖池', '宝箱道具概率-五星龙印随机宝箱', '宝箱道具概率-五星龙印高级随机宝箱', '宝箱道具概率-五星龙印特级随机宝箱'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "150",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1600",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "五星龙印随机宝箱",
                                "数量": "2",
                                "概率": "0.59%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "600",
                                "概率": "23.60%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1200",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "11.80%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "13000",
                                "概率": "23.60%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "20000",
                                "概率": "11.80%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "25000",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "4",
                                "概率": "23.60%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "0.80%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "100次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.72%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.00%"
                            },
                            {
                                "奖池类型": "100-500次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.48%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.24%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "500次以上",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.16%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.40%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.100%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.184%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.552%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "1.655%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "110",
                                "概率": "0.046%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1100",
                                "概率": "0.460%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "11000",
                                "概率": "4.597%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "0.460%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "45.973%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "45.973%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.050%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.150%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.184%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.551%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "1.653%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "130",
                                "概率": "0.046%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1300",
                                "概率": "0.459%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "13200",
                                "概率": "4.593%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "120",
                                "概率": "0.459%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1200",
                                "概率": "45.927%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "12000",
                                "概率": "45.927%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级龙印",
                                "数量": "1",
                                "概率": "0.012%"
                            },
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.048%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.240%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.443%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "1.329%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "3.986%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "160",
                                "概率": "0.044%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1600",
                                "概率": "0.443%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "16000",
                                "概率": "4.429%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "144",
                                "概率": "0.443%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1440",
                                "概率": "44.291%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "14400",
                                "概率": "44.291%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.24%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "2.34%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "96.72%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.41%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "1.23%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "4.11%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "8.56%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "85.56%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.18%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.53%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "1.58%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "5.28%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "4.40%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "44.01%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "44.01%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幸运魔法】概率公布",
                date: "2023-05-25",
                show: false,
                description: "",
                outHeaders: ['普通奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "3.08%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.31%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "2",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "5",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "10 三角龙鳞",
                                "数量": "5",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "1",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "8",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "40",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "5",
                                "概率": "1.26%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "4",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "2",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "幸运伙伴碎片",
                                "数量": "1",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "3",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "1",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "3天加速",
                                "数量": "3",
                                "概率": "1.26%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "5",
                                "概率": "0.56%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "4",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "20",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "数量": "1",
                                "概率": "1.26%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "2",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "高级资源自选宝箱",
                                "数量": "1",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "150",
                                "概率": "5.04%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "数量": "2",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "2",
                                "概率": "2.52%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "50",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "2.52%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【装备寻宝】获得道具概率公布",
                date: "2023-05-22",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '触发大奖奖池概率', '三种大奖奖池概率-1-100次', '三种大奖奖池概率-100-500次', '三种大奖奖池概率-500次以上', '【高级大奖】奖池概率', '【特级大奖】奖池', '【至尊大奖】奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "五星装备自选宝箱",
                                "数量": "1",
                                "概率": "0.25%"
                            },
                            {
                                "道具": "五星装备随机宝箱",
                                "数量": "1",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "装备材料自选宝箱",
                                "数量": "1",
                                "概率": "4.25%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "800",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "8000",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "500",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "300",
                                "概率": "12.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "4000",
                                "概率": "16.25%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "5000",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "3000",
                                "概率": "26.25%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "0.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "高级大奖",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级大奖",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊大奖",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "300",
                                "概率": "4.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "800",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "500",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "3000",
                                "概率": "13.40%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "10000",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "8000",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "5000",
                                "概率": "22.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "500",
                                "概率": "4.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "800",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "5000",
                                "概率": "13.40%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15000",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "10000",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "8000",
                                "概率": "22.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "200",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "150",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1500",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "15000",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "150",
                                "概率": "12.00%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "80",
                                "概率": "13.40%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "22.50%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "10000",
                                "概率": "22.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【精灵王子降临】获得伙伴概率公布",
                date: "2023-05-15",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "精灵王子",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "精灵王子",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【符文共鸣】天演·始动符文池概率更新",
                date: "2023-05-12",
                show: false,
                description: "",
                outHeaders: ['【符文共鸣】天演·始动符文池概率更新'],
                tables: [
                    {
                        "subHeaders": [
                            "符文类型",
                            "符文数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "1",
                                "概率": "4.19%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "2",
                                "概率": "12.10%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "4",
                                "概率": "7.10%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "6",
                                "概率": "1.61%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "1",
                                "概率": "4.19%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "2",
                                "概率": "12.10%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "4",
                                "概率": "7.10%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "6",
                                "概率": "1.61%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "1",
                                "概率": "0.81%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "2",
                                "概率": "2.42%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "4",
                                "概率": "4.92%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "6",
                                "概率": "6.85%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "1",
                                "概率": "0.81%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "2",
                                "概率": "2.42%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "4",
                                "概率": "4.92%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "6",
                                "概率": "6.85%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "1",
                                "概率": "0.56%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "2",
                                "概率": "1.69%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "4",
                                "概率": "3.31%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "6",
                                "概率": "4.44%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "1",
                                "概率": "0.56%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "2",
                                "概率": "1.69%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "4",
                                "概率": "3.31%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "6",
                                "概率": "4.44%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【蛮石宝藏】概率公布",
                date: "2023-05-10",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布', '单抽连线概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "远古蛮石",
                                "数量": "3",
                                "概率": "6.67%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "2",
                                "概率": "13.33%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "1",
                                "概率": "26.67%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "1",
                                "概率": "26.67%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "2",
                                "概率": "26.67%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "活动",
                            "概率"
                        ],
                        "data": [
                            {
                                "活动": "单抽连线概率",
                                "概率": "0.143%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【怪物猎人】最后一击奖励概率公布",
                date: "2023-05-09",
                show: false,
                description: "",
                outHeaders: ['【怪物猎人】最后一击奖励概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "8小时加速",
                                "数量": "2",
                                "概率": "19.08%"
                            },
                            {
                                "道具": "8小时加速",
                                "数量": "5",
                                "概率": "19.08%"
                            },
                            {
                                "道具": "3小时加速",
                                "数量": "17",
                                "概率": "19.08%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "2",
                                "概率": "19.08%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "5",
                                "概率": "19.08%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "7",
                                "概率": "1.91%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "10",
                                "概率": "1.91%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "12",
                                "概率": "0.38%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "25",
                                "概率": "0.38%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【伙伴祝福】获得道具概率公布",
                date: "2023-05-06",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "太古黑曜水晶",
                                "数量": "5",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "10",
                                "概率": "2.30%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "8",
                                "概率": "3.49%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "5",
                                "概率": "11.75%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "3",
                                "概率": "16.43%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "1",
                                "概率": "18.91%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "7",
                                "概率": "2.36%"
                            },
                            {
                                "道具": "石币礼盒",
                                "数量": "1",
                                "概率": "16.66%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "3",
                                "概率": "8.10%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "16.43%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "3.51%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【春日探险】获得道具概率公布",
                date: "2023-04-30",
                show: false,
                description: "",
                outHeaders: ['普通奖励', '幸运大奖奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "幸运大奖奖池",
                                "个数": "1",
                                "概率": "2.09%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "10",
                                "概率": "0.26%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "个数": "5",
                                "概率": "1.31%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "个数": "20",
                                "概率": "2.62%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "30",
                                "概率": "14.40%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "5",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "个数": "5",
                                "概率": "13.09%"
                            },
                            {
                                "道具": "暴龙鳞",
                                "个数": "30",
                                "概率": "6.54%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "1",
                                "概率": "10.47%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "15",
                                "概率": "11.78%"
                            },
                            {
                                "道具": "双头龙鳞",
                                "个数": "10",
                                "概率": "10.47%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "个数": "80",
                                "概率": "11.78%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "3",
                                "概率": "1.57%"
                            },
                            {
                                "道具": "暴龙鳞",
                                "个数": "15",
                                "概率": "12.04%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "个数": "1",
                                "概率": "0.006%"
                            },
                            {
                                "道具": "始祖龙鳞",
                                "个数": "100",
                                "概率": "0.059%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "50",
                                "概率": "35.251%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "200",
                                "概率": "58.751%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "个数": "50",
                                "概率": "5.875%"
                            },
                            {
                                "道具": "旭日骄阳钻石（永久）",
                                "个数": "1",
                                "概率": "0.059%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "开斋节系列活动沙漠狂欢概率公布",
                date: "2023-04-21",
                show: false,
                description: "",
                outHeaders: ['开斋节系列活动沙漠狂欢概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "活动",
                            "概率"
                        ],
                        "data": [
                            {
                                "活动": "幸运格子概率",
                                "概率": "2%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2023-04-17",
                show: false,
                description: "",
                outHeaders: ['白银转盘概率公布', '白银宝箱XII概率公布', '黄金转盘概率公布', '黄金宝箱XII概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "至尊据点外观自选Ⅴ",
                                "数量": "1",
                                "概率": "0.0010%"
                            },
                            {
                                "道具": "黄金龟碎片",
                                "数量": "10",
                                "概率": "24.7471%"
                            },
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "荣耀自选宝箱",
                                "数量": "1",
                                "概率": "11.4217%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "1",
                                "概率": "22.8434%"
                            },
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "紫晶神奇龟碎片",
                                "数量": "2",
                                "概率": "9.5181%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "23.7952%"
                            },
                            {
                                "道具": "白银宝箱XII",
                                "数量": "1",
                                "概率": "0.0143%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "5",
                                "概率": "7.6145%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0019%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "50",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "80",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "8.75%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "30",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "400",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "800",
                                "概率": "11.25%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "10",
                                "概率": "21.25%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "50",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "50",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "20",
                                "概率": "2.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "至尊据点外观自选Ⅵ",
                                "数量": "1",
                                "概率": "0.008%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "12.533%"
                            },
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "荣耀资源自选宝箱",
                                "数量": "1",
                                "概率": "29.245%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "25",
                                "概率": "25.067%"
                            },
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "100",
                                "概率": "1.671%"
                            },
                            {
                                "道具": "稀有钻石神奇龟碎片",
                                "数量": "10",
                                "概率": "25.485%"
                            },
                            {
                                "道具": "黄金宝箱XII",
                                "数量": "1",
                                "概率": "0.033%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "45",
                                "概率": "5.849%"
                            },
                            {
                                "道具": "传说五星自选 XIX",
                                "数量": "1",
                                "概率": "0.008%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "80",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "100",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "80",
                                "概率": "18.00%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "10",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2023-04-13",
                show: false,
                description: "",
                outHeaders: ['援琴女神伙伴池', '烈焰剑魔伙伴池', '血咒怨灵伙伴池', '吸血鬼塔娜伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【行者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【人鱼塞壬】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【血咒怨灵】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【泰坦古克】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2022-04-10",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "3.03%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.30%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "紫色祭司碎片",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "1",
                                "概率": "1.72%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "1",
                                "概率": "1.24%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "信仰火炬",
                                "数量": "1",
                                "概率": "0.45%"
                            },
                            {
                                "道具": "信仰圣水",
                                "数量": "1",
                                "概率": "1.24%"
                            },
                            {
                                "道具": "酋长猫战纹宝箱",
                                "数量": "1",
                                "概率": "1.24%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "20",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "10",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "未知祭司碎片",
                                "数量": "5",
                                "概率": "1.24%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "1",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "5",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "3",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "3",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "3天加速",
                                "数量": "2",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "4",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "25",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "数量": "1",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "1",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "高级资源自选宝箱",
                                "数量": "1",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "1",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "4",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "数量": "2",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "2",
                                "概率": "4.97%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "2.48%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "1",
                                "概率": "0.01%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "5",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "6",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "冥神·哈迪斯碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "5",
                                "概率": "80.00%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "6",
                                "概率": "13.20%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "7",
                                "概率": "4.50%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "8",
                                "概率": "1.50%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "10",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "8",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "10",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "12",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "14",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "16",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "24",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "25",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "30",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "35",
                                "概率": "7.70%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "40",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "50",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "75",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【狂野狩猎】狩猎猛犸象概率公布",
                date: "2023-04-03",
                show: false,
                description: "",
                outHeaders: ['狂野模式狩猎奖池', '狂野模式灵魂宝箱奖池', '最后一击额外奖励（必得雷神祝福油）', '普通模式狩猎奖池', '普通模式灵魂宝箱奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "11",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "11",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "天演·强攻符文-Lv.1",
                                "数量": "11",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "天演·致残符文-Lv.1",
                                "数量": "11",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "嗜血符文-Lv.1",
                                "数量": "11",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "重击符文-Lv.1",
                                "数量": "11",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "11",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "11",
                                "概率": "16.00%"
                            },
                            {
                                "道具": "8小时训练加速",
                                "数量": "11",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "8小时研究加速",
                                "数量": "11",
                                "概率": "4.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "11",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "11",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "22",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "22",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "33",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "33",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "2",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "1",
                                "概率": "25.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "1",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "1",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "1",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "天演·强攻符文-Lv.1",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "天演·致残符文-Lv.1",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "嗜血符文-Lv.1",
                                "数量": "1",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "重击符文-Lv.1",
                                "数量": "1",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "50宝石",
                                "数量": "1",
                                "概率": "16.00%"
                            },
                            {
                                "道具": "8小时训练加速",
                                "数量": "1",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "8小时研究加速",
                                "数量": "1",
                                "概率": "4.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "1",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "1",
                                "概率": "45.00%"
                            },
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "2",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "2",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "天演·天火符文-Lv.1",
                                "数量": "3",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "天演·战吼符文-Lv.1",
                                "数量": "3",
                                "概率": "1.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【占卜赞歌】概率公布",
                date: "2023-03-29",
                show: false,
                description: "",
                outHeaders: ['普通奖励', '特殊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "占卜秘钥（特殊奖池）",
                                "数量": "1",
                                "概率": "0.39%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "史诗信物宝箱",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "1.58%"
                            },
                            {
                                "道具": "紫晶远古龟",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "1",
                                "概率": "3.95%"
                            },
                            {
                                "道具": "稀有信物宝箱",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "远古神奇龟",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "数量": "1",
                                "概率": "7.89%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "11.84%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "23.68%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "2",
                                "概率": "23.68%"
                            },
                            {
                                "道具": "黄金龟碎片",
                                "数量": "50",
                                "概率": "23.68%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XVIII",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "10",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "10",
                                "概率": "2.31%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.46%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "3",
                                "概率": "4.63%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "10",
                                "概率": "46.25%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "3",
                                "概率": "46.25%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙祈愿】概率更新",
                date: "2023-03-28",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '珍稀转盘奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "15",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "10",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "3",
                                "概率": "1.37%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "8.58%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "20",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "12",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "5",
                                "概率": "1.37%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "2",
                                "概率": "8.58%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "2",
                                "概率": "0.69%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "5",
                                "概率": "6.86%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "3",
                                "概率": "15.10%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "11",
                                "概率": "24.02%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "1",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "1",
                                "概率": "10.98%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "1",
                                "概率": "12.63%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "9.13%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "转盘奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "转盘奖励": "超级大奖",
                                "概率": "2.00%"
                            },
                            {
                                "转盘奖励": "次级大奖",
                                "概率": "5.00%"
                            },
                            {
                                "转盘奖励": "三级大奖",
                                "概率": "93.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【野蛮挑战宝箱】概率公布",
                date: "2023-03-27",
                show: false,
                description: "",
                outHeaders: ['宝箱奖励说明', '普通奖励', '高级奖励', '超级大奖'],
                tables: [
                    {
                        "subHeaders": [
                            "宝箱类型",
                            "奖励"
                        ],
                        "data": [
                            {
                                "宝箱类型": "挑战宝箱",
                                "奖励": "开启挑战宝箱会获得四份奖励，前三份奖励为普通奖励，第四份奖励1%概率为高级奖励，99%概率为普通奖励。"
                            },
                            {
                                "宝箱类型": "超级挑战宝箱",
                                "奖励": "开启超级挑战宝箱会获得四份奖励，前三份奖励为普通奖励，第四份奖励1%概率为超级大奖，99%概率为高级奖励。"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法粉尘",
                                "数量": "8000",
                                "概率": "11.87%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "800",
                                "概率": "5.93%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "11.87%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "500",
                                "概率": "5.93%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "4000",
                                "概率": "11.87%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "400",
                                "概率": "5.93%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "5",
                                "概率": "10.40%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "2",
                                "概率": "5.94%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "5",
                                "概率": "6.53%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "2",
                                "概率": "5.93%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "50",
                                "概率": "11.87%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "25",
                                "概率": "5.93%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "远古蛮石",
                                "数量": "50",
                                "概率": "6.25%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "40",
                                "概率": "28.75%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "5",
                                "概率": "6.25%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "4",
                                "概率": "28.75%"
                            },
                            {
                                "道具": "赤血护腕（绿）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "赤血结晶（绿）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "赤血戒指（绿）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "赤血项链（绿）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "黑龙之首（白）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "黑龙之牙（白）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "黑龙之翼（白）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "黑龙之爪（白）",
                                "数量": "1",
                                "概率": "2.50%"
                            },
                            {
                                "道具": "紫晶头盔（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "紫晶项链（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "紫晶胸甲（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "紫晶臂铠（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "紫晶腿甲（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "紫晶战靴（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "紫晶剑（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "紫晶盾牌（蓝）",
                                "数量": "1",
                                "概率": "1.25%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "传说五星自选 XⅥ",
                                "数量": "1",
                                "概率": "1.96%"
                            },
                            {
                                "道具": "不朽的据点外观自选",
                                "数量": "1",
                                "概率": "3.89%"
                            },
                            {
                                "道具": "鸿蒙主宰者",
                                "数量": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "远古守护（永久）",
                                "数量": "1",
                                "概率": "0.79%"
                            },
                            {
                                "道具": "赤血护腕（紫）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "赤血结晶（紫）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "赤血戒指（紫）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "赤血项链（紫）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "黑龙之首（橙）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "黑龙之牙（橙）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "黑龙之翼（橙）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "黑龙之爪（橙）",
                                "数量": "1",
                                "概率": "7.75%"
                            },
                            {
                                "道具": "紫晶头盔（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "紫晶项链（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "紫晶胸甲（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "紫晶臂铠（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "紫晶腿甲（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "紫晶战靴（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "紫晶剑（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            },
                            {
                                "道具": "紫晶盾牌（闪紫）",
                                "数量": "1",
                                "概率": "3.87%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【龙印寻宝】获得道具概率公布",
                date: "2023-03-25",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '触发大奖奖池概率', '抽取次数-概率变化', '宝箱大奖奖池概率-高级奖池', '宝箱大奖奖池概率-特级奖池', '宝箱大奖奖池概率-至尊奖池', '宝箱道具概率-五星龙印随机宝箱', '五星龙印高级随机宝箱', '五星龙印特级随机宝箱'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "五星龙印随机宝箱",
                                "数量": "2",
                                "概率": "0.68%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "600",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "27.15%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "12500",
                                "概率": "27.15%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "15000",
                                "概率": "13.58%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "20000",
                                "概率": "1.63%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "25000",
                                "概率": "0.68%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "27.15%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "0.80%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "100次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.72%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.00%"
                            },
                            {
                                "奖池类型": "100-500次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.48%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.24%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "500次以上",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.16%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.40%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.100%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.176%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.529%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "1.588%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "22",
                                "概率": "0.004%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "240",
                                "概率": "0.044%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6000",
                                "概率": "0.441%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "20",
                                "概率": "0.044%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "200",
                                "概率": "8.825%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "88.247%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.050%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.150%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.184%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.551%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "1.653%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "24",
                                "概率": "0.046%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "260",
                                "概率": "0.459%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6600",
                                "概率": "0.459%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "22",
                                "概率": "4.593%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "220",
                                "概率": "45.927%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5500",
                                "概率": "45.927%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级龙印",
                                "数量": "1",
                                "概率": "0.012%"
                            },
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.048%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.240%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.451%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "1.354%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "26",
                                "概率": "0.406%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "280",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "7200",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "24",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "240",
                                "概率": "40.620%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6000",
                                "概率": "40.620%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "2.34%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "96.72%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.41%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "1.23%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "4.11%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "8.56%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "85.56%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.16%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "1.47%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "4.90%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "1.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "10.22%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "81.73%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祖先庇佑】道具概率公布",
                date: "2023-03-24",
                show: false,
                description: "",
                outHeaders: ['触发庇佑模式概率', '古老贝壳奖池', '发光贝壳奖池', '庇佑模式：龙印奖池', '庇佑模式：远古宝物奖池', '庇佑模式：装备奖池', '庇佑模式：龙奖池', '庇佑模式：血精石奖池', '庇佑模式：龟奖池', '庇佑模式：神器&技能鲶鱼奖池', '庇佑模式：战纹奖池', '庇佑模式：BUFF奖池', '庇佑模式：宝石奖池', '庇佑模式：魔骨奖池', '庇佑模式：荣耀&魔法奖池', '庇佑模式：龙结晶奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "行为",
                            "概率"
                        ],
                        "data": [
                            {
                                "行为": "古老贝壳祈祷",
                                "概率": "3.33%"
                            },
                            {
                                "行为": "发光贝壳祈祷",
                                "概率": "20.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "发光贝壳",
                                "数量": "1",
                                "概率": "3.38%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "5.41%"
                            },
                            {
                                "道具": "蓝色祭司碎片",
                                "数量": "2",
                                "概率": "10.14%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "12",
                                "概率": "8.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "5",
                                "概率": "21.62%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "1",
                                "概率": "6.76%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "1",
                                "概率": "13.51%"
                            },
                            {
                                "道具": "500,000 象牙",
                                "数量": "1",
                                "概率": "12.16%"
                            },
                            {
                                "道具": "500,000 石头",
                                "数量": "1",
                                "概率": "12.16%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "0.57%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "1.15%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "2.30%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "1",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "20",
                                "概率": "24.14%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "10",
                                "概率": "20.11%"
                            },
                            {
                                "道具": "200,000 魔法",
                                "数量": "8",
                                "概率": "5.75%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "4",
                                "概率": "8.62%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "17.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "750",
                                "概率": "0.52%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "300",
                                "概率": "8.29%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "2000",
                                "概率": "6.22%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "22.80%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "624",
                                "概率": "3.11%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "312",
                                "概率": "10.36%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "250",
                                "概率": "22.80%"
                            },
                            {
                                "道具": "100 龙魄粉尘",
                                "数量": "190",
                                "概率": "25.91%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "2250",
                                "概率": "0.52%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "624",
                                "概率": "8.38%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "5000",
                                "概率": "6.28%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2500",
                                "概率": "23.04%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "624",
                                "概率": "3.14%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "312",
                                "概率": "10.47%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "250",
                                "概率": "23.04%"
                            },
                            {
                                "道具": "100 魔法粉尘",
                                "数量": "190",
                                "概率": "25.13%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "数量": "375",
                                "概率": "0.52%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "150",
                                "概率": "8.38%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "6.28%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "500",
                                "概率": "23.04%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "150",
                                "概率": "3.14%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "75",
                                "概率": "10.47%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "53",
                                "概率": "23.04%"
                            },
                            {
                                "道具": "100 青石矿粉",
                                "数量": "30",
                                "概率": "25.13%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.017%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.034%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "3",
                                "概率": "12.063%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "25.849%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "15",
                                "概率": "1.723%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "5",
                                "概率": "8.616%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "1",
                                "概率": "51.697%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100 血精石",
                                "数量": "10",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "5",
                                "概率": "1.23%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "25",
                                "概率": "6.17%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "15",
                                "概率": "12.33%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "112",
                                "概率": "18.50%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "75",
                                "概率": "30.83%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "38",
                                "概率": "30.83%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.074%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "5",
                                "概率": "0.739%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "3",
                                "概率": "7.388%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "25.859%"
                            },
                            {
                                "道具": "太古神奇龟",
                                "数量": "1",
                                "概率": "0.554%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "5",
                                "概率": "18.471%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "3",
                                "概率": "22.165%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "2",
                                "概率": "24.751%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "高级神器自选宝箱Ⅳ",
                            "1",
                            "0.24%"
                        ],
                        "data": [
                            {
                                "高级神器自选宝箱Ⅳ": "稀有伙伴结晶",
                                "1": "20",
                                "0.24%": "0.47%"
                            },
                            {
                                "高级神器自选宝箱Ⅳ": "稀有伙伴结晶",
                                "1": "8",
                                "0.24%": "3.54%"
                            },
                            {
                                "高级神器自选宝箱Ⅳ": "稀有伙伴结晶",
                                "1": "1",
                                "0.24%": "29.52%"
                            },
                            {
                                "高级神器自选宝箱Ⅳ": "技能鲶鱼",
                                "1": "1",
                                "0.24%": "0.12%"
                            },
                            {
                                "高级神器自选宝箱Ⅳ": "技能鲶鱼碎片",
                                "1": "2",
                                "0.24%": "28.34%"
                            },
                            {
                                "高级神器自选宝箱Ⅳ": "技能鲶鱼碎片",
                                "1": "1",
                                "0.24%": "37.78%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "6",
                                "概率": "0.35%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "5.13%"
                            },
                            {
                                "道具": "精英战纹匣",
                                "数量": "1",
                                "概率": "14.00%"
                            },
                            {
                                "道具": "专属战纹宝箱",
                                "数量": "1",
                                "概率": "21.00%"
                            },
                            {
                                "道具": "进阶战纹匣",
                                "数量": "1",
                                "概率": "15.17%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "20",
                                "概率": "11.67%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "12",
                                "概率": "19.84%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "8",
                                "概率": "12.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "远古之矛",
                                "数量": "1",
                                "概率": "0.25%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "1",
                                "概率": "0.28%"
                            },
                            {
                                "道具": "50%行军兵量增加",
                                "数量": "1",
                                "概率": "0.61%"
                            },
                            {
                                "道具": "集结兵量增加",
                                "数量": "1",
                                "概率": "0.61%"
                            },
                            {
                                "道具": "50%攻击加成",
                                "数量": "1",
                                "概率": "3.07%"
                            },
                            {
                                "道具": "50%防御加成",
                                "数量": "1",
                                "概率": "3.84%"
                            },
                            {
                                "道具": "25%行军兵量增加",
                                "数量": "1",
                                "概率": "16.12%"
                            },
                            {
                                "道具": "1天攻击加成",
                                "数量": "1",
                                "概率": "16.12%"
                            },
                            {
                                "道具": "1天防御加成",
                                "数量": "1",
                                "概率": "16.12%"
                            },
                            {
                                "道具": "1天和平守护",
                                "数量": "1",
                                "概率": "10.75%"
                            },
                            {
                                "道具": "行军队列",
                                "数量": "1",
                                "概率": "16.12%"
                            },
                            {
                                "道具": "1天反侦查",
                                "数量": "1",
                                "概率": "16.12%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "100宝石",
                                "数量": "100",
                                "概率": "0.25%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "50",
                                "概率": "1.14%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "20",
                                "概率": "3.79%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "15",
                                "概率": "12.64%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "12",
                                "概率": "27.81%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "54.36%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔骨能耗减少",
                                "数量": "1",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "10",
                                "概率": "0.93%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "5",
                                "概率": "5.58%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "2",
                                "概率": "37.21%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "8",
                                "概率": "27.91%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "6",
                                "概率": "27.91%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀旗帜",
                                "数量": "700",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "300",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "185",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "135",
                                "概率": "18.00%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "600",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "250",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "150",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "90",
                                "概率": "18.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "8",
                                "概率": "0.37%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "4",
                                "概率": "1.11%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "8",
                                "概率": "2.58%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "8.86%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "6",
                                "概率": "14.76%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "4",
                                "概率": "51.66%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "2",
                                "概率": "20.66%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【魅影刺客降临】获得伙伴概率公布",
                date: "2023-03-21",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "魅影刺客",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "魅影刺客",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙复制】获得道具概率公布",
                date: "2023-03-17",
                show: false,
                description: "",
                outHeaders: ['三角龙奖池', '暴龙奖池', '双头龙奖池', '始祖龙奖池', '额外奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "三角龙",
                                "数量": "1",
                                "概率": "0.02%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "15",
                                "概率": "0.45%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "9",
                                "概率": "9.05%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "6",
                                "概率": "22.62%"
                            },
                            {
                                "道具": "三角龙碎片",
                                "数量": "3",
                                "概率": "67.86%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "暴龙",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "12",
                                "概率": "1.75%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "8",
                                "概率": "9.07%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "5",
                                "概率": "42.31%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "2",
                                "概率": "46.84%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "12",
                                "概率": "0.89%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "8",
                                "概率": "10.62%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "5",
                                "概率": "31.85%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "2",
                                "概率": "56.62%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "10",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "6",
                                "概率": "5.51%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "3",
                                "概率": "23.59%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "2",
                                "概率": "70.78%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "4",
                                "概率": "0.25%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "4",
                                "概率": "0.25%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "8",
                                "概率": "9.95%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "30",
                                "概率": "14.93%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "4",
                                "概率": "19.90%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "20",
                                "概率": "24.88%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "29.85%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【伙伴祝福】获得道具概率公布",
                date: "2023-03-14",
                show: false,
                description: "",
                outHeaders: ['奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "太古黑曜水晶",
                                "数量": "2",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "10",
                                "概率": "3.31%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "8",
                                "概率": "4.52%"
                            },
                            {
                                "道具": "远古战魂",
                                "数量": "5",
                                "概率": "19.57%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "7",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "2",
                                "概率": "3.31%"
                            },
                            {
                                "道具": "石币礼盒",
                                "数量": "1",
                                "概率": "18.06%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "4.52%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "18.06%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "5",
                                "概率": "10.54%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "3",
                                "概率": "15.05%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【遗迹探宝】概率公布",
                date: "2023-03-07",
                show: false,
                description: "",
                outHeaders: ['普通奖池', '稀有奖池', '积分暴击倍数概率'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "稀有奖池",
                                "个数": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "3",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "1",
                                "概率": "1.99%"
                            },
                            {
                                "道具": "技能鲶鱼礼盒",
                                "个数": "1",
                                "概率": "1.99%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "个数": "1",
                                "概率": "3.48%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "个数": "2",
                                "概率": "9.94%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "个数": "1",
                                "概率": "11.93%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "个数": "1",
                                "概率": "11.93%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "个数": "4",
                                "概率": "11.93%"
                            },
                            {
                                "道具": "血精石",
                                "个数": "60",
                                "概率": "11.93%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "5",
                                "概率": "9.94%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "个数": "5",
                                "概率": "11.93%"
                            },
                            {
                                "道具": "100宝石",
                                "个数": "10",
                                "概率": "11.93%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "个数",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "撕裂地平线（永久）",
                                "个数": "1",
                                "概率": "0.47%"
                            },
                            {
                                "道具": "传说五星自选 XVIII",
                                "个数": "1",
                                "概率": "2.37%"
                            },
                            {
                                "道具": "不朽的据点外观自选V",
                                "个数": "1",
                                "概率": "4.74%"
                            },
                            {
                                "道具": "金晶琥珀",
                                "个数": "10",
                                "概率": "7.11%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "个数": "1",
                                "概率": "9.48%"
                            },
                            {
                                "道具": "战斗增益道具自选宝箱",
                                "个数": "1",
                                "概率": "14.22%"
                            },
                            {
                                "道具": "1 始祖龙鳞",
                                "个数": "70",
                                "概率": "14.22%"
                            },
                            {
                                "道具": "远古蛮石",
                                "个数": "70",
                                "概率": "23.70%"
                            },
                            {
                                "道具": "酋长希拉战纹宝箱",
                                "个数": "2",
                                "概率": "23.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "倍数",
                            "概率"
                        ],
                        "data": [
                            {
                                "倍数": "1",
                                "概率": "95.43%"
                            },
                            {
                                "倍数": "2",
                                "概率": "3.52%"
                            },
                            {
                                "倍数": "4",
                                "概率": "0.75%"
                            },
                            {
                                "倍数": "10",
                                "概率": "0.25%"
                            },
                            {
                                "倍数": "20",
                                "概率": "0.05%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幸运荣耀】获得道具概率公布",
                date: "2023-02-23",
                show: false,
                description: "",
                outHeaders: ['抛掷奖励概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "荣耀旗帜",
                                "数量": "250",
                                "概率": "5.26%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "200",
                                "概率": "10.53%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "150",
                                "概率": "21.05%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "100",
                                "概率": "31.58%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "5",
                                "概率": "5.26%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "2",
                                "概率": "10.53%"
                            },
                            {
                                "道具": "5宝石",
                                "数量": "50",
                                "概率": "5.26%"
                            },
                            {
                                "道具": "5宝石",
                                "数量": "25",
                                "概率": "10.53%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【装备寻宝】概率公布",
                date: "2023-02-21",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '触发大奖奖池概率', '大奖奖池三种宝箱概率', '宝箱大奖奖池概率-高级宝箱奖池', '宝箱大奖奖池概率-特级宝箱奖池', '宝箱大奖奖池概率-至尊宝箱奖池', '宝箱道具奖池概率-四星首领装备随机宝箱', '宝箱道具奖池概率-四星首领装备随机高级宝箱', '宝箱道具奖池概率-三星首领装备随机宝箱'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "青石结晶",
                                "数量": "300",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1200",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "30",
                                "概率": "0.80%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "4500",
                                "概率": "1.99%"
                            },
                            {
                                "道具": "三星首领装备随机宝箱",
                                "数量": "1",
                                "概率": "3.98%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "3000",
                                "概率": "7.97%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "500",
                                "概率": "11.95%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "200",
                                "概率": "19.92%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "19.92%"
                            },
                            {
                                "道具": "青石矿粉",
                                "数量": "1500",
                                "概率": "31.87%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "60次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "90.00%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.00%"
                            },
                            {
                                "奖池类型": "60-300次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "60.00%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "30.00%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "10.00%"
                            },
                            {
                                "奖池类型": "300次以上",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "20.00%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "50.00%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "30.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "1.19%"
                            },
                            {
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "2.38%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "200",
                                "概率": "1.49%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "100",
                                "概率": "9.94%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "500",
                                "概率": "34.80%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "400",
                                "概率": "49.70%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级装备",
                                "数量": "1",
                                "概率": "0.10%"
                            },
                            {
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "0.40%"
                            },
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "1.19%"
                            },
                            {
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "2.37%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "240",
                                "概率": "1.49%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "120",
                                "概率": "14.93%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "800",
                                "概率": "29.77%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "600",
                                "概率": "49.55%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级装备",
                                "数量": "1",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "5级装备",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "0.74%"
                            },
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "1.19%"
                            },
                            {
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "2.37%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "300",
                                "概率": "1.49%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "150",
                                "概率": "34.75%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "1000",
                                "概率": "19.60%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "800",
                                "概率": "39.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "0.96%"
                            },
                            {
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "2.96%"
                            },
                            {
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "5.84%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "300",
                                "概率": "39.02%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "200",
                                "概率": "51.22%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级装备",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "4级装备",
                                "数量": "1",
                                "概率": "1.92%"
                            },
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "5.84%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "50",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "青石结晶",
                                "数量": "30",
                                "概率": "84.87%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3级装备",
                                "数量": "1",
                                "概率": "0.98%"
                            },
                            {
                                "道具": "2级装备",
                                "数量": "1",
                                "概率": "2.93%"
                            },
                            {
                                "道具": "1级装备",
                                "数量": "1",
                                "概率": "5.85%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "150",
                                "概率": "4.88%"
                            },
                            {
                                "道具": "青石矿石",
                                "数量": "120",
                                "概率": "85.37%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【至尊转盘】获得道具概率公布",
                date: "2023-02-20",
                show: false,
                description: "",
                outHeaders: ['白银转盘概率公布', '白银宝箱Ⅹ概率公布', '黄金转盘概率公布', '黄金宝箱Ⅹ概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "白银宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.0128%"
                            },
                            {
                                "道具": "至尊据点外观自选IV",
                                "数量": "1",
                                "概率": "0.0009%"
                            },
                            {
                                "道具": "黄金龟碎片",
                                "数量": "10",
                                "概率": "22.2103%"
                            },
                            {
                                "道具": "白银宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.0128%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "5",
                                "概率": "10.2509%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "4",
                                "概率": "8.5424%"
                            },
                            {
                                "道具": "白银宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.0128%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "1",
                                "概率": "20.5018%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "17.0848%"
                            },
                            {
                                "道具": "白银宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.0128%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "3",
                                "概率": "21.3560%"
                            },
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "0.0017%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "紫晶太古龟",
                                "数量": "1",
                                "概率": "1.25%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "50",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "暴龙碎片",
                                "数量": "80",
                                "概率": "5.00%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "8.75%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "30",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "400",
                                "概率": "7.50%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "800",
                                "概率": "11.25%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "10",
                                "概率": "21.25%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "50",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "50",
                                "概率": "20.00%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "20",
                                "概率": "2.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "黄金宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.028%"
                            },
                            {
                                "道具": "至尊据点外观自选Ⅴ",
                                "数量": "1",
                                "概率": "0.007%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "21.100%"
                            },
                            {
                                "道具": "黄金宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.028%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "90",
                                "概率": "16.880%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "80",
                                "概率": "19.693%"
                            },
                            {
                                "道具": "黄金宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.028%"
                            },
                            {
                                "道具": "6,000 魔骨",
                                "数量": "1",
                                "概率": "8.088%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "10",
                                "概率": "21.452%"
                            },
                            {
                                "道具": "黄金宝箱Ⅺ",
                                "数量": "1",
                                "概率": "0.028%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "20",
                                "概率": "12.660%"
                            },
                            {
                                "道具": "传说五星自选 XVIII",
                                "数量": "1",
                                "概率": "0.007%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "双头龙",
                                "数量": "1",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "远古之泉",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "远古之矛",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "远古之盾",
                                "数量": "5",
                                "概率": "6.00%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "3",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "80",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "100",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "稀有伙伴结晶",
                                "数量": "80",
                                "概率": "18.00%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "10",
                                "概率": "9.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1000",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【限定伙伴再临】概率更新",
                date: "2023-02-16",
                show: false,
                description: "",
                outHeaders: ['行者伙伴池', '人鱼塞壬伙伴池', '血咒怨灵伙伴池', '泰坦古克伙伴池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【行者】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【人鱼塞壬】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【血咒怨灵】概率",
                                "概率": "0.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3星伙伴概率",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "4星伙伴概率",
                                "概率": "9.50%"
                            },
                            {
                                "道具": "【泰坦古克】概率",
                                "概率": "0.50%"
                            }
                        ]
                    }
                ]
            },


            {
                name: "【浇灌玫瑰】获得道具概率公布",
                date: "2023-02-13",
                show: false,
                description: "",
                outHeaders: ['浇灌奖池概率公布（每次浇灌获得三次奖励）', '玫瑰信封奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魅力玫瑰",
                                "数量": "1",
                                "概率": "27.30%"
                            },
                            {
                                "道具": "暴龙鳞",
                                "数量": "2",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "三角龙鳞",
                                "数量": "4",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "15",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "20",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "1,500 魔骨",
                                "数量": "2",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "100 龙结晶",
                                "数量": "2",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "7,000 魂能",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "洗炼灵石碎片",
                                "数量": "1",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "4",
                                "概率": "7.27%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "1",
                                "概率": "7.27%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙鳞",
                                "数量": "5",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "10 双头龙鳞",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "远古蛮石",
                                "数量": "10",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "天演强攻1",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "天演致残1",
                                "数量": "1",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "3",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "2",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "130",
                                "概率": "10.00%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【祭司暴击】概率更新",
                date: "2022-02-13",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池', '大奖奖池A', '大奖奖池B', '大奖奖池C', '大奖奖池D'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "3.64%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.36%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "紫晶远古龟",
                                "数量": "1",
                                "概率": "0.12%"
                            },
                            {
                                "道具": "紫色祭司碎片",
                                "数量": "1",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "1",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "1",
                                "概率": "0.30%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "1",
                                "概率": "0.60%"
                            },
                            {
                                "道具": "攻击加成（联盟）",
                                "数量": "1",
                                "概率": "0.60%"
                            },
                            {
                                "道具": "酋长猫战纹宝箱",
                                "数量": "1",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "1",
                                "概率": "0.30%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "3",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "10",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "0.60%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "5",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "石币礼盒",
                                "数量": "2",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "1",
                                "概率": "0.60%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "1",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "1",
                                "概率": "0.00%"
                            },
                            {
                                "道具": "3天加速",
                                "数量": "3",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "5",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "紫晶远古龟碎片",
                                "数量": "10",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "数量": "1",
                                "概率": "3.01%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "3",
                                "概率": "1.50%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "2",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "高级资源自选宝箱",
                                "数量": "1",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "专属战纹宝箱",
                                "数量": "1",
                                "概率": "0.30%"
                            },
                            {
                                "道具": "20,000 魔骨",
                                "数量": "2",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "5,000 信仰结晶",
                                "数量": "5",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "4",
                                "概率": "6.02%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "100",
                                "概率": "0.60%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "6.02%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "5",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "6",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "7",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "8",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "10",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "战神·阿瑞斯碎片",
                                "数量": "15",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "5",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "6",
                                "概率": "15.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "7",
                                "概率": "8.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "8",
                                "概率": "4.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "10",
                                "概率": "2.00%"
                            },
                            {
                                "道具": "爱神·阿佛洛狄忒碎片",
                                "数量": "15",
                                "概率": "1.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "8",
                                "概率": "90.00%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "10",
                                "概率": "8.20%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "12",
                                "概率": "1.00%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "14",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "16",
                                "概率": "0.20%"
                            },
                            {
                                "道具": "海神·波塞冬碎片",
                                "数量": "24",
                                "概率": "0.10%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "25",
                                "概率": "70.00%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "30",
                                "概率": "18.20%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "35",
                                "概率": "7.70%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "40",
                                "概率": "3.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "50",
                                "概率": "0.50%"
                            },
                            {
                                "道具": "史诗祭司自选宝箱III",
                                "数量": "75",
                                "概率": "0.10%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【巨龙祈愿】获得道具概率公布",
                date: "2023-02-10",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '珍稀转盘奖池概率公布'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "始祖龙碎片",
                                "数量": "15",
                                "概率": "0.06%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "10",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "3",
                                "概率": "1.37%"
                            },
                            {
                                "道具": "始祖龙碎片",
                                "数量": "1",
                                "概率": "8.58%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "20",
                                "概率": "0.07%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "12",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "5",
                                "概率": "1.37%"
                            },
                            {
                                "道具": "双头龙碎片",
                                "数量": "2",
                                "概率": "8.58%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "1",
                                "概率": "0.69%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "2",
                                "概率": "6.86%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "1",
                                "概率": "15.10%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "5",
                                "概率": "24.02%"
                            },
                            {
                                "道具": "5,000 龙结晶",
                                "数量": "1",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "1",
                                "概率": "10.98%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "1",
                                "概率": "12.63%"
                            },
                            {
                                "道具": "龙秘果",
                                "数量": "10",
                                "概率": "9.13%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "转盘奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "转盘奖励": "超级大奖",
                                "概率": "2.00%"
                            },
                            {
                                "转盘奖励": "次级大奖",
                                "概率": "5.00%"
                            },
                            {
                                "转盘奖励": "三级大奖",
                                "概率": "93.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【远古寻宝】获得道具概率公布",
                date: "2023-02-10",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '触发大奖奖池概率', '抽取次数-概率变化', '宝箱大奖奖池概率-高级奖池', '宝箱大奖奖池概率-特级奖池', '宝箱大奖奖池概率-至尊奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "魔法结晶",
                                "数量": "150",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2000",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "五星宝物碎片宝箱",
                                "数量": "1",
                                "概率": "0.69%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "75",
                                "概率": "6.85%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "600",
                                "概率": "27.41%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "800",
                                "概率": "27.41%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1000",
                                "概率": "6.87%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1200",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "10000",
                                "概率": "2.74%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "4",
                                "概率": "27.41%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "0.80%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "100次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.72%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.00%"
                            },
                            {
                                "奖池类型": "100-500次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.48%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.24%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "500次以上",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.16%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.40%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.18%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.66%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "175",
                                "概率": "4.60%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1750",
                                "概率": "0.46%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "17500",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "150",
                                "概率": "23.00%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1500",
                                "概率": "68.99%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "15000",
                                "概率": "0.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级宝物",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.18%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "0.55%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "1.66%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "200",
                                "概率": "0.46%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2000",
                                "概率": "4.60%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "20000",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "175",
                                "概率": "22.99%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "1750",
                                "概率": "68.96%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "17500",
                                "概率": "0.46%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级宝物",
                                "数量": "1",
                                "概率": "0.01%"
                            },
                            {
                                "道具": "5级宝物",
                                "数量": "1",
                                "概率": "0.03%"
                            },
                            {
                                "道具": "4级宝物",
                                "数量": "1",
                                "概率": "0.16%"
                            },
                            {
                                "道具": "3级宝物",
                                "数量": "1",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "2级宝物",
                                "数量": "1",
                                "概率": "1.27%"
                            },
                            {
                                "道具": "1级宝物",
                                "数量": "1",
                                "概率": "3.82%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "225",
                                "概率": "4.25%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2250",
                                "概率": "0.42%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "22500",
                                "概率": "0.04%"
                            },
                            {
                                "道具": "魔法结晶",
                                "数量": "200",
                                "概率": "63.68%"
                            },
                            {
                                "道具": "魔法碎片",
                                "数量": "2000",
                                "概率": "25.47%"
                            },
                            {
                                "道具": "魔法粉尘",
                                "数量": "20000",
                                "概率": "0.42%"
                            }
                        ]
                    }
                ]
            },


            {
                name: "【龙印寻宝】概率更新",
                date: "2023-02-06",
                show: false,
                description: "",
                outHeaders: ['普通奖池概率公布', '触发大奖奖池概率', '抽取次数-概率变化', '宝箱大奖奖池概率-高级奖池', '宝箱大奖奖池概率-特级奖池', '宝箱大奖奖池概率-至尊奖池', '宝箱道具概率-五星龙印随机宝箱', '宝箱道具概率-五星龙印高级随机宝箱', '宝箱道具概率-五星龙印特级随机宝箱'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "0.08%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "0.27%"
                            },
                            {
                                "道具": "五星龙印随机宝箱",
                                "数量": "2",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "500",
                                "概率": "1.35%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "26.93%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "12500",
                                "概率": "26.93%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "15000",
                                "概率": "13.47%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "20000",
                                "概率": "2.69%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "25000",
                                "概率": "0.67%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "5",
                                "概率": "26.93%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池": "触发大奖奖池",
                                "概率": "0.80%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖池类型",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖池类型": "100次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.72%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.00%"
                            },
                            {
                                "奖池类型": "100-500次",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.48%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.24%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.08%"
                            },
                            {
                                "奖池类型": "500次以上",
                                "概率": "-"
                            },
                            {
                                "奖池类型": "高级宝箱奖池",
                                "概率": "0.16%"
                            },
                            {
                                "奖池类型": "特级宝箱奖池",
                                "概率": "0.40%"
                            },
                            {
                                "奖池类型": "至尊宝箱奖池",
                                "概率": "0.24%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.100%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.176%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.529%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "1.588%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "22",
                                "概率": "0.004%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "240",
                                "概率": "0.044%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6000",
                                "概率": "0.441%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "20",
                                "概率": "0.044%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "200",
                                "概率": "8.825%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "88.247%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.050%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.150%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.184%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.551%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "1.653%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "24",
                                "概率": "0.046%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "260",
                                "概率": "0.459%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6600",
                                "概率": "0.459%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "22",
                                "概率": "4.593%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "220",
                                "概率": "45.927%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5500",
                                "概率": "45.927%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "6级龙印",
                                "数量": "1",
                                "概率": "0.012%"
                            },
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.048%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.240%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.451%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "1.354%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "26",
                                "概率": "0.406%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "280",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "7200",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "24",
                                "概率": "4.062%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "240",
                                "概率": "40.620%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "6000",
                                "概率": "40.620%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "0.70%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "2.34%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "5000",
                                "概率": "96.72%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.14%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "0.41%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "1.23%"
                            },
                            {
                                "道具": "1级龙印",
                                "数量": "1",
                                "概率": "4.11%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "8.56%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "85.56%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "5级龙印",
                                "数量": "1",
                                "概率": "0.16%"
                            },
                            {
                                "道具": "4级龙印",
                                "数量": "1",
                                "概率": "0.49%"
                            },
                            {
                                "道具": "3级龙印",
                                "数量": "1",
                                "概率": "1.47%"
                            },
                            {
                                "道具": "2级龙印",
                                "数量": "1",
                                "概率": "4.90%"
                            },
                            {
                                "道具": "龙魄结晶",
                                "数量": "100",
                                "概率": "1.02%"
                            },
                            {
                                "道具": "龙魄碎片",
                                "数量": "1000",
                                "概率": "10.22%"
                            },
                            {
                                "道具": "龙魄粉尘",
                                "数量": "10000",
                                "概率": "81.73%"
                            }
                        ]
                    }
                ]
            },


            {
                name: "【援琴女神降临】获得伙伴概率公布",
                date: "2023-01-23",
                show: false,
                description: "",
                outHeaders: ['稀有黑曜石神奇龟', '稀有黑曜石远古龟'],
                tables: [
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "援琴女神",
                                "概率": "0.50%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "9.50%"
                            },
                            {
                                "伙伴": "3星伙伴",
                                "概率": "90.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "伙伴",
                            "概率"
                        ],
                        "data": [
                            {
                                "伙伴": "援琴女神",
                                "概率": "6.00%"
                            },
                            {
                                "伙伴": "4星伙伴",
                                "概率": "94.00%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【幸运魔法】概率更新",
                date: "2023-01-06",
                show: false,
                description: "",
                outHeaders: ['卡牌奖励奖池'],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "道具": "3倍幸运数字",
                                "数量": "1",
                                "概率": "2.83%"
                            },
                            {
                                "道具": "5倍幸运数字",
                                "数量": "1",
                                "概率": "0.28%"
                            },
                            {
                                "道具": "技能鲶鱼",
                                "数量": "1",
                                "概率": "0.05%"
                            },
                            {
                                "道具": "攻击加成（联盟）",
                                "数量": "1",
                                "概率": "0.46%"
                            },
                            {
                                "道具": "酋长战纹宝箱",
                                "数量": "1",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "10 暴龙鳞",
                                "数量": "6",
                                "概率": "2.32%"
                            },
                            {
                                "道具": "洗炼灵石",
                                "数量": "4",
                                "概率": "2.32%"
                            },
                            {
                                "道具": "紫晶远古龟",
                                "数量": "1",
                                "概率": "0.09%"
                            },
                            {
                                "道具": "100 血精石",
                                "数量": "1",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "10 血精石",
                                "数量": "3",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "血精石",
                                "数量": "15",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "技能鲶鱼碎片",
                                "数量": "5",
                                "概率": "2.32%"
                            },
                            {
                                "道具": "史诗信物自选宝箱",
                                "数量": "1",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "荣耀印记",
                                "数量": "250",
                                "概率": "2.32%"
                            },
                            {
                                "道具": "荣耀旗帜",
                                "数量": "100",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "2,000 龙结晶",
                                "数量": "2",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "500 龙结晶",
                                "数量": "5",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "3天加速",
                                "数量": "4",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "1天加速",
                                "数量": "7",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "1小时加速",
                                "数量": "100",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "稀有召唤石",
                                "数量": "6",
                                "概率": "1.16%"
                            },
                            {
                                "道具": "石币礼盒",
                                "数量": "3",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "稀有钻石神奇龟",
                                "数量": "1",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "紫晶神奇龟",
                                "数量": "1",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "黄金神奇龟",
                                "数量": "2",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "外观金币",
                                "数量": "3",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "高级资源自选宝箱",
                                "数量": "1",
                                "概率": "2.32%"
                            },
                            {
                                "道具": "普通伙伴结晶",
                                "数量": "200",
                                "概率": "1.17%"
                            },
                            {
                                "道具": "专属战纹宝箱",
                                "数量": "1",
                                "概率": "2.32%"
                            },
                            {
                                "道具": "80,000 魂能",
                                "数量": "4",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "30,000 魂能",
                                "数量": "4",
                                "概率": "4.64%"
                            },
                            {
                                "道具": "资源自选宝箱",
                                "数量": "6",
                                "概率": "2.32%"
                            },
                            {
                                "道具": "100宝石",
                                "数量": "10",
                                "概率": "4.64%"
                            }
                        ]
                    }
                ]
            },

            {
                name: "【符文共鸣】天演·始动符文池概率更新",
                date: "2023-01-03",
                show: false,
                description: "",
                outHeaders: ['【符文共鸣】天演·始动符文池概率更新'],
                tables: [
                    {
                        "subHeaders": [
                            "符文类型",
                            "符文数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "1",
                                "概率": "10.30%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "2",
                                "概率": "3.86%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "4",
                                "概率": "1.93%"
                            },
                            {
                                "符文类型": "天演·强攻",
                                "符文数量": "6",
                                "概率": "0.64%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "1",
                                "概率": "10.30%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "2",
                                "概率": "3.86%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "4",
                                "概率": "1.93%"
                            },
                            {
                                "符文类型": "天演·致残",
                                "符文数量": "6",
                                "概率": "0.64%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "1",
                                "概率": "1.07%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "2",
                                "概率": "3.22%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "4",
                                "概率": "6.44%"
                            },
                            {
                                "符文类型": "嗜血",
                                "符文数量": "6",
                                "概率": "9.12%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "1",
                                "概率": "1.07%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "2",
                                "概率": "3.22%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "4",
                                "概率": "6.44%"
                            },
                            {
                                "符文类型": "重击",
                                "符文数量": "6",
                                "概率": "9.12%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "1",
                                "概率": "0.75%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "2",
                                "概率": "2.25%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "4",
                                "概率": "4.51%"
                            },
                            {
                                "符文类型": "战吼",
                                "符文数量": "6",
                                "概率": "5.90%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "1",
                                "概率": "0.75%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "2",
                                "概率": "2.25%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "4",
                                "概率": "4.51%"
                            },
                            {
                                "符文类型": "天火",
                                "符文数量": "6",
                                "概率": "5.90%"
                            }
                        ]
                    }
                ]
            }
        ];

        vm.gameProps = [
            {
                name: "【稀有彩蛋宝箱】道具概率公布",
                date: "2020-04-11",
                show: false,
                description: "",
                outHeaders: ["彩蛋宝箱", "彩蛋宝箱 "],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "概率": "0.10%",
                                "道具": "据点彩蛋*1"
                            },
                            {
                                "概率": "7.91%",
                                "道具": "双头龙碎片*5"
                            },
                            {
                                "概率": "7.91%",
                                "道具": "外观金币*3"
                            },
                            {
                                "概率": "9.89%",
                                "道具": "100 龙结晶*5"
                            },
                            {
                                "概率": "4.95%",
                                "道具": "500 龙结晶*2"
                            },
                            {
                                "概率": "9.89%",
                                "道具": "龙秘果*50"
                            },
                            {
                                "概率": "19.78%",
                                "道具": "1小时加速*5"
                            },
                            {
                                "概率": "19.78%",
                                "道具": "3小时加速*3"
                            },
                            {
                                "概率": "19.78%",
                                "道具": "远古龟碎片*5"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "概率": "1.37%",
                                "道具": "据点彩蛋*1"
                            },
                            {
                                "概率": "2.74%",
                                "道具": "双头龙*1"
                            },
                            {
                                "概率": "6.85%",
                                "道具": "暴龙*1"
                            },
                            {
                                "概率": "6.85%",
                                "道具": "太古神奇龟*1"
                            },
                            {
                                "概率": "41.10%",
                                "道具": "外观金币*30"
                            },
                            {
                                "概率": "41.10%",
                                "道具": "5,000 龙结晶*1"
                            }
                        ]
                    }
                ]
            },        
            {
                name: "【紫晶远古龟】获得道具概率公布",
                date: "2020-04-03",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "概率": "94%",
                                "道具": "4星伙伴"
                            },
                            {
                                "概率": "6%",
                                "道具": "5星降临限定伙伴"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【外观金币宝箱】获得道具概率公布",
                date: "2020-03-19",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "概率": "0.79%",
                                "道具": "外观金币*10"
                            },
                            {
                                "概率": "3.97%",
                                "道具": "外观金币*5"
                            },
                            {
                                "概率": "23.81%",
                                "道具": "外观金币*1"
                            },
                            {
                                "概率": "7.94%",
                                "道具": "8小时加速*1"
                            },
                            {
                                "概率": "15.87%",
                                "道具": "3小时加速*1"
                            },
                            {
                                "概率": "15.87%",
                                "道具": "6,000 魔骨*1"
                            },
                            {
                                "概率": "15.87%",
                                "道具": "200,000 魔法*1"
                            },
                            {
                                "概率": "15.87%",
                                "道具": "100宝石*5"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【紫晶神奇龟】获得道具概率公布",
                date: "2020-03-04",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "道具",
                            "概率"
                        ],
                        "data": [
                            {
                                "概率": "90%",
                                "道具": "3星伙伴"
                            },
                            {
                                "概率": "9.5%",
                                "道具": "4星伙伴"
                            },
                            {
                                "概率": "0.5%",
                                "道具": "5星降临限定伙伴"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【祭司宝箱】概率公布",
                date: "2019-10-08",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "福鹦碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "胖吉碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "白胡子碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "扎瓦克碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "福鹦碎片*1",
                                "概率": "20.83%"
                            },
                            {
                                "奖励": "胖吉碎片*1",
                                "概率": "20.83%"
                            },
                            {
                                "奖励": "白胡子碎片*1",
                                "概率": "20.83%"
                            },
                            {
                                "奖励": "扎瓦克碎片*1",
                                "概率": "20.83%"
                            }
                        ]
                    }
                    
                ]
            },
            {
                name: "【高级祭司宝箱】概率公布",
                date: "2019-10-08",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "森林之歌·巴德碎片*3",
                                "概率": "0.96%"
                            },
                            {
                                "奖励": "北极星·阿基米碎片*3",
                                "概率": "0.96%"
                            },
                            {
                                "奖励": "蛮牛之力·马尔斯碎片*3",
                                "概率": "0.96%"
                            },
                            {
                                "奖励": "摄魂者·卡莎碎片*3",
                                "概率": "0.96%"
                            },
                            {
                                "奖励": "福鹦碎片*3",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "胖吉碎片*3",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "白胡子碎片*3",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "扎瓦克碎片*3",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "森林之歌·巴德碎片*1",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "北极星·阿基米碎片*1",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "蛮牛之力·马尔斯碎片*1",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "摄魂者·卡莎碎片*1",
                                "概率": "4.81%"
                            },
                            {
                                "奖励": "福鹦碎片*1",
                                "概率": "14.42%"
                            },
                            {
                                "奖励": "胖吉碎片*1",
                                "概率": "14.42%"
                            },
                            {
                                "奖励": "白胡子碎片*1",
                                "概率": "14.42%"
                            },
                            {
                                "奖励": "扎瓦克碎片*1",
                                "概率": "14.42%"
                            }
                        ]
                    }
                    
                ]
            },
            {
                name: "【精英祭司宝箱】概率公布",
                date: "2019-10-08",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "森林之歌·巴德碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "北极星·阿基米碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "蛮牛之力·马尔斯碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "摄魂者·卡莎碎片*5",
                                "概率": "4.17%"
                            },
                            {
                                "奖励": "森林之歌·巴德碎片*1",
                                "概率": "20.83%"
                            },
                            {
                                "奖励": "北极星·阿基米碎片*1",
                                "概率": "20.83%"
                            },
                            {
                                "奖励": "蛮牛之力·马尔斯碎片*1",
                                "概率": "20.83%"
                            },
                            {
                                "奖励": "摄魂者·卡莎碎片*1",
                                "概率": "20.83%"
                            }
                        ]
                    }                    
                ]
            },
            {
                name: "【石币礼盒】获得道具概率公布",
                date: "2019-07-17",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "石币*500",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "石币*300",
                                "概率": "2.00%"
                            },
                            {
                                "奖励": "石币*200",
                                "概率": "4.00%"
                            },
                            {
                                "奖励": "石币*100",
                                "概率": "8.00%"
                            },
                            {
                                "奖励": "石币*75",
                                "概率": "12.00%"
                            },
                            {
                                "奖励": "石币*50",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "石币*40",
                                "概率": "23.00%"
                            },
                            {
                                "奖励": "石币*30",
                                "概率": "30.00%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【河豚礼盒】获得道具概率公布",
                date: "2018-11-30",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                       "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "河豚（永久）",
                                "概率": "0.30%"
                            },
                            {
                                "奖励": "河豚 （2天）",
                                "概率": "2.20%"
                            },
                            {
                                "奖励": "100宝石",
                                "概率": "2.50%"
                            },
                            {
                                "奖励": "100宝石",
                                "概率": "15.00%"
                            },
                            {
                                "奖励": "3小时加速",
                                "概率": "10.00%"
                            },
                        {
                            "奖励": "1小时加速",
                            "概率": "15.00%"
                        },
                        {
                            "奖励": "15分钟加速",
                            "概率": "15.00%"
                        },
                        {
                            "奖励": "3小时训练加速",
                            "概率": "10.00%"
                        },
                        {
                            "奖励": "1小时训练加速",
                            "概率": "15.00%"
                        },
                        {
                            "奖励": "15分钟训练加速",
                            "概率": "15.00%"
                        }
                        ]
                    }                                  
                ]
            },
            {
                name: "【暴龙碎片宝箱】概率公布",
                date: "2019-03-11",
                show: false,
                description: "",
                outHeaders: [""],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "暴龙碎片*30",
                                "概率": "0.50%"
                            },
                            {
                                "奖励": "暴龙碎片*15",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "暴龙碎片*10",
                                "概率": "2.50%"
                            },
                            {
                                "奖励": "暴龙碎片*8",
                                "概率": "5.00%"
                            },
                            {
                                "奖励": "暴龙碎片*6",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "暴龙碎片*4",
                                "概率": "18.00%"
                            },
                            {
                                "奖励": "暴龙碎片*3",
                                "概率": "25.00%"
                            },
                            {
                                "奖励": "暴龙碎片*2",
                                "概率": "38.00%"
                            }
                        ]
                    }                                 
                ]
            },  
            {
                    name: "【黑猫小姐礼盒】获得道具概率公布",
                    date: "2018-10-30",
                    show: false,
                    description: "",
                    outHeaders: [],
            tables: [
            {
                "subHeaders": [
                    "奖励",
                "概率"
                ],
                "data": [
                {
                    "奖励": "黑猫小姐（永久）",
                    "概率": "0.30%"
                },
                {
                    "奖励": "黑猫小姐（2天）",
                    "概率": "2.20%"
                },
                {
                    "奖励": "100宝石",
                    "概率": "2.50%"
                },
                {
                    "奖励": "100宝石",
                    "概率": "15.00%"
                },
                {
                    "奖励": "3小时加速",
                    "概率": "10.00%"
                },
                {
                    "奖励": "1小时加速",
                    "概率": "15.00%"
                },
                {
                    "奖励": "15分钟加速",
                    "概率": "15.00%"
                },
                {
                    "奖励": "3小时训练加速",
                    "概率": "10.00%"
                },
                {
                    "奖励": "1小时训练加速",
                    "概率": "15.00%"
                },
                {
                    "奖励": "15分钟训练加速",
                    "概率": "15.00%"
                }
                ]
            }
            ]
                },
            {
                name: "【宝箱】获得道具概率公布",
                date: "2018-09-05",
                show: false,
                description: "",
                outHeaders: [
                    "【魔法礼盒】概率公布", "【宝石礼盒】概率公布",
                    "【长矛礼盒】概率公布", "【时光宝箱】概率公布",
                    "【火矛礼盒】概率公布", "【魂能礼盒】概率公布",
                    "【鱼饵宝箱】概率公布", "【技能鲶鱼礼盒】概率公布",
                    "【神奇龟宝箱】概率公布", "【鲶鱼人宝箱】概率公布",
                    "【稀有信物宝箱】概率公布", "【进阶战纹匣】概率公布",
                    "【专属战纹宝箱】概率公布"
                    ],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "5000000魔法",
                                "概率": "0.50%"
                            },
                            {
                                "奖励": "3000000魔法",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "2000000魔法",
                                "概率": "4.50%"
                            },
                            {
                                "奖励": "1000000魔法",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "500000魔法",
                                "概率": "15.00%"
                            },
                            {
                                "奖励": "300000魔法",
                                "概率": "18.00%"
                            },
                            {
                                "奖励": "200000魔法",
                                "概率": "24.00%"
                            },
                            {
                                "奖励": "100000魔法",
                                "概率": "27.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "10000宝石",
                                "概率": "0.50%"
                            },
                            {
                                "奖励": "5000宝石",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "3000宝石",
                                "概率": "3.50%"
                            },
                            {
                                "奖励": "2000宝石",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "1000宝石",
                                "概率": "18.00%"
                            },
                            {
                                "奖励": "800宝石",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "600宝石",
                                "概率": "22.00%"
                            },
                            {
                                "奖励": "500宝石",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "5000长矛",
                                "概率": "0.50%"
                            },
                            {
                                "奖励": "2500长矛",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "1500长矛",
                                "概率": "3.50%"
                            },
                            {
                                "奖励": "1000长矛",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "500长矛",
                                "概率": "18.00%"
                            },
                            {
                                "奖励": "400长矛",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "300长矛",
                                "概率": "22.00%"
                            },
                            {
                                "奖励": "250长矛",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "1小时加速*100",
                                "概率": "0.50%"
                            },
                            {
                                "奖励": "1小时加速*50",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "1小时加速*30",
                                "概率": "5.00%"
                            },
                            {
                                "奖励": "1小时加速*20",
                                "概率": "8.50%"
                            },
                            {
                                "奖励": "1小时加速*10",
                                "概率": "15.00%"
                            },
                            {
                                "奖励": "1小时加速*8",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "1小时加速*5",
                                "概率": "25.00%"
                            },
                            {
                                "奖励": "1小时加速*3",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "5000火矛",
                                "概率": "0.50%"
                            },
                            {
                                "奖励": "2500火矛",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "1500火矛",
                                "概率": "3.50%"
                            },
                            {
                                "奖励": "1000火矛",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "500火矛",
                                "概率": "18.00%"
                            },
                            {
                                "奖励": "400火矛",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "300火矛",
                                "概率": "22.00%"
                            },
                            {
                                "奖励": "250火矛",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "200000魂能",
                                "概率": "0.30%"
                            },
                            {
                                "奖励": "100000魂能",
                                "概率": "0.90%"
                            },
                            {
                                "奖励": "50000魂能",
                                "概率": "2.00%"
                            },
                            {
                                "奖励": "30000魂能",
                                "概率": "5.00%"
                            },
                            {
                                "奖励": "20000魂能",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "15000魂能",
                                "概率": "0.2"
                            },
                            {
                                "奖励": "12000魂能",
                                "概率": "0.268"
                            },
                            {
                                "奖励": "10000魂能",
                                "概率": "35.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "高级鱼饵*1",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "普通鱼饵*5",
                                "概率": "5.00%"
                            },
                            {
                                "奖励": "普通鱼饵*4",
                                "概率": "24.00%"
                            },
                            {
                                "奖励": "普通鱼饵*3",
                                "概率": "30.00%"
                            },
                            {
                                "奖励": "普通鱼饵*2",
                                "概率": "40.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "技能鲶鱼*1",
                                "概率": "1.00%"
                            },
                            {
                                "奖励": "技能鲶鱼碎片*20",
                                "概率": "3.00%"
                            },
                            {
                                "奖励": "技能鲶鱼碎片*15",
                                "概率": "6.00%"
                            },
                            {
                                "奖励": "技能鲶鱼碎片*10",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "技能鲶鱼碎片*8",
                                "概率": "15.00%"
                            },
                            {
                                "奖励": "技能鲶鱼碎片*5",
                                "概率": "20%"
                            },
                            {
                                "奖励": "技能鲶鱼碎片*4",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "技能鲶鱼碎片*3",
                                "概率": "25.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "太古神奇龟*1",
                                "概率": "0.50%"
                            },
                            {
                                "奖励": "远古神奇龟*1",
                                "概率": "2.00%"
                            },
                            {
                                "奖励": "黄金神奇龟*10",
                                "概率": "7.50%"
                            },
                            {
                                "奖励": "黄金神奇龟*8",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "黄金神奇龟*5",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "黄金神奇龟*3",
                                "概率": "25%"
                            },
                            {
                                "奖励": "黄金神奇龟*2",
                                "概率": "35.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "技能鲶鱼*1",
                                "概率": "2.00%"
                            },
                            {
                                "奖励": "3星鲶鱼人*1",
                                "概率": "24.50%"
                            },
                            {
                                "奖励": "15级经验鱼（狂野）*1",
                                "概率": "24.50%"
                            },
                            {
                                "奖励": "15级经验鱼（智慧）*1",
                                "概率": "24.50%"
                            },
                            {
                                "奖励": "15级经验鱼（勇敢）*1",
                                "概率": "24.50%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "莎娅的信物（稀有）*5",
                                "概率": "3.30%"
                            },
                            {
                                "奖励": "希拉的信物（稀有）*5",
                                "概率": "3.30%"
                            },
                            {
                                "奖励": "伊恩的信物（稀有）*5",
                                "概率": "3.40%"
                            },
                            {
                                "奖励": "莎娅的信物（稀有）*3",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "希拉的信物（稀有）*3",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "伊恩的信物（稀有）*3",
                                "概率": "10.00%"
                            },
                            {
                                "奖励": "莎娅的信物（稀有）*2",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "希拉的信物（稀有）*2",
                                "概率": "20.00%"
                            },
                            {
                                "奖励": "伊恩的信物（稀有）*2",
                                "概率": "20.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "魔法（绿色）",
                                "概率": "50.00%"
                            },
                            {
                                "奖励": "稀有（蓝色）",
                                "概率": "40.00%"
                            },
                            {
                                "奖励": "史诗（蓝色）",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        "subHeaders": [
                            "奖励",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "史诗（橙色）",
                                "概率": "90%"
                            },
                            {
                                "奖励": "传说（紫色）",
                                "概率": "10%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【战纹匣】获得道具概率公布",
                date: "2018-05-25",
                show: false,
                description: "",
                outHeaders: ["普通战纹盒", "精英战纹盒"],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "普通（白色）",
                                "概率": "60.00%"
                            },
                            {
                                "道具": "魔法（绿色）",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "稀有（蓝色）",
                                "概率": "10.00%"
                            }
                        ]
                    },
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "史诗（橙色）",
                                "概率": "90%"
                            },
                            {
                                "道具": "传说（紫色）",
                                "概率": "10%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【神奇龟】获得道具概率公布",
                date: "2017-11-10",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "1 星伙伴",
                                "概率": "75%"
                            },
                            {
                                "道具": "2 星伙伴",
                                "概率": "24%"
                            },
                            {
                                "道具": "3 星伙伴",
                                "概率": "1%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【黄金神奇龟】获得道具概率公布",
                date: "2017-11-10",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "3 星伙伴",
                                "概率": "90%"
                            },
                            {
                                "道具": "4 星伙伴",
                                "概率": "9.5%"
                            },
                            {
                                "道具": "5 星伙伴",
                                "概率": "0.5%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【远古神奇龟】获得道具概率公布",
                date: "2017-11-10",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "4 星伙伴",
                                "概率": "94%"
                            },
                            {
                                "道具": "5 星伙伴",
                                "概率": "6%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【勇敢神奇龟】获得道具概率公布",
                date: "2017-11-10",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "3 星勇敢伙伴",
                                "概率": "90%"
                            },
                            {
                                "道具": "4 星勇敢伙伴",
                                "概率": "9.5%"
                            },
                            {
                                "道具": "5 星勇敢伙伴",
                                "概率": "0.5%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【智慧神奇龟】获得道具概率公布",
                date: "2017-11-10",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "3 星智慧伙伴",
                                "概率": "90%"
                            },
                            {
                                "道具": "4 星智慧伙伴",
                                "概率": "9.5%"
                            },
                            {
                                "道具": "5 星智慧伙伴",
                                "概率": "0.5%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【狂野神奇龟】获得道具概率公布",
                date: "2017-11-10",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "3 星狂野伙伴",
                                "概率": "90%"
                            },
                            {
                                "道具": "4 星狂野伙伴",
                                "概率": "9.5%"
                            },
                            {
                                "道具": "5 星狂野伙伴",
                                "概率": "0.5%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【高级符文箱】获得道具概率公布",
                date: "2017-08-28",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "1 星符文",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "2 星符文",
                                "概率": "35.00%"
                            },
                            {
                                "道具": "3 星符文",
                                "概率": "35.00%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【一堆高级符文箱】获得道具概率公布",
                date: "2017-08-28",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "1 星符文",
                                "概率": "0.81%"
                            },
                            {
                                "道具": "2 星符文",
                                "概率": "17.04%"
                            },
                            {
                                "道具": "3 星符文",
                                "概率": "82.15%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【专家级符文箱】获得道具概率公布",
                date: "2017-08-28",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "2 星符文",
                                "概率": "53.00%"
                            },
                            {
                                "道具": "3 星符文",
                                "概率": "30.00%"
                            },
                            {
                                "道具": "4 星符文",
                                "概率": "17.00%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【一堆专家级符文箱】获得道具概率公布",
                date: "2017-08-28",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "2 星符文",
                                "概率": "7.89%"
                            },
                            {
                                "道具": "3 星符文",
                                "概率": "39.57%"
                            },
                            {
                                "道具": "4 星符文",
                                "概率": "52.54%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【大师级符文箱】获得道具概率公布",
                date: "2017-08-28",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "3 星符文",
                                "概率": "72.00%"
                            },
                            {
                                "道具": "4 星符文",
                                "概率": "18.00%"
                            },
                            {
                                "道具": "5 星符文",
                                "概率": "10.00%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【一堆大师级符文箱】获得道具概率公布",
                date: "2017-08-28",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        subHeaders: ["道具", "概率"],
                        data: [
                            {
                                "道具": "3 星符文",
                                "概率": "26.87%"
                            },
                            {
                                "道具": "4 星符文",
                                "概率": "38.74%"
                            },
                            {
                                "道具": "5 星符文",
                                "概率": "34.39%"
                            }
                        ]
                    }
                ]
            }
        ];

        vm.gameProps_303 = [
            {
                name: "【高级泰坦宝箱】获得道具概率公布",
                date: "2019-04-16",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "无畏碎片",
                                "数量": "5",
                                "概率": "2.92%"
                            },
                            {
                                "奖励": "蓝色空间碎片",
                                "数量": "5",
                                "概率": "1.25%"
                            },
                            {
                                "奖励": "破天者碎片",
                                "数量": "5",
                                "概率": "0.42%"
                            },
                            {
                                "奖励": "大洋守护者碎片",
                                "数量": "5",
                                "概率": "2.92%"
                            },
                            {
                                "奖励": "战争先驱碎片",
                                "数量": "5",
                                "概率": "1.67%"
                            },
                            {
                                "奖励": "愤怒守卫碎片",
                                "数量": "5",
                                "概率": "1.67%"
                            },
                            {
                                "奖励": "束缚者碎片",
                                "数量": "5",
                                "概率": "2.92%"
                            },
                            {
                                "奖励": "狂徒碎片",
                                "数量": "5",
                                "概率": "2.92%"
                            },
                            {
                                "奖励": "无畏碎片",
                                "数量": "1",
                                "概率": "14.58%"
                            },
                            {
                                "奖励": "蓝色空间碎片",
                                "数量": "1",
                                "概率": "6.25%"
                            },
                            {
                                "奖励": "破天者碎片",
                                "数量": "1",
                                "概率": "2.08%"
                            },
                            {
                                "奖励": "大洋守护者碎片",
                                "数量": "1",
                                "概率": "14.58%"
                            },
                            {
                                "奖励": "战争先驱碎片",
                                "数量": "1",
                                "概率": "8.33%"
                            },
                            {
                                "奖励": "愤怒守卫碎片",
                                "数量": "1",
                                "概率": "8.33%"
                            },
                            {
                                "奖励": "束缚者碎片",
                                "数量": "1",
                                "概率": "14.58%"
                            },
                            {
                                "奖励": "狂徒碎片",
                                "数量": "1",
                                "概率": "14.58%"
                            }
                        ]
                    }
                ]
            },
            {
                name: "【精英泰坦宝箱】获得道具概率公布",
                date: "2019-04-16",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "蓝色空间碎片",
                                "数量": "5",
                                "概率": "3.03%"
                              },
                              {
                                "奖励": "破天者碎片",
                                "数量": "5",
                                "概率": "3.03%"
                              },
                              {
                                "奖励": "战争先驱碎片",
                                "数量": "5",
                                "概率": "3.03%"
                              },
                              {
                                "奖励": "愤怒守卫碎片",
                                "数量": "5",
                                "概率": "3.03%"
                              },
                              {
                                "奖励": "德古拉碎片",
                                "数量": "5",
                                "概率": "2.27%"
                              },
                              {
                                "奖励": "审判碎片",
                                "数量": "5",
                                "概率": "2.27%"
                              },
                              {
                                "奖励": "蓝色空间碎片",
                                "数量": "1",
                                "概率": "15.15%"
                              },
                              {
                                "奖励": "破天者碎片",
                                "数量": "1",
                                "概率": "15.15%"
                              },
                              {
                                "奖励": "战争先驱碎片",
                                "数量": "1",
                                "概率": "15.15%"
                              },
                              {
                                "奖励": "愤怒守卫碎片",
                                "数量": "1",
                                "概率": "15.15%"
                              },
                              {
                                "奖励": "德古拉碎片",
                                "数量": "1",
                                "概率": "11.37%"
                              },
                              {
                                "奖励": "审判碎片",
                                "数量": "1",
                                "概率": "11.37%"
                              }
                        ]
                    }
                ]
            },
            {
                name: "【高级副官宝箱】获得道具概率公布",
                date: "2019-04-16",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "元素大师碎片",
                                "数量": "4",
                                "概率": "4.67%"
                              },
                              {
                                "奖励": "发明家碎片",
                                "数量": "4",
                                "概率": "2.67%"
                              },
                              {
                                "奖励": "女政客碎片",
                                "数量": "4",
                                "概率": "4.67%"
                              },
                              {
                                "奖励": "演说家碎片",
                                "数量": "4",
                                "概率": "0.99%"
                              },
                              {
                                "奖励": "不屈老兵碎片",
                                "数量": "4",
                                "概率": "4.67%"
                              },
                              {
                                "奖励": "战场鼓励师碎片",
                                "数量": "4",
                                "概率": "0.99%"
                              },
                              {
                                "奖励": "大白鲨碎片",
                                "数量": "4",
                                "概率": "1.33%"
                              },
                              {
                                "奖励": "元素大师碎片",
                                "数量": "1",
                                "概率": "18.67%"
                              },
                              {
                                "奖励": "发明家碎片",
                                "数量": "1",
                                "概率": "10.67%"
                              },
                              {
                                "奖励": "女政客碎片",
                                "数量": "1",
                                "概率": "18.67%"
                              },
                              {
                                "奖励": "演说家碎片",
                                "数量": "1",
                                "概率": "4.00%"
                              },
                              {
                                "奖励": "不屈老兵碎片",
                                "数量": "1",
                                "概率": "18.67%"
                              },
                              {
                                "奖励": "战场鼓励师碎片",
                                "数量": "1",
                                "概率": "4.00%"
                              },
                              {
                                "奖励": "大白鲨碎片",
                                "数量": "1",
                                "概率": "5.33%"
                              }
                        ]
                    }
                ]
            },
            {
                name: "【精英副官宝箱】获得道具概率公布",
                date: "2019-04-16",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        "subHeaders": [
                            "奖励",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "奖励": "发明家碎片",
                                "数量": "4",
                                "概率": "4.00%"
                              },
                              {
                                "奖励": "科学怪人碎片",
                                "数量": "4",
                                "概率": "1.10%"
                              },
                              {
                                "奖励": "演说家碎片",
                                "数量": "4",
                                "概率": "4.00%"
                              },
                              {
                                "奖励": "政策先锋碎片",
                                "数量": "4",
                                "概率": "1.80%"
                              },
                              {
                                "奖励": "战场鼓励师碎片",
                                "数量": "4",
                                "概率": "4.00%"
                              },
                              {
                                "奖励": "大白鲨碎片",
                                "数量": "4",
                                "概率": "4.00%"
                              },
                              {
                                "奖励": "最高指挥官碎片",
                                "数量": "4",
                                "概率": "1.10%"
                              },
                              {
                                "奖励": "发明家碎片",
                                "数量": "1",
                                "概率": "16.00%"
                              },
                              {
                                "奖励": "科学怪人碎片",
                                "数量": "1",
                                "概率": "4.40%"
                              },
                              {
                                "奖励": "演说家碎片",
                                "数量": "1",
                                "概率": "16.00%"
                              },
                              {
                                "奖励": "政策先锋碎片",
                                "数量": "1",
                                "概率": "7.20%"
                              },
                              {
                                "奖励": "战场鼓励师碎片",
                                "数量": "1",
                                "概率": "16.00%"
                              },
                              {
                                "奖励": "大白鲨碎片",
                                "数量": "1",
                                "概率": "16.00%"
                              },
                              {
                                "奖励": "最高指挥官碎片",
                                "数量": "1",
                                "概率": "4.40%"
                              }
                        ]
                    }
                ]
            },
            {
                name: "【普通克隆】获得道具概率公布",
                date: "2019-04-16",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        "subHeaders": [
                            "品质",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "品质": "蓝",
                                "数量": "1",
                                "概率": "57.69%"
                              },
                              {
                                "品质": "蓝",
                                "数量": "2",
                                "概率": "23.08%"
                              },
                              {
                                "品质": "蓝",
                                "数量": "3",
                                "概率": "9.62%"
                              },
                              {
                                "品质": "蓝",
                                "数量": "18",
                                "概率": "0.96%"
                              },
                              {
                                "品质": "紫",
                                "数量": "1",
                                "概率": "5.77%"
                              },
                              {
                                "品质": "紫",
                                "数量": "2",
                                "概率": "1.92%"
                              },
                              {
                                "品质": "紫",
                                "数量": "3",
                                "概率": "0.96%"
                              }
                         ]
                    }
                        
                 ]
            },
            {
                name: "【高级克隆】获得道具概率公布",
                date: "2019-04-16",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        "subHeaders": [
                            "品质",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "品质": "蓝",
                                "数量": "4",
                                "概率": "46.57%"
                              },
                              {
                                "品质": "蓝",
                                "数量": "6",
                                "概率": "23.28%"
                              },
                              {
                                "品质": "蓝",
                                "数量": "18",
                                "概率": "5.82%"
                              },
                              {
                                "品质": "紫",
                                "数量": "2",
                                "概率": "11.64%"
                              },
                              {
                                "品质": "紫",
                                "数量": "4",
                                "概率": "5.82%"
                              },
                              {
                                "品质": "紫",
                                "数量": "6",
                                "概率": "2.91%"
                              },
                              {
                                "品质": "紫",
                                "数量": "8",
                                "概率": "1.75%"
                              },
                              {
                                "品质": "紫",
                                "数量": "18",
                                "概率": "0.41%"
                              },
                              {
                                "品质": "橙",
                                "数量": "2",
                                "概率": "1.16%"
                              },
                              {
                                "品质": "橙",
                                "数量": "3",
                                "概率": "0.58%"
                              },
                              {
                                "品质": "橙",
                                "数量": "18",
                                "概率": "0.06%"
                              }
                         ]
                    }
                        
                 ]
            },
            {
                name: "【专家级克隆】获得道具概率公布",
                date: "2019-04-16",
                show: false,
                description: "",
                outHeaders: [],
                tables: [
                    {
                        "subHeaders": [
                            "品质",
                            "数量",
                            "概率"
                        ],
                        "data": [
                            {
                                "品质": "紫",
                                "数量": "6",
                                "概率": "46.67%"
                              },
                              {
                                "品质": "紫",
                                "数量": "12",
                                "概率": "16.67%"
                              },
                              {
                                "品质": "紫",
                                "数量": "18",
                                "概率": "6.67%"
                              },
                              {
                                "品质": "橙",
                                "数量": "6",
                                "概率": "20.00%"
                              },
                              {
                                "品质": "橙",
                                "数量": "12",
                                "概率": "8.33%"
                              },
                              {
                                "品质": "橙",
                                "数量": "18",
                                "概率": "1.67%"
                              }
                         ]
                    }
                        
                 ]
            }
        ];
    }
    
})();
(function() {
    'use strict';

    angular
        .module('trident')
        .controller('AboutController', AboutController);

    /** @ngInject */
    function AboutController() {
        var vm = this;

        vm.title = "about page";
    }
})();

(function() {
  'use strict';

  angular
    .module('trident')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
    'use strict';

    angular
        .module('trident')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.when('', '/app/home');

        $stateProvider
            .state('app', {
                url: '/app',
                abstract: true,
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main'
            }).state('app.home', {
                url: '/home',
                templateUrl: 'app/home/home.html',
                controller: 'HomeController',
                controllerAs: 'home'
            }).state('app.about', {
                url: '/about',
                templateUrl: 'app/about/about.html',
                controller: 'AboutController',
                controllerAs: 'about'
            }).state('app.show', {
                url: '/show',
                templateUrl: 'app/show/show.html',
                controller: 'ShowController',
                controllerAs: 'show'
            }).state('app.contact', {
                url: '/contact',
                templateUrl: 'app/contact/contact.html',
                controller: 'ContactController',
                controllerAs: 'contact'
            }).state('app.parental', {
                url: '/parental',
                templateUrl: 'app/parental/parental.html',
                controller: 'ParentalController',
                controllerAs: 'parental'
            }).state('app.privacy', {
                url: '/privacy',
                templateUrl: 'app/privacy/privacy.html',
                controller: 'PrivacyController',
                controllerAs: 'privacy'
            }).state('app.disputeHandling', {
                url: '/disputeHandling',
                templateUrl: 'app/disputeHandling/disputeHandling.html',
                controller: 'DisputeHandlingController',
                controllerAs: 'disputeHandling'
            }).state('app.announcement', {
                url: '/announcement',
                templateUrl: 'app/announcement/announcement.html',
                controller: 'AnnouncementController',
                controllerAs: 'announcement'
            });

        $urlRouterProvider.otherwise('/app/home');
    }

})();

(function () {
    'use strict';

    angular
        .module('trident')
        .constant('_', window._);

})();


(function() {
  'use strict';

  angular
    .module('trident')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, localStorageServiceProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 2000;
    toastrConfig.positionClass = 'toast-bottom-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = false;

    // Set options of local storage service
    localStorageServiceProvider
        .setPrefix('trident')
        .setNotify(true, true)
  }

})();

angular.module("trident").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<div><p class=\"description-content paragraph-space\"><strong>成都三叉戟科技</strong>致力于精品游戏的创作，现团队平均7年以上的游戏开发经验，无论是程序、美术、策划、运营、市场，都有一颗热爱游戏的心，立志通过团队的力量，打造出玩家都热爱的手游精品。</p><p class=description-content>对三叉戟来说，致力于精品就要有优秀的文化基因为保障。</p><img class=paragraph-space style=\"margin-left: 2em\" src=assets/images/about_us.png alt=\"about us\" height=260 width=400><p class=\"description-content paragraph-space\"><strong>对产品</strong>：我们致力于匠人精神。无论身处何职，每个成员在打磨我们产品时，都应怀揣一颗匠人之心，卓求卓越，精益求精。</p><p class=\"description-content paragraph-space\"><strong>对玩家</strong>：我们以优质的服务为依托。在每一个交流互动环节，我们都要具备热情、周到、主动的服务意识。</p><p class=\"description-content paragraph-space\"><strong>对工作</strong>：我们相信，只有对生活、对游戏、对所做的事情和所处的团队拥有一份仁爱之心，我们才能快乐的创作快乐。</p><p class=\"description-content paragraph-space\">而正直与信任则是我们团队的文化基石。</p><p class=\"description-content paragraph-space\"><span style=\"font-size: 28px\"><strong>make something people love</strong></span></p><div class=\"description-content paragraph-space\"><a href=javascript:void(0) data-ng-click=\"about.hideCertificate = !about.hideCertificate\">网络文化经营许可证</a> <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal\">←点击<span data-ng-if=!about.hideCertificate>收起</span><span data-ng-if=about.hideCertificate>查看</span></span><div data-ng-if=!about.hideCertificate><img src=assets/docs/trident-allowed-certificate.jpg width=100% height=100%></div></div></div>");
$templateCache.put("app/announcement/announcement.html","<div class=announcement-container><uib-tabset><uib-tab heading=猿族时代运营><img class=announcement-panel-head src=assets/images/p2_banner.png alt=\"head picture\"><div class=\"panel panel-info announcement-panel announcement-panel-follow\"><div class=panel-heading>活动概率公告</div><div class=panel-body><div data-ng-repeat=\"activity in announcement.activities_aoa\"><div><a class=custom-item-link href=javascript:void(0) data-ng-click=\"activity.show = !activity.show\">{{activity.date}}&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{activity.name}}</a> <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal\">←点击<span data-ng-if=!activity.show>展开</span><span data-ng-if=activity.show>缩回</span></span><div class=announcement-content-container data-ng-if=activity.show><p data-ng-if=activity.description style=\"text-align: justify; font-style: italic; font-size: 13px\">{{activity.description}}</p><table class=\"table table-bordered\"><tr data-ng-repeat-start=\"_ in activity.outHeaders\" data-ng-if=\"$index % 2 == 0\"><th data-ng-repeat=\"oh in activity.outHeaders.slice($index, $index+2)\">{{oh}}</th></tr><tr data-ng-repeat-end data-ng-if=\"$index % 2 == 0\"><td data-ng-repeat=\"t in activity.tables.slice($index, $index+2)\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr><tr><td data-ng-repeat=\"t in activity.tables\" data-ng-if=\"activity.outHeaders.length == 0\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr></table></div></div></div></div></div></uib-tab><uib-tab heading=野蛮时代运营><img class=announcement-panel-head src=assets/images/ba_operation_announcement_panel.png alt=\"head picture\"><div class=\"panel panel-info announcement-panel announcement-panel-follow\"><div class=panel-heading>活动概率公告</div><div class=panel-body><div data-ng-repeat=\"activity in announcement.activities\"><div><a class=custom-item-link href=javascript:void(0) data-ng-click=\"activity.show = !activity.show\">{{activity.date}}&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{activity.name}}</a> <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal\">←点击<span data-ng-if=!activity.show>展开</span><span data-ng-if=activity.show>缩回</span></span><div class=announcement-content-container data-ng-if=activity.show><p data-ng-if=activity.description style=\"text-align: justify; font-style: italic; font-size: 13px\">{{activity.description}}</p><table class=\"table table-bordered\"><tr data-ng-repeat-start=\"_ in activity.outHeaders\" data-ng-if=\"$index % 2 == 0\"><th data-ng-repeat=\"oh in activity.outHeaders.slice($index, $index+2)\">{{oh}}</th></tr><tr data-ng-repeat-end data-ng-if=\"$index % 2 == 0\"><td data-ng-repeat=\"t in activity.tables.slice($index, $index+2)\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr><tr><td data-ng-repeat=\"t in activity.tables\" data-ng-if=\"activity.outHeaders.length == 0\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr></table></div></div></div></div></div><div class=\"panel panel-info announcement-panel announcement-panel-follow\"><div class=panel-heading>道具概率公告</div><div class=panel-body><div data-ng-repeat=\"item in announcement.gameProps\"><div><a class=custom-item-link href=javascript:void(0) data-ng-click=\"item.show = !item.show\">{{item.date}}&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{item.name}}</a> <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal\">←点击<span data-ng-if=!item.show>展开</span><span data-ng-if=item.show>缩回</span></span><div class=announcement-content-container data-ng-if=item.show><p data-ng-if=item.description style=\"text-align: justify; font-style: italic; font-size: 13px\">{{item.description}}</p><table class=\"table table-bordered\"><tr data-ng-repeat-start=\"_ in item.outHeaders\" data-ng-if=\"$index % 2 == 0\"><th data-ng-repeat=\"oh in item.outHeaders.slice($index, $index+2)\">{{oh}}</th></tr><tr data-ng-repeat-end data-ng-if=\"$index % 2 == 0\"><td data-ng-repeat=\"t in item.tables.slice($index, $index+2)\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr><tr><td data-ng-repeat=\"t in item.tables\" data-ng-if=\"item.outHeaders.length == 0\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr></table></div></div></div></div></div></uib-tab><!--<uib-tab heading=\"服务申请\">--><!-- --><!--</uib-tab>--><uib-tab heading=小岛大作战运营><img class=announcement-panel-head src=assets/images/303_operation_announcement_panel.png alt=\"head picture\"><!--<div class=\"panel panel-info announcement-panel announcement-panel-follow\">\n               <div class=\"panel-heading\">活动概率公告</div>\n                <div class=\"panel-body\">\n                    <div data-ng-repeat=\"activity in announcement.activities_303\">\n                        <div>\n                            <a class=\"custom-item-link\" href=\"javascript:void(0)\" data-ng-click=\"activity.show = !activity.show\">{{activity.date}}&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{activity.name}}</a>\n                            <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal;\">←点击<span data-ng-if=\"!activity.show\">展开</span><span data-ng-if=\"activity.show\">缩回</span></span>\n                            <div class=\"announcement-content-container\" data-ng-if=\"activity.show\">\n                                <p data-ng-if=\"activity.description\" style=\"text-align: justify; font-style: italic; font-size: 13px\">{{activity.description}}</p>\n                                <table class=\"table table-bordered\">\n                                    <tr data-ng-repeat-start=\"_ in activity.outHeaders\" data-ng-if=\"$index % 2 == 0\">\n                                        <th data-ng-repeat=\"oh in activity.outHeaders.slice($index, $index+2)\">{{oh}}</th>\n                                    </tr>\n                                    <tr data-ng-repeat-end data-ng-if=\"$index % 2 == 0\">\n                                        <td data-ng-repeat=\"t in activity.tables.slice($index, $index+2)\">\n                                            <table class=\"table table-striped\">\n                                                <tr>\n                                                    <th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th>\n                                                </tr>\n                                                <tr data-ng-repeat=\"x in t.data\">\n                                                    <td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td>\n                                                </tr>\n                                            </table>\n                                        </td>\n                                    </tr>\n                                    <tr>\n                                        <td data-ng-repeat=\"t in activity.tables\" data-ng-if=\"activity.outHeaders.length == 0\">\n                                            <table class=\"table table-striped\">\n                                                <tr>\n                                                    <th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th>\n                                                </tr>\n                                                <tr data-ng-repeat=\"x in t.data\">\n                                                    <td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td>\n                                                </tr>\n                                            </table>\n                                        </td>\n                                    </tr>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>--><div class=\"panel panel-info announcement-panel announcement-panel-follow\"><div class=panel-heading>道具概率公告</div><div class=panel-body><div data-ng-repeat=\"item in announcement.gameProps_303\"><div><a class=custom-item-link href=javascript:void(0) data-ng-click=\"item.show = !item.show\">{{item.date}}&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{item.name}}</a> <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal\">←点击<span data-ng-if=!item.show>展开</span><span data-ng-if=item.show>缩回</span></span><div class=announcement-content-container data-ng-if=item.show><p data-ng-if=item.description style=\"text-align: justify; font-style: italic; font-size: 13px\">{{item.description}}</p><table class=\"table table-bordered\"><tr data-ng-repeat-start=\"_ in item.outHeaders\" data-ng-if=\"$index % 2 == 0\"><th data-ng-repeat=\"oh in item.outHeaders.slice($index, $index+2)\">{{oh}}</th></tr><tr data-ng-repeat-end data-ng-if=\"$index % 2 == 0\"><td data-ng-repeat=\"t in item.tables.slice($index, $index+2)\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr><tr><td data-ng-repeat=\"t in item.tables\" data-ng-if=\"item.outHeaders.length == 0\"><table class=\"table table-striped\"><tr><th data-ng-repeat=\"ih in t.subHeaders\">{{ih}}</th></tr><tr data-ng-repeat=\"x in t.data\"><td data-ng-repeat=\"ih in t.subHeaders\">{{x.hasOwnProperty(ih) && x[ih] || \"\"}}</td></tr></table></td></tr></table></div></div></div></div></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/contact/contact.html","<div class=contact-info><div class=location-image><img src=assets/images/trident_location.png alt=location></div><div class=contact-text><div class=address-text><h3>公司地址：</h3><p class=contact-detail>成都市高新区天府软件园A3-3楼</p></div><div class=phone-text><h3>联系电话：</h3><p class=contact-detail>028-83313298</p></div><div class=manager><h3>联系人：</h3><p class=contact-detail>侯先生</p></div></div><div class=clear></div></div>");
$templateCache.put("app/disputeHandling/disputeHandling.html","<div><p style=\"margin-bottom: 30px\">如果玩家对tap4fun的游戏，或者对客服服务有任何异议，请玩家提供相关材料发送邮件到邮箱： <a href=mailto:support@tap4fun.com>support@tap4fun.com</a> 进行后续处理</p><h4>玩家之间的纠纷处理</h4><p>如果玩家之间发生纠纷无法协商一致的，玩家可从游戏内直接点击联系客服进行问题协调，如果暂时无法通过游戏内联系客服的，可将问题发送至邮箱：<a href=mailto:support@tap4fun.com>support@tap4fun.com</a></p></div>");
$templateCache.put("app/home/home.html","<div class=\"page-row head-row\" style=\"background-image: url(\'assets/images/trident_main.png\')\"><h1>精品游戏创作营</h1><p style=\"font-size: 16px\">对每一款产品，都怀揣一颗匠人之心<br>追求卓越、精益求精、打造游戏精品化路线</p></div><div class=page-row><p class=description-content><strong>三叉戟科技</strong>拥有国内顶尖的游戏制作及发行团队，致力于手机精品游戏开发，打造国际一流手游体验。对我们来说，玩家的每一次心动，都是我们要追求的极致体验。 点击 <a ui-sref=app.about>关于</a>，了解更多。</p></div>");
$templateCache.put("app/login/login.html","<div class=login-container><div class=login-panel><h3 style=\"margin-bottom: 50px\">登录</h3><form><div class=form-group><label for=userName>邮箱:</label><input type=text class=form-control id=userName data-ng-model=login.userName placeholder=\"eg: example@example.com\"></div><div class=form-group><label for=userPassword>密码:</label><input type=password class=form-control id=userPassword data-ng-model=login.userPassword placeholder=Password></div><button class=\"btn btn-info\" data-ng-click=login.login()>登录</button></form></div></div>");
$templateCache.put("app/parental/parental.html","<div class=parental-container><uib-tabset><uib-tab heading=工程体系><img class=parental-panel-head src=assets/images/parental_head.png alt=\"head picture\"><div class=\"panel panel-info parental-panel parental-panel-follow\"><div class=panel-heading>工程介绍</div><div class=panel-body><p class=description-content>“网络游戏未成年人家长监护工程”是一项由完美时空、腾讯、盛大游戏、网易、搜狐畅游、巨人网络六家网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护， 引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。它提供了一种切实可行的方法，一种家长实施监控的管道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。</p><p class=description-content>该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注及对用实际行动营造和谐社会的愿望。</p><a href=javascript:void(0) data-ng-click=\"parental.showTips = !parental.showTips\">未成年人健康参与网络游戏提示</a> <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal\">←点击<span data-ng-if=!parental.showTips>展开</span><span data-ng-if=parental.showTips>缩回</span></span><div data-ng-if=parental.showTips><p class=description-content>随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：</p><p class=description-content>一、主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。</p><p class=description-content>二、不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。</p><p class=description-content>三、不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。</p><p class=description-content>四、养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。</p><p class=description-content>五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。</p></div></div></div></uib-tab><uib-tab heading=服务申请><div class=\"panel panel-info parental-panel parental-panel-head\"><div class=panel-heading>监护申请流程</div><div class=panel-body><img class=parental-image src=assets/images/apply_flow.png alt=\"apply flow\"><br><a href=javascript:void(0) data-ng-click=\"parental.showDetails = !parental.showDetails\">流程介绍详细说明</a> <span style=\"color: #AEAEAE;font-size: 12px;font-weight: normal\">←点击<span data-ng-if=!parental.showDetails>展开</span><span data-ng-if=parental.showDetails>缩回</span></span><div data-ng-if=parental.showDetails><h4>监护人提出申请</h4><ul><li>在监护人发现被监护人有沉溺{{parental.studio.cn_name}}网络游戏的情况下，监护人可向{{parental.studio.cn_name}}公司申请发起未成年人家长监护机制。</li><li>监护人 需亲自通过邮寄方式 向我司提供有效材料，向{{parental.studio.cn_name}}公司提出未成年人账户监控的申请。在收到邮件后，我司即开始启动监护机制审核流程，首先进入疑似账号身份确认期。</li></ul><h4>疑似账号身份确认期（15 个自然日）</h4><ul><li>在判断申请材料完整的情况下，我司将通过官方邮箱联系疑似帐号归属者，告知其在 15 个自然日内将按照监护人需求对其账号进行相关操作，并要求疑似账号归属者提供身份材料以便我司判定其与监护人监护关系；</li><li>若疑似账号归属者在 15 个自然日内不能提供有效身份证明或逾期提供，则默认为疑似账号归属者与被监护人身份相符。我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；</li><li>若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人相符，我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；</li><li>若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人不符，我司则无法判定其与被监护人的身份关系。在此情况下，为保障用户游戏账号安全，我司将通知监护人通过公安机关出具账号找回协查证明，由我司协助被监护人找回游戏账号后再进行后续操作；</li></ul></div></div></div><div class=\"panel panel-info parental-panel parental-panel-follow\"><div class=panel-heading>监护服务申请书</div><div class=panel-body><p class=indent-multiple>申请表单：<a href=assets/docs/ApplyResources.zip>成都{{parental.studio.cn_name}}科技有限公司未成年人用户家长监控服务申请书</a><br>温馨提醒，您在邮寄申请书时，要记得一起提供如下资料：<br>附件1：申请人的身份证（复印件）<br>附件2：被申请人的身份证（复印件）<br>附件3：申请人与被申请人的监护法律关系证明文件（户口簿或者其他合法有效证明文件）<br>单位经营地址<br>成都高新区世纪城路1129号A区5栋3层302<br>邮编<br>610041<br>监护工程专线电话<br>028-85185301<br>监护工程专线传真<br>028-85185301</p></div></div></uib-tab><uib-tab heading=常见问题><div class=\"panel panel-info parental-panel parental-panel-head\"><div class=panel-heading>常见问题解答</div><div class=panel-body><div class=parental-question><h4>Q1：“网络游戏未成年人家长监护机制工程”是什么？</h4><p class=indent-multiple>“网络游戏未成年人家长监护工程”是一项由完美时空、腾讯、盛大游戏、网易、搜狐畅游、巨人网络六家网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导， 旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。它提供了一种切实可行的方法，一种家长实施监控的管道， 使家长纠正部分未成年子女沉迷游戏的行为成为可能。该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注以及对用实际行动营造和谐社会的愿望。</p></div><div class=parental-question><h4>Q2：什么情况下需要申请该项服务呢？</h4><p class=indent-multiple>在监护人发现被监护人有沉溺{{parental.studio.cn_name}}网络游戏的情况下，监护人可向{{parental.studio.cn_name}}公司申请发起未成年人家长监护机制。</p></div><div class=parental-question><h4>Q3：申请该项服务时需要提交哪些资料呢？如何提交呢？</h4><p class=indent-multiple>申请人需通过邮寄方式向我司提交《成都{{parental.studio.cn_name}}科技有限公司未成年人用户家长监控服务申请书》及其中所提及需提供的附件，包含：<br>附件1：申请人的身份证（复印件）<br>附件2：被申请人的身份证（复印件）<br>附件3：申请人与被申请人的监护法律关系证明文件（户口簿或者其他合法有效证明文件）<br>您在填写《成都{{parental.studio.cn_name}}科技有限公司未成年人用户家长监控服务申请书》时，请提供尽可能详尽、真实的玩家资料，以便帐号归属的判定。</p></div><div class=parental-question><h4>Q4：相关资料寄往哪里呢？</h4><p class=indent-multiple>请将相关资料邮寄至：（请在信封表面写上“家长监控服务申请书”的字样） 收件人：成都{{parental.studio.cn_name}}科技有限公司 地　址：成都高新区世纪城路1129号A区5栋3层302 邮　编：610041</p></div><div class=parental-question><h4>Q5：提交资料后，后续处理流程怎样呢？</h4><p class=indent-multiple>您提交相关申请资料后，我司客服人员将按照监护申请流程尽快处理您的申请，处理过程中可能需要对监护人和被监护人进行电话回访以便信息的判定，希望您的配合。</p></div><div class=parental-question><h4>Q6：判定帐号归属需要多久呢？</h4><p class=indent-multiple>在判断申请材料完整的情况下，我司将联系疑似账号归属者，告知其在 15 个自然日内将按照监护人需求对其账号进行相关操作，并要求疑似账号归属者提供身份材料以便我司判定其与监护人监护关系；<br>若疑似账号归属者在 15 个自然日内不能提供有效身份证明或逾期提供，则默认为疑似账号归属者与被监护人身份相符。我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；<br>若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人相符，我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；<br>若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人不符，我司则无法判定其与被监护人的身份关系。在此情况下，为保障用户游戏账号安全，我司将通知监护人通过公安机关出具账号找回协查证明，由我司协助被监护人找回游戏账号后再进行后续操作；</p></div><div class=parental-question><h4>Q7:若发现对帐号归属有疑义或账号被恶意防沉迷限制怎么办？</h4><p class=indent-multiple>您需要在收到通知后15个自然日内提供您的身份证复印件（纸质），并通过以下地址邮寄到我司，如果我司在15个自然日内未收到您的身份证复印件，我们会将您的账号纳入家长监控系统。<br>收件人：成都{{parental.studio.cn_name}}科技有限公司<br>地　址：成都高新区世纪城路1129号A区5栋3层302<br>邮　编：610041<br>注1：请在身份证复印件上写明您的签名。<br>注2：请您注意我司提供该项服务不收取任何费用，以免上当受骗。</p></div></div></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/main/main.html","<navbar></navbar><div class=main-container><ui-view></ui-view></div><site-footer></site-footer>");
$templateCache.put("app/privacy/privacy.html","<div class=privacy-container><div style=\"text-align: right\"><a style=\"cursor: pointer\" ng-repeat=\"lang in privacy.supported_languages\" ng-class=\"{\'lang_matched\': privacy.lang == lang}\" ng-click=\"privacy.lang = lang\">{{\' \' + privacy.local_name[lang]}}</a></div><div ng-if=\"privacy.lang == \'zh-CN\'\"><h1 class=p1 style=\"text-align: center\"><span class=s1><strong>成都三叉戟科技有限公司隐私政策</strong></span></h1><p class=p2>&nbsp;</p><p class=p3>&nbsp;</p><p class=p4><span class=s1>成都三叉戟科技有限公司及关联公司（以下统称</span><span class=s2>&ldquo;</span><span class=s1>三叉戟</span><span class=s2>&rdquo;</span><span class=s1>或</span><span class=s2>&ldquo;</span><span class=s1>我们</span><span class=s2>&rdquo;</span><span class=s1>）一向庄严承诺保护使用三叉戟的产品和服务（以下统称</span><span class=s2>&ldquo;</span><span class=s1>我们的服务</span><span class=s2>&rdquo;</span><span class=s1>）之用户（以下统称</span><span class=s2>&ldquo;</span><span class=s1>用户</span><span class=s2>&rdquo;</span><span class=s1>或</span><span class=s2>&ldquo;</span><span class=s1>您</span><span class=s2>&rdquo;</span><span class=s1>）的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的我们的服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。</span></p><p class=p5><span class=s1><strong>请注意我们不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私政策》最新版本始终保持了解。</strong>在阅读完本政策之后，如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，请与</span><span class=s2>Dept-csteam@nibirutech.com</span><span class=s1>联系。</span></p><p class=p5><span class=s1><strong>您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。</strong></span></p><p class=p3>&nbsp;</p><h2 class=p6 style=\"text-align: center\"><span class=s1><strong>目录</strong></span></h2><p class=p7><span class=s1><strong>一、我们可能收集的信息</strong></span></p><p class=p7><span class=s1><strong>二、我们如何收集和使用信息</strong></span></p><p class=p7><span class=s1><strong>三、我们可能分享、转让和披露的信息</strong></span></p><p class=p7><span class=s1><strong>四、我们如何保留、储存和保护信息</strong></span></p><p class=p7><span class=s1><strong>五、如何管理您的信息</strong></span></p><p class=p7><span class=s1><strong>六、广告服务</strong></span></p><p class=p7><span class=s1><strong>七、第三方服务</strong></span></p><p class=p7><span class=s1><strong>八、年龄限制</strong></span></p><p class=p7><span class=s1><strong>九、通知和修订</strong></span></p><p class=p7><span class=s1><strong>十、如何联系我们</strong></span></p><p class=p8>&nbsp;</p><p class=p7><span class=s1><strong>一、我们可能收集的信息</strong></span></p><p class=p7><span class=s3>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</span></p><p class=p7><span class=s1>（一）</span><span class=s3>与个人身份无关的信息：</span></p><p class=p7><span class=s1>当您使用我们的服务时，我们可能收集和汇总诸如用户的来源途径、访问顺序等信息，例如记录使用我们的服务的每个用户的来源途径、浏览器软件等。</span></p><p class=p7><span class=s1>（二）有关个人身份的信息：</span></p><p class=p7><span class=s1>当您使用我们的服务时，我们可能收集和汇总或要求您提供有关个人身份的信息，例如个人身份证明（包括身份证、护照、驾驶证等）；生日、籍贯、性别、兴趣爱好、个人电话号码、面部特征；网络身份标识信息（包括系统账号、</span><span class=s4>IP</span><span class=s1>地址、电子邮箱地址及与前述有关的密码、口令、口令保护答案等）；个人财产信息（交易记录、余额、优惠券、游戏类兑换码、银行卡信息等）；通讯信息；个人上网记录和日志信息（包括网站浏览记录、软件使用记录、点击记录、操作日志等）；设备信息（包括设备型号、设备</span><span class=s4>MAC</span><span class=s1>地址、操作系统类型、设备设置）；软件列表唯一设备识别码（如</span><span class=s4>IMEI/android ID/IDFA/OPENUDID/GUID</span><span class=s1>、</span><span class=s4>SIM</span><span class=s1>卡</span><span class=s4>IMSI</span><span class=s1>信息等在内的描述个人常用设备基本情况的信息）；位置信息（包括行程信息、精准定位信息、住宿信息、经纬度等）。</span></p><p class=p9>&nbsp;</p><p class=p7><span class=s1><strong>二、我们如何收集和使用信息</strong></span></p><p class=p7><span class=s1>（一）我们将通过以下途径收集和获得您的信息：</span></p><p class=p7><span class=s4>1</span><span class=s1>、您提供的信息：</span></p><p class=p7><span class=s1>（</span><span class=s4>1</span><span class=s1>）您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；</span></p><p class=p7><span class=s1>（</span><span class=s4>2</span><span class=s1>）您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</span></p><p class=p7><span class=s4>2</span><span class=s1>、其他方分享的您的信息。其他方使用我们的服务时所提供有关您的共享信息。</span></p><p class=p7><span class=s4>3</span><span class=s1>、我们获取的您的信息。您在使用我们的服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息等。</span></p><p class=p7><span class=s1>（二）我们会出于以下目的，收集和使用您的信息：</span></p><p class=p7><span class=s4>1</span><span class=s1>、帮助您完成注册</span></p><p class=p7><span class=s1>为便于我们为您提供服务，您需要提供基本注册信息，例如手机号码、电子邮箱地址等，并创建您的用户名和密码。</span></p><p class=p7><span class=s4>2</span><span class=s1>、向您提供服务</span></p><p class=p7><span class=s1>我们所收集和使用的信息是为您提供服务的必要条件，如缺少相关信息，我们将无法为您提供服务的核心内容，例如：当您与我们联系时，我们可能会保存您的通信</span><span class=s4>/</span><span class=s1>通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</span></p><p class=p7><span class=s4>3</span><span class=s1>、向您推送信息</span></p><p class=p7><span class=s1>（</span><span class=s4>1</span><span class=s1>）邮件和信息推送。您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照相关提示，在设备上选择取消订阅。</span></p><p class=p7><span class=s1>（</span><span class=s4>2</span><span class=s1>）与服务有关的公告。我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</span></p><p class=p7><span class=s4>4</span><span class=s1>、为您提供安全保障</span></p><p class=p7><span class=s5><strong>为确保您身份真实性、向您提供更好的安全保障，您可以向我们提供身份证明、面部特征等生物识别信息等个人敏感信息以完成实名认证。</strong></span></p><p class=p7><span class=s5><strong>除身份验证外，我们可能将您的信息用于客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的服务的安全性；我们可能使用或整合我们所收集的您的信息，以及我们的合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</strong></span></p><p class=p7><span class=s4>5</span><span class=s1>、改进我们的服务</span></p><p class=p7><span class=s1>我们可能让您参与有关我们的服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。</span></p><p class=p7><span class=s5><strong>您了解并同意，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。</strong></span></p><p class=p7><span class=s1>如果我们将您的信息用于本《隐私政策》中未载明的其他用途，会事先征求您同意。</span></p><p class=p7><span class=s4>6</span><span class=s1>、征得授权同意的例外</span></p><p class=p7><span class=s1>根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</span></p><p class=p7><span class=s1>（</span><span class=s4>1</span><span class=s1>）与国家安全、国防安全有关的；</span></p><p class=p7><span class=s1>（</span><span class=s4>2</span><span class=s1>）与公共安全、公共卫生、重大公共利益有关的；</span></p><p class=p7><span class=s1>（</span><span class=s4>3</span><span class=s1>）与犯罪侦查、起诉、审判和判决执行等有关的；</span></p><p class=p7><span class=s1>（</span><span class=s4>4</span><span class=s1>）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</span></p><p class=p7><span class=s1>（</span><span class=s4>5</span><span class=s1>）所收集的信息是您自行向社会公众公开的；</span></p><p class=p7><span class=s1>（</span><span class=s4>6</span><span class=s1>）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</span></p><p class=p7><span class=s1>（</span><span class=s4>7</span><span class=s1>）根据您的要求签订合同所必需的；</span></p><p class=p7><span class=s1>（</span><span class=s4>8</span><span class=s1>）用于维护我们的服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span></p><p class=p7><span class=s1>（</span><span class=s4>9</span><span class=s1>）为合法的新闻报道所必需的；</span></p><p class=p7><span class=s1>（</span><span class=s4>10</span><span class=s1>）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</span></p><p class=p7><span class=s1>（</span><span class=s4>11</span><span class=s1>）法律法规规定的其他情形。</span></p><p class=p9>&nbsp;</p><p class=p7><span class=s1><strong>三、我们可能分享、转让或披露的信息</strong></span></p><p class=p7><span class=s1>（一）分享</span></p><p class=p7><span class=s1>除以下情形外，<strong>未经您同意</strong>，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</span></p><p class=p7><span class=s4><strong>1</strong></span><span class=s1><strong>、</strong></span><span class=s5><strong>向您提供我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以实现您需要的核心功能或提供您需要的服务。</strong></span></p><p class=p7><span class=s4><strong>2</strong></span><span class=s1><strong>、</strong></span><span class=s5><strong>维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以帮助我们为您提供更有针对性、更完善的服务。</strong></span></p><p class=p7><span class=s4><strong>3</strong></span><span class=s1><strong>、</strong></span><span class=s5><strong>实现本《隐私政策》第二条</strong></span><span class=s6><strong>&ldquo;</strong></span><span class=s5><strong>我们如何收集和使用信息</strong></span><span class=s6><strong>&rdquo;</strong></span><span class=s5><strong>部分所述目的。</strong></span></p><p class=p7><span class=s4><strong>4</strong></span><span class=s1><strong>、</strong></span><span class=s5><strong>履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利。</strong></span></p><p class=p7><span class=s4>5</span><span class=s1>、在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过</span><span class=s4>,</span><span class=s1>这并不包括违反本《隐私政策》中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。</span></p><p class=p7><span class=s4>6</span><span class=s1>、应您合法需求，协助处理您与他人的纠纷或争议；</span></p><p class=p7><span class=s4>7</span><span class=s1>、应您的监护人合法要求而提供您的信息</span></p><p class=p7><span class=s4>8</span><span class=s1>、基于符合法律法规的社会公共利益而提供</span></p><p class=p7><span class=s1>我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本《隐私政策》以及其他任何相关的保密和安全措施来处理信息。</span></p><p class=p7><span class=s1>（二）转让</span></p><p class=p7><span class=s4>1</span><span class=s1>、</span><span class=s5><strong>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。</strong></span><span class=s1>我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束，否则</span><span class=s4>,</span><span class=s1>我们将要求该公司、组织重新向您征求授权同意。</span></p><p class=p7><span class=s4>2</span><span class=s1>、在获得您的明确同意后，我们会向其他方转让您的信息。</span></p><p class=p7><span class=s1>（三）披露</span></p><p class=p7><span class=s1>我们或我们的关联公司仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的信息：</span></p><p class=p7><span class=s4>1</span><span class=s1>、根据您的需求，在您明确同意的披露方式下披露您所指定的信息；</span></p><p class=p7><span class=s4>2</span><span class=s1>、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span></p><p class=p7><span class=s4>3</span><span class=s1>、为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</span></p><p class=p9>&nbsp;</p><p class=p7><span class=s1><strong>四、我们如何保留、储存和保护信息</strong></span></p><p class=p7><span class=s1>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与</span><span class=s4>&ldquo;</span><span class=s1>服务</span><span class=s4>&rdquo;</span><span class=s1>之间交换数据（如信用卡信息）时受</span><span class=s4>SSL</span><span class=s1>加密保护；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息。</span></p><p class=p7><span class=s1>（二）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span></p><p class=p7><span class=s1>（三）互联网并非绝对安全的环境，而且电子邮件、即时通讯等用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保护您的账户安全。</span></p><p class=p7><span class=s1>（四）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或损坏，导致您的合法权益受损，我们将承担相应的法律责任。</span></p><p class=p7><span class=s1>（五）安全事件处置</span></p><p class=p7><span class=s1>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span></p><p class=p7><span class=s5><strong>请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您使用我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</strong></span></p><p class=p8>&nbsp;</p><p class=p7><span class=s1><strong>五、如何管理您的信息</strong></span></p><p class=p7><span class=s1>（一）访问、更新和删除</span></p><p class=p7><span class=s1>我们鼓励您更新和修改您的信息以使其更准确有效。您能通过我们的服务访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段，尽可能保证您可以访问、更新和更正自己的信息或使用服务时提供的其他信息。</span></p><p class=p7><span class=s1>（二）公开与分享</span></p><p class=p7><span class=s1>我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。</span></p><p class=p7><span class=s5><strong>如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。</strong></span></p><p class=p7><span class=s1>（三）注销</span></p><p class=p7><span class=s1>您随时可注销此前注册的账户，在注销账户后，我们将停止为您提供服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</span></p><p class=p7><span class=s1>（四）改变您授权同意的范围</span></p><p class=p7><span class=s1>您总是可以选择是否披露信息。有些信息是使用我们的服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。</span></p><p class=p7><span class=s5><strong>当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。</strong></span></p><p class=p7><span class=s1>（五）有关敏感信息的提示</span></p><p class=p7><span class=s5><strong>某些信息因其特殊性可能被认为是敏感信息，例如您的种族、宗教、个人健康和医疗信息等，以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹、交易信息、未成年人的信息等。</strong></span></p><p class=p7><span class=s5><strong>请注意，您在我们的服务中所提供、上传或发布的内容和信息（例如有关您社交活动的照片或信息），可能会泄露您的敏感信息。您需要谨慎地考虑，是否使用我们的服务披露您的敏感信息。</strong></span></p><p class=p7><span class=s5><strong>您同意您的敏感信息按本《隐私政策》所述的目的和方式来处理。</strong></span></p><p class=p10><span class=s7><strong>您可通过向</strong></span><span class=s1><strong>Dept-csteam@nibirutech.com</strong></span><span class=s7><strong>发出请求来管理你的个人信息。</strong></span></p><p class=p8>&nbsp;</p><p class=p7><span class=s1><strong>六、广告服务</strong></span></p><p class=p7><span class=s4>1</span><span class=s1>、我们可能使用您的相关信息，向您提供与您更加相关的广告。</span></p><p class=p7><span class=s4>2</span><span class=s1>、我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：</span></p><p class=p7><span class=s1>（</span><span class=s4>1</span><span class=s1>）</span> <span class=s1>我们的商品或服务，我们的关联公司和合作伙伴的商品或服务，（统称</span><span class=s4>&ldquo;</span><span class=s1>互联网服务</span><span class=s4>&rdquo;</span><span class=s1>）；</span></p><p class=p7><span class=s1>（</span><span class=s4>2</span><span class=s1>）第三方供应商，以及与下列有关的第三方商品或服务：食物和餐饮、体育、音乐、电影、电视、现场表演及其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及其他金融服务、会员积分和奖励计划，以及我们认为可能与您相关的其他商品或服务。</span></p><p class=p7><span class=s5><strong>如您不希望我们将您的个人信息用作前述广告用途，您可以通过我们在广告中提供的相关提示，或在特定服务中提供的指引，要求我们停止为上述用途使用您的个人信息。</strong></span></p><p class=p8>&nbsp;</p><p class=p7><span class=s1><strong>七、第三方服务</strong></span></p><p class=p7><span class=s1>我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：</span></p><p class=p7><span class=s1>（</span><span class=s4>1</span><span class=s1>）您利用</span><span class=s4> &ldquo;</span><span class=s1>分享</span><span class=s4>&rdquo;</span><span class=s1>键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置</span><span class=s4>cookies</span><span class=s1>，从而正常运行上述功能；</span></p><p class=p7><span class=s1>（</span><span class=s4>2</span><span class=s1>）我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站；</span></p><p class=p7><span class=s1>（</span><span class=s4>3</span><span class=s1>）其他接入第三方服务的情形。</span></p><p class=p7><span class=s5><strong>该等第三方社交媒体或其他服务由相关的第三方。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。</strong></span></p><p class=p8>&nbsp;</p><p class=p7><span class=s1><strong>八、年龄限制</strong></span></p><p class=p7><span class=s1>我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本《隐私政策》，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意和指导。</span></p><p class=p8>&nbsp;</p><p class=p7><span class=s1><strong>九、通知和修订</strong></span></p><p class=p7><span class=s1>我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。</span><span class=s5><strong>如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。</strong></span></p><p class=p8>&nbsp;</p><p class=p7><span class=s1><strong>十、如何联系我们</strong></span></p><p class=p7><span class=s1>如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或我们的隐私措施的问题请与我们联系。地址是</span><span class=s4>Dept-csteam@nibirutech.com</span><span class=s1>。</span></p><p class=p2>&nbsp;</p><p class=p11><span class=s1>成都三叉戟科技有限公司对于本协议内容拥有最终解释权和修订权。</span></p><p class=p12>&nbsp;</p><p class=p12>&nbsp;</p><p class=p13 style=\"text-align: right\"><span class=s1>成都三叉戟科技有限公司</span></p><p class=p13 style=\"text-align: right\"><span class=s1>二〇一八年六月</span></p></div><div ng-if=\"privacy.lang == \'en\'\"><style type=text/css>ol.lst-kix_list_7-0{list-style-type:none}.lst-kix_list_14-1>li:before{content:\"o  \"}.lst-kix_list_14-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-0.start{counter-reset:lst-ctn-kix_list_9-0 0}.lst-kix_list_14-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_14-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-6>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_9-1{list-style-type:none}ol.lst-kix_list_7-4.start{counter-reset:lst-ctn-kix_list_7-4 0}.lst-kix_list_9-0>li{counter-increment:lst-ctn-kix_list_9-0}ol.lst-kix_list_7-5{list-style-type:none}ol.lst-kix_list_7-6{list-style-type:none}ol.lst-kix_list_7-7{list-style-type:none}ol.lst-kix_list_7-8{list-style-type:none}ol.lst-kix_list_7-1{list-style-type:none}ol.lst-kix_list_11-8.start{counter-reset:lst-ctn-kix_list_11-8 0}ol.lst-kix_list_7-3{list-style-type:none}ol.lst-kix_list_7-4{list-style-type:none}.lst-kix_list_14-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-1{list-style-type:none}ul.lst-kix_list_17-0{list-style-type:none}ul.lst-kix_list_17-8{list-style-type:none}ul.lst-kix_list_17-7{list-style-type:none}ul.lst-kix_list_17-6{list-style-type:none}ul.lst-kix_list_17-5{list-style-type:none}ul.lst-kix_list_17-4{list-style-type:none}ul.lst-kix_list_17-3{list-style-type:none}.lst-kix_list_14-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-2{list-style-type:none}ol.lst-kix_list_8-8.start{counter-reset:lst-ctn-kix_list_8-8 0}ol.lst-kix_list_10-4.start{counter-reset:lst-ctn-kix_list_10-4 0}.lst-kix_list_5-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-0{list-style-type:none}.lst-kix_list_24-7>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_27-0{list-style-type:none}ul.lst-kix_list_27-1{list-style-type:none}.lst-kix_list_24-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_27-2{list-style-type:none}.lst-kix_list_5-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-5.start{counter-reset:lst-ctn-kix_list_9-5 0}.lst-kix_list_5-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-3>li{counter-increment:lst-ctn-kix_list_8-3}.lst-kix_list_5-1>li:before{content:\"o  \"}.lst-kix_list_24-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_5-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_24-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_24-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_9-4>li{counter-increment:lst-ctn-kix_list_9-4}ol.lst-kix_list_6-6{list-style-type:none}ul.lst-kix_list_27-3{list-style-type:none}.lst-kix_list_24-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_6-7{list-style-type:none}ul.lst-kix_list_27-4{list-style-type:none}.lst-kix_list_5-4>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-8{list-style-type:none}ul.lst-kix_list_27-5{list-style-type:none}ul.lst-kix_list_27-6{list-style-type:none}.lst-kix_list_5-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-2{list-style-type:none}ul.lst-kix_list_27-7{list-style-type:none}ol.lst-kix_list_6-3{list-style-type:none}ul.lst-kix_list_27-8{list-style-type:none}ol.lst-kix_list_6-4{list-style-type:none}.lst-kix_list_24-6>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-5{list-style-type:none}.lst-kix_list_23-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_6-1>li:before{content:\"o  \"}.lst-kix_list_6-3>li:before{content:\"\" counter(lst-ctn-kix_list_6-3,decimal) \". \"}.lst-kix_list_6-5>li{counter-increment:lst-ctn-kix_list_6-5}.lst-kix_list_6-8>li{counter-increment:lst-ctn-kix_list_6-8}.lst-kix_list_23-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-0>li:before{content:\"\" counter(lst-ctn-kix_list_6-0,decimal) \". \"}.lst-kix_list_6-4>li:before{content:\"\" counter(lst-ctn-kix_list_6-4,decimal) \". \"}.lst-kix_list_23-2>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_16-2{list-style-type:none}ul.lst-kix_list_16-1{list-style-type:none}ul.lst-kix_list_16-0{list-style-type:none}.lst-kix_list_23-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_23-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-2>li:before{content:\"\" counter(lst-ctn-kix_list_6-2,decimal) \". \"}.lst-kix_list_24-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_16-8{list-style-type:none}ul.lst-kix_list_16-7{list-style-type:none}ul.lst-kix_list_16-6{list-style-type:none}ul.lst-kix_list_16-5{list-style-type:none}.lst-kix_list_24-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_16-4{list-style-type:none}.lst-kix_list_6-8>li:before{content:\"\" counter(lst-ctn-kix_list_6-8,decimal) \". \"}ul.lst-kix_list_16-3{list-style-type:none}.lst-kix_list_6-5>li:before{content:\"\" counter(lst-ctn-kix_list_6-5,decimal) \". \"}.lst-kix_list_6-7>li:before{content:\"\" counter(lst-ctn-kix_list_6-7,decimal) \". \"}.lst-kix_list_23-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_23-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_6-6>li:before{content:\"\" counter(lst-ctn-kix_list_6-6,decimal) \". \"}ol.lst-kix_list_10-6.start{counter-reset:lst-ctn-kix_list_10-6 0}.lst-kix_list_7-4>li:before{content:\"\" counter(lst-ctn-kix_list_7-4,upper-roman) \". \"}.lst-kix_list_7-6>li:before{content:\"\" counter(lst-ctn-kix_list_7-6,upper-roman) \". \"}ol.lst-kix_list_6-2.start{counter-reset:lst-ctn-kix_list_6-2 0}.lst-kix_list_22-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_22-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-6>li{counter-increment:lst-ctn-kix_list_7-6}.lst-kix_list_8-6>li{counter-increment:lst-ctn-kix_list_8-6}.lst-kix_list_22-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-7{list-style-type:none}ol.lst-kix_list_9-8{list-style-type:none}.lst-kix_list_13-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-3{list-style-type:none}ol.lst-kix_list_9-4{list-style-type:none}ol.lst-kix_list_9-5{list-style-type:none}.lst-kix_list_7-8>li:before{content:\"\" counter(lst-ctn-kix_list_7-8,upper-roman) \". \"}ol.lst-kix_list_9-6{list-style-type:none}ol.lst-kix_list_9-0{list-style-type:none}ol.lst-kix_list_9-2{list-style-type:none}.lst-kix_list_22-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-8>li{counter-increment:lst-ctn-kix_list_9-8}.lst-kix_list_4-1>li:before{content:\"o  \"}.lst-kix_list_15-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-7{list-style-type:none}ul.lst-kix_list_19-6{list-style-type:none}.lst-kix_list_4-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-5{list-style-type:none}ul.lst-kix_list_19-4{list-style-type:none}ul.lst-kix_list_19-3{list-style-type:none}.lst-kix_list_25-5>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_19-2{list-style-type:none}ul.lst-kix_list_19-1{list-style-type:none}.lst-kix_list_10-5>li{counter-increment:lst-ctn-kix_list_10-5}ul.lst-kix_list_19-0{list-style-type:none}.lst-kix_list_15-1>li:before{content:\"o  \"}.lst-kix_list_25-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_15-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-8{list-style-type:none}.lst-kix_list_6-4>li{counter-increment:lst-ctn-kix_list_6-4}ol.lst-kix_list_9-2.start{counter-reset:lst-ctn-kix_list_9-2 0}.lst-kix_list_9-3>li{counter-increment:lst-ctn-kix_list_9-3}.lst-kix_list_11-2>li{counter-increment:lst-ctn-kix_list_11-2}ol.lst-kix_list_8-8{list-style-type:none}.lst-kix_list_12-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-6.start{counter-reset:lst-ctn-kix_list_7-6 0}ol.lst-kix_list_8-4{list-style-type:none}.lst-kix_list_12-1>li:before{content:\"o  \"}ol.lst-kix_list_8-5{list-style-type:none}ol.lst-kix_list_8-6{list-style-type:none}ol.lst-kix_list_8-7{list-style-type:none}ol.lst-kix_list_8-0{list-style-type:none}ol.lst-kix_list_8-1{list-style-type:none}ol.lst-kix_list_8-2{list-style-type:none}ol.lst-kix_list_8-3{list-style-type:none}.lst-kix_list_10-4>li{counter-increment:lst-ctn-kix_list_10-4}.lst-kix_list_13-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-0{list-style-type:none}.lst-kix_list_13-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-8{list-style-type:none}ul.lst-kix_list_18-7{list-style-type:none}ul.lst-kix_list_18-6{list-style-type:none}ul.lst-kix_list_18-5{list-style-type:none}.lst-kix_list_12-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-4{list-style-type:none}ul.lst-kix_list_18-3{list-style-type:none}ul.lst-kix_list_18-2{list-style-type:none}ol.lst-kix_list_6-0.start{counter-reset:lst-ctn-kix_list_6-0 0}ul.lst-kix_list_18-1{list-style-type:none}.lst-kix_list_13-1>li:before{content:\"o  \"}ul.lst-kix_list_24-0{list-style-type:none}ul.lst-kix_list_24-1{list-style-type:none}ul.lst-kix_list_24-2{list-style-type:none}ul.lst-kix_list_24-3{list-style-type:none}ul.lst-kix_list_24-4{list-style-type:none}ul.lst-kix_list_24-5{list-style-type:none}ol.lst-kix_list_11-6{list-style-type:none}ol.lst-kix_list_11-7{list-style-type:none}ol.lst-kix_list_11-8{list-style-type:none}.lst-kix_list_7-1>li{counter-increment:lst-ctn-kix_list_7-1}ol.lst-kix_list_11-2{list-style-type:none}ol.lst-kix_list_11-3{list-style-type:none}.lst-kix_list_3-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_11-4{list-style-type:none}ol.lst-kix_list_11-5{list-style-type:none}ul.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_5-8{list-style-type:none}ul.lst-kix_list_5-5{list-style-type:none}ol.lst-kix_list_11-0{list-style-type:none}ul.lst-kix_list_5-6{list-style-type:none}.lst-kix_list_21-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_8-0>li{counter-increment:lst-ctn-kix_list_8-0}ul.lst-kix_list_24-6{list-style-type:none}ul.lst-kix_list_5-0{list-style-type:none}ul.lst-kix_list_24-7{list-style-type:none}.lst-kix_list_10-0>li{counter-increment:lst-ctn-kix_list_10-0}.lst-kix_list_3-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_24-8{list-style-type:none}ul.lst-kix_list_5-3{list-style-type:none}.lst-kix_list_3-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_5-4{list-style-type:none}.lst-kix_list_26-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_5-1{list-style-type:none}.lst-kix_list_8-0>li:before{content:\"\" counter(lst-ctn-kix_list_8-0,upper-roman) \". \"}ul.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_8-7>li:before{content:\"\" counter(lst-ctn-kix_list_8-7,upper-roman) \". \"}.lst-kix_list_3-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_10-7.start{counter-reset:lst-ctn-kix_list_10-7 0}.lst-kix_list_26-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_21-1>li:before{content:\"o  \"}.lst-kix_list_8-3>li:before{content:\"\" counter(lst-ctn-kix_list_8-3,upper-roman) \". \"}ul.lst-kix_list_13-5{list-style-type:none}ul.lst-kix_list_13-4{list-style-type:none}ul.lst-kix_list_13-3{list-style-type:none}ul.lst-kix_list_13-2{list-style-type:none}ul.lst-kix_list_13-1{list-style-type:none}.lst-kix_list_3-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_13-0{list-style-type:none}.lst-kix_list_26-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li:before{content:\"\" counter(lst-ctn-kix_list_8-4,upper-roman) \". \"}.lst-kix_list_10-2>li{counter-increment:lst-ctn-kix_list_10-2}ol.lst-kix_list_8-5.start{counter-reset:lst-ctn-kix_list_8-5 0}ul.lst-kix_list_13-8{list-style-type:none}.lst-kix_list_11-1>li:before{content:\"o  \"}ul.lst-kix_list_13-7{list-style-type:none}ul.lst-kix_list_13-6{list-style-type:none}.lst-kix_list_21-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-0>li:before{content:\"\" counter(lst-ctn-kix_list_11-0,decimal) \". \"}ol.lst-kix_list_9-3.start{counter-reset:lst-ctn-kix_list_9-3 0}.lst-kix_list_26-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_8-8>li:before{content:\"\" counter(lst-ctn-kix_list_8-8,upper-roman) \". \"}.lst-kix_list_16-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-0{list-style-type:none}ul.lst-kix_list_23-1{list-style-type:none}.lst-kix_list_16-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-2{list-style-type:none}ul.lst-kix_list_23-3{list-style-type:none}ul.lst-kix_list_23-4{list-style-type:none}ul.lst-kix_list_23-5{list-style-type:none}ul.lst-kix_list_23-6{list-style-type:none}.lst-kix_list_4-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-8{list-style-type:none}.lst-kix_list_16-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-6{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}.lst-kix_list_25-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li{counter-increment:lst-ctn-kix_list_8-4}ul.lst-kix_list_4-0{list-style-type:none}ul.lst-kix_list_23-7{list-style-type:none}.lst-kix_list_25-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_23-8{list-style-type:none}ol.lst-kix_list_10-8.start{counter-reset:lst-ctn-kix_list_10-8 0}.lst-kix_list_16-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-4{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}.lst-kix_list_11-3>li{counter-increment:lst-ctn-kix_list_11-3}ol.lst-kix_list_7-1.start{counter-reset:lst-ctn-kix_list_7-1 0}ul.lst-kix_list_12-6{list-style-type:none}ol.lst-kix_list_8-6.start{counter-reset:lst-ctn-kix_list_8-6 0}ul.lst-kix_list_12-5{list-style-type:none}.lst-kix_list_17-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-4{list-style-type:none}ul.lst-kix_list_12-3{list-style-type:none}ul.lst-kix_list_12-2{list-style-type:none}ul.lst-kix_list_12-1{list-style-type:none}.lst-kix_list_17-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-0{list-style-type:none}.lst-kix_list_17-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-8{list-style-type:none}ul.lst-kix_list_12-7{list-style-type:none}ol.lst-kix_list_8-0.start{counter-reset:lst-ctn-kix_list_8-0 0}.lst-kix_list_7-0>li:before{content:\"\" counter(lst-ctn-kix_list_7-0,upper-roman) \". \"}ol.lst-kix_list_9-7.start{counter-reset:lst-ctn-kix_list_9-7 0}.lst-kix_list_22-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_2-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-1{list-style-type:none}ul.lst-kix_list_26-2{list-style-type:none}ul.lst-kix_list_26-3{list-style-type:none}.lst-kix_list_22-1>li:before{content:\"o  \"}.lst-kix_list_27-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-6>li{counter-increment:lst-ctn-kix_list_6-6}.lst-kix_list_7-3>li:before{content:\"\" counter(lst-ctn-kix_list_7-3,upper-roman) \". \"}.lst-kix_list_10-0>li:before{content:\"\" counter(lst-ctn-kix_list_10-0,decimal) \". \"}.lst-kix_list_9-7>li{counter-increment:lst-ctn-kix_list_9-7}.lst-kix_list_13-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-4{list-style-type:none}ul.lst-kix_list_26-5{list-style-type:none}ul.lst-kix_list_26-6{list-style-type:none}ul.lst-kix_list_26-7{list-style-type:none}.lst-kix_list_8-7>li{counter-increment:lst-ctn-kix_list_8-7}ul.lst-kix_list_26-8{list-style-type:none}ul.lst-kix_list_7-2{list-style-type:none}.lst-kix_list_27-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_7-7>li:before{content:\"\" counter(lst-ctn-kix_list_7-7,upper-roman) \". \"}ol.lst-kix_list_8-1.start{counter-reset:lst-ctn-kix_list_8-1 0}.lst-kix_list_15-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-5>li{counter-increment:lst-ctn-kix_list_9-5}.lst-kix_list_10-4>li:before{content:\"\" counter(lst-ctn-kix_list_10-4,decimal) \". \"}.lst-kix_list_10-8>li:before{content:\"\" counter(lst-ctn-kix_list_10-8,decimal) \". \"}.lst-kix_list_4-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-3{list-style-type:none}ul.lst-kix_list_15-2{list-style-type:none}.lst-kix_list_15-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-1{list-style-type:none}.lst-kix_list_15-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_15-0{list-style-type:none}.lst-kix_list_4-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_25-4>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_15-8{list-style-type:none}ul.lst-kix_list_15-7{list-style-type:none}ul.lst-kix_list_15-6{list-style-type:none}.lst-kix_list_9-3>li:before{content:\"\" counter(lst-ctn-kix_list_9-3,decimal) \". \"}ul.lst-kix_list_15-5{list-style-type:none}ul.lst-kix_list_15-4{list-style-type:none}ol.lst-kix_list_7-0.start{counter-reset:lst-ctn-kix_list_7-0 0}.lst-kix_list_25-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_25-0{list-style-type:none}ul.lst-kix_list_25-1{list-style-type:none}ul.lst-kix_list_25-2{list-style-type:none}.lst-kix_list_9-7>li:before{content:\"\" counter(lst-ctn-kix_list_9-7,decimal) \". \"}ul.lst-kix_list_25-3{list-style-type:none}ul.lst-kix_list_25-4{list-style-type:none}.lst-kix_list_11-4>li:before{content:\"\" counter(lst-ctn-kix_list_11-4,decimal) \". \"}.lst-kix_list_12-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_20-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-4>li{counter-increment:lst-ctn-kix_list_7-4}ul.lst-kix_list_25-5{list-style-type:none}.lst-kix_list_1-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_25-6{list-style-type:none}.lst-kix_list_20-1>li:before{content:\"o  \"}ul.lst-kix_list_25-7{list-style-type:none}ul.lst-kix_list_25-8{list-style-type:none}.lst-kix_list_11-8>li:before{content:\"\" counter(lst-ctn-kix_list_11-8,decimal) \". \"}.lst-kix_list_12-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_6-1{list-style-type:none}ol.lst-kix_list_8-4.start{counter-reset:lst-ctn-kix_list_8-4 0}.lst-kix_list_1-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_14-4{list-style-type:none}ul.lst-kix_list_14-3{list-style-type:none}ul.lst-kix_list_14-2{list-style-type:none}.lst-kix_list_13-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_14-1{list-style-type:none}ul.lst-kix_list_14-0{list-style-type:none}.lst-kix_list_10-7>li{counter-increment:lst-ctn-kix_list_10-7}ul.lst-kix_list_14-8{list-style-type:none}ul.lst-kix_list_14-7{list-style-type:none}.lst-kix_list_2-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_8-3.start{counter-reset:lst-ctn-kix_list_8-3 0}ul.lst-kix_list_14-6{list-style-type:none}.lst-kix_list_11-5>li{counter-increment:lst-ctn-kix_list_11-5}ul.lst-kix_list_14-5{list-style-type:none}ol.lst-kix_list_9-8.start{counter-reset:lst-ctn-kix_list_9-8 0}.lst-kix_list_1-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_12-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-2>li{counter-increment:lst-ctn-kix_list_8-2}ul.lst-kix_list_20-2{list-style-type:none}ul.lst-kix_list_20-3{list-style-type:none}.lst-kix_list_19-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_19-1>li:before{content:\"o  \"}ul.lst-kix_list_20-4{list-style-type:none}ul.lst-kix_list_20-5{list-style-type:none}ul.lst-kix_list_20-6{list-style-type:none}ul.lst-kix_list_1-0{list-style-type:none}ul.lst-kix_list_20-7{list-style-type:none}ul.lst-kix_list_20-8{list-style-type:none}.lst-kix_list_19-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-1>li{counter-increment:lst-ctn-kix_list_8-1}ol.lst-kix_list_8-2.start{counter-reset:lst-ctn-kix_list_8-2 0}.lst-kix_list_19-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_20-0{list-style-type:none}ul.lst-kix_list_20-1{list-style-type:none}ol.lst-kix_list_6-6.start{counter-reset:lst-ctn-kix_list_6-6 0}.lst-kix_list_7-0>li{counter-increment:lst-ctn-kix_list_7-0}.lst-kix_list_11-0>li{counter-increment:lst-ctn-kix_list_11-0}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}ul.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_9-6.start{counter-reset:lst-ctn-kix_list_9-6 0}.lst-kix_list_19-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-2.start{counter-reset:lst-ctn-kix_list_11-2 0}.lst-kix_list_19-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-2>li{counter-increment:lst-ctn-kix_list_9-2}ol.lst-kix_list_8-7.start{counter-reset:lst-ctn-kix_list_8-7 0}.lst-kix_list_10-3>li{counter-increment:lst-ctn-kix_list_10-3}.lst-kix_list_18-0>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-1>li:before{content:\"o  \"}.lst-kix_list_18-2>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-7.start{counter-reset:lst-ctn-kix_list_11-7 0}ul.lst-kix_list_22-0{list-style-type:none}.lst-kix_list_2-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_22-1{list-style-type:none}ul.lst-kix_list_22-2{list-style-type:none}ul.lst-kix_list_22-3{list-style-type:none}ul.lst-kix_list_22-4{list-style-type:none}.lst-kix_list_2-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-3>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_22-5{list-style-type:none}ul.lst-kix_list_22-6{list-style-type:none}ul.lst-kix_list_22-7{list-style-type:none}.lst-kix_list_27-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_10-3.start{counter-reset:lst-ctn-kix_list_10-3 0}.lst-kix_list_18-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-4.start{counter-reset:lst-ctn-kix_list_9-4 0}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_list_10-1>li:before{content:\"o  \"}.lst-kix_list_18-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_3-1{list-style-type:none}ul.lst-kix_list_22-8{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_7-7>li{counter-increment:lst-ctn-kix_list_7-7}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_10-7>li:before{content:\"\" counter(lst-ctn-kix_list_10-7,decimal) \". \"}.lst-kix_list_7-8>li{counter-increment:lst-ctn-kix_list_7-8}.lst-kix_list_10-5>li:before{content:\"\" counter(lst-ctn-kix_list_10-5,decimal) \". \"}.lst-kix_list_10-3>li:before{content:\"\" counter(lst-ctn-kix_list_10-3,decimal) \". \"}ol.lst-kix_list_7-3.start{counter-reset:lst-ctn-kix_list_7-3 0}ul.lst-kix_list_11-1{list-style-type:none}.lst-kix_list_11-7>li{counter-increment:lst-ctn-kix_list_11-7}.lst-kix_list_9-2>li:before{content:\"\" counter(lst-ctn-kix_list_9-2,decimal) \". \"}.lst-kix_list_20-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-0>li:before{content:\"\" counter(lst-ctn-kix_list_9-0,decimal) \". \"}ul.lst-kix_list_21-1{list-style-type:none}ul.lst-kix_list_21-2{list-style-type:none}ul.lst-kix_list_21-3{list-style-type:none}ul.lst-kix_list_21-4{list-style-type:none}.lst-kix_list_20-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_21-5{list-style-type:none}ul.lst-kix_list_21-6{list-style-type:none}ul.lst-kix_list_21-7{list-style-type:none}ul.lst-kix_list_21-8{list-style-type:none}ol.lst-kix_list_10-7{list-style-type:none}.lst-kix_list_9-6>li:before{content:\"\" counter(lst-ctn-kix_list_9-6,decimal) \". \"}ol.lst-kix_list_10-8{list-style-type:none}ol.lst-kix_list_10-3{list-style-type:none}.lst-kix_list_9-4>li:before{content:\"\" counter(lst-ctn-kix_list_9-4,decimal) \". \"}ol.lst-kix_list_10-4{list-style-type:none}ol.lst-kix_list_10-5{list-style-type:none}.lst-kix_list_11-3>li:before{content:\"\" counter(lst-ctn-kix_list_11-3,decimal) \". \"}ol.lst-kix_list_10-6{list-style-type:none}ul.lst-kix_list_21-0{list-style-type:none}.lst-kix_list_6-3>li{counter-increment:lst-ctn-kix_list_6-3}.lst-kix_list_20-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-0{list-style-type:none}ul.lst-kix_list_2-8{list-style-type:none}ol.lst-kix_list_10-2{list-style-type:none}.lst-kix_list_20-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-5>li:before{content:\"\" counter(lst-ctn-kix_list_11-5,decimal) \". \"}ul.lst-kix_list_2-2{list-style-type:none}.lst-kix_list_20-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_9-8>li:before{content:\"\" counter(lst-ctn-kix_list_9-8,decimal) \". \"}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:\"o  \"}ul.lst-kix_list_2-7{list-style-type:none}.lst-kix_list_11-7>li:before{content:\"\" counter(lst-ctn-kix_list_11-7,decimal) \". \"}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_8-5>li{counter-increment:lst-ctn-kix_list_8-5}.lst-kix_list_1-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-5.start{counter-reset:lst-ctn-kix_list_10-5 0}.lst-kix_list_1-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_1-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_10-1{list-style-type:none}ol.lst-kix_list_7-5.start{counter-reset:lst-ctn-kix_list_7-5 0}.lst-kix_list_2-1>li:before{content:\"o  \"}.lst-kix_list_27-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_2-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-8>li{counter-increment:lst-ctn-kix_list_11-8}ol.lst-kix_list_7-7.start{counter-reset:lst-ctn-kix_list_7-7 0}.lst-kix_list_3-1>li:before{content:\"o  \"}.lst-kix_list_3-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_26-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-1>li:before{content:\"\" counter(lst-ctn-kix_list_8-1,upper-roman) \". \"}.lst-kix_list_8-2>li:before{content:\"\" counter(lst-ctn-kix_list_8-2,upper-roman) \". \"}.lst-kix_list_6-0>li{counter-increment:lst-ctn-kix_list_6-0}.lst-kix_list_3-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-5.start{counter-reset:lst-ctn-kix_list_11-5 0}.lst-kix_list_21-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-5>li:before{content:\"\" counter(lst-ctn-kix_list_8-5,upper-roman) \". \"}.lst-kix_list_8-6>li:before{content:\"\" counter(lst-ctn-kix_list_8-6,upper-roman) \". \"}.lst-kix_list_26-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_26-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_3-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-2>li:before{content:\"\" counter(lst-ctn-kix_list_11-2,decimal) \". \"}.lst-kix_list_21-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-6.start{counter-reset:lst-ctn-kix_list_11-6 0}.lst-kix_list_16-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-4.start{counter-reset:lst-ctn-kix_list_6-4 0}.lst-kix_list_25-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_17-1>li:before{content:\"o  \"}.lst-kix_list_25-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-1>li:before{content:\"o  \"}.lst-kix_list_7-3>li{counter-increment:lst-ctn-kix_list_7-3}.lst-kix_list_16-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_16-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-8.start{counter-reset:lst-ctn-kix_list_7-8 0}ol.lst-kix_list_11-0.start{counter-reset:lst-ctn-kix_list_11-0 0}ol.lst-kix_list_6-3.start{counter-reset:lst-ctn-kix_list_6-3 0}ol.lst-kix_list_10-2.start{counter-reset:lst-ctn-kix_list_10-2 0}.lst-kix_list_17-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-2>li{counter-increment:lst-ctn-kix_list_6-2}.lst-kix_list_2-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_22-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-1>li:before{content:\"\" counter(lst-ctn-kix_list_7-1,decimal) \". \"}.lst-kix_list_7-5>li:before{content:\"\" counter(lst-ctn-kix_list_7-5,upper-roman) \". \"}.lst-kix_list_9-6>li{counter-increment:lst-ctn-kix_list_9-6}.lst-kix_list_27-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-7>li{counter-increment:lst-ctn-kix_list_6-7}.lst-kix_list_10-6>li{counter-increment:lst-ctn-kix_list_10-6}.lst-kix_list_11-6>li{counter-increment:lst-ctn-kix_list_11-6}ol.lst-kix_list_10-0.start{counter-reset:lst-ctn-kix_list_10-0 0}.lst-kix_list_7-5>li{counter-increment:lst-ctn-kix_list_7-5}.lst-kix_list_15-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-4>li{counter-increment:lst-ctn-kix_list_11-4}ol.lst-kix_list_6-8.start{counter-reset:lst-ctn-kix_list_6-8 0}.lst-kix_list_10-2>li:before{content:\"\" counter(lst-ctn-kix_list_10-2,decimal) \". \"}.lst-kix_list_20-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-5.start{counter-reset:lst-ctn-kix_list_6-5 0}.lst-kix_list_4-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_10-8>li{counter-increment:lst-ctn-kix_list_10-8}.lst-kix_list_25-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_10-6>li:before{content:\"\" counter(lst-ctn-kix_list_10-6,decimal) \". \"}.lst-kix_list_9-1>li:before{content:\"o  \"}ol.lst-kix_list_6-7.start{counter-reset:lst-ctn-kix_list_6-7 0}.lst-kix_list_9-5>li:before{content:\"\" counter(lst-ctn-kix_list_9-5,decimal) \". \"}.lst-kix_list_12-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-6>li:before{content:\"\" counter(lst-ctn-kix_list_11-6,decimal) \". \"}.lst-kix_list_20-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-3.start{counter-reset:lst-ctn-kix_list_11-3 0}.lst-kix_list_1-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-8>li{counter-increment:lst-ctn-kix_list_8-8}.lst-kix_list_1-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-4.start{counter-reset:lst-ctn-kix_list_11-4 0}.lst-kix_list_2-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-2>li:before{content:\"\\0025aa  \"}ol{margin:0;padding:0}table td,table th{padding:0}.c21{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:280.1pt;border-top-color:#000000;border-bottom-style:solid}.c18{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:157.8pt;border-top-color:#000000;border-bottom-style:solid}.c39{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:291.1pt;border-top-color:#000000;border-bottom-style:solid}.c12{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:137.2pt;border-top-color:#000000;border-bottom-style:solid}.c55{-webkit-text-decoration-skip:none;color:#0000ff;font-weight:400;text-decoration:underline;vertical-align:baseline;text-decoration-skip-ink:none;font-size:10.5pt;font-family:\"\\007b49\\007ebf\";font-style:normal}.c14{margin-left:18pt;padding-top:0pt;padding-left:-3.8pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c17{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c44{padding-top:0pt;text-indent:21pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c28{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:\"Arial\";font-style:normal}.c38{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:14pt;font-family:\"Arial\";font-style:normal}.c8{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10.5pt;font-family:\"\\007b49\\007ebf\";font-style:normal}.c30{color:#777777;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10.5pt;font-family:\"Arial\";font-style:normal}.c0{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:\"Arial\";font-style:normal}.c11{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c4{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10.5pt;font-family:\"Arial\";font-style:normal}.c27{padding-top:0pt;text-indent:21pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c10{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10.5pt;font-family:\"Arial\";font-style:normal}.c53{padding-top:0pt;text-indent:28pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:center}.c29{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c26{-webkit-text-decoration-skip:none;color:#0000ff;font-weight:400;text-decoration:underline;text-decoration-skip-ink:none;font-family:\"Arial\"}.c15{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c5{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c3{padding-top:6pt;padding-bottom:6pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c1{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-indent:21pt;text-align:justify}.c35{padding-top:12pt;padding-bottom:12pt;line-height:1.0;text-align:justify}.c32{font-family:\"Arial\";font-style:italic;color:#000000;font-weight:700}.c22{font-size:9pt;font-family:\"Arial\";color:#000000;font-weight:400}.c13{font-size:9pt;font-family:\"Arial\";color:#000000;font-weight:700}.c2{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c31{text-decoration:none;vertical-align:baseline;font-size:12pt;font-style:normal}.c52{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c36{font-size:11.5pt;font-family:\"Arial\";color:#212121;font-weight:700}.c34{font-size:12pt;font-family:\"Arial\";font-weight:700}.c49{text-decoration:none;vertical-align:baseline;font-style:normal}.c40{text-decoration:none;vertical-align:baseline;font-size:10.5pt}.c24{background-color:#ffffff;padding:72pt 16pt 72pt 16pt;margin:auto;}.c23{font-family:\"Arial\";color:#000000;font-weight:400}.c33{font-weight:400;font-family:\"Arial\"}.c20{color:inherit;text-decoration:inherit}.c6{padding:0;margin:0}.c46{font-family:\"Arial\";font-weight:700}.c25{height:45pt}.c41{color:#000000}.c58{height:103pt}.c56{height:14pt}.c45{height:29pt}.c43{height:20pt}.c57{height:74pt}.c51{height:22pt}.c37{font-size:9pt}.c48{height:6pt}.c16{height:59pt}.c50{margin-left:14.2pt}.c19{height:18pt}.c47{text-indent:21pt}.c59{height:44pt}.c42{text-indent:20pt}.c7{text-indent:26.2pt}.c9{height:10pt}.c54{height:19pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:\"Georgia\";line-height:1.0;page-break-after:avoid;font-style:italic;text-align:justify}li{color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}p{margin:0;color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h2{padding-top:5pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h3{padding-top:5pt;color:#000000;font-weight:700;font-size:13.5pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h4{padding-top:5pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}</style><p class=c53><span class=c38>Privacy Policy </span></p><p class=c44><span class=c10>Last Updated: 05/2018</span></p><p class=c44><span class=c46>You acknowledge that you have read and understood this privacy policy. If you do not agree with this privacy policy, you must not use Tap4Fun Services. If you change your mind in the future, you may withdraw your consent to use of your personal information in accordance with this policy.</span></p><p class=c1><span class=c10>At Tap4Fun, we know your privacy is very important to you, so please take the time to carefully read our privacy policy. Our policy is designed to help you understand :</span></p><p class=c1><span class=c4>1、What information do we collect about you;</span></p><p class=c1><span class=c4>2、How will we use the information about you;</span></p><p class=c1><span class=c4>3、Who do we share your information with;</span></p><p class=c1><span class=c4>4、How long do we keep hold of your information;</span></p><p class=c1><span class=c4>5、How can I exercise my rights over my information;</span></p><p class=c1><span class=c4>6、Dispute Resolution;</span></p><p class=c1><span class=c4>7、How will we notify you of changes;</span></p><p class=c1><span class=c4>8、Contact Information;</span></p><p class=c1><span class=c10>This privacy policy applies to all Tap4Fun services that directly reference or link to this policy, but does not apply to Tap4Fun services that have separate privacy policies that do not incorporate this policy.</span></p><p class=c35><span class=\"c34 c41\">SECTION 1</span><span class=c34>:</span><span class=c28>&nbsp;WHERE WE ARE A DATA CONTROLLER</span></p><p class=c3><span class=\"c41 c46\">1.The Types of Personal Information We Use</span></p><p class=c1><span class=c10>This section describes the different types of personal information we collect and how we collect it. We will collect and use the following information about you:</span></p><p class=c3><span class=\"c46 c41\">Information</span><span class=c36>&nbsp;you provide us.</span></p><ul class=\"c6 lst-kix_list_23-0 start\"><li class=c14><span class=c10>when you register for the Game (including your nominated nickname,or custom accounts and information we import from your connected social media account (WeChat, Facebook) in order to set up your profile, including your name as it appears on your social media profile and your profile picture);</span></li><li class=c14><span class=c10>when you log-in as a ‘guest’ in order to use the Game (your nickname); and</span></li><li class=c14><span class=c10>when you participate in a survey in the Game (in which case we will process the information you provide to us as part of the survey).</span></li><li class=c14><span class=\"c23 c31\">i</span><span class=c10>nformation you provide when seeking help from us such as your name, telephone number and records of the issues you experience; and</span></li><li class=c14><span class=c10>Billing information, such as your name, payment card number and payment account details;</span></li></ul><p class=c3><span class=c4>Information we collect about you.</span></p><p class=c27><span class=c10>We automatically collect certain data from you when you use the Game, including your IP address and device information (such as application version, network type, OS) and information regarding your use of the Game, such as date and time stamps of actions. We also collect and store your data each time you interact with us, for example, when you use in-app support to communicate with us.</span></p><p class=c3><span class=c4>Information you generate and display in the course of using the Game Services.&nbsp;</span></p><p class=c27><span class=c23>You may provide additional information as part of your profile (such as gender). You may also provide or generate information when you communicate with other users in the Game (e.g., chat log data, chat content).</span></p><p class=c3><span class=c4>Data we collect from our partners.</span></p><ul class=\"c6 lst-kix_list_23-0\"><li class=c14><span class=c10>Data we receive if you link a third party tool with the Service (such as WeChat, Facebook)</span></li><li class=c14><span class=c11>Demographic data (such as to determine the coarse location of your IP address)</span></li><li class=c14><span class=c11>Data to fight fraud (such as refund abuse in games or click fraud in advertising)</span></li><li class=c14><span class=c11>Data from platforms that the games run on (such as to verify payment)</span></li><li class=c14><span class=c11>Data for advertising and analytics purposes, so we can provide you a better Service</span></li></ul><p class=c3><span class=c4>Cookies.</span></p><p class=c3><span class=c10>We use cookies and other similar technologies (e.g. web beacons, log files, scripts and eTags) (“Cookies”) to enhance your experience using the Services. Cookies are small files which, when placed on your device, enable us to provide certain features and functionality. You have the option to permit installation of such Cookies or subsequently disable them. You may accept all cookies, or instruct the device (in the case of the Game) to provide notice at the time of installation of cookies, or refuse to accept all cookies by adjusting the relevant cookie retention function in your device. However, in the event of your refusal to install cookies, the Game may be unable to operate as designed.</span></p><p class=c3><span class=c4>2.How we use your personal information</span></p><p class=c29><span class=c10>We will use the information in the following ways:</span></p><a id=t.e54a1e0c46f5523b1c49649046cdbe7eb80a3157></a><a id=t.0></a><table class=c2><tbody><tr class=c51><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c13>Personal Information</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c13>Use</span></p></td></tr><tr class=c51><td class=c18 colspan=1 rowspan=1><p class=c15><span class=c22>Nickname</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We use this information to create your account for the Game in accordance with your request.</span></p></td></tr><tr class=c54><td class=c18 colspan=1 rowspan=1><p class=c15><span class=c0>Social Connect Information:</span></p><p class=c15><span class=c0>WeChat: Open ID, profile photo, alias, gender, region</span></p><p class=c15><span class=\"c33 c37\">Facebook: Name, Facebook ID, profile picture</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c0>We use this information to: •create your account for the Game in accordance with your request; • share in-game photos on Facebook at your request.</span></p></td></tr><tr class=c25><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Generated Open ID</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We generate this and use this to store your Game data (including level and progress) with your profile.</span></p></td></tr><tr class=c43><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Game Play Statistics (Level, Score/s)</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We use this information to provide you with feedback and information about your gameplay and progress.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>IP Address</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We use this information to improve our services, including the functionality of the Game.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Device ID, Device Information</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We use this information: • to improve our services, including the functionality of the Game; • for security and verification purposes; • identify and address bugs and assess game function for optimisation; and • to combat users registering for multiple accounts.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Advertising ID</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>If you click on a link that advertises the Game, we store the Advertising ID for that advertisement with your profile.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Chat Data</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>If you enable chat services (audio or text) then we will process such data in order to deliver your messages to other users.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Transaction Records: payments on Google Play or iOS App Store&nbsp;</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We use this information to maintain a record of your transaction history.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Customer Support Ticket ID &amp; User Communications with Support</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We use this information to:• improve our services;• provide troubleshooting such as addressing and remediating technical issues and bugs.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c22>Security-Related Information</span></p></td><td class=c39 colspan=1 rowspan=1><p class=c5><span class=c22>We use this information:• for security and verification purposes;•identify and address bugs and assess game function for optimis ation;&nbsp;•solve game crashes and optimise compatibility of devices with the game; and&nbsp;•to combat users registering for multiple accounts.</span></p></td></tr><tr class=c19><td class=c18 colspan=1 rowspan=1><p class=c5><span class=c0>Survey Information and content of survey responses</span></p></td><td class=c39 colspan=1 rowspan=1><p class=\"c5 c9\"><span class=c0></span></p></td></tr></tbody></table><p class=c3><span class=c4>analyze, profile, and segment.</span></p><p class=\"c29 c42\"><span class=c11>In all of the above cases and purposes, we may analyze, profile and segment all collected data.</span></p><p class=c3><span class=c4>Legal Basis for Processing</span></p><p class=c44><span class=c33>If you are a resident of the European Union, we rely on a number of legal grounds to process information about you. For example, we will process information about you where we have your consent, where we have a legitimate interest to do so, where the processing is necessary for the performance of a contract with you, and where we have a legal obligation to process your information. For example, we rely on our legitimate interests to serve targeted marketing and on contractual necessity to process information when you create an account. To learn more about the legal grounds on which we rely to process your information for any particular purpose, please contact us via the options in </span><span class=\"c46 c41\">C</span><span class=c46>ontact &amp; Complaints</span><span class=c33>&nbsp;below.</span></p><p class=c3><span class=c4>3.How We Share Your Personal Information</span></p><p class=c29><span class=c10>We share your personal information with selected third parties in and outside your country, including:</span></p><ul class=\"c6 lst-kix_list_23-0\"><li class=c14><span class=c17>other players and users.</span><span class=c8>&nbsp;</span><span class=c11>Social features are a core component of our games. Other players and users may, for example, see your profile data, in-game activities and read the messages you have posted.</span></li><li class=c14><span class=c17>partners working for Tap4Fun.</span><span class=c8>&nbsp;</span><span class=c11>Tap4Fun has partners to perform services for us. These partners process your data only at and according to Tap4Fun ´s instructions to provide the Service, such as hosting, player support, advertising, analytics and fraud prevention.</span></li><li class=c14><span class=c17>other companies and public authorities. </span><span class=c11>In order to combat fraud and illegal activity, we may exchange data with other companies and organizations and provide it to public authorities in response to lawful requests. We may also disclose your data based on your consent, to comply with the law or to protect the rights, property or safety of us, our players or others.</span></li><li class=c14><span class=c17>related</span><span class=c4>&nbsp;group companies(Tap4Fun(Hong Kong)Limited.,</span><span class=c10>&nbsp;with whom we share your personal information to operate the Game Services;</span></li><li class=c14><span class=c4>law enforcement agencies, public authorities or other judicial bodies and organisations.</span></li><li class=c14><span class=c17>a third party that acquires all or substantially all of us or our business.&nbsp;</span><span class=c11>We will disclose information to a third party in the event that we sell or buy any business or undergo a merger, in which case we will disclose your data to the prospective buyer of such business. We will also disclose information to a third party if we sell, buy, merge or partner with other companies or businesses, or sell some or all of our assets. In such transactions, user information may be among the transferred assets.</span></li></ul><p class=c3><span class=c4>4.Data Retention</span></p><p class=c27><span class=c10>We will retain your personal information as described below (except if otherwise required to be retained by applicable law).</span></p><a id=t.3ab6a24884679c3afbfec754195ae684fe235a02></a><a id=t.1></a><table class=c52><tbody><tr class=c56><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c13>Personal Information</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c13>Retention Policy</span></p></td></tr><tr class=c59><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Nickname</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game (i.e. until account deletion in accordance with your request) and then deleted within 30 days.</span></p></td></tr><tr class=c16><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Social Connect Information:<br>WeChat</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game (i.e. until account deletion in accordance with your request or you revoke access to your social media account) and then deleted within 30 days.&nbsp;</span></p></td></tr><tr class=c58><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Social Connect Information:<br>Facebook</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 15 days.<br>Where you do not request for account deletion, such data will be retained for 1 year after the Game is shut down, before it is deleted.&nbsp;</span></p></td></tr><tr class=c58><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0><br>Game Play Statistics (Level, Heroes, Score/s)</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 15 days.&nbsp;<br>Where you do not request for account deletion, such data will be retained for 1 year after the Game is shut down, before it is deleted.&nbsp;</span></p></td></tr><tr class=c45><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Chat Communications (Audio message)</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for 7 days on our servers and deleted automatically upon expiry of such period.</span></p></td></tr><tr class=c57><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Chat Communications (Text)</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 7 days.&nbsp;<br>Where you do not request for account deletion, such data will be retained for 1 year after the Game is shut down, before it is deleted.&nbsp;</span></p></td></tr><tr class=c48><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>OpenID</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 15 days.&nbsp;<br>Where you do not request for account deletion, such data will be retained for 1 year after the Game is shut down, before it is deleted.&nbsp;</span></p></td></tr><tr class=c48><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>IP Address</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 15 days.&nbsp;<br>Where you do not request for account deletion, such data will be retained for 1 year after the Game is shut down, before it is deleted.&nbsp;</span></p></td></tr><tr class=c48><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Device ID, Device Information</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 30 days.<br>Where you do not request for account deletion, such data will be retained for 1 year after the Game is shut down, before it is deleted.&nbsp;</span></p></td></tr><tr class=c48><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Advertising ID</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 15 days.&nbsp;<br>Where you do not request for account deletion, such data will be retained for 1 year after the Game is shut down, before it is deleted.&nbsp;</span></p></td></tr><tr class=c48><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Transaction Records</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game (i.e. until account deletion in accordance with your request) and then for the duration of any retention periods for which such data must be retained in order to comply with our legal obligations.</span></p></td></tr><tr class=c48><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Customer Support Ticket ID &amp; User Communications with Support</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Support data is deleted within 30 days of a lawful request from you for the erasure of such data (see the Erasure section of this privacy policy).</span></p></td></tr><tr class=c48><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Security-Related Information&nbsp;</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for the lifetime of your use of the Game, until account deletion in accordance with your request, upon which it will be deleted within 30 days.&nbsp;</span></p></td></tr><tr class=c45><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c0>Survey Information</span></p></td><td class=c21 colspan=1 rowspan=1><p class=c5><span class=c0>Stored for: (a) if you provide your email as part of the survey, up to 6 months (in order for us to follow up with you) and then the data is anonymised; or (b) if you do not provide your email as part of the survey, up to 1 month and then the data is anonymised.</span></p></td></tr></tbody></table><p class=\"c29 c9\"><span class=c10></span></p><p class=c27><span class=c10>Personal Information is kept until the end of its life cycle (as set out in the retention policy above). When destroying personal information, measures will be taken to make the personal information irrecoverable or irreproducible, and electronic files which contain personal information will be deleted permanently using a technical method which makes the files irreproducible.</span></p><p class=c27><span class=c10>In the event that the processing and retention period have terminated, but personal information is required to be retained continuously for other reasons including for the purposes as prescribed under applicable laws, the relevant personal information will be stored and maintained separately from other types of personal information. If you require us to destroy your personal information before the end of its life cycle (as set out in the retention policy above), we will destroy your personal information in accordance with local laws.</span></p><p class=c35><span class=\"c34 c41\">SECTION 2</span><span class=c34>:</span><span class=c28>YOUR RIGHTS</span></p><p class=c29><span class=c32>This section (“Your Rights”)</span><span class=c4>&nbsp;applies to users that are located in the European Economic Area only.</span></p><p class=c27><span class=c23>You have certain rights in relation to the personal information we hold about you. Some of these only apply in certain circumstances (as set out in more detail below). We must respond to a request by you to exercise those rights without undue delay and at least within one month (though this may be extended by a further two months in certain circumstances). To exercise any of your rights, please email us at </span><span class=c26><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c10>.</span></p><p class=c3><span class=\"c32 c40\">1.Access</span></p><p class=c27><span class=c23>You have the right to access personal information we hold about you, how we use it, and who we share it with. You can access the personal information you have made available as part of your account by logging into your Game account and by contacting </span><span class=c26><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c23>. If you believe we hold any other personal information about you, please email us at </span><span class=c26><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c10>.</span></p><p class=c3><span class=\"c32 c40\">2.Portability</span></p><p class=c27><span class=c33>You have the right to receive a copy of certain personal information we process about you. This comprises any personal information we process on the basis of your consent</span><span class=c23>&nbsp;(e.g., certain survey information) or pursuant to our contract with you , as described in the section “</span><span class=c32>How We Use Your Personal Information</span><span class=c10>”. You have the right to receive this information in a structured, commonly used and machine-readable format. You also have the right to request that we transfer that personal information to another party.&nbsp;</span></p><p class=c27><span class=c10>If you wish for us to transfer such personal information to a third party, please ensure you detail that party in your request. Note that we can only do so where it is technically feasible. Please note that we may not be able to provide you with personal information if providing it would interfere with another’s rights (e.g., where providing the personal information we hold about you would reveal information about another person or our trade secrets or intellectual property).</span></p><p class=c3><span class=\"c32 c40\">3.Correction</span></p><p class=c1><span class=c33>You have the right to correct any personal information held about you that is inaccurate. You can access the personal information you have made available as part of your account by logging into your Game account. If you believe we hold any other personal information about you and that information is inaccurate, please email us at </span><span class=c26><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c23>.</span></p><p class=c3><span class=\"c32 c40\">4.Erasure</span></p><p class=c1><span class=c33>You can delete your account, or remove certain personal information, by logging into your Game account. If there is any other personal information you believe we process that you would like us to erase, please email us at </span><span class=c26><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c23>.</span></p><p class=\"c1 c9\"><span class=c10></span></p><p class=c1><span class=c10>You may request that we erase the personal information we hold about you in the following circumstances:</span></p><ul class=\"c6 lst-kix_list_23-0\"><li class=c14><span class=c10>you believe that it is no longer necessary for us to hold such personal information; or</span></li><li class=c14><span class=c10>you believe the personal information we hold about you is being unlawfully processed by us.&nbsp;</span></li></ul><p class=\"c29 c9 c50\"><span class=c10></span></p><p class=c1><span class=c10>You can also exercise your right to restrict our processing of your personal information (as described below) whilst we consider your request.&nbsp;</span></p><p class=\"c1 c9\"><span class=c10></span></p><p class=c1><span class=c10>We may need to retain personal information if there are valid grounds under data protection laws for us to do so (e.g., for the defence of legal claims or freedom of expression) but we will let you know if that is the case. Where you have requested that we erase personal information that has been made available publicly on the Game Services and there are grounds for erasure, we will use reasonable steps to try to tell others that are displaying the personal information or providing links to the personal information to erase it too.</span></p><p class=c3><span class=\"c32 c40\">5.Restriction of Processing to Storage Only</span></p><p class=c1><span class=c10>You have a right to require us to stop processing the personal information we hold about you other than for storage purposes in certain circumstances. Please note, however, that if we stop processing the personal information, we may use it again if there are valid grounds under data protection laws for us to do so (e.g., for the defence of legal claims or for another’s protection). As above, where we agree to stop processing the personal information, we will try to tell any third party to whom we have disclosed the relevant personal information so that they can stop processing it too.&nbsp;</span></p><p class=c1><span class=c10>You may request we stop processing and just store the personal information we hold about you where:&nbsp;</span></p><ul class=\"c6 lst-kix_list_23-0\"><li class=c14><span class=c10>you believe the personal information is not accurate for the period it takes for us to verify whether it is accurate;</span></li><li class=c14><span class=c10>you wish to erase the personal information as the processing we are doing is unlawful but you want us to retain the personal information but just store it instead; or&nbsp;</span></li><li class=c14><span class=c10>you wish to erase the personal information as it is no longer necessary for our purposes but you require it to be stored for the establishment, exercise or defence of legal claims.</span></li></ul><p class=c3><span class=\"c32 c40\">6.Objection</span></p><p class=c1><span class=c33>You have the right to object to our processing of personal information about you. We will consider your request in other circumstances as detailed below by emailing us at </span><span class=c26><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c10>&nbsp;.</span></p><p class=c3><span class=\"c32 c40\">7.Announcements</span></p><p class=c1><span class=c10>We may from time to time send you announcements when we consider it necessary to do so (such as when we temporarily suspend Game access for maintenance, or security, privacy or administrative-related communications). You may not opt-out of these service-related announcements, which are not promotional in nature.&nbsp;</span></p><p class=c35><span class=\"c34 c41\">SECTION 3</span><span class=c34>:</span><span class=c28>MISCELLANEOUS </span></p><p class=c3><span class=c4>1.Information security</span></p><p class=c1><span class=c10>We have implemented administrative, physical and technical security measures that are designed to protect your information from loss, theft, misuse, unauthorized access, disclosure, alteration and destruction. You should understand though that, despite our efforts, no security can be guaranteed as impenetrable.</span></p><p class=c3><span class=c4>2.Information about children</span></p><p class=c1 id=h.gjdgxs><span class=c10>We do not knowingly collect or solicit personal information from or direct or target interest based advertising to anyone under the age of 16 or knowingly allow such persons to use our Services. If you are under 16, please do not send any information about yourself to us, including your name, address, telephone number, or email address. No one under the age of 16 may provide any personal information. In the event that we learn that we have collected personal information from a child under age 16, we will delete that information as quickly as possible. If you believe that we might have any information from or about a child under the age of 16, please contact us.</span></p><p class=c3><span class=\"c46 c41\">3.</span><span>&nbsp;</span><span class=c4>Links to Sites and Service Operated by Others</span></p><p class=\"c3 c47\"><span class=c10>Tap4Fun Service may contain links to other sites, applications, and services. Because Tap4Fun does not operate those other sites, applications, and services, we cannot take responsibility for the privacy practices of the entities that operate them. We recommend that you consistently check privacy policies to understand an operator’s practices. As a reminder, this policy describes Tap4Fun’s practices.</span></p><p class=c3><span class=c4>4.Changes</span></p><p class=c1><span class=c10>Tap4Fun may update this privacy policy from time to time. When we update it, we will revise the \"Last Updated\" date above. If we make material changes in the way we collect, use, retain or share your personal information, we will notify you by sending you an email at the last email address that you provided us, or by posting notice of the changes on the services covered by this privacy policy.</span></p><p class=c3><span class=c4>4.International Transfer</span></p><p class=\"c3 c7\"><span class=c10>We may transfer information that we collect about you to affiliated entities, or to other third parties across borders and from your country or jurisdiction to other countries or jurisdictions around the world. Please note that these countries and jurisdictions may not have the same data protection laws as your own jurisdiction, and we take steps to ensure adequate safeguards are in place to enable transfer of information and the use and disclosure of information about you, including personal information, as described in this Policy.</span></p><p class=c3><span class=c4>5.Contact &amp; Complaints</span></p><p class=c27><span class=c23>Questions, comments and requests regarding this policy are welcomed. Please contact us via email at </span><span class=c26><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c10>&nbsp;, via phone at 0086-028-83313298, or via regular mail at Tap4Fun Co., Ltd, Attn: Privacy Administrator, Building A3, Tianfu software park, high-tech zone, Chengdu, Sichuan, China.</span></p><p class=c1><span class=c10>In the event that you wish to make a complaint about how we process your personal information, please contact us in the first instance at </span><span class=c55><a class=c20 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c10>&nbsp;and we will endeavor to deal with your request as soon as possible. This is without prejudice to your right to launch a claim with the data protection authority in the country in which you live or work where you think we have infringed data protection laws.</span></p><br></div><div ng-if=\"privacy.lang == \'de-DE\'\"><style type=text/css>ol.lst-kix_list_7-0{list-style-type:none}.lst-kix_list_14-1>li:before{content:\"o  \"}.lst-kix_list_14-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-0.start{counter-reset:lst-ctn-kix_list_9-0 0}.lst-kix_list_14-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_14-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-6>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_9-1{list-style-type:none}ol.lst-kix_list_7-4.start{counter-reset:lst-ctn-kix_list_7-4 0}.lst-kix_list_9-0>li{counter-increment:lst-ctn-kix_list_9-0}ol.lst-kix_list_7-5{list-style-type:none}ol.lst-kix_list_7-6{list-style-type:none}ol.lst-kix_list_7-7{list-style-type:none}ol.lst-kix_list_7-8{list-style-type:none}ol.lst-kix_list_7-1{list-style-type:none}ol.lst-kix_list_11-8.start{counter-reset:lst-ctn-kix_list_11-8 0}ol.lst-kix_list_7-3{list-style-type:none}ol.lst-kix_list_7-4{list-style-type:none}.lst-kix_list_14-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-1{list-style-type:none}ul.lst-kix_list_17-0{list-style-type:none}ul.lst-kix_list_17-8{list-style-type:none}ul.lst-kix_list_17-7{list-style-type:none}ul.lst-kix_list_17-6{list-style-type:none}ul.lst-kix_list_17-5{list-style-type:none}ul.lst-kix_list_17-4{list-style-type:none}ul.lst-kix_list_17-3{list-style-type:none}.lst-kix_list_14-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-2{list-style-type:none}ol.lst-kix_list_8-8.start{counter-reset:lst-ctn-kix_list_8-8 0}ol.lst-kix_list_10-4.start{counter-reset:lst-ctn-kix_list_10-4 0}.lst-kix_list_5-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-0{list-style-type:none}.lst-kix_list_24-7>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_27-0{list-style-type:none}ul.lst-kix_list_27-1{list-style-type:none}.lst-kix_list_24-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_27-2{list-style-type:none}.lst-kix_list_5-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-5.start{counter-reset:lst-ctn-kix_list_9-5 0}.lst-kix_list_5-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-3>li{counter-increment:lst-ctn-kix_list_8-3}.lst-kix_list_5-1>li:before{content:\"o  \"}.lst-kix_list_24-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_5-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_24-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_24-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_9-4>li{counter-increment:lst-ctn-kix_list_9-4}ol.lst-kix_list_6-6{list-style-type:none}ul.lst-kix_list_27-3{list-style-type:none}.lst-kix_list_24-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_6-7{list-style-type:none}ul.lst-kix_list_27-4{list-style-type:none}.lst-kix_list_5-4>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-8{list-style-type:none}ul.lst-kix_list_27-5{list-style-type:none}ul.lst-kix_list_27-6{list-style-type:none}.lst-kix_list_5-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-2{list-style-type:none}ul.lst-kix_list_27-7{list-style-type:none}ol.lst-kix_list_6-3{list-style-type:none}ul.lst-kix_list_27-8{list-style-type:none}ol.lst-kix_list_6-4{list-style-type:none}.lst-kix_list_24-6>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-5{list-style-type:none}.lst-kix_list_23-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_6-1>li:before{content:\"o  \"}.lst-kix_list_6-3>li:before{content:\"\" counter(lst-ctn-kix_list_6-3,decimal) \". \"}.lst-kix_list_6-5>li{counter-increment:lst-ctn-kix_list_6-5}.lst-kix_list_6-8>li{counter-increment:lst-ctn-kix_list_6-8}.lst-kix_list_23-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-0>li:before{content:\"\" counter(lst-ctn-kix_list_6-0,decimal) \". \"}.lst-kix_list_6-4>li:before{content:\"\" counter(lst-ctn-kix_list_6-4,decimal) \". \"}.lst-kix_list_23-2>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_16-2{list-style-type:none}ul.lst-kix_list_16-1{list-style-type:none}ul.lst-kix_list_16-0{list-style-type:none}.lst-kix_list_23-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_23-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-2>li:before{content:\"\" counter(lst-ctn-kix_list_6-2,decimal) \". \"}.lst-kix_list_24-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_16-8{list-style-type:none}ul.lst-kix_list_16-7{list-style-type:none}ul.lst-kix_list_16-6{list-style-type:none}ul.lst-kix_list_16-5{list-style-type:none}.lst-kix_list_24-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_16-4{list-style-type:none}.lst-kix_list_6-8>li:before{content:\"\" counter(lst-ctn-kix_list_6-8,decimal) \". \"}ul.lst-kix_list_16-3{list-style-type:none}.lst-kix_list_6-5>li:before{content:\"\" counter(lst-ctn-kix_list_6-5,decimal) \". \"}.lst-kix_list_6-7>li:before{content:\"\" counter(lst-ctn-kix_list_6-7,decimal) \". \"}.lst-kix_list_23-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_23-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_6-6>li:before{content:\"\" counter(lst-ctn-kix_list_6-6,decimal) \". \"}ol.lst-kix_list_10-6.start{counter-reset:lst-ctn-kix_list_10-6 0}.lst-kix_list_7-4>li:before{content:\"\" counter(lst-ctn-kix_list_7-4,upper-roman) \". \"}.lst-kix_list_7-6>li:before{content:\"\" counter(lst-ctn-kix_list_7-6,upper-roman) \". \"}ol.lst-kix_list_6-2.start{counter-reset:lst-ctn-kix_list_6-2 0}.lst-kix_list_22-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_22-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-6>li{counter-increment:lst-ctn-kix_list_7-6}.lst-kix_list_8-6>li{counter-increment:lst-ctn-kix_list_8-6}.lst-kix_list_22-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-7{list-style-type:none}ol.lst-kix_list_9-8{list-style-type:none}.lst-kix_list_13-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-3{list-style-type:none}ol.lst-kix_list_9-4{list-style-type:none}ol.lst-kix_list_9-5{list-style-type:none}.lst-kix_list_7-8>li:before{content:\"\" counter(lst-ctn-kix_list_7-8,upper-roman) \". \"}ol.lst-kix_list_9-6{list-style-type:none}ol.lst-kix_list_9-0{list-style-type:none}ol.lst-kix_list_9-2{list-style-type:none}.lst-kix_list_22-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-8>li{counter-increment:lst-ctn-kix_list_9-8}.lst-kix_list_4-1>li:before{content:\"o  \"}.lst-kix_list_15-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-7{list-style-type:none}ul.lst-kix_list_19-6{list-style-type:none}.lst-kix_list_4-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-5{list-style-type:none}ul.lst-kix_list_19-4{list-style-type:none}ul.lst-kix_list_19-3{list-style-type:none}.lst-kix_list_25-5>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_19-2{list-style-type:none}ul.lst-kix_list_19-1{list-style-type:none}.lst-kix_list_10-5>li{counter-increment:lst-ctn-kix_list_10-5}ul.lst-kix_list_19-0{list-style-type:none}.lst-kix_list_15-1>li:before{content:\"o  \"}.lst-kix_list_25-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_15-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-8{list-style-type:none}.lst-kix_list_6-4>li{counter-increment:lst-ctn-kix_list_6-4}ol.lst-kix_list_9-2.start{counter-reset:lst-ctn-kix_list_9-2 0}.lst-kix_list_9-3>li{counter-increment:lst-ctn-kix_list_9-3}.lst-kix_list_11-2>li{counter-increment:lst-ctn-kix_list_11-2}ol.lst-kix_list_8-8{list-style-type:none}.lst-kix_list_12-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-6.start{counter-reset:lst-ctn-kix_list_7-6 0}ol.lst-kix_list_8-4{list-style-type:none}.lst-kix_list_12-1>li:before{content:\"o  \"}ol.lst-kix_list_8-5{list-style-type:none}ol.lst-kix_list_8-6{list-style-type:none}ol.lst-kix_list_8-7{list-style-type:none}ol.lst-kix_list_8-0{list-style-type:none}ol.lst-kix_list_8-1{list-style-type:none}ol.lst-kix_list_8-2{list-style-type:none}ol.lst-kix_list_8-3{list-style-type:none}.lst-kix_list_10-4>li{counter-increment:lst-ctn-kix_list_10-4}.lst-kix_list_13-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-0{list-style-type:none}.lst-kix_list_13-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-8{list-style-type:none}ul.lst-kix_list_18-7{list-style-type:none}ul.lst-kix_list_18-6{list-style-type:none}ul.lst-kix_list_18-5{list-style-type:none}.lst-kix_list_12-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-4{list-style-type:none}ul.lst-kix_list_18-3{list-style-type:none}ul.lst-kix_list_18-2{list-style-type:none}ol.lst-kix_list_6-0.start{counter-reset:lst-ctn-kix_list_6-0 0}ul.lst-kix_list_18-1{list-style-type:none}.lst-kix_list_13-1>li:before{content:\"o  \"}ul.lst-kix_list_24-0{list-style-type:none}ul.lst-kix_list_24-1{list-style-type:none}ul.lst-kix_list_24-2{list-style-type:none}ul.lst-kix_list_24-3{list-style-type:none}ul.lst-kix_list_24-4{list-style-type:none}ul.lst-kix_list_24-5{list-style-type:none}ol.lst-kix_list_11-6{list-style-type:none}ol.lst-kix_list_11-7{list-style-type:none}ol.lst-kix_list_11-8{list-style-type:none}.lst-kix_list_7-1>li{counter-increment:lst-ctn-kix_list_7-1}ol.lst-kix_list_11-2{list-style-type:none}ol.lst-kix_list_11-3{list-style-type:none}.lst-kix_list_3-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_11-4{list-style-type:none}ol.lst-kix_list_11-5{list-style-type:none}ul.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_5-8{list-style-type:none}ul.lst-kix_list_5-5{list-style-type:none}ol.lst-kix_list_11-0{list-style-type:none}ul.lst-kix_list_5-6{list-style-type:none}.lst-kix_list_21-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_8-0>li{counter-increment:lst-ctn-kix_list_8-0}ul.lst-kix_list_24-6{list-style-type:none}ul.lst-kix_list_5-0{list-style-type:none}ul.lst-kix_list_24-7{list-style-type:none}.lst-kix_list_10-0>li{counter-increment:lst-ctn-kix_list_10-0}.lst-kix_list_3-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_24-8{list-style-type:none}ul.lst-kix_list_5-3{list-style-type:none}.lst-kix_list_3-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_5-4{list-style-type:none}.lst-kix_list_26-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_5-1{list-style-type:none}.lst-kix_list_8-0>li:before{content:\"\" counter(lst-ctn-kix_list_8-0,upper-roman) \". \"}ul.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_8-7>li:before{content:\"\" counter(lst-ctn-kix_list_8-7,upper-roman) \". \"}.lst-kix_list_3-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_10-7.start{counter-reset:lst-ctn-kix_list_10-7 0}.lst-kix_list_26-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_21-1>li:before{content:\"o  \"}.lst-kix_list_8-3>li:before{content:\"\" counter(lst-ctn-kix_list_8-3,upper-roman) \". \"}ul.lst-kix_list_13-5{list-style-type:none}ul.lst-kix_list_13-4{list-style-type:none}ul.lst-kix_list_13-3{list-style-type:none}ul.lst-kix_list_13-2{list-style-type:none}ul.lst-kix_list_13-1{list-style-type:none}.lst-kix_list_3-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_13-0{list-style-type:none}.lst-kix_list_26-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li:before{content:\"\" counter(lst-ctn-kix_list_8-4,upper-roman) \". \"}.lst-kix_list_10-2>li{counter-increment:lst-ctn-kix_list_10-2}ol.lst-kix_list_8-5.start{counter-reset:lst-ctn-kix_list_8-5 0}ul.lst-kix_list_13-8{list-style-type:none}.lst-kix_list_11-1>li:before{content:\"o  \"}ul.lst-kix_list_13-7{list-style-type:none}ul.lst-kix_list_13-6{list-style-type:none}.lst-kix_list_21-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-0>li:before{content:\"\" counter(lst-ctn-kix_list_11-0,decimal) \". \"}ol.lst-kix_list_9-3.start{counter-reset:lst-ctn-kix_list_9-3 0}.lst-kix_list_26-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_8-8>li:before{content:\"\" counter(lst-ctn-kix_list_8-8,upper-roman) \". \"}.lst-kix_list_16-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-0{list-style-type:none}ul.lst-kix_list_23-1{list-style-type:none}.lst-kix_list_16-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-2{list-style-type:none}ul.lst-kix_list_23-3{list-style-type:none}ul.lst-kix_list_23-4{list-style-type:none}ul.lst-kix_list_23-5{list-style-type:none}ul.lst-kix_list_23-6{list-style-type:none}.lst-kix_list_4-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-8{list-style-type:none}.lst-kix_list_16-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-6{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}.lst-kix_list_25-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li{counter-increment:lst-ctn-kix_list_8-4}ul.lst-kix_list_4-0{list-style-type:none}ul.lst-kix_list_23-7{list-style-type:none}.lst-kix_list_25-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_23-8{list-style-type:none}ol.lst-kix_list_10-8.start{counter-reset:lst-ctn-kix_list_10-8 0}.lst-kix_list_16-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-4{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}.lst-kix_list_11-3>li{counter-increment:lst-ctn-kix_list_11-3}ol.lst-kix_list_7-1.start{counter-reset:lst-ctn-kix_list_7-1 0}ul.lst-kix_list_12-6{list-style-type:none}ol.lst-kix_list_8-6.start{counter-reset:lst-ctn-kix_list_8-6 0}ul.lst-kix_list_12-5{list-style-type:none}.lst-kix_list_17-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-4{list-style-type:none}ul.lst-kix_list_12-3{list-style-type:none}ul.lst-kix_list_12-2{list-style-type:none}ul.lst-kix_list_12-1{list-style-type:none}.lst-kix_list_17-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-0{list-style-type:none}.lst-kix_list_17-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-8{list-style-type:none}ul.lst-kix_list_12-7{list-style-type:none}ol.lst-kix_list_8-0.start{counter-reset:lst-ctn-kix_list_8-0 0}.lst-kix_list_7-0>li:before{content:\"\" counter(lst-ctn-kix_list_7-0,upper-roman) \". \"}ol.lst-kix_list_9-7.start{counter-reset:lst-ctn-kix_list_9-7 0}.lst-kix_list_22-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_2-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-1{list-style-type:none}ul.lst-kix_list_26-2{list-style-type:none}ul.lst-kix_list_26-3{list-style-type:none}.lst-kix_list_22-1>li:before{content:\"o  \"}.lst-kix_list_27-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-6>li{counter-increment:lst-ctn-kix_list_6-6}.lst-kix_list_7-3>li:before{content:\"\" counter(lst-ctn-kix_list_7-3,upper-roman) \". \"}.lst-kix_list_10-0>li:before{content:\"\" counter(lst-ctn-kix_list_10-0,decimal) \". \"}.lst-kix_list_9-7>li{counter-increment:lst-ctn-kix_list_9-7}.lst-kix_list_13-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-4{list-style-type:none}ul.lst-kix_list_26-5{list-style-type:none}ul.lst-kix_list_26-6{list-style-type:none}ul.lst-kix_list_26-7{list-style-type:none}.lst-kix_list_8-7>li{counter-increment:lst-ctn-kix_list_8-7}ul.lst-kix_list_26-8{list-style-type:none}ul.lst-kix_list_7-2{list-style-type:none}.lst-kix_list_27-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_7-7>li:before{content:\"\" counter(lst-ctn-kix_list_7-7,upper-roman) \". \"}ol.lst-kix_list_8-1.start{counter-reset:lst-ctn-kix_list_8-1 0}.lst-kix_list_15-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-5>li{counter-increment:lst-ctn-kix_list_9-5}.lst-kix_list_10-4>li:before{content:\"\" counter(lst-ctn-kix_list_10-4,decimal) \". \"}.lst-kix_list_10-8>li:before{content:\"\" counter(lst-ctn-kix_list_10-8,decimal) \". \"}.lst-kix_list_4-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-3{list-style-type:none}ul.lst-kix_list_15-2{list-style-type:none}.lst-kix_list_15-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-1{list-style-type:none}.lst-kix_list_15-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_15-0{list-style-type:none}.lst-kix_list_4-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_25-4>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_15-8{list-style-type:none}ul.lst-kix_list_15-7{list-style-type:none}ul.lst-kix_list_15-6{list-style-type:none}.lst-kix_list_9-3>li:before{content:\"\" counter(lst-ctn-kix_list_9-3,decimal) \". \"}ul.lst-kix_list_15-5{list-style-type:none}ul.lst-kix_list_15-4{list-style-type:none}ol.lst-kix_list_7-0.start{counter-reset:lst-ctn-kix_list_7-0 0}.lst-kix_list_25-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_25-0{list-style-type:none}ul.lst-kix_list_25-1{list-style-type:none}ul.lst-kix_list_25-2{list-style-type:none}.lst-kix_list_9-7>li:before{content:\"\" counter(lst-ctn-kix_list_9-7,decimal) \". \"}ul.lst-kix_list_25-3{list-style-type:none}ul.lst-kix_list_25-4{list-style-type:none}.lst-kix_list_11-4>li:before{content:\"\" counter(lst-ctn-kix_list_11-4,decimal) \". \"}.lst-kix_list_12-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_20-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-4>li{counter-increment:lst-ctn-kix_list_7-4}ul.lst-kix_list_25-5{list-style-type:none}.lst-kix_list_1-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_25-6{list-style-type:none}.lst-kix_list_20-1>li:before{content:\"o  \"}ul.lst-kix_list_25-7{list-style-type:none}ul.lst-kix_list_25-8{list-style-type:none}.lst-kix_list_11-8>li:before{content:\"\" counter(lst-ctn-kix_list_11-8,decimal) \". \"}.lst-kix_list_12-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_6-1{list-style-type:none}ol.lst-kix_list_8-4.start{counter-reset:lst-ctn-kix_list_8-4 0}.lst-kix_list_1-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_14-4{list-style-type:none}ul.lst-kix_list_14-3{list-style-type:none}ul.lst-kix_list_14-2{list-style-type:none}.lst-kix_list_13-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_14-1{list-style-type:none}ul.lst-kix_list_14-0{list-style-type:none}.lst-kix_list_10-7>li{counter-increment:lst-ctn-kix_list_10-7}ul.lst-kix_list_14-8{list-style-type:none}ul.lst-kix_list_14-7{list-style-type:none}.lst-kix_list_2-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_8-3.start{counter-reset:lst-ctn-kix_list_8-3 0}ul.lst-kix_list_14-6{list-style-type:none}.lst-kix_list_11-5>li{counter-increment:lst-ctn-kix_list_11-5}ul.lst-kix_list_14-5{list-style-type:none}ol.lst-kix_list_9-8.start{counter-reset:lst-ctn-kix_list_9-8 0}.lst-kix_list_1-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_12-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-2>li{counter-increment:lst-ctn-kix_list_8-2}ul.lst-kix_list_20-2{list-style-type:none}ul.lst-kix_list_20-3{list-style-type:none}.lst-kix_list_19-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_19-1>li:before{content:\"o  \"}ul.lst-kix_list_20-4{list-style-type:none}ul.lst-kix_list_20-5{list-style-type:none}ul.lst-kix_list_20-6{list-style-type:none}ul.lst-kix_list_1-0{list-style-type:none}ul.lst-kix_list_20-7{list-style-type:none}ul.lst-kix_list_20-8{list-style-type:none}.lst-kix_list_19-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-1>li{counter-increment:lst-ctn-kix_list_8-1}ol.lst-kix_list_8-2.start{counter-reset:lst-ctn-kix_list_8-2 0}.lst-kix_list_19-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_20-0{list-style-type:none}ul.lst-kix_list_20-1{list-style-type:none}ol.lst-kix_list_6-6.start{counter-reset:lst-ctn-kix_list_6-6 0}.lst-kix_list_7-0>li{counter-increment:lst-ctn-kix_list_7-0}.lst-kix_list_11-0>li{counter-increment:lst-ctn-kix_list_11-0}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}ul.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_9-6.start{counter-reset:lst-ctn-kix_list_9-6 0}.lst-kix_list_19-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-2.start{counter-reset:lst-ctn-kix_list_11-2 0}.lst-kix_list_19-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-2>li{counter-increment:lst-ctn-kix_list_9-2}ol.lst-kix_list_8-7.start{counter-reset:lst-ctn-kix_list_8-7 0}.lst-kix_list_10-3>li{counter-increment:lst-ctn-kix_list_10-3}.lst-kix_list_18-0>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-1>li:before{content:\"o  \"}.lst-kix_list_18-2>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-7.start{counter-reset:lst-ctn-kix_list_11-7 0}ul.lst-kix_list_22-0{list-style-type:none}.lst-kix_list_2-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_22-1{list-style-type:none}ul.lst-kix_list_22-2{list-style-type:none}ul.lst-kix_list_22-3{list-style-type:none}ul.lst-kix_list_22-4{list-style-type:none}.lst-kix_list_2-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-3>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_22-5{list-style-type:none}ul.lst-kix_list_22-6{list-style-type:none}ul.lst-kix_list_22-7{list-style-type:none}.lst-kix_list_27-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_10-3.start{counter-reset:lst-ctn-kix_list_10-3 0}.lst-kix_list_18-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-4.start{counter-reset:lst-ctn-kix_list_9-4 0}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_list_10-1>li:before{content:\"o  \"}.lst-kix_list_18-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_3-1{list-style-type:none}ul.lst-kix_list_22-8{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_7-7>li{counter-increment:lst-ctn-kix_list_7-7}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_10-7>li:before{content:\"\" counter(lst-ctn-kix_list_10-7,decimal) \". \"}.lst-kix_list_7-8>li{counter-increment:lst-ctn-kix_list_7-8}.lst-kix_list_10-5>li:before{content:\"\" counter(lst-ctn-kix_list_10-5,decimal) \". \"}.lst-kix_list_10-3>li:before{content:\"\" counter(lst-ctn-kix_list_10-3,decimal) \". \"}ol.lst-kix_list_7-3.start{counter-reset:lst-ctn-kix_list_7-3 0}ul.lst-kix_list_11-1{list-style-type:none}.lst-kix_list_11-7>li{counter-increment:lst-ctn-kix_list_11-7}.lst-kix_list_9-2>li:before{content:\"\" counter(lst-ctn-kix_list_9-2,decimal) \". \"}.lst-kix_list_20-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-0>li:before{content:\"\" counter(lst-ctn-kix_list_9-0,decimal) \". \"}ul.lst-kix_list_21-1{list-style-type:none}ul.lst-kix_list_21-2{list-style-type:none}ul.lst-kix_list_21-3{list-style-type:none}ul.lst-kix_list_21-4{list-style-type:none}.lst-kix_list_20-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_21-5{list-style-type:none}ul.lst-kix_list_21-6{list-style-type:none}ul.lst-kix_list_21-7{list-style-type:none}ul.lst-kix_list_21-8{list-style-type:none}ol.lst-kix_list_10-7{list-style-type:none}.lst-kix_list_9-6>li:before{content:\"\" counter(lst-ctn-kix_list_9-6,decimal) \". \"}ol.lst-kix_list_10-8{list-style-type:none}ol.lst-kix_list_10-3{list-style-type:none}.lst-kix_list_9-4>li:before{content:\"\" counter(lst-ctn-kix_list_9-4,decimal) \". \"}ol.lst-kix_list_10-4{list-style-type:none}ol.lst-kix_list_10-5{list-style-type:none}.lst-kix_list_11-3>li:before{content:\"\" counter(lst-ctn-kix_list_11-3,decimal) \". \"}ol.lst-kix_list_10-6{list-style-type:none}ul.lst-kix_list_21-0{list-style-type:none}.lst-kix_list_6-3>li{counter-increment:lst-ctn-kix_list_6-3}.lst-kix_list_20-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-0{list-style-type:none}ul.lst-kix_list_2-8{list-style-type:none}ol.lst-kix_list_10-2{list-style-type:none}.lst-kix_list_20-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-5>li:before{content:\"\" counter(lst-ctn-kix_list_11-5,decimal) \". \"}ul.lst-kix_list_2-2{list-style-type:none}.lst-kix_list_20-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_9-8>li:before{content:\"\" counter(lst-ctn-kix_list_9-8,decimal) \". \"}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:\"o  \"}ul.lst-kix_list_2-7{list-style-type:none}.lst-kix_list_11-7>li:before{content:\"\" counter(lst-ctn-kix_list_11-7,decimal) \". \"}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_8-5>li{counter-increment:lst-ctn-kix_list_8-5}.lst-kix_list_1-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-5.start{counter-reset:lst-ctn-kix_list_10-5 0}.lst-kix_list_1-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_1-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_10-1{list-style-type:none}ol.lst-kix_list_7-5.start{counter-reset:lst-ctn-kix_list_7-5 0}.lst-kix_list_2-1>li:before{content:\"o  \"}.lst-kix_list_27-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_2-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-8>li{counter-increment:lst-ctn-kix_list_11-8}ol.lst-kix_list_7-7.start{counter-reset:lst-ctn-kix_list_7-7 0}.lst-kix_list_3-1>li:before{content:\"o  \"}.lst-kix_list_3-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_26-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-1>li:before{content:\"\" counter(lst-ctn-kix_list_8-1,upper-roman) \". \"}.lst-kix_list_8-2>li:before{content:\"\" counter(lst-ctn-kix_list_8-2,upper-roman) \". \"}.lst-kix_list_6-0>li{counter-increment:lst-ctn-kix_list_6-0}.lst-kix_list_3-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-5.start{counter-reset:lst-ctn-kix_list_11-5 0}.lst-kix_list_21-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-5>li:before{content:\"\" counter(lst-ctn-kix_list_8-5,upper-roman) \". \"}.lst-kix_list_8-6>li:before{content:\"\" counter(lst-ctn-kix_list_8-6,upper-roman) \". \"}.lst-kix_list_26-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_26-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_3-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-2>li:before{content:\"\" counter(lst-ctn-kix_list_11-2,decimal) \". \"}.lst-kix_list_21-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-6.start{counter-reset:lst-ctn-kix_list_11-6 0}.lst-kix_list_16-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-4.start{counter-reset:lst-ctn-kix_list_6-4 0}.lst-kix_list_25-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_17-1>li:before{content:\"o  \"}.lst-kix_list_25-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-1>li:before{content:\"o  \"}.lst-kix_list_7-3>li{counter-increment:lst-ctn-kix_list_7-3}.lst-kix_list_16-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_16-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-8.start{counter-reset:lst-ctn-kix_list_7-8 0}ol.lst-kix_list_11-0.start{counter-reset:lst-ctn-kix_list_11-0 0}ol.lst-kix_list_6-3.start{counter-reset:lst-ctn-kix_list_6-3 0}ol.lst-kix_list_10-2.start{counter-reset:lst-ctn-kix_list_10-2 0}.lst-kix_list_17-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-2>li{counter-increment:lst-ctn-kix_list_6-2}.lst-kix_list_2-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_22-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-1>li:before{content:\"\" counter(lst-ctn-kix_list_7-1,decimal) \". \"}.lst-kix_list_7-5>li:before{content:\"\" counter(lst-ctn-kix_list_7-5,upper-roman) \". \"}.lst-kix_list_9-6>li{counter-increment:lst-ctn-kix_list_9-6}.lst-kix_list_27-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-7>li{counter-increment:lst-ctn-kix_list_6-7}.lst-kix_list_10-6>li{counter-increment:lst-ctn-kix_list_10-6}.lst-kix_list_11-6>li{counter-increment:lst-ctn-kix_list_11-6}ol.lst-kix_list_10-0.start{counter-reset:lst-ctn-kix_list_10-0 0}.lst-kix_list_7-5>li{counter-increment:lst-ctn-kix_list_7-5}.lst-kix_list_15-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-4>li{counter-increment:lst-ctn-kix_list_11-4}ol.lst-kix_list_6-8.start{counter-reset:lst-ctn-kix_list_6-8 0}.lst-kix_list_10-2>li:before{content:\"\" counter(lst-ctn-kix_list_10-2,decimal) \". \"}.lst-kix_list_20-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-5.start{counter-reset:lst-ctn-kix_list_6-5 0}.lst-kix_list_4-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_10-8>li{counter-increment:lst-ctn-kix_list_10-8}.lst-kix_list_25-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_10-6>li:before{content:\"\" counter(lst-ctn-kix_list_10-6,decimal) \". \"}.lst-kix_list_9-1>li:before{content:\"o  \"}ol.lst-kix_list_6-7.start{counter-reset:lst-ctn-kix_list_6-7 0}.lst-kix_list_9-5>li:before{content:\"\" counter(lst-ctn-kix_list_9-5,decimal) \". \"}.lst-kix_list_12-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-6>li:before{content:\"\" counter(lst-ctn-kix_list_11-6,decimal) \". \"}.lst-kix_list_20-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-3.start{counter-reset:lst-ctn-kix_list_11-3 0}.lst-kix_list_1-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-8>li{counter-increment:lst-ctn-kix_list_8-8}.lst-kix_list_1-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-4.start{counter-reset:lst-ctn-kix_list_11-4 0}.lst-kix_list_2-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-2>li:before{content:\"\\0025aa  \"}ol{margin:0;padding:0}table td,table th{padding:0}.c22{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:157.8pt;border-top-color:#000000;border-bottom-style:solid}.c12{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:137.2pt;border-top-color:#000000;border-bottom-style:solid}.c11{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:280.1pt;border-top-color:#000000;border-bottom-style:solid}.c29{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:291.1pt;border-top-color:#000000;border-bottom-style:solid}.c46{-webkit-text-decoration-skip:none;color:#0000ff;font-weight:400;text-decoration:underline;vertical-align:baseline;text-decoration-skip-ink:none;font-size:10pt;font-family:\"\\007b49\\007ebf\";font-style:normal}.c2{margin-left:18pt;padding-top:0pt;padding-left:-3.8pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c6{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c8{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:\"Arial\";font-style:normal}.c9{padding-top:0pt;text-indent:20pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c4{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:8pt;font-family:\"Arial\";font-style:normal}.c18{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:\"Arial\";font-style:normal}.c26{padding-top:0pt;text-indent:24pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:center}.c7{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:italic}.c3{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:\"Arial\";font-style:normal}.c16{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:\"Arial\";font-style:normal}.c23{-webkit-text-decoration-skip:none;color:#0000ff;font-weight:400;text-decoration:underline;text-decoration-skip-ink:none;font-size:10pt;font-family:\"Arial\"}.c27{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c37{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c20{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c30{font-weight:400;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:\"Arial\";font-style:normal}.c5{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c0{padding-top:6pt;padding-bottom:6pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c28{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c24{padding-top:12pt;padding-bottom:12pt;line-height:1.0;text-align:justify}.c13{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-align:justify}.c45{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c40{font-size:11pt;font-family:\"Arial\";color:#212121;font-weight:700}.c19{font-size:10pt;font-family:\"Arial\";font-weight:700}.c41{font-size:8pt;font-family:\"Arial\";font-weight:700}.c47{background-color:#ffffff;padding:72pt 16pt 72pt 16pt;margin:auto;}.c49{text-decoration:none;vertical-align:baseline;font-style:normal}.c50{font-weight:400;font-size:10pt;font-family:\"\\007b49\\007ebf\"}.c31{font-size:8pt;font-family:\"Arial\";font-weight:400}.c32{font-size:10pt;font-family:\"Arial\";font-weight:400}.c17{color:inherit;text-decoration:inherit}.c34{margin-left:14.2pt;height:10pt}.c39{padding:0;margin:0}.c42{height:103pt}.c33{height:44pt}.c44{height:10pt}.c21{text-indent:18pt}.c55{font-size:10pt}.c36{height:19pt}.c48{text-indent:25pt}.c35{height:22pt}.c38{height:45pt}.c43{height:6pt}.c52{height:20pt}.c10{text-indent:20pt}.c14{height:18pt}.c54{height:14pt}.c57{color:#777777}.c51{height:74pt}.c56{height:29pt}.c53{font-style:italic}.c25{color:#000000}.c15{height:59pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:\"Georgia\";line-height:1.0;page-break-after:avoid;font-style:italic;text-align:justify}li{color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}p{margin:0;color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h2{padding-top:5pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h3{padding-top:5pt;color:#000000;font-weight:700;font-size:13.5pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h4{padding-top:5pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}</style><p class=c26><span class=c3>Datenschutzrichtlinie </span></p><p class=\"c27 c10\"><span class=c1>Letzte Aktualisierung: 05/2018</span></p><p class=\"c10 c27\"><span class=c19>Hiermit bestätigen Sie, dass Sie diese Datenschutzrichtlinie gelesen und verstanden haben. Sollten Sie dieser Datenschutzrichtlinie nicht zustimmen, dürfen Sie die Dienste von Tap4Fun nicht verwenden. Sollten Sie in Zukunft Ihre Meinung ändern, können Sie Ihre Zustimmung dazu, dass Ihre personenbezogenen Daten gemäß dieser Richtlinie verwendet werden, widerrufen.</span></p><p class=\"c13 c10\"><span class=c1>Bei Tap4Fun wissen wir, wie wichtig Ihnen der Schutz Ihrer Daten ist, daher sollten Sie sich die Zeit nehmen, unsere Datenschutzrichtlinie sorgfältig zu lesen. Unsere Richtlinie dient dazu, Ihnen Folgendes zu vermitteln:</span></p><p class=\"c13 c10\"><span class=c6>1. Welche Daten wir über Sie sammeln;</span></p><p class=\"c13 c10\"><span class=c6>2. Wie wir Ihre Daten verwenden;</span></p><p class=\"c13 c10\"><span class=c6>3. Mit wem wir Ihre Daten teilen;</span></p><p class=\"c13 c10\"><span class=c6>4. Wie lange wir Ihre Daten aufbewahren;</span></p><p class=\"c13 c10\"><span class=c6>5. Wie Sie Ihre Rechte zu Ihren Daten geltend machen können;</span></p><p class=\"c13 c10\"><span class=c6>6. Streitschlichtung;</span></p><p class=\"c13 c10\"><span class=c6>7. Wie wir Sie über Änderungen informieren;</span></p><p class=\"c13 c10\"><span class=c6>8. Kontaktinformationen;</span></p><p class=\"c13 c10\"><span class=c1>Diese Datenschutzrichtlinie gilt für alle Dienstleistungen von Tap4Fun, die direkt auf diese Richtlinie verweisen oder verlinken, doch sie gilt nicht für Dienstleistungen von Tap4Fun, die separate Datenschutzrichtlinien haben, welche diese Richtlinie nicht einbeziehen.</span></p><p class=c24><span class=c16>ABSCHNITT 1： WENN WIR DATENVERANTWORTLICHER SIND </span></p><p class=c0><span class=\"c19 c25\">1. Die Art von personenbezogenen Daten, die wir verwenden</span></p><p class=\"c13 c10\"><span class=c1>Dieser Abschnitt beschreibt die unterschiedlichen Arten von personenbezogenen Daten, die wir sammeln, und wie wir sie sammeln. Wir sammeln und verwenden die folgenden Daten über Sie:</span></p><p class=c0><span class=\"c19 c25\">Daten</span><span class=c40>, die Sie uns bereitstellen.</span></p><ul class=\"c39 lst-kix_list_23-0 start\"><li class=c2><span class=c1>wenn Sie sich für das Spiel registrieren (einschließlich Ihres gewählten Benutzernamens oder benutzerdefinierten Konten und Daten, die wir aus Ihren verbundenen Social-Media-Konten importieren (WeChat, Facebook), um Ihr Profil einzurichten, einschließlich Ihres Namens, wie er auf Ihrem Social-Media-Profil erscheint, und Ihres Profilbildes).</span></li><li class=c2><span class=c1>wenn Sie sich als „Gast“ anmelden, um das Spiel (Ihren Benutzernamen) zu verwenden; und </span></li><li class=c2><span class=c1>wenn Sie an einer Umfrage im Spiel teilnehmen (in diesem Fall werden wir die Daten verarbeiten, die Sie uns im Rahmen dieser Umfrage bereitstellen).</span></li><li class=c2><span class=c8>D</span><span class=c1>aten, die Sie bereitstellen, wenn Sie Hilfe von uns ersuchen, beispielsweise Ihr Name, Ihre Telefonnummer und Aufzeichnungen der Probleme, die Ihnen begegnet sind; und</span></li><li class=c2><span class=c1>Rechnungsdaten, wie etwa Ihr Name. die Nummer der Zahlungskarte und Zahlungskontodetails;</span></li></ul><p class=c0><span class=c6>Daten, die wir über Sie sammeln.</span></p><p class=c9><span class=c1>Wir sammeln automatisch bestimmte Daten von Ihnen, wenn Sie das Spiel verwenden, einschließlich Ihrer IP-Adresse und Geräteinformationen (wie Anwendungsversion, Netzwerktyp, Betriebssystem) und Daten zu Ihrer Verwendung des Spiels, wie etwa Datums- und Zeitstempel von Aktionen. Wir sammeln und speichern Ihre Daten jedes Mal, wenn Sie mit uns interagieren, beispielsweise wenn Sie In-App-Support verwenden, um mit uns zu kommunizieren.</span></p><p class=c0><span class=c6>Daten, die Sie bei der Verwendung der Spieldienste generieren und anzeigen.&nbsp;</span></p><p class=c9><span class=\"c32 c25\">Sie können weitere Daten im Rahmen Ihres Profils angeben (wie etwa Geschlecht). Sie können außerdem Daten bereitstellen oder generieren, wenn sie mit anderen Benutzern im Spiel kommunizieren (z. B. Chat-Protokolldaten, Chat-Inhalte).</span></p><p class=c0><span class=c6>Daten, die wir von unseren Partnern sammeln.</span></p><ul class=\"c39 lst-kix_list_23-0\"><li class=c2><span class=c1>Daten, die wir erhalten, wenn Sie ein Drittanbieter-Tool mit dem Dienst verbinden (wie etwa WeChat, Facebook).</span></li><li class=c2><span class=\"c30 c25\">Demografische Daten (um beispielsweise den groben Standort Ihrer IP-Adresse zu ermitteln)</span></li><li class=c2><span class=\"c30 c25\">Daten zur Betrugsbekämpfung (wie etwa der Missbrauch von Rückerstattungen bei Spielen oder Klick-Betrug bei Werbung)</span></li><li class=c2><span class=\"c30 c25\">Daten von Plattformen, auf denen die Spiele laufen (wie etwa zur Zahlungsverifizierung).</span></li><li class=c2><span class=\"c25 c30\">Daten für Werbe- und Analysezwecke damit wir Ihnen einen besseren Service liefern können.</span></li></ul><p class=c0><span class=c6>Cookies.</span></p><p class=c0><span class=c1>Wir verwenden Cookies und andere ähnliche Technologien (z. B. Web-Beacons, Skripte und eTags) („Cookies“), um Ihr Erlebnis bei der Nutzung des Dienstes zu verbessern. Cookies sind kleine Dateien, die auf Ihrem Gerät gespeichert werden, damit wir Ihnen bestimmte Merkmale und Funktionen anbieten können. Sie haben die Möglichkeit, die Installation solcher Cookies abzulehnen oder sie nachträglich zu deaktivieren. Sie können alle Cookies akzeptieren oder das Gerät anweisen (im Fall des Spiels), Sie zum Zeitpunkt der Installation von Cookies zu benachrichtigen, oder Sie können alle Cookies ablehnen, indem Sie die betreffende Cookie-Einstellung in Ihrem Gerät anpassen. Falls Sie jedoch die Installation von Cookies ablehnen, kann das Spiel unter Umständen nicht wie vorgesehen funktionieren.</span></p><p class=c0><span class=c6>2. Wie wir Ihre personenbezogenen Daten verwenden.</span></p><p class=c20><span class=c1>Wir verwenden die Daten auf folgende Arten:</span></p><a id=t.b3adc5ab54f72b5e7d6cdb8c2ea22cded0dce98e></a><a id=t.0></a><table class=c45><tbody><tr class=c35><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c25 c41\">Personenbezogene Daten</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c41 c25\">Verwendung</span></p></td></tr><tr class=c35><td class=c22 colspan=1 rowspan=1><p class=c37><span class=\"c31 c25\">Benutzername</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir verwenden diese Daten, um Ihr Konto für das Spiel gemäß Ihrer Anfrage zu erstellen.</span></p></td></tr><tr class=c36><td class=c22 colspan=1 rowspan=1><p class=c37><span class=c4>Social-Media-Verbindungsdaten:</span></p><p class=c37><span class=c4>WeChat: Open ID, Profilfoto, Benutzername, Geschlecht, Region</span></p><p class=c37><span class=c31>Facebook: Name, Facebook-ID, Profilbild</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=c4>Wir verwenden diese Daten, um: • Ihr Konto für das Spiel entsprechend Ihrer Anfrage zu erstellen; • In-Game-Fotos auf Ihre Anfrage hin auf Facebook zu teilen.</span></p></td></tr><tr class=c38><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Generierte Open ID</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir generieren diese und verwenden sie, um Ihre Spieldaten (einschließlich Stufen und Fortschritt) mit Ihrem Profil zu speichern.</span></p></td></tr><tr class=c52><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Gameplay-Statistik (Stufe, Punkte)</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir verwenden diese Daten, um Ihnen Feedback und Informationen über Ihr Gameplay und Ihren Fortschritt zu liefern.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">IP-Adresse</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir verwenden diese Daten, um unsere Dienste zu verbessern, einschließlich der Funktionalität des Spiels.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Geräte-ID, Gerätedaten</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir verwenden diese Daten: • um unsere Dienste zu verbessern, einschließlich der Funktionalität des Spiels; • für Sicherheits- und Verifizierungszwecke; • um Fehler zu erkennen und zu beheben und Spielfunktionen zur Optimierung zu bewerten; und • um zu verhindern, dass Benutzer sich für mehrere Konten registrieren.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Advertising ID</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c25 c31\">Wenn Sie auf einen Link klicken, mit dem das Spiel beworben wird, speichern wir die Advertising ID für diese Werbung mit Ihrem Profil.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Chat-Daten</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wenn Sie einen Chat-Dienst (Audio oder Text) aktivieren, dann verarbeiten wir solche Daten, um Ihre Mitteilung an andere Benutzer zu liefern.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Transaktionsaufzeichnungen: Zahlungen bei Google Pay oder im iOS App Store&nbsp;</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir verwenden diese Daten, um eine Aufzeichnung Ihrer Transaktionshistorie zu führen.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Kunden-Support-Ticket-ID und Benutzerkommunikation mit dem Support</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir verwenden diese Daten, um:• unsere Services zu verbessern;• Fehlerbehebung zu leisten, wie etwa, um technische Probleme oder Bugs zu beheben.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Sicherheitsrelevante Daten</span></p></td><td class=c29 colspan=1 rowspan=1><p class=c5><span class=\"c31 c25\">Wir verwenden diese Daten:• für Sicherheits- und Verifizierungszwecke;• um Bugs zu identifizieren und zu beheben und Spielfunktionen zur Optimierung zu identifizieren;&nbsp;• um Spielabstürze zu beheben und die Kompatibilität von Geräten mit dem Spiel zu optimieren; und&nbsp;• um zu Verhindern, dass Benutzer mehrere Konten registrieren.</span></p></td></tr><tr class=c14><td class=c22 colspan=1 rowspan=1><p class=c5><span class=c4>Umfragedaten und Inhalte von Umfrageergebnissen</span></p></td><td class=c29 colspan=1 rowspan=1><p class=\"c5 c44\"><span class=c4></span></p></td></tr></tbody></table><p class=c0><span class=c6>Analysieren, Profilieren und Segmentieren.</span></p><p class=\"c20 c21\"><span class=\"c30 c25\">Für alle oben genannten Fälle und Zwecke können wir alle gesammelten Daten analysieren, profilieren und segmentieren.</span></p><p class=c0><span class=c6>Rechtliche Grundlage für die Verarbeitung</span></p><p class=\"c27 c10\"><span class=c32>Wenn Sie in der Europäischen Union leben, stützen wir uns auf eine Reihe von rechtlichen Grundlagen, um Daten über Sie zu verarbeiten. Beispielsweise verarbeiten wir Daten über Sie, wo wir Ihre Zustimmung haben, wo wir ein legitimes Interesse daran haben, wo die Verarbeitung für die Ausführung eines Vertrages mit Ihnen notwendig ist und wo wir eine rechtliche Pflicht haben, Ihre Daten zu verarbeiten. Beispielsweise stützen wir uns auf unser legitimes Interesse, Ihnen gezieltes Marketing zu liefern, und auf die vertragliche Notwendigkeit, Daten zu verarbeiten, wenn Sie ein Konto erstellen. Um mehr über die rechtlichen Grundlagen zu erfahren, auf die wir uns stützen, um Ihre Daten für einen bestimmten Zweck zu verarbeiten, kontaktieren Sie uns bitte über die untenstehenden Optionen unter </span><span class=\"c19 c25\">Kontakt</span><span class=c19>&nbsp;und Beschwerden</span><span class=c32>.</span></p><p class=c0><span class=c6>3. Wie wir Ihre personenbezogenen Daten teilen</span></p><p class=c20><span class=c1>Wir teilen Ihre personenbezogenen Daten mit ausgewählten dritten Parteien innerhalb und außerhalb Ihres Landes, einschließlich:</span></p><ul class=\"c39 lst-kix_list_23-0\"><li class=c2><span class=c18>anderen Spielern und Benutzern.</span><span class=\"c49 c25 c50\">&nbsp;</span><span class=\"c30 c25\">Social-Media-Merkmale sind eine Kernkomponente unserer Spiele. Andere Spieler und Benutzer können beispielsweise Ihre Profildaten und In-Game-Aktivitäten sehen und die Mitteilungen lesen, die Sie gepostet haben.</span></li><li class=c2><span class=c18>Partner, die für Tap4Fun arbeiten.</span><span class=\"c49 c50 c25\">&nbsp;</span><span class=\"c30 c25\">Tap4Fun hat Partner, um Dienstleistungen für uns auszuführen. Diese Partner verarbeiten Ihre Daten nur auf Anweisung von Tap4Fun und nur entsprechend unserer Anweisungen, um Dienstleistungen wie beispielsweise Hosting, Spieler-Support, Werbung, Analytik und Betrugsverhinderung zu erbringen .</span></li><li class=c2><span class=c18>andere Unternehmen und öffentliche Behörden. </span><span class=\"c30 c25\">Um Betrug und illegale Aktivitäten zu bekämpfen, tauschen wir unter Umständen Daten mit anderen Unternehmen und Organisationen aus und liefern diese an öffentlichen Behörden, wenn diese eine rechtmäßig Anfrage stellen. Wir können Ihre Daten auch basierend auf Ihrem Einverständnis offenlegen, um den Gesetzen zu entsprechen oder um die Rechte und die Sicherheit von uns, unseren Spielern oder anderen zu schützen.</span></li><li class=c2><span class=c18>angeschlossene</span><span class=c6>&nbsp;Unternehmen der Gruppe Tap4Fun (Hong Kong) Limited.,</span><span class=c1>, mit denen wir Ihre personenbezogenen Daten teilen, um die Spieldienste zu betreiben;</span></li><li class=c2><span class=c6>Justizbehörden, öffentliche Behörden oder andere Justizstellen und -organisationen.</span></li><li class=c2><span class=c18>eine dritte Partei, die unser gesamtes Geschäft oder einen substanziellen Teil davon übernimmt.&nbsp;</span><span class=\"c30 c25\">Wir legen Daten einer dritten Partei offen, falls wir ein Unternehmen verkaufen oder kaufen oder einen Unternehmenszusammenschluss durchführen, in welchem Fall wir Ihre Daten dem potenziellen Käufer offenlegen. Wir legen Daten auch einer dritten Partei offen, wenn wir andere Unternehmen oder Geschäfte kaufen, verkaufen, uns mit ihnen zusammenschließen oder Partnerschaften mit Ihnen eingehen oder wenn wir unser Vermögen ganz oder in Teilen an sie verkaufen. In solchen Transaktionen können Benutzerinformationen Bestandteil der übertragenen Vermögenswerte sein.</span></li></ul><p class=c0><span class=c6>4. Datenspeicherung</span></p><p class=c9><span class=c1>Wir werden Ihre personenbezogenen Daten aufbewahren, wie es im Folgenden beschrieben ist (außer das anwendbare Recht schreibt eine Speicherung aus anderen Gründen vor).</span></p><a id=t.a1080246adde7821833f1f7cfc64dbddc82ccb68></a><a id=t.1></a><table class=c28><tbody><tr class=c54><td class=c12 colspan=1 rowspan=1><p class=c5><span class=\"c41 c25\">Personenbezogene Daten</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=\"c41 c25\">Aufbewahrungsrichtlinie</span></p></td></tr><tr class=c33><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Benutzername</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Wird für die gesamte Dauer Ihrer Nutzung des Spiels gespeichert (d. h. bis zur Kontolöschung gemäß Ihrer Anfrage) und dann innerhalb von 30 Tagen gelöscht.</span></p></td></tr><tr class=c15><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Social-Media-Verbindungsdaten:<br>WeChat</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Wird für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt (d. h. bis zur Kontolöschung gemäß Ihrer Anfrage oder bis Sie den Zugriff auf Ihr Social-Media-Konto widerrufen) und dann innerhalb von 30 Tagen gelöscht.&nbsp;</span></p></td></tr><tr class=c42><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Social-Media-Verbindungsdaten:<br>Facebook</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, woraufhin sie innerhalb von 15 Tagen gelöscht werden.<br>Wenn Sie keine Kontolöschung beantragen, werden solche Daten für ein Jahr nach Einstellung des Spiels aufbewahrt, bevor sie gelöscht werden.&nbsp;</span></p></td></tr><tr class=c42><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4><br>Gameplay-Statistik (Stufe, Helden, Punkte)</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, woraufhin sie innerhalb von 15 Tagen gelöscht werden.&nbsp;<br>Wenn Sie keine Kontolöschung beantragen, werden solche Daten für ein Jahr nach Einstellung des Spiels aufbewahrt, bevor sie gelöscht werden.&nbsp;</span></p></td></tr><tr class=c56><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Chat-Kommunikationen (Audio-Nachricht)</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für sieben Tage auf unseren Servern gespeichert und nach Ablauf dieses Zeitraums automatisch gelöscht.</span></p></td></tr><tr class=c51><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Chat-Kommunikationen (Text)</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, woraufhin sie innerhalb von 7 Tagen gelöscht werden.&nbsp;<br>Wenn Sie keine Kontolöschung beantragen, werden solche Daten für ein Jahr nach Einstellung des Spiels aufbewahrt, bevor sie gelöscht werden.&nbsp;</span></p></td></tr><tr class=c43><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>OpenID</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, woraufhin sie innerhalb von 15 Tagen gelöscht werden.&nbsp;<br>Wenn Sie keine Kontolöschung beantragen, werden solche Daten für ein Jahr nach Einstellung des Spiels aufbewahrt, bevor sie gelöscht werden.&nbsp;</span></p></td></tr><tr class=c43><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>IP-Adresse</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Wird für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, danach wird sie innerhalb von 15 Tagen gelöscht.&nbsp;<br>Wenn Sie keine Kontolöschung beantragen, werden solche Daten für ein Jahr nach Einstellung des Spiels aufbewahrt, bevor sie gelöscht werden.&nbsp;</span></p></td></tr><tr class=c43><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Geräte-ID, Gerätedaten</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, danach werden sie innerhalb von 30 Tagen gelöscht.<br>Wenn Sie keine Kontolöschung beantragen, werden solche Daten für ein Jahr nach Einstellung des Spiels aufbewahrt, bevor sie gelöscht werden.&nbsp;</span></p></td></tr><tr class=c43><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Advertising ID</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, danach werden sie innerhalb von 15 Tagen gelöscht.&nbsp;<br>Wenn Sie keine Kontolöschung beantragen, werden solche Daten für ein Jahr nach Einstellung des Spiels aufbewahrt, bevor sie gelöscht werden.&nbsp;</span></p></td></tr><tr class=c43><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Transaktionsaufzeichnungen</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Wird für die gesamte Dauer Ihrer Nutzung des Spiels gespeichert (d. h. bis zur Kontolöschung gemäß Ihrer Anfrage) und dann für die Dauer des Aufbewahrungszeitraums, für den solche Daten gespeichert werden müssen, um unsere gesetzlichen Verpflichtungen zu erfüllen.</span></p></td></tr><tr class=c43><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Kunden-Support-Ticket-ID und Benutzerkommunikation mit dem Support</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Support-Daten werden innerhalb von 30 Tagen nach einer rechtmäßigen Anfrage von Ihnen für die Löschung solcher Daten gelöscht (siehe den Abschnitt „Löschung“ in dieser Datenschutzrichtlinie).</span></p></td></tr><tr class=c43><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Sicherheitsrelevante Daten&nbsp;</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden für die gesamte Dauer Ihrer Nutzung des Spiels aufbewahrt, bis zur Kontolöschung gemäß Ihrer Anfrage, danach werden sie innerhalb von 30 Tagen gelöscht.&nbsp;</span></p></td></tr><tr class=c56><td class=c12 colspan=1 rowspan=1><p class=c5><span class=c4>Umfragedaten</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c5><span class=c4>Werden aufbewahrt für: (a) wenn Sie Ihre E-Mail-Adresse im Rahmen der Umfrage angeben, bis zu sechs Monate (damit wir Sie nachfolgend kontaktieren können) und dann werden die Daten anonymisiert; oder (b) falls Sie Ihre E-Mail im Rahmen dieser Umfrage nicht angeben, bis zu einen Monat, und danach werden die Daten anonymisiert.</span></p></td></tr></tbody></table><p class=\"c20 c44\"><span class=c1></span></p><p class=c9><span class=c1>Personenbezogene Daten werden bis zum Ende ihres Lebenszyklus aufbewahrt (wie in der obigen Aufbewahrungsrichtlinie festgelegt). Wenn personenbezogene Daten vernichtet werden, werden Maßnahmen ergriffen, damit die personenbezogenen Daten nicht wiederhergestellt oder reproduziert werden können, und elektronische Dateien, die personenbezogene Daten enthalten, werden mit Hilfe einer technischen Methode, die die Wiederherstellbarkeit der Dateien verhindert, dauerhaft gelöscht.</span></p><p class=c9><span class=c1>In Fällen, in denen sowohl der Verarbeitungs- als auch der Aufbewahrungszeitraum beendet ist, Ihre personenbezogenen Daten aber aus anderen Gründen, einschließlich derer, die gemäß anwendbarer Gesetze vorgeschrieben sind, weiterhin aufbewahrt werden müssen, werden die betreffenden personenbezogenen Daten separat von anderen Arten von personenbezogenen Daten gespeichert und aufbewahrt. Sollten Sie die Vernichtung Ihrer personenbezogenen Daten vor dem Ende ihres Lebenszyklus (wie es in der obigen Aufbewahrungsrichtlinie festgelegt ist) verlangen, werden wir Ihre personenbezogenen Daten im Einklang mit den lokalen Gesetzen vernichten.</span></p><p class=c24><span class=c16>ABSCHNITT 2：IHRE RECHTE</span></p><p class=c20><span class=\"c19 c53 c25\">Dieser Abschnitt („Ihre Rechte“)</span><span class=c6>&nbsp;betrifft nur Nutzer, die im europäischen Wirtschaftsraum ansässig sind.</span></p><p class=c9><span class=\"c32 c25\">Sie haben bestimmte Rechte in Bezug auf die personenbezogenen Daten, die wir von Ihnen aufbewahren. Einige von diesen gelten nur unter bestimmten Umständen (wie im Folgenden detaillierter ausgeführt wird). Wir müssen auf eine Anfrage von Ihnen, um diese Rechte geltend zu machen, ohne ungebührliche Verzögerung und mindestens innerhalb eines Monats reagieren (allerdings kann dieser Zeitraum unter bestimmten Umständen um weitere zwei Monate verlängert werden). Um eines Ihrer Rechte geltend zu machen, schreiben Sie uns bitte eine E-Mail an </span><span class=c23><a class=c17 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>.</span></p><p class=c0><span class=c7>1. Zugriff</span></p><p class=c9><span class=\"c32 c25\">Sie haben das Recht, auf die personenbezogenen Daten zuzugreifen, die wir von Ihnen aufbewahren und zu erfahren, wie wir sie verwenden und mit wem wir sie teilen. Sie können auf die personenbezogenen Daten zugreifen, die Sie im Rahmen Ihres Kontos verfügbar gemacht haben, indem Sie sich in Ihrem Spielkonto anmelden und indem Sie </span><span class=c23><a class=c17 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c32 c25\">&nbsp;kontaktieren. Falls Sie annehmen, dass wir sonstige personenbezogenen Daten über Sie aufbewahren, schreiben Sie uns bitte eine E-Mail an </span><span class=c23><a class=c17 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>.</span></p><p class=c0><span class=c7>2. Übertragbarkeit</span></p><p class=c9><span class=c32>Sie haben das Recht, eine Kopie bestimmter personenbezogener Daten zu erhalten, die wir über Sie verarbeiten. Dies beinhaltet alle personenbezogenen Daten, die wir auf der Grundlage Ihrer Zustimmung </span><span class=\"c25 c32\">(z. B. bestimmte Umfragedaten) oder gemäß unseres Vertrags mit Ihnen, wie es im Abschnitt „</span><span class=\"c19 c25 c53\">Wie wir Ihre personenbezogenen Daten verwenden</span><span class=c1>“ beschrieben ist, verarbeiten. Sie haben das Recht, diese Daten in einem strukturierten, häufig verwendeten und maschinenlesbaren Format zu erhalten. Sie haben außerdem das Recht, zu verlangen, dass wir Ihre personenbezogenen Daten an eine andere Partei übertragen.&nbsp;</span></p><p class=c9><span class=c1>Wenn Sie möchten, dass wir solche personenbezogenen Daten an eine dritte Partei übertragen, geben Sie diese Partei bitte in Ihrer Anfrage an. Beachten Sie bitte, dass wir dies nur tun können, wenn dies technisch möglich ist. Bitte beachten Sie, dass wir Ihnen unter Umständen keine personenbezogenen Daten aushändigen können, falls dies mit den Rechten einer anderen Person kollidiert (d. h. falls die personenbezogenen Daten, die wir von Ihnen aufbewahren, die Daten einer anderen Person oder unsere Geschäftsgeheimnisse oder geistiges Eigentum preisgeben würden).</span></p><p class=c0><span class=c7>3. Korrektur</span></p><p class=\"c13 c10\"><span class=c32>Sie haben das Recht, personenbezogene Daten, die über Sie aufbewahrt werden, zu korrigieren, falls diese unzutreffend sind. Sie können auf diese personenbezogenen Daten zugreifen, die Sie im Rahmen Ihres Kontos verfügbar gemacht haben, indem Sie sich bei Ihrem Spielkonto anmelden. Sollten Sie annehmen, dass wir sonstige personenbezogene Daten über Sie aufbewahren und dass diese Daten fehlerhaft sind, schreiben Sie uns bitte eine E-Mail an support@tap</span><span class=c23><a class=c17 href=mailto:support@tap4fun.com>4fun.com</a></span><span class=\"c32 c25\">.</span></p><p class=c0><span class=c7>4. Löschung</span></p><p class=\"c13 c10\"><span class=c32>Sie können Ihr Konto oder bestimmte personenbezogene Daten löschen, indem Sie sich bei Ihrem Spielkonto anmelden. Sollten dort weitere personenbezogene Daten vorhanden sein, von denen Sie annehmen, dass wir sie verarbeiten, und die Sie löschen möchten, schreiben Sie uns bitte eine E-Mail an </span><span class=c23><a class=c17 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c32>.</span><span class=\"c32 c25\">.</span></p><p class=\"c13 c44 c10\"><span class=c1></span></p><p class=\"c10 c13\"><span class=c1>Sie können unter den folgenden Umständen anfordern, dass wir die personenbezogenen Daten löschen:</span></p><ul class=\"c39 lst-kix_list_23-0\"><li class=c2><span class=c1>Sie sind der Meinung, dass es nicht länger notwendig für uns ist, dass wir diese personenbezogenen Daten von Ihnen aufbewahren; oder</span></li><li class=c2><span class=c1>Sie sind der Meinung, dass die personenbezogenen Daten, die wir von Ihnen aufbewahren, von uns unrechtmäßig verarbeitet werden.&nbsp;</span></li></ul><p class=\"c20 c34\"><span class=c1></span></p><p class=\"c13 c10\"><span class=c1>Sie können außerdem Ihr Recht geltend machen, unsere Verarbeitung Ihrer personenbezogenen Daten einzuschränken (wie im Folgenden beschrieben), während wir Ihre Anfrage prüfen.&nbsp;</span></p><p class=\"c13 c44 c10\"><span class=c1></span></p><p class=\"c13 c10\"><span class=c1>Unter Umständen müssen wir Ihre personenbezogenen Daten aufbewahren, falls nach den Datenschutzgesetzen berechtigte Gründe für uns bestehen, dies zu tun (z. B. zur Verteidigung gegen rechtliche Forderungen oder zur freien Meinungsäußerung), allerdings werden wir Sie informieren, falls dies der Fall sein sollte. In Fällen, in denen Sie angefragt haben, dass wir personenbezogene Daten löschen, die in den Spieldiensten öffentlich gemacht wurden und für die Löschungsgründe bestehen, werden wir angemessene Schritte unternehmen, um zu versuchen, andere, die diese personenbezogenen Daten anzeigen oder Links zu ihnen bereitstellen, aufzufordern, sie ebenfalls zu löschen.</span></p><p class=c0><span class=c7>5. Einschränkung der Verarbeitung auf ausschließliche Speicherung</span></p><p class=\"c13 c10\"><span class=c1>Sie haben das Recht, von uns zu verlangen, dass wir die Verarbeitung der personenbezogenen Daten, die wir über Sie aufbewahren, für andere Zwecke als für die Speicherung unter bestimmten Umständen einstellen. Bitte beachten Sie jedoch, dass, wenn wir die Verarbeitung personenbezogener Daten einstellen, wir sie erneut verwenden könnten, falls nach den Datenschutzgesetzen gültige Gründe für uns vorliegen, dies zu tun (z. B. zur Verteidigung gegen rechtliche Forderungen oder zum Schutz eines anderen). Wie oben erwähnt, werden wir, in Fällen, in denen wir der Beendigung der Verarbeitung personenbezogener Informationen zustimmen, versuchen, dritte Parteien zu informieren, denen wir die relevanten personenbezogenen Daten offengelegt haben, damit diese ebenfalls die Verarbeitung dieser Daten einstellen können.&nbsp;</span></p><p class=\"c13 c10\"><span class=c1>Sie können von uns verlangen, dass wir die Verarbeitung der personenbezogenen Daten, die wir über Sie aufbewahren, einstellen und diese lediglich speichern, falls:&nbsp;</span></p><ul class=\"c39 lst-kix_list_23-0\"><li class=c2><span class=c1>Sie annehmen, dass die personenbezogenen Daten nicht korrekt sind, für den Zeitraum, den wir benötigen, um die Korrektheit der Informationen zu verifizieren.</span></li><li class=c2><span class=c1>Sie möchten, dass wir die personenbezogenen Daten löschen, da Sie annehmen, dass die Verarbeitung, die wir vornehmen, unrechtmäßig ist, Sie jedoch möchten, dass wir die personenbezogenen Daten behalten, sie jedoch nur speichern; oder&nbsp;</span></li><li class=c2><span class=c1>Sie die personenbezogenen Daten löschen möchten, da sie für unsere Zwecke nicht länger erforderlich sind, Sie jedoch die Aufbewahrung für die Begründung, Geltendmachung oder Verteidigung von Rechtsansprüchen benötigen.</span></li></ul><p class=c0><span class=c7>6. Einwand</span></p><p class=\"c13 c10\"><span class=c32>Sie haben das Recht, einen Einwand gegen unsere Verarbeitung der personenbezogenen Daten über Sie zu erheben. Wir werden Ihre Anfrage unter anderen Umständen als den im Folgenden beschriebenen berücksichtigen, wenn Sie uns eine E-Mail an </span><span class=c23><a class=c17 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>&nbsp;schreiben.&nbsp;.</span></p><p class=c0><span class=c7>7. Ankündigungen</span></p><p class=\"c13 c10\"><span class=c1>Wir werden Ihnen von Zeit zu Zeit Ankündigungen zusenden, wenn wir es für notwendig halten, dies zu tun (beispielsweise wenn wir den Spielzugang für Wartung zeitweilig unterbrechen oder für Nachrichten bezüglich Sicherheit, Datenschutz oder Administration). Sie können diese dienstleistungsbezogenen Ankündigungen, die keinen Werbecharakter haben, nicht ablehnen („Opt-out“).&nbsp;</span></p><p class=c24><span class=c16>ABSCHNITT 3：VERSCHIEDENES </span></p><p class=c0><span class=c6>1. Informationssicherheit</span></p><p class=\"c13 c10\"><span class=c1>Wir haben administrative, physische und technische Sicherheitsmaßnahmen implementiert, die dazu entwickelt wurden, Ihre Daten vor Verlust, Diebstahl, Missbrauch, unautorisiertem Zugriff, Offenlegung, Abänderung und Zerstörung zu schützen. Sie sollten jedoch verstehen, dass trotz unserer Anstrengungen keine Sicherheit als undurchdringlich garantiert werden kann.</span></p><p class=c0><span class=c6>2. Informationen über Kinder</span></p><p class=\"c13 c10\" id=h.gjdgxs><span class=c1>Wir erheben oder erbitten nicht bewusst personenbezogene Daten von Kindern unter 16 Jahren, wir richten keine interessenbasierte Werbung auf solche Kinder und erlauben es solchen Personen nicht, unsere Dienste zu verwenden. Falls Sie unter 16 Jahre alt sind, senden Sie bitte keine Informationen über sich selbst an uns, inklusive Ihres Namens, Ihrer Adresse, Telefonnummer oder E-Mail-Adresse. Niemand unter 16 Jahren darf personenbezogene Daten bereitstellen. Sollten wir erfahren, dass wir personenbezogene Daten von einem Kind erhoben haben, dass jünger als 16 Jahre ist, werden wir diese Informationen so schnell wie möglich löschen. Falls Sie vermuten, dass wir Informationen von einem oder über ein Kind unter 16 Jahren haben, kontaktieren Sie uns bitte.</span></p><p class=c0><span class=\"c19 c25\">3.</span><span class=c55>&nbsp;</span><span class=c6>Links zu Webseiten und Diensten, die von anderen betrieben werden</span></p><p class=\"c0 c10\"><span class=c1>Der Tap4Fun-Dienst kann Links zu anderen Webseiten, Anwendungen und Diensten beinhalten. Da Tap4Fun diese anderen Webseiten, Anwendungen und Dienste nicht betreibt, können wir keine Verantwortung für die Datenschutzpraktiken der Stellen übernehmen, die diese betreiben. Wir empfehlen, dass Sie Datenschutzrichtlinien immer wieder überprüfen, um die Praktiken eines Betreibers zu verstehen. Zur Erinnerung; diese Richtlinie beschreibt die Datenschutzpraktiken von Tap4Fun.</span></p><p class=c0><span class=c6>4. Änderungen</span></p><p class=\"c13 c10\"><span class=c1>Tap4Fun kann diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wenn wir sie aktualisieren, ändern wie das Datum der letzten Aktualisierung oben. Sollten wir substanzielle Änderungen daran vornehmen, wie wir Ihre personenbezogenen Daten erheben, verwenden, aufbewahren oder teilen, werden wir Sie benachrichtigen, indem wir Ihnen eine E-Mail an die letzte E-Mail-Adresse senden, die Sie uns gegeben haben, oder indem wir eine Bekanntgabe der Änderungen auf den Diensten posten, die von dieser Datenschutzrichtlinie abgedeckt sind.</span></p><p class=c0><span class=c6>4. Internationale Übertragung</span></p><p class=\"c0 c48\"><span class=c1>Wir können Daten, die wir über Sie erheben, an angeschlossene Unternehmen oder an andere Drittanbieter übertragen, die sich jenseits der Grenzen Ihres Landes oder Ihrer Jurisdiktion in einem anderen Land oder einer anderen Jurisdiktion auf der ganzen Welt befinden. Bitte beachten Sie, dass diese Länder und Jurisdiktionen unter Umständen nicht die gleichen Datenschutzgesetze haben wie Ihre eigene Jurisdiktion. Wir ergreifen Schritte, um sicherzustellen, dass ausreichend Schutzmaßnahmen vorhanden sind, um eine Übertragung von Daten und die Verwendung und Offenlegung von Daten über Sie, einschließlich personenbezogener Daten wie in dieser Datenschutzrichtlinie beschrieben, zu ermöglichen.</span></p><p class=c0><span class=c6>5. Kontakt und Beschwerden</span></p><p class=c9><span class=\"c32 c25\">Wir begrüßen Fragen, Kommentare und Anfragen bezüglich dieser Richtlinie. Bitte kontaktieren Sie uns per E-Mail an </span><span class=c23><a class=c17 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>, telefonisch unter der Nummer 0086-028-83313298 oder per Post an die Adresse Tap4Fun Co., Ltd, Attn: Privacy Administrator, Building A3, Tianfu software park, high-tech zone, Chengdu, Sichuan, China.</span></p><p class=\"c13 c10\"><span class=c1>Sollten Sie eine Beschwerde dazu vorbringen, wie wir Ihre personenbezogenen Daten verarbeiten, kontaktieren Sie uns bitte in erster Instanz per E-Mail an</span><span class=c46><a class=c17 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>, und wir werden versuchen, Ihre Anfrage so schnell wie möglich zu bearbeiten. Dies geschieht unbeschadet gegenüber Ihrem Recht, eine Beschwerde bei der Datenschutzbehörde in Ihrem Land einzureichen, in dem Sie leben oder arbeiten oder für das Sie eine Verletzung von Datenschutzgesetzen durch uns annehmen.</span></p><br></div><div ng-if=\"privacy.lang == \'es-419\'\"><style type=text/css>ol.lst-kix_list_7-0{list-style-type:none}.lst-kix_list_14-1>li:before{content:\"o  \"}.lst-kix_list_14-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-0.start{counter-reset:lst-ctn-kix_list_9-0 0}.lst-kix_list_14-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_14-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-6>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_9-1{list-style-type:none}ol.lst-kix_list_7-4.start{counter-reset:lst-ctn-kix_list_7-4 0}.lst-kix_list_9-0>li{counter-increment:lst-ctn-kix_list_9-0}ol.lst-kix_list_7-5{list-style-type:none}ol.lst-kix_list_7-6{list-style-type:none}ol.lst-kix_list_7-7{list-style-type:none}ol.lst-kix_list_7-8{list-style-type:none}ol.lst-kix_list_7-1{list-style-type:none}ol.lst-kix_list_11-8.start{counter-reset:lst-ctn-kix_list_11-8 0}ol.lst-kix_list_7-3{list-style-type:none}ol.lst-kix_list_7-4{list-style-type:none}.lst-kix_list_14-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-1{list-style-type:none}ul.lst-kix_list_17-0{list-style-type:none}ul.lst-kix_list_17-8{list-style-type:none}ul.lst-kix_list_17-7{list-style-type:none}ul.lst-kix_list_17-6{list-style-type:none}ul.lst-kix_list_17-5{list-style-type:none}ul.lst-kix_list_17-4{list-style-type:none}ul.lst-kix_list_17-3{list-style-type:none}.lst-kix_list_14-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-2{list-style-type:none}ol.lst-kix_list_8-8.start{counter-reset:lst-ctn-kix_list_8-8 0}ol.lst-kix_list_10-4.start{counter-reset:lst-ctn-kix_list_10-4 0}.lst-kix_list_5-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-0{list-style-type:none}.lst-kix_list_24-7>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_27-0{list-style-type:none}ul.lst-kix_list_27-1{list-style-type:none}.lst-kix_list_24-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_27-2{list-style-type:none}.lst-kix_list_5-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-5.start{counter-reset:lst-ctn-kix_list_9-5 0}.lst-kix_list_5-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-3>li{counter-increment:lst-ctn-kix_list_8-3}.lst-kix_list_5-1>li:before{content:\"o  \"}.lst-kix_list_24-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_5-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_24-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_24-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_9-4>li{counter-increment:lst-ctn-kix_list_9-4}ol.lst-kix_list_6-6{list-style-type:none}ul.lst-kix_list_27-3{list-style-type:none}.lst-kix_list_24-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_6-7{list-style-type:none}ul.lst-kix_list_27-4{list-style-type:none}.lst-kix_list_5-4>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-8{list-style-type:none}ul.lst-kix_list_27-5{list-style-type:none}ul.lst-kix_list_27-6{list-style-type:none}.lst-kix_list_5-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-2{list-style-type:none}ul.lst-kix_list_27-7{list-style-type:none}ol.lst-kix_list_6-3{list-style-type:none}ul.lst-kix_list_27-8{list-style-type:none}ol.lst-kix_list_6-4{list-style-type:none}.lst-kix_list_24-6>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-5{list-style-type:none}.lst-kix_list_23-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_6-1>li:before{content:\"o  \"}.lst-kix_list_6-3>li:before{content:\"\" counter(lst-ctn-kix_list_6-3,decimal) \". \"}.lst-kix_list_6-5>li{counter-increment:lst-ctn-kix_list_6-5}.lst-kix_list_6-8>li{counter-increment:lst-ctn-kix_list_6-8}.lst-kix_list_23-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-0>li:before{content:\"\" counter(lst-ctn-kix_list_6-0,decimal) \". \"}.lst-kix_list_6-4>li:before{content:\"\" counter(lst-ctn-kix_list_6-4,decimal) \". \"}.lst-kix_list_23-2>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_16-2{list-style-type:none}ul.lst-kix_list_16-1{list-style-type:none}ul.lst-kix_list_16-0{list-style-type:none}.lst-kix_list_23-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_23-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-2>li:before{content:\"\" counter(lst-ctn-kix_list_6-2,decimal) \". \"}.lst-kix_list_24-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_16-8{list-style-type:none}ul.lst-kix_list_16-7{list-style-type:none}ul.lst-kix_list_16-6{list-style-type:none}ul.lst-kix_list_16-5{list-style-type:none}.lst-kix_list_24-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_16-4{list-style-type:none}.lst-kix_list_6-8>li:before{content:\"\" counter(lst-ctn-kix_list_6-8,decimal) \". \"}ul.lst-kix_list_16-3{list-style-type:none}.lst-kix_list_6-5>li:before{content:\"\" counter(lst-ctn-kix_list_6-5,decimal) \". \"}.lst-kix_list_6-7>li:before{content:\"\" counter(lst-ctn-kix_list_6-7,decimal) \". \"}.lst-kix_list_23-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_23-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_6-6>li:before{content:\"\" counter(lst-ctn-kix_list_6-6,decimal) \". \"}ol.lst-kix_list_10-6.start{counter-reset:lst-ctn-kix_list_10-6 0}.lst-kix_list_7-4>li:before{content:\"\" counter(lst-ctn-kix_list_7-4,upper-roman) \". \"}.lst-kix_list_7-6>li:before{content:\"\" counter(lst-ctn-kix_list_7-6,upper-roman) \". \"}ol.lst-kix_list_6-2.start{counter-reset:lst-ctn-kix_list_6-2 0}.lst-kix_list_22-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_22-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-6>li{counter-increment:lst-ctn-kix_list_7-6}.lst-kix_list_8-6>li{counter-increment:lst-ctn-kix_list_8-6}.lst-kix_list_22-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-7{list-style-type:none}ol.lst-kix_list_9-8{list-style-type:none}.lst-kix_list_13-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-3{list-style-type:none}ol.lst-kix_list_9-4{list-style-type:none}ol.lst-kix_list_9-5{list-style-type:none}.lst-kix_list_7-8>li:before{content:\"\" counter(lst-ctn-kix_list_7-8,upper-roman) \". \"}ol.lst-kix_list_9-6{list-style-type:none}ol.lst-kix_list_9-0{list-style-type:none}ol.lst-kix_list_9-2{list-style-type:none}.lst-kix_list_22-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-8>li{counter-increment:lst-ctn-kix_list_9-8}.lst-kix_list_4-1>li:before{content:\"o  \"}.lst-kix_list_15-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-7{list-style-type:none}ul.lst-kix_list_19-6{list-style-type:none}.lst-kix_list_4-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-5{list-style-type:none}ul.lst-kix_list_19-4{list-style-type:none}ul.lst-kix_list_19-3{list-style-type:none}.lst-kix_list_25-5>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_19-2{list-style-type:none}ul.lst-kix_list_19-1{list-style-type:none}.lst-kix_list_10-5>li{counter-increment:lst-ctn-kix_list_10-5}ul.lst-kix_list_19-0{list-style-type:none}.lst-kix_list_15-1>li:before{content:\"o  \"}.lst-kix_list_25-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_15-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-8{list-style-type:none}.lst-kix_list_6-4>li{counter-increment:lst-ctn-kix_list_6-4}ol.lst-kix_list_9-2.start{counter-reset:lst-ctn-kix_list_9-2 0}.lst-kix_list_9-3>li{counter-increment:lst-ctn-kix_list_9-3}.lst-kix_list_11-2>li{counter-increment:lst-ctn-kix_list_11-2}ol.lst-kix_list_8-8{list-style-type:none}.lst-kix_list_12-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-6.start{counter-reset:lst-ctn-kix_list_7-6 0}ol.lst-kix_list_8-4{list-style-type:none}.lst-kix_list_12-1>li:before{content:\"o  \"}ol.lst-kix_list_8-5{list-style-type:none}ol.lst-kix_list_8-6{list-style-type:none}ol.lst-kix_list_8-7{list-style-type:none}ol.lst-kix_list_8-0{list-style-type:none}ol.lst-kix_list_8-1{list-style-type:none}ol.lst-kix_list_8-2{list-style-type:none}ol.lst-kix_list_8-3{list-style-type:none}.lst-kix_list_10-4>li{counter-increment:lst-ctn-kix_list_10-4}.lst-kix_list_13-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-0{list-style-type:none}.lst-kix_list_13-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-8{list-style-type:none}ul.lst-kix_list_18-7{list-style-type:none}ul.lst-kix_list_18-6{list-style-type:none}ul.lst-kix_list_18-5{list-style-type:none}.lst-kix_list_12-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-4{list-style-type:none}ul.lst-kix_list_18-3{list-style-type:none}ul.lst-kix_list_18-2{list-style-type:none}ol.lst-kix_list_6-0.start{counter-reset:lst-ctn-kix_list_6-0 0}ul.lst-kix_list_18-1{list-style-type:none}.lst-kix_list_13-1>li:before{content:\"o  \"}ul.lst-kix_list_24-0{list-style-type:none}ul.lst-kix_list_24-1{list-style-type:none}ul.lst-kix_list_24-2{list-style-type:none}ul.lst-kix_list_24-3{list-style-type:none}ul.lst-kix_list_24-4{list-style-type:none}ul.lst-kix_list_24-5{list-style-type:none}ol.lst-kix_list_11-6{list-style-type:none}ol.lst-kix_list_11-7{list-style-type:none}ol.lst-kix_list_11-8{list-style-type:none}.lst-kix_list_7-1>li{counter-increment:lst-ctn-kix_list_7-1}ol.lst-kix_list_11-2{list-style-type:none}ol.lst-kix_list_11-3{list-style-type:none}.lst-kix_list_3-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_11-4{list-style-type:none}ol.lst-kix_list_11-5{list-style-type:none}ul.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_5-8{list-style-type:none}ul.lst-kix_list_5-5{list-style-type:none}ol.lst-kix_list_11-0{list-style-type:none}ul.lst-kix_list_5-6{list-style-type:none}.lst-kix_list_21-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_8-0>li{counter-increment:lst-ctn-kix_list_8-0}ul.lst-kix_list_24-6{list-style-type:none}ul.lst-kix_list_5-0{list-style-type:none}ul.lst-kix_list_24-7{list-style-type:none}.lst-kix_list_10-0>li{counter-increment:lst-ctn-kix_list_10-0}.lst-kix_list_3-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_24-8{list-style-type:none}ul.lst-kix_list_5-3{list-style-type:none}.lst-kix_list_3-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_5-4{list-style-type:none}.lst-kix_list_26-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_5-1{list-style-type:none}.lst-kix_list_8-0>li:before{content:\"\" counter(lst-ctn-kix_list_8-0,upper-roman) \". \"}ul.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_8-7>li:before{content:\"\" counter(lst-ctn-kix_list_8-7,upper-roman) \". \"}.lst-kix_list_3-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_10-7.start{counter-reset:lst-ctn-kix_list_10-7 0}.lst-kix_list_26-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_21-1>li:before{content:\"o  \"}.lst-kix_list_8-3>li:before{content:\"\" counter(lst-ctn-kix_list_8-3,upper-roman) \". \"}ul.lst-kix_list_13-5{list-style-type:none}ul.lst-kix_list_13-4{list-style-type:none}ul.lst-kix_list_13-3{list-style-type:none}ul.lst-kix_list_13-2{list-style-type:none}ul.lst-kix_list_13-1{list-style-type:none}.lst-kix_list_3-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_13-0{list-style-type:none}.lst-kix_list_26-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li:before{content:\"\" counter(lst-ctn-kix_list_8-4,upper-roman) \". \"}.lst-kix_list_10-2>li{counter-increment:lst-ctn-kix_list_10-2}ol.lst-kix_list_8-5.start{counter-reset:lst-ctn-kix_list_8-5 0}ul.lst-kix_list_13-8{list-style-type:none}.lst-kix_list_11-1>li:before{content:\"o  \"}ul.lst-kix_list_13-7{list-style-type:none}ul.lst-kix_list_13-6{list-style-type:none}.lst-kix_list_21-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-0>li:before{content:\"\" counter(lst-ctn-kix_list_11-0,decimal) \". \"}ol.lst-kix_list_9-3.start{counter-reset:lst-ctn-kix_list_9-3 0}.lst-kix_list_26-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_8-8>li:before{content:\"\" counter(lst-ctn-kix_list_8-8,upper-roman) \". \"}.lst-kix_list_16-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-0{list-style-type:none}ul.lst-kix_list_23-1{list-style-type:none}.lst-kix_list_16-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-2{list-style-type:none}ul.lst-kix_list_23-3{list-style-type:none}ul.lst-kix_list_23-4{list-style-type:none}ul.lst-kix_list_23-5{list-style-type:none}ul.lst-kix_list_23-6{list-style-type:none}.lst-kix_list_4-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-8{list-style-type:none}.lst-kix_list_16-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-6{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}.lst-kix_list_25-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li{counter-increment:lst-ctn-kix_list_8-4}ul.lst-kix_list_4-0{list-style-type:none}ul.lst-kix_list_23-7{list-style-type:none}.lst-kix_list_25-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_23-8{list-style-type:none}ol.lst-kix_list_10-8.start{counter-reset:lst-ctn-kix_list_10-8 0}.lst-kix_list_16-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-4{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}.lst-kix_list_11-3>li{counter-increment:lst-ctn-kix_list_11-3}ol.lst-kix_list_7-1.start{counter-reset:lst-ctn-kix_list_7-1 0}ul.lst-kix_list_12-6{list-style-type:none}ol.lst-kix_list_8-6.start{counter-reset:lst-ctn-kix_list_8-6 0}ul.lst-kix_list_12-5{list-style-type:none}.lst-kix_list_17-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-4{list-style-type:none}ul.lst-kix_list_12-3{list-style-type:none}ul.lst-kix_list_12-2{list-style-type:none}ul.lst-kix_list_12-1{list-style-type:none}.lst-kix_list_17-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-0{list-style-type:none}.lst-kix_list_17-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-8{list-style-type:none}ul.lst-kix_list_12-7{list-style-type:none}ol.lst-kix_list_8-0.start{counter-reset:lst-ctn-kix_list_8-0 0}.lst-kix_list_7-0>li:before{content:\"\" counter(lst-ctn-kix_list_7-0,upper-roman) \". \"}ol.lst-kix_list_9-7.start{counter-reset:lst-ctn-kix_list_9-7 0}.lst-kix_list_22-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_2-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-1{list-style-type:none}ul.lst-kix_list_26-2{list-style-type:none}ul.lst-kix_list_26-3{list-style-type:none}.lst-kix_list_22-1>li:before{content:\"o  \"}.lst-kix_list_27-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-6>li{counter-increment:lst-ctn-kix_list_6-6}.lst-kix_list_7-3>li:before{content:\"\" counter(lst-ctn-kix_list_7-3,upper-roman) \". \"}.lst-kix_list_10-0>li:before{content:\"\" counter(lst-ctn-kix_list_10-0,decimal) \". \"}.lst-kix_list_9-7>li{counter-increment:lst-ctn-kix_list_9-7}.lst-kix_list_13-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-4{list-style-type:none}ul.lst-kix_list_26-5{list-style-type:none}ul.lst-kix_list_26-6{list-style-type:none}ul.lst-kix_list_26-7{list-style-type:none}.lst-kix_list_8-7>li{counter-increment:lst-ctn-kix_list_8-7}ul.lst-kix_list_26-8{list-style-type:none}ul.lst-kix_list_7-2{list-style-type:none}.lst-kix_list_27-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_7-7>li:before{content:\"\" counter(lst-ctn-kix_list_7-7,upper-roman) \". \"}ol.lst-kix_list_8-1.start{counter-reset:lst-ctn-kix_list_8-1 0}.lst-kix_list_15-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-5>li{counter-increment:lst-ctn-kix_list_9-5}.lst-kix_list_10-4>li:before{content:\"\" counter(lst-ctn-kix_list_10-4,decimal) \". \"}.lst-kix_list_10-8>li:before{content:\"\" counter(lst-ctn-kix_list_10-8,decimal) \". \"}.lst-kix_list_4-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-3{list-style-type:none}ul.lst-kix_list_15-2{list-style-type:none}.lst-kix_list_15-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-1{list-style-type:none}.lst-kix_list_15-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_15-0{list-style-type:none}.lst-kix_list_4-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_25-4>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_15-8{list-style-type:none}ul.lst-kix_list_15-7{list-style-type:none}ul.lst-kix_list_15-6{list-style-type:none}.lst-kix_list_9-3>li:before{content:\"\" counter(lst-ctn-kix_list_9-3,decimal) \". \"}ul.lst-kix_list_15-5{list-style-type:none}ul.lst-kix_list_15-4{list-style-type:none}ol.lst-kix_list_7-0.start{counter-reset:lst-ctn-kix_list_7-0 0}.lst-kix_list_25-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_25-0{list-style-type:none}ul.lst-kix_list_25-1{list-style-type:none}ul.lst-kix_list_25-2{list-style-type:none}.lst-kix_list_9-7>li:before{content:\"\" counter(lst-ctn-kix_list_9-7,decimal) \". \"}ul.lst-kix_list_25-3{list-style-type:none}ul.lst-kix_list_25-4{list-style-type:none}.lst-kix_list_11-4>li:before{content:\"\" counter(lst-ctn-kix_list_11-4,decimal) \". \"}.lst-kix_list_12-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_20-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-4>li{counter-increment:lst-ctn-kix_list_7-4}ul.lst-kix_list_25-5{list-style-type:none}.lst-kix_list_1-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_25-6{list-style-type:none}.lst-kix_list_20-1>li:before{content:\"o  \"}ul.lst-kix_list_25-7{list-style-type:none}ul.lst-kix_list_25-8{list-style-type:none}.lst-kix_list_11-8>li:before{content:\"\" counter(lst-ctn-kix_list_11-8,decimal) \". \"}.lst-kix_list_12-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_6-1{list-style-type:none}ol.lst-kix_list_8-4.start{counter-reset:lst-ctn-kix_list_8-4 0}.lst-kix_list_1-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_14-4{list-style-type:none}ul.lst-kix_list_14-3{list-style-type:none}ul.lst-kix_list_14-2{list-style-type:none}.lst-kix_list_13-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_14-1{list-style-type:none}ul.lst-kix_list_14-0{list-style-type:none}.lst-kix_list_10-7>li{counter-increment:lst-ctn-kix_list_10-7}ul.lst-kix_list_14-8{list-style-type:none}ul.lst-kix_list_14-7{list-style-type:none}.lst-kix_list_2-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_8-3.start{counter-reset:lst-ctn-kix_list_8-3 0}ul.lst-kix_list_14-6{list-style-type:none}.lst-kix_list_11-5>li{counter-increment:lst-ctn-kix_list_11-5}ul.lst-kix_list_14-5{list-style-type:none}ol.lst-kix_list_9-8.start{counter-reset:lst-ctn-kix_list_9-8 0}.lst-kix_list_1-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_12-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-2>li{counter-increment:lst-ctn-kix_list_8-2}ul.lst-kix_list_20-2{list-style-type:none}ul.lst-kix_list_20-3{list-style-type:none}.lst-kix_list_19-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_19-1>li:before{content:\"o  \"}ul.lst-kix_list_20-4{list-style-type:none}ul.lst-kix_list_20-5{list-style-type:none}ul.lst-kix_list_20-6{list-style-type:none}ul.lst-kix_list_1-0{list-style-type:none}ul.lst-kix_list_20-7{list-style-type:none}ul.lst-kix_list_20-8{list-style-type:none}.lst-kix_list_19-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-1>li{counter-increment:lst-ctn-kix_list_8-1}ol.lst-kix_list_8-2.start{counter-reset:lst-ctn-kix_list_8-2 0}.lst-kix_list_19-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_20-0{list-style-type:none}ul.lst-kix_list_20-1{list-style-type:none}ol.lst-kix_list_6-6.start{counter-reset:lst-ctn-kix_list_6-6 0}.lst-kix_list_7-0>li{counter-increment:lst-ctn-kix_list_7-0}.lst-kix_list_11-0>li{counter-increment:lst-ctn-kix_list_11-0}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}ul.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_9-6.start{counter-reset:lst-ctn-kix_list_9-6 0}.lst-kix_list_19-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-2.start{counter-reset:lst-ctn-kix_list_11-2 0}.lst-kix_list_19-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-2>li{counter-increment:lst-ctn-kix_list_9-2}ol.lst-kix_list_8-7.start{counter-reset:lst-ctn-kix_list_8-7 0}.lst-kix_list_10-3>li{counter-increment:lst-ctn-kix_list_10-3}.lst-kix_list_18-0>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-1>li:before{content:\"o  \"}.lst-kix_list_18-2>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-7.start{counter-reset:lst-ctn-kix_list_11-7 0}ul.lst-kix_list_22-0{list-style-type:none}.lst-kix_list_2-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_22-1{list-style-type:none}ul.lst-kix_list_22-2{list-style-type:none}ul.lst-kix_list_22-3{list-style-type:none}ul.lst-kix_list_22-4{list-style-type:none}.lst-kix_list_2-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-3>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_22-5{list-style-type:none}ul.lst-kix_list_22-6{list-style-type:none}ul.lst-kix_list_22-7{list-style-type:none}.lst-kix_list_27-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_10-3.start{counter-reset:lst-ctn-kix_list_10-3 0}.lst-kix_list_18-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-4.start{counter-reset:lst-ctn-kix_list_9-4 0}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_list_10-1>li:before{content:\"o  \"}.lst-kix_list_18-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_3-1{list-style-type:none}ul.lst-kix_list_22-8{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_7-7>li{counter-increment:lst-ctn-kix_list_7-7}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_10-7>li:before{content:\"\" counter(lst-ctn-kix_list_10-7,decimal) \". \"}.lst-kix_list_7-8>li{counter-increment:lst-ctn-kix_list_7-8}.lst-kix_list_10-5>li:before{content:\"\" counter(lst-ctn-kix_list_10-5,decimal) \". \"}.lst-kix_list_10-3>li:before{content:\"\" counter(lst-ctn-kix_list_10-3,decimal) \". \"}ol.lst-kix_list_7-3.start{counter-reset:lst-ctn-kix_list_7-3 0}ul.lst-kix_list_11-1{list-style-type:none}.lst-kix_list_11-7>li{counter-increment:lst-ctn-kix_list_11-7}.lst-kix_list_9-2>li:before{content:\"\" counter(lst-ctn-kix_list_9-2,decimal) \". \"}.lst-kix_list_20-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-0>li:before{content:\"\" counter(lst-ctn-kix_list_9-0,decimal) \". \"}ul.lst-kix_list_21-1{list-style-type:none}ul.lst-kix_list_21-2{list-style-type:none}ul.lst-kix_list_21-3{list-style-type:none}ul.lst-kix_list_21-4{list-style-type:none}.lst-kix_list_20-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_21-5{list-style-type:none}ul.lst-kix_list_21-6{list-style-type:none}ul.lst-kix_list_21-7{list-style-type:none}ul.lst-kix_list_21-8{list-style-type:none}ol.lst-kix_list_10-7{list-style-type:none}.lst-kix_list_9-6>li:before{content:\"\" counter(lst-ctn-kix_list_9-6,decimal) \". \"}ol.lst-kix_list_10-8{list-style-type:none}ol.lst-kix_list_10-3{list-style-type:none}.lst-kix_list_9-4>li:before{content:\"\" counter(lst-ctn-kix_list_9-4,decimal) \". \"}ol.lst-kix_list_10-4{list-style-type:none}ol.lst-kix_list_10-5{list-style-type:none}.lst-kix_list_11-3>li:before{content:\"\" counter(lst-ctn-kix_list_11-3,decimal) \". \"}ol.lst-kix_list_10-6{list-style-type:none}ul.lst-kix_list_21-0{list-style-type:none}.lst-kix_list_6-3>li{counter-increment:lst-ctn-kix_list_6-3}.lst-kix_list_20-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-0{list-style-type:none}ul.lst-kix_list_2-8{list-style-type:none}ol.lst-kix_list_10-2{list-style-type:none}.lst-kix_list_20-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-5>li:before{content:\"\" counter(lst-ctn-kix_list_11-5,decimal) \". \"}ul.lst-kix_list_2-2{list-style-type:none}.lst-kix_list_20-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_9-8>li:before{content:\"\" counter(lst-ctn-kix_list_9-8,decimal) \". \"}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:\"o  \"}ul.lst-kix_list_2-7{list-style-type:none}.lst-kix_list_11-7>li:before{content:\"\" counter(lst-ctn-kix_list_11-7,decimal) \". \"}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_8-5>li{counter-increment:lst-ctn-kix_list_8-5}.lst-kix_list_1-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-5.start{counter-reset:lst-ctn-kix_list_10-5 0}.lst-kix_list_1-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_1-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_10-1{list-style-type:none}ol.lst-kix_list_7-5.start{counter-reset:lst-ctn-kix_list_7-5 0}.lst-kix_list_2-1>li:before{content:\"o  \"}.lst-kix_list_27-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_2-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-8>li{counter-increment:lst-ctn-kix_list_11-8}ol.lst-kix_list_7-7.start{counter-reset:lst-ctn-kix_list_7-7 0}.lst-kix_list_3-1>li:before{content:\"o  \"}.lst-kix_list_3-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_26-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-1>li:before{content:\"\" counter(lst-ctn-kix_list_8-1,upper-roman) \". \"}.lst-kix_list_8-2>li:before{content:\"\" counter(lst-ctn-kix_list_8-2,upper-roman) \". \"}.lst-kix_list_6-0>li{counter-increment:lst-ctn-kix_list_6-0}.lst-kix_list_3-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-5.start{counter-reset:lst-ctn-kix_list_11-5 0}.lst-kix_list_21-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-5>li:before{content:\"\" counter(lst-ctn-kix_list_8-5,upper-roman) \". \"}.lst-kix_list_8-6>li:before{content:\"\" counter(lst-ctn-kix_list_8-6,upper-roman) \". \"}.lst-kix_list_26-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_26-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_3-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-2>li:before{content:\"\" counter(lst-ctn-kix_list_11-2,decimal) \". \"}.lst-kix_list_21-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-6.start{counter-reset:lst-ctn-kix_list_11-6 0}.lst-kix_list_16-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-4.start{counter-reset:lst-ctn-kix_list_6-4 0}.lst-kix_list_25-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_17-1>li:before{content:\"o  \"}.lst-kix_list_25-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-1>li:before{content:\"o  \"}.lst-kix_list_7-3>li{counter-increment:lst-ctn-kix_list_7-3}.lst-kix_list_16-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_16-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-8.start{counter-reset:lst-ctn-kix_list_7-8 0}ol.lst-kix_list_11-0.start{counter-reset:lst-ctn-kix_list_11-0 0}ol.lst-kix_list_6-3.start{counter-reset:lst-ctn-kix_list_6-3 0}ol.lst-kix_list_10-2.start{counter-reset:lst-ctn-kix_list_10-2 0}.lst-kix_list_17-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-2>li{counter-increment:lst-ctn-kix_list_6-2}.lst-kix_list_2-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_22-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-1>li:before{content:\"\" counter(lst-ctn-kix_list_7-1,decimal) \". \"}.lst-kix_list_7-5>li:before{content:\"\" counter(lst-ctn-kix_list_7-5,upper-roman) \". \"}.lst-kix_list_9-6>li{counter-increment:lst-ctn-kix_list_9-6}.lst-kix_list_27-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-7>li{counter-increment:lst-ctn-kix_list_6-7}.lst-kix_list_10-6>li{counter-increment:lst-ctn-kix_list_10-6}.lst-kix_list_11-6>li{counter-increment:lst-ctn-kix_list_11-6}ol.lst-kix_list_10-0.start{counter-reset:lst-ctn-kix_list_10-0 0}.lst-kix_list_7-5>li{counter-increment:lst-ctn-kix_list_7-5}.lst-kix_list_15-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-4>li{counter-increment:lst-ctn-kix_list_11-4}ol.lst-kix_list_6-8.start{counter-reset:lst-ctn-kix_list_6-8 0}.lst-kix_list_10-2>li:before{content:\"\" counter(lst-ctn-kix_list_10-2,decimal) \". \"}.lst-kix_list_20-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-5.start{counter-reset:lst-ctn-kix_list_6-5 0}.lst-kix_list_4-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_10-8>li{counter-increment:lst-ctn-kix_list_10-8}.lst-kix_list_25-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_10-6>li:before{content:\"\" counter(lst-ctn-kix_list_10-6,decimal) \". \"}.lst-kix_list_9-1>li:before{content:\"o  \"}ol.lst-kix_list_6-7.start{counter-reset:lst-ctn-kix_list_6-7 0}.lst-kix_list_9-5>li:before{content:\"\" counter(lst-ctn-kix_list_9-5,decimal) \". \"}.lst-kix_list_12-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-6>li:before{content:\"\" counter(lst-ctn-kix_list_11-6,decimal) \". \"}.lst-kix_list_20-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-3.start{counter-reset:lst-ctn-kix_list_11-3 0}.lst-kix_list_1-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-8>li{counter-increment:lst-ctn-kix_list_8-8}.lst-kix_list_1-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-4.start{counter-reset:lst-ctn-kix_list_11-4 0}.lst-kix_list_2-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-2>li:before{content:\"\\0025aa  \"}ol{margin:0;padding:0}table td,table th{padding:0}.c3{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:137.2pt;border-top-color:#000000;border-bottom-style:solid}.c24{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:280.1pt;border-top-color:#000000;border-bottom-style:solid}.c19{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:157.8pt;border-top-color:#000000;border-bottom-style:solid}.c17{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:291.1pt;border-top-color:#000000;border-bottom-style:solid}.c5{margin-left:18pt;padding-top:0pt;padding-left:-3.8pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c0{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c4{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:8pt;font-family:\"Arial\";font-style:normal}.c50{padding-top:0pt;text-indent:24pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:center}.c8{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"\\007b49\\007ebf\";font-style:normal}.c2{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c9{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:\"Arial\";font-style:normal}.c12{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-family:\"Arial\";font-style:italic}.c1{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c6{padding-top:6pt;padding-bottom:6pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c7{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c34{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c27{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c15{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-indent:20pt;text-align:justify}.c30{font-size:11pt;font-family:\"Arial\";color:#212121;font-weight:700}.c44{text-decoration:none;vertical-align:baseline;font-size:12pt;font-style:normal}.c23{text-decoration:none;vertical-align:baseline;font-size:9pt;font-style:normal}.c31{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c40{padding-top:12pt;padding-bottom:12pt;line-height:1.0;text-align:justify}.c37{-webkit-text-decoration-skip:none;color:#0000ff;text-decoration:underline;text-decoration-skip-ink:none}.c38{color:#777777;text-decoration:none;vertical-align:baseline;font-style:normal}.c32{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c52{font-weight:400;vertical-align:baseline;font-family:\"\\007b49\\007ebf\";font-style:normal}.c14{font-family:\"Arial\";color:#000000;font-weight:400}.c42{background-color:#ffffff;padding:72pt 16pt 72pt 16pt;margin:auto;}.c21{font-family:\"Arial\";color:#000000;font-weight:700}.c46{text-decoration:none;vertical-align:baseline;font-style:normal}.c13{padding:0;margin:0}.c10{color:inherit;text-decoration:inherit}.c20{font-family:\"Arial\";font-weight:400}.c33{font-family:\"Arial\";font-weight:700}.c43{text-indent:25pt}.c54{height:44pt}.c47{height:14pt}.c35{text-indent:18pt}.c36{height:45pt}.c39{height:29pt}.c16{height:10pt}.c11{font-size:10pt}.c18{height:22pt}.c28{text-indent:20pt}.c22{font-size:8pt}.c55{height:19pt}.c41{height:20pt}.c29{height:18pt}.c45{height:59pt}.c25{height:6pt}.c26{font-style:italic}.c51{margin-left:14.2pt}.c48{height:74pt}.c49{font-size:11pt}.c53{height:103pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:\"Georgia\";line-height:1.0;page-break-after:avoid;font-style:italic;text-align:justify}li{color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}p{margin:0;color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h2{padding-top:5pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h3{padding-top:5pt;color:#000000;font-weight:700;font-size:13.5pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h4{padding-top:5pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}</style><p class=c50><span class=\"c21 c44\">Política de privacidad </span></p><p class=\"c34 c28\"><span class=c0>Última actualización: 05/2018</span></p><p class=\"c34 c28\"><span class=\"c11 c33\">Usted reconoce que ha leído y comprendido esta política de privacidad. Si no está de acuerdo con la política de privacidad, no debe usar los servicios de Tap4Fun. Si cambia de opinión en el futuro, puede retirar su consentimiento con respecto al uso de su información personal de conformidad con esta política.</span></p><p class=c15><span class=c0>En Tap4Fun, sabemos que la privacidad es muy importante para usted, así que le rogamos que se tome un momento para leer con atención nuestra política de privacidad. Nuestra política está diseñada para ayudarlo a comprender lo siguiente:</span></p><p class=c15><span class=c2>1、Qué información recopilamos sobre usted;</span></p><p class=c15><span class=c2>2、Cómo utilizaremos su información;</span></p><p class=c15><span class=c2>3、Con quiénes compartimos su información;</span></p><p class=c15><span class=c2>4、Por cuánto tiempo conservamos su información;</span></p><p class=c15><span class=c2>5、Cómo puede ejercer sus derechos sobre la información;</span></p><p class=c15><span class=c2>6、Cómo apelar a una resolución;</span></p><p class=c15><span class=c2>7、Cómo será notificado cuando se implementen cambios;</span></p><p class=c15><span class=c2>8、Cuál es nuestra información de contacto;</span></p><p class=c15><span class=c0>Esta política de privacidad se aplica a todos los servicios de Tap4Fun que se relacionan con esta política o se refieren directamente a ella, pero no se aplica a los servicios de Tap4Fun que tienen políticas de privacidad independientes no incorporadas a esta política.</span></p><p class=c40><span class=c9>SECCIÓN 1: CASOS EN LOS QUE SOMOS CONTROLADORES DE DATOS</span></p><p class=c6><span class=\"c21 c11\">1. Los tipos de información personal que utilizamos</span></p><p class=c15><span class=c0>Esta sección describe los distintos tipos de información personal que recopilamos y cómo recopilamos dicha información. Recopilaremos y utilizaremos la siguiente información sobre usted:</span></p><p class=c6><span class=\"c11 c21\">Información</span><span class=c30>&nbsp;que usted nos proporcione.</span></p><ul class=\"c13 lst-kix_list_23-0 start\"><li class=c5><span class=c0>Cuando se registra para jugar un juego (incluido el apodo elegido o las cuentas e información personalizadas que importamos de su cuenta de redes sociales vinculada (WeChat, Facebook) con el fin de configurar su perfil, lo que incluye el nombre que aparece en su perfil de redes sociales y su fotografía de perfil;</span></li><li class=c5><span class=c0>Cuando inicia sesión como \"invitado\" para usar el juego (su apodo); y</span></li><li class=c5><span class=c0>Cuando participa en una encuesta en el juego (en cuyo caso procesaremos la información que nos proporcione como parte de la encuesta).</span></li><li class=c5><span class=\"c14 c46 c49\">I</span><span class=c0>nformación que nos proporcione cuando solicita ayuda, como su nombre, número de teléfono y registros de los problemas que ha experimentado; e</span></li><li class=c5><span class=c0>Información de facturación, como su nombre, número de tarjeta de pago y detalles de la cuenta de pago;</span></li></ul><p class=c6><span class=c2>Información que recopilamos sobre usted.</span></p><p class=\"c27 c28\"><span class=c0>Recopilamos de manera automática determinados datos sobre usted cuando utiliza el juego, incluida su dirección IP e información del dispositivo (como versión de la aplicación, tipo de red, SO) e información sobre su uso del juego, como registros de fecha y hora de sus acciones. También recopilamos y almacenamos datos cada vez que interactúa con nosotros, por ejemplo, cuando utiliza el soporte dentro de la aplicación para comunicarse con nosotros.</span></p><p class=c6><span class=c2>Información que usted genera y muestra mientras utiliza los servicios del juego.&nbsp;</span></p><p class=\"c27 c28\"><span class=\"c14 c11\">Puede que también brinde información adicional como parte de su perfil (por ejemplo, el sexo). Además, puede que proporcione o genere información cuando se comunica con otros usuarios del juego (por ejemplo: datos de registro del chat, contenido del chat).</span></p><p class=c6><span class=c2>Datos que recopilamos de nuestros socios.</span></p><ul class=\"c13 lst-kix_list_23-0\"><li class=c5><span class=c0>Datos que recibimos si usted vincula una herramienta de un tercero con el servicio (como WeChat, Facebook)</span></li><li class=c5><span class=\"c23 c14\">Datos demográficos (por ejemplo, para determinar la ubicación aproximada de su dirección IP)</span></li><li class=c5><span class=\"c23 c14\">Datos para combatir el fraude (como el abuso de reembolsos en los juegos o el fraude por clic en las publicidades)</span></li><li class=c5><span class=\"c23 c14\">Datos de las plataformas en las que se ejecutan los juegos (por ejemplo, para verificar el pago)</span></li><li class=c5><span class=\"c23 c14\">Datos con fines publicitarios y analíticos para que podamos brindar un mejor servicio</span></li></ul><p class=c6><span class=c2>Cookies.</span></p><p class=c6><span class=c0>Utilizamos cookies y otras tecnologías similares (como balizas web, archivos de registro, scripts y eTags) (\"Cookies\") para mejorar su experiencia al utilizar los servicios. Las cookies son pequeños archivos que, cuando se instalan en su dispositivo, nos permiten brindar determinadas características y funcionalidades. Usted tiene la opción de aceptar la instalación de estas cookies o desactivarlas posteriormente. Usted puede aceptar todas las cookies, ordenarle al dispositivo (en el caso del juego) que le notifique cuando vayan a instalarse cookies o bien rechazar todas las cookies configurando la función de restricción de cookies correspondiente en su dispositivo. Sin embargo, si usted rechaza la instalación de cookies, el juego podría no funcionar según lo previsto.</span></p><p class=c6><span class=c2>2. Cómo utilizamos su información personal</span></p><p class=c27><span class=c0>Utilizaremos la información de los siguientes modos:</span></p><a id=t.7284b7cdcb47d37f624f15efcdbc89b2f1fce26f></a><a id=t.0></a><table class=c32><tbody><tr class=c18><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c21 c22\">Información personal</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c21 c22\">Uso</span></p></td></tr><tr class=c18><td class=c19 colspan=1 rowspan=1><p class=c7><span class=\"c14 c22\">Apodo</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Usamos esta información para crear su cuenta para el juego de acuerdo con su solicitud.</span></p></td></tr><tr class=c55><td class=c19 colspan=1 rowspan=1><p class=c7><span class=c4>Información de Social Connect:</span></p><p class=c7><span class=c4>WeChat: OpenID, fotografía de perfil, alias, sexo, región</span></p><p class=c7><span class=\"c20 c22\">Facebook: nombre, ID de Facebook, fotografía de perfil</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=c4>Utilizamos esta información con los siguientes fines: •crear su cuenta para el juego de acuerdo con su solicitud; • compartir fotografías del juego en Facebook según lo solicite.</span></p></td></tr><tr class=c36><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">OpenID generado</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Generamos esto para almacenar sus datos del juego (incluido el nivel y el progreso) con su perfil.</span></p></td></tr><tr class=c41><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Estadísticas de rendimiento en el juego (nivel, puntuación)</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Utilizamos esta información para brindarle comentarios e información acerca de su rendimiento y progreso.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Dirección IP</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Utilizamos esta información para mejorar nuestros servicios, incluida la funcionalidad del juego.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">ID del dispositivo, información del dispositivo</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Utilizamos esta información con los siguientes fines: • mejorar nuestros servicios, incluida la funcionalidad del juego; • para fines de seguridad y verificación; • identificar y solucionar fallos y evaluar el funcionamiento del juego para optimizarlo; y • evitar que los usuarios registren múltiples cuentas.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">ID publicitaria</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Si hace clic en un enlace que promociona el juego, guardaremos la ID publicitaria de ese anuncio con su perfil.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Datos del chat</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Si activa los servicios de chat (audio o texto), procesaremos dichos datos a fin de transmitir sus mensajes a otros usuarios.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Registros de transacciones: pagos en Google Play o iOS App Store&nbsp;</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Utilizamos esta información para mantener un registro de su historial de transacciones.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">ID de boletos de soporte para el cliente y comunicaciones del usuario con el departamento de soporte</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Utilizamos esta información con los siguientes fines: • mejorar nuestros servicios; • solucionar problemas tales como inconvenientes técnicos y fallos.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Información relacionada con la seguridad</span></p></td><td class=c17 colspan=1 rowspan=1><p class=c1><span class=\"c14 c22\">Utilizamos esta información con los siguientes fines: • para fines de seguridad y verificación; • identificar y solucionar fallos y evaluar el funcionamiento del juego para optimizarlo;&nbsp;• solucionar las interrupciones del juego y optimizar la compatibilidad de los dispositivos con el juego; y&nbsp;•evitar que los usuarios registren múltiples cuentas.</span></p></td></tr><tr class=c29><td class=c19 colspan=1 rowspan=1><p class=c1><span class=c4>Información de encuestas y contenido de las respuestas a encuestas</span></p></td><td class=c17 colspan=1 rowspan=1><p class=\"c1 c16\"><span class=c4></span></p></td></tr></tbody></table><p class=c6><span class=c2>Analizar, trazar un perfil y segmentar.</span></p><p class=\"c27 c35\"><span class=\"c23 c14\">En todos los casos y fines anteriores, es posible que analicemos, tracemos un perfil y segmentemos los datos recopilados.</span></p><p class=c6><span class=c2>Fundamentos jurídicos del procesamiento</span></p><p class=\"c28 c34\"><span class=\"c20 c11\">Si usted vive en la Unión Europea, estamos amparados por diversos fundamentos jurídicos que nos permiten procesar información sobre usted. Por ejemplo, procesaremos información sobre usted cuando tengamos su consentimiento, cuando tengamos un interés legítimo para hacerlo, cuando dicho procesamiento sea necesario para el cumplimiento de un contrato celebrado con usted y cuando tengamos la obligación legal de procesar la información. Por ejemplo, nos basamos en nuestro interés legítimo de proporcionar publicidad dirigida y en una necesidad contractual de procesar información cuando usted crea una cuenta. Para obtener más información acerca de los fundamentos jurídicos en que nos amparamos para procesar información con un fin en particular, póngase en contacto por alguno de los medios que figuran en la sección </span><span class=\"c21 c11\">C</span><span class=\"c33 c11\">ontacto y quejas</span><span class=\"c20 c11\">&nbsp;más abajo.</span></p><p class=c6><span class=c2>3. Cómo compartimos su información personal</span></p><p class=c27><span class=c0>Compartimos su información personal con terceros seleccionados dentro y fuera de su país, lo que incluye:</span></p><ul class=\"c13 lst-kix_list_23-0\"><li class=c5><span class=\"c21 c23\">otros jugadores y usuarios.</span><span class=c8>&nbsp;</span><span class=\"c23 c14\">Las funciones sociales son un componente fundamental de nuestros juegos. Otros jugadores y usuarios podrían, por ejemplo, ver los datos de su perfil, actividades en el juego y leer los mensajes que ha publicado.</span></li><li class=c5><span class=\"c23 c21\">socios que trabajan para Tap4Fun.</span><span class=c8>&nbsp;</span><span class=\"c23 c14\">Tap4Fun tiene socios que nos prestan servicios. Estos socios procesan sus datos únicamente de acuerdo con las instrucciones de Tap4Fun a fin de prestar el servicio, por ejemplo, servicios de hospedaje, soporte para el jugador, publicidad, análisis y prevención de fraude.</span></li><li class=c5><span class=\"c23 c21\">otras compañías y autoridades públicas. </span><span class=\"c23 c14\">A fin de combatir el fraude y las actividades ilegales, es posible que intercambiemos datos con otras compañías y organizaciones, y que estos sean proporcionados a las autoridades públicas en respuesta a una solicitud legítima. Es posible que divulguemos sus datos con su consentimiento a fin de cumplir con las leyes o proteger nuestros derechos, propiedad o seguridad y los de otros jugadores y usuarios.</span></li><li class=c5><span class=\"c23 c21\">compañías del grupo</span><span class=c2>&nbsp;relacionadas, como Tap4Fun (Hong Kong) Limited.,</span><span class=c0>&nbsp;con quienes compartimos su información personal para brindar los servicios del juego;</span></li><li class=c5><span class=c2>agencias del orden público, autoridades públicas y otras entidades u organismos judiciales.</span></li><li class=c5><span class=\"c23 c21\">un tercero que adquiera la totalidad del negocio o una parte significativa de este.&nbsp;</span><span class=\"c23 c14\">Divulgaremos información a un tercero en caso de que vendamos o compremos cualquier negocio o experimentemos una fusión, en cuyo caso divulgaremos sus datos al eventual comprador de dicho negocio. También divulgaremos información a un tercero si vendemos, compramos, fusionamos o nos asociamos con otras compañías o negocios, o si vendemos algunos o todos nuestros activos. En dichas transacciones, la información del usuario podría encontrarse entre los activos transferidos.</span></li></ul><p class=c6><span class=c2>4. Retención de los datos</span></p><p class=\"c27 c28\"><span class=c0>Retendremos su información personal tal como se describe a continuación (salvo que la ley vigente requiera que se retenga de algún otro modo):</span></p><a id=t.8d279159ea8ecd8ab5e5bdbdecf412f5b30c5cdd></a><a id=t.1></a><table class=c31><tbody><tr class=c47><td class=c3 colspan=1 rowspan=1><p class=c1><span class=\"c21 c22\">Información personal</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=\"c21 c22\">Política de retención</span></p></td></tr><tr class=c54><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Apodo</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego (es decir, hasta la eliminación de la cuenta de acuerdo con su solicitud) y luego se elimina en un plazo de 30 días.</span></p></td></tr><tr class=c45><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Información de Social Connect:<br>WeChat</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego (es decir, hasta la eliminación de la cuenta de acuerdo con su solicitud o bien cuando usted revoca el acceso a su cuenta de redes sociales) y luego se elimina en un plazo de 30 días.&nbsp;</span></p></td></tr><tr class=c53><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Información de Social Connect:<br>Facebook</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se elimina en un plazo de 15 días.<br>Si usted no solicita la eliminación de la cuenta, los datos se conservarán durante 1 año luego de que el juego sea sacado de funcionamiento y luego serán eliminados.&nbsp;</span></p></td></tr><tr class=c53><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4><br>Estadísticas de rendimiento en el juego (nivel, héroes, puntuación)</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacenan por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se eliminan en un plazo de 15 días.&nbsp;<br>Si usted no solicita la eliminación de la cuenta, los datos se conservarán durante 1 año luego de que el juego sea sacado de funcionamiento y luego serán eliminados.&nbsp;</span></p></td></tr><tr class=c39><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Mensajes del chat (mensajes de audio)</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacenan durante 7 días en nuestros servidores y luego se eliminan automáticamente una vez cumplido dicho plazo.</span></p></td></tr><tr class=c48><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Mensajes del chat (mensajes de texto)</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacenan por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se elimina en un plazo de 7 días.&nbsp;<br>Si usted no solicita la eliminación de la cuenta, los datos se conservarán durante 1 año luego de que el juego sea sacado de funcionamiento y luego serán eliminados.&nbsp;</span></p></td></tr><tr class=c25><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>OpenID</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se elimina en un plazo de 15 días.&nbsp;<br>Si usted no solicita la eliminación de la cuenta, los datos se conservarán durante 1 año luego de que el juego sea sacado de funcionamiento y luego serán eliminados.&nbsp;</span></p></td></tr><tr class=c25><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Dirección IP</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se elimina en un plazo de 15 días.&nbsp;<br>Si usted no solicita la eliminación de la cuenta, los datos se conservarán durante 1 año luego de que el juego sea sacado de funcionamiento y luego serán eliminados.&nbsp;</span></p></td></tr><tr class=c25><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>ID del dispositivo, información del dispositivo</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se elimina en un plazo de 30 días.<br>Si usted no solicita la eliminación de la cuenta, los datos se conservarán durante 1 año luego de que el juego sea sacado de funcionamiento y luego serán eliminados.&nbsp;</span></p></td></tr><tr class=c25><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>ID publicitaria</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se elimina en un plazo de 15 días.&nbsp;<br>Si usted no solicita la eliminación de la cuenta, los datos se conservarán durante 1 año luego de que el juego sea sacado de funcionamiento y luego serán eliminados.&nbsp;</span></p></td></tr><tr class=c25><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Registros de transacciones</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacenan por la duración de su uso del juego (es decir, hasta la eliminación de la cuenta de acuerdo con su solicitud) y luego por la duración de cualquier período de retención por el que dichos datos deban retenerse a fin de cumplir con nuestras obligaciones legales.</span></p></td></tr><tr class=c25><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>ID de boletos de soporte para el cliente y comunicaciones del usuario con el departamento de soporte</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Los datos de soporte se eliminan en un plazo de 30 días después de una solicitud legítima por su parte para la eliminación de dichos datos (consulte la sección Eliminación de esta política de privacidad).</span></p></td></tr><tr class=c25><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Información relacionada con la seguridad&nbsp;</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>Se almacena por la duración de su uso del juego hasta la eliminación de la cuenta de acuerdo con su solicitud y luego se elimina en un plazo de 30 días.&nbsp;</span></p></td></tr><tr class=c39><td class=c3 colspan=1 rowspan=1><p class=c1><span class=c4>Información de encuestas</span></p></td><td class=c24 colspan=1 rowspan=1><p class=c1><span class=c4>(a) Si usted proporciona su dirección de correo electrónico como parte de la encuesta, se almacenará durante 6 meses como máximo (para que podamos hacer el seguimiento con usted) y luego los datos se anonimizarán. (b) Si no proporciona su dirección de correo electrónico como parte de la encuesta, se almacenará durante 1 mes como máximo y luego los datos se anonimizarán.</span></p></td></tr></tbody></table><p class=\"c27 c16\"><span class=c0></span></p><p class=\"c27 c28\"><span class=c0>La información personal se conserva hasta el final de su ciclo de vida (tal como se establece en la política de retención anterior). Al momento de destruir información personal, se tomarán medidas para que esta sea irrecuperable o irreproducible. Los archivos electrónicos que contengan información personal serán eliminados de forma permanente a través de un método técnico que hace que los archivos sean irreproducibles.</span></p><p class=\"c27 c28\"><span class=c0>En caso de que los períodos de procesamiento y retención hayan terminado pero la información personal deba seguir conservándose de manera continua por otros motivos, incluidos los dispuestos por las leyes vigentes, la información personal pertinente será almacenada y mantenida en lugar distinto del de los demás tipos de información personal. Si usted solicita que destruyamos su información personal antes de finalizar su ciclo de vida (tal como se establece en la política de retención anterior), destruiremos su información personal de conformidad con lo establecido por las leyes locales.</span></p><p class=c40><span class=c9>SECCIÓN 2: SUS DERECHOS</span></p><p class=c27><span class=\"c21 c11 c26\">Esta sección (“Sus derechos”)</span><span class=c2>&nbsp;se aplica a los usuarios que viven en el Espacio Económico Europeo únicamente.</span></p><p class=\"c27 c28\"><span class=\"c14 c11\">Usted goza de ciertos derechos en relación con la información personal que nosotros tenemos sobre usted. Algunos de estos derechos solo se aplican en ciertas circunstancias (tal como se detalla a continuación). Es nuestra obligación responder a cualquier solicitud que realice en ejercicio de estos derechos sin demoras indebidas y dentro del plazo mínimo de un mes (este puede extenderse otros dos meses más en determinados casos). Para ejercer cualquiera de sus derechos, envíenos un correo electrónico a </span><span class=\"c37 c20 c11\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c0>..</span></p><p class=c6><span class=\"c12 c11\">1. Acceso</span></p><p class=\"c27 c28\"><span class=\"c11 c14\">Usted tiene derecho a acceder a la información personal que tenemos sobre usted y a saber cómo la usamos y con quién la compartimos. Puede acceder a la información personal que nos ha facilitado como parte de su cuenta iniciando sesión en la cuenta del juego y enviando un correo electrónico a </span><span class=\"c37 c20 c11\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c14 c11\">. Si usted cree que hemos recopilado cualquier otra información personal sobre usted, envíenos un correo electrónico a </span><span class=\"c37 c20 c11\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c0>..</span></p><p class=c6><span class=\"c12 c11\">2. Portabilidad</span></p><p class=\"c27 c28\"><span class=\"c20 c11\">Usted tiene derecho a recibir una copia de cierta información personal sobre usted que procesamos. Esto incluye la información personal que procesamos sobre la base de su consentimiento</span><span class=\"c14 c11\">&nbsp;(por ejemplo, cierta información de encuestas) o en virtud de un contrato celebrado con usted, tal como se describe en la sección “</span><span class=\"c21 c11 c26\">Cómo utilizamos su información personal</span><span class=c0>”. Tiene derecho a recibir esta información en un formato estructurado, de uso frecuente y que sea legible por una máquina. También tiene derecho a solicitar que transfiramos esa información personal a un tercero.</span></p><p class=\"c27 c28\"><span class=c0>Si desea que transfiramos dicha información personal a un tercero, asegúrese de detallar quién es el tercero en su solicitud. Tenga en cuenta que solo podemos hacer eso si es técnicamente posible. Además, tenga en cuenta que quizás no podamos brindarle información personal si esto interfiriere con los derechos de otra persona (por ejemplo, cuando proporcionarle información personal que recopilamos sobre usted revelara información sobre otra persona o sobre nuestros secretos comerciales o propiedad intelectual).</span></p><p class=c6><span class=\"c12 c11\">3. Corrección</span></p><p class=c15><span class=\"c20 c11\">Usted tiene derecho a corregir la información personal que tengamos sobre usted y que sea imprecisa. Puede acceder a la información personal que nos ha facilitado como parte de su cuenta iniciando sesión en la cuenta del juego. Si usted cree que hemos recopilado cualquier otra información personal sobre usted y que esa información es imprecisa, envíenos un correo electrónico a </span><span class=\"c37 c20 c11\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c20 c11\">.</span><span class=\"c14 c11\">.</span></p><p class=c6><span class=\"c11 c12\">4. Eliminación</span></p><p class=c15><span class=\"c20 c11\">Usted puede eliminar su cuenta o borrar cierta información personal iniciando sesión en la cuenta del juego. Si desea que eliminemos cualquier otra información que usted crea que procesamos, envíenos un correo electrónico a </span><span class=\"c37 c20 c11\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c20 c11\">.</span><span class=\"c14 c11\">.</span></p><p class=\"c15 c16\"><span class=c0></span></p><p class=c15><span class=c0>Usted puede solicitar que eliminemos la información personal que tenemos sobre usted en los siguientes casos:</span></p><ul class=\"c13 lst-kix_list_23-0\"><li class=c5><span class=c0>cuando considere que ya no hay necesidad de que nosotros almacenemos dicha información personal; o</span></li><li class=c5><span class=c0>cuando considere que la información personal que nosotros almacenamos se está procesando de modo ilegítimo.&nbsp;</span></li></ul><p class=\"c27 c16 c51\"><span class=c0></span></p><p class=c15><span class=c0>También puede ejercer su derecho a restringir nuestro procesamiento de la información personal (como se describe a continuación) mientras evaluamos su solicitud.&nbsp;</span></p><p class=\"c15 c16\"><span class=c0></span></p><p class=c15><span class=c0>Es posible que debamos conservar su información personal si existen motivos válidos en virtud de las leyes de protección de datos para hacerlo (por ejemplo, para la defensa de demandas legales o libertad de expresión), pero le informaremos si este es el caso. Cuando haya solicitado que eliminemos información personal que se ha publicado abiertamente a través de los servicios del juego y existan motivos para su eliminación, tomaremos las medidas razonables para pedirles a quienes están mostrando la información personal o proporcionando enlaces a la información personal que también la eliminen.</span></p><p class=c6><span class=\"c12 c11\">5. Restricción de procesamiento a los fines de almacenamiento únicamente</span></p><p class=c15><span class=c0>Usted tiene derecho a solicitarnos que dejemos de procesar información personal que tengamos sobre usted para fines que no sean los de almacenamiento en determinadas circunstancias. Tenga en cuenta, sin embargo, que si dejamos de procesar la información personal, podríamos volver a utilizarla si existieran motivos válidos en virtud de las leyes de protección de datos para hacerlo (por ejemplo, para la defensa de demandas legales o para la protección de otra persona). Como mencionamos anteriormente, cuando aceptemos dejar de procesar la información personal, les pediremos a los terceros a quienes hemos divulgado la información personal pertinente que ellos también dejen de procesarla.&nbsp;</span></p><p class=c15><span class=c0>Usted puede solicitar que dejemos de procesar la información personal sobre usted que tengamos y simplemente la almacenemos en los siguientes casos:</span></p><ul class=\"c13 lst-kix_list_23-0\"><li class=c5><span class=c0>cuando crea que la información personal no es precisa, durante el tiempo que nos tome verificar si es precisa o no;</span></li><li class=c5><span class=c0>cuando desee eliminar la información personal porque el procesamiento que estamos realizando es ilegal, pero quiera que conservemos la información personal y simplemente la almacenemos; o&nbsp;</span></li><li class=c5><span class=c0>cuando desee eliminar la información personal porque ya no es necesaria para nuestros fines, pero quiera que la almacenemos para la presentación, el ejercicio o la defensa de demandas legales.</span></li></ul><p class=c6><span class=\"c12 c11\">6. Objeción</span></p><p class=c15><span class=\"c11 c20\">Usted tiene derecho a objetar nuestro procesamiento de información personal sobre usted. Evaluaremos su solicitud en otras circunstancias según se detalla a continuación si nos envía un correo electrónico a </span><span class=\"c20 c11 c37\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c0>.&nbsp;.</span></p><p class=c6><span class=\"c12 c11\">7. Anuncios</span></p><p class=c15><span class=c0>Ocasionalmente, podríamos enviarle anuncios cuando consideremos que es necesario hacerlo (por ejemplo, cuando suspendamos momentáneamente el acceso al juego con fines de mantenimiento o para comunicar asuntos administrativos, de seguridad o privacidad). Usted no puede excluirse de estos anuncios relacionados con el servicios, dado que no son de naturaleza promocional.&nbsp;</span></p><p class=c40><span class=c9>SECCIÓN 3: DISPOSICIONES VARIAS </span></p><p class=c6><span class=c2>1. Seguridad de la información.</span></p><p class=c15><span class=c0>Hemos implementado medidas de seguridad administrativas, físicas y técnicas para proteger su información contra pérdida, robo, uso indebido, acceso no autorizado, divulgación, alteración y destrucción. No obstante, debe saber que, a pesar de nuestros esfuerzos, ningún tipo de seguridad garantiza la impenetrabilidad.</span></p><p class=c6><span class=c2>2. Información sobre niños</span></p><p class=c15 id=h.gjdgxs><span class=c0>No recopilamos ni solicitamos deliberadamente información personal ni dirigimos anuncios basados en los intereses a ninguna persona menor de 16 años, como tampoco permitimos deliberadamente que dichas personas utilicen nuestros servicios. Si tiene menos de 16 años, no envíe información sobre usted, lo que incluye su nombre, dirección, número de teléfono o dirección de correo electrónico. Ningún menor de 16 años debe proporcionar información personal. En caso de que tomemos conocimiento de que hemos recopilado información personal de un menor de 16 años, eliminaremos dicha información tan pronto como sea posible. Si usted cree que podríamos tener información sobre un menor de 16 años, comuníquese con nosotros.</span></p><p class=c6><span class=\"c21 c11\">3.</span><span class=c11>&nbsp;</span><span class=c2>Enlaces a sitios y servicios administrados por terceros</span></p><p class=\"c6 c28\"><span class=c0>El servicio de Tap4Fun podría contener enlaces a otros sitios, aplicaciones y servicios. Dado que Tap4Fun no administra estos sitios, aplicaciones y servicios, no podemos asumir ninguna responsabilidad por las prácticas de privacidad de las entidades que los administran. Le recomendamos que verifique constantemente las políticas de privacidad para entender las prácticas de los administradores. A modo de recordatorio, esta política describe las prácticas de Tap4Fun.</span></p><p class=c6><span class=c2>4. Cambios</span></p><p class=c15><span class=c0>Tap4Fun podría actualizar esta Política de privacidad ocasionalmente. Cuando la actualicemos, modificaremos la fecha de \"Última actualización\" indicada más arriba. Si implementamos cambios significativos en la forma en que recopilamos, usamos, retenemos o compartimos su información personal, lo notificaremos por correo electrónico a la última dirección de correo electrónico proporcionada, o bien publicaremos un aviso con los cambios en los servicios objeto de esta Política de privacidad.</span></p><p class=c6><span class=c2>4. Transferencia internacional</span></p><p class=\"c6 c43\"><span class=c0>Es posible que transfiramos la información que recopilamos sobre usted a entidades afiliadas o a otros terceros fuera del país y desde su país o jurisdicción a otros países o jurisdicciones del resto del mundo. Tenga en cuenta que estos países y jurisdicciones podrían no tener las mismas leyes de protección de los datos que su jurisdicción y nosotros tomamos medidas para asegurarnos de que haya protecciones adecuadas para permitir la transferencia de información y el uso y divulgación de información sobre usted, lo que incluye información personal, tal como se describe en esta Política.</span></p><p class=c6><span class=c2>5. Contacto y quejas</span></p><p class=\"c27 c28\"><span class=\"c14 c11\">No dude en contactarnos con preguntas, comentarios y solicitudes en relación con esta política. Envíenos un correo electrónico a </span><span class=\"c37 c20 c11\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c0>&nbsp;, llámenos al 0086-028-83313298 o envíe una carta por correo postal a Tap4Fun Co., Ltd, Atn: Administrador de Privacidad, Building A3, Tianfu Software Park, High-Tech Zone, Chengdu, Sichuan, China.</span></p><p class=c15><span class=c0>En caso de que desee realizar una queja con respecto a cómo procesamos su información personal, contáctenos en primer lugar enviando un correo electrónico a </span><span class=\"c37 c11 c52\"><a class=c10 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c0>&nbsp;y haremos todo lo posible para abordar su solicitud a la brevedad. Esto no impide que ejerza su derecho de presentar una demanda ante una autoridad de protección de datos en el país en el que reside o trabaja cuando usted considere que se han infringido las leyes de protección de datos.</span></p><br></div><div ng-if=\"privacy.lang == \'fr-FR\'\"><style type=text/css>ol.lst-kix_list_7-0{list-style-type:none}.lst-kix_list_14-1>li:before{content:\"o  \"}.lst-kix_list_14-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-0.start{counter-reset:lst-ctn-kix_list_9-0 0}.lst-kix_list_14-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_14-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-6>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_9-1{list-style-type:none}ol.lst-kix_list_7-4.start{counter-reset:lst-ctn-kix_list_7-4 0}.lst-kix_list_9-0>li{counter-increment:lst-ctn-kix_list_9-0}ol.lst-kix_list_7-5{list-style-type:none}ol.lst-kix_list_7-6{list-style-type:none}ol.lst-kix_list_7-7{list-style-type:none}ol.lst-kix_list_7-8{list-style-type:none}ol.lst-kix_list_7-1{list-style-type:none}ol.lst-kix_list_11-8.start{counter-reset:lst-ctn-kix_list_11-8 0}ol.lst-kix_list_7-3{list-style-type:none}ol.lst-kix_list_7-4{list-style-type:none}.lst-kix_list_14-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-1{list-style-type:none}ul.lst-kix_list_17-0{list-style-type:none}ul.lst-kix_list_17-8{list-style-type:none}ul.lst-kix_list_17-7{list-style-type:none}ul.lst-kix_list_17-6{list-style-type:none}ul.lst-kix_list_17-5{list-style-type:none}ul.lst-kix_list_17-4{list-style-type:none}ul.lst-kix_list_17-3{list-style-type:none}.lst-kix_list_14-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-2{list-style-type:none}ol.lst-kix_list_8-8.start{counter-reset:lst-ctn-kix_list_8-8 0}ol.lst-kix_list_10-4.start{counter-reset:lst-ctn-kix_list_10-4 0}.lst-kix_list_5-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-0{list-style-type:none}.lst-kix_list_24-7>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_27-0{list-style-type:none}ul.lst-kix_list_27-1{list-style-type:none}.lst-kix_list_24-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_27-2{list-style-type:none}.lst-kix_list_5-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-5.start{counter-reset:lst-ctn-kix_list_9-5 0}.lst-kix_list_5-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-3>li{counter-increment:lst-ctn-kix_list_8-3}.lst-kix_list_5-1>li:before{content:\"o  \"}.lst-kix_list_24-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_5-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_24-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_24-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_9-4>li{counter-increment:lst-ctn-kix_list_9-4}ol.lst-kix_list_6-6{list-style-type:none}ul.lst-kix_list_27-3{list-style-type:none}.lst-kix_list_24-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_6-7{list-style-type:none}ul.lst-kix_list_27-4{list-style-type:none}.lst-kix_list_5-4>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-8{list-style-type:none}ul.lst-kix_list_27-5{list-style-type:none}ul.lst-kix_list_27-6{list-style-type:none}.lst-kix_list_5-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-2{list-style-type:none}ul.lst-kix_list_27-7{list-style-type:none}ol.lst-kix_list_6-3{list-style-type:none}ul.lst-kix_list_27-8{list-style-type:none}ol.lst-kix_list_6-4{list-style-type:none}.lst-kix_list_24-6>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-5{list-style-type:none}.lst-kix_list_23-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_6-1>li:before{content:\"o  \"}.lst-kix_list_6-3>li:before{content:\"\" counter(lst-ctn-kix_list_6-3,decimal) \". \"}.lst-kix_list_6-5>li{counter-increment:lst-ctn-kix_list_6-5}.lst-kix_list_6-8>li{counter-increment:lst-ctn-kix_list_6-8}.lst-kix_list_23-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-0>li:before{content:\"\" counter(lst-ctn-kix_list_6-0,decimal) \". \"}.lst-kix_list_6-4>li:before{content:\"\" counter(lst-ctn-kix_list_6-4,decimal) \". \"}.lst-kix_list_23-2>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_16-2{list-style-type:none}ul.lst-kix_list_16-1{list-style-type:none}ul.lst-kix_list_16-0{list-style-type:none}.lst-kix_list_23-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_23-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-2>li:before{content:\"\" counter(lst-ctn-kix_list_6-2,decimal) \". \"}.lst-kix_list_24-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_16-8{list-style-type:none}ul.lst-kix_list_16-7{list-style-type:none}ul.lst-kix_list_16-6{list-style-type:none}ul.lst-kix_list_16-5{list-style-type:none}.lst-kix_list_24-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_16-4{list-style-type:none}.lst-kix_list_6-8>li:before{content:\"\" counter(lst-ctn-kix_list_6-8,decimal) \". \"}ul.lst-kix_list_16-3{list-style-type:none}.lst-kix_list_6-5>li:before{content:\"\" counter(lst-ctn-kix_list_6-5,decimal) \". \"}.lst-kix_list_6-7>li:before{content:\"\" counter(lst-ctn-kix_list_6-7,decimal) \". \"}.lst-kix_list_23-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_23-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_6-6>li:before{content:\"\" counter(lst-ctn-kix_list_6-6,decimal) \". \"}ol.lst-kix_list_10-6.start{counter-reset:lst-ctn-kix_list_10-6 0}.lst-kix_list_7-4>li:before{content:\"\" counter(lst-ctn-kix_list_7-4,upper-roman) \". \"}.lst-kix_list_7-6>li:before{content:\"\" counter(lst-ctn-kix_list_7-6,upper-roman) \". \"}ol.lst-kix_list_6-2.start{counter-reset:lst-ctn-kix_list_6-2 0}.lst-kix_list_22-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_22-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-6>li{counter-increment:lst-ctn-kix_list_7-6}.lst-kix_list_8-6>li{counter-increment:lst-ctn-kix_list_8-6}.lst-kix_list_22-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-7{list-style-type:none}ol.lst-kix_list_9-8{list-style-type:none}.lst-kix_list_13-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-3{list-style-type:none}ol.lst-kix_list_9-4{list-style-type:none}ol.lst-kix_list_9-5{list-style-type:none}.lst-kix_list_7-8>li:before{content:\"\" counter(lst-ctn-kix_list_7-8,upper-roman) \". \"}ol.lst-kix_list_9-6{list-style-type:none}ol.lst-kix_list_9-0{list-style-type:none}ol.lst-kix_list_9-2{list-style-type:none}.lst-kix_list_22-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-8>li{counter-increment:lst-ctn-kix_list_9-8}.lst-kix_list_4-1>li:before{content:\"o  \"}.lst-kix_list_15-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-7{list-style-type:none}ul.lst-kix_list_19-6{list-style-type:none}.lst-kix_list_4-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-5{list-style-type:none}ul.lst-kix_list_19-4{list-style-type:none}ul.lst-kix_list_19-3{list-style-type:none}.lst-kix_list_25-5>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_19-2{list-style-type:none}ul.lst-kix_list_19-1{list-style-type:none}.lst-kix_list_10-5>li{counter-increment:lst-ctn-kix_list_10-5}ul.lst-kix_list_19-0{list-style-type:none}.lst-kix_list_15-1>li:before{content:\"o  \"}.lst-kix_list_25-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_15-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-8{list-style-type:none}.lst-kix_list_6-4>li{counter-increment:lst-ctn-kix_list_6-4}ol.lst-kix_list_9-2.start{counter-reset:lst-ctn-kix_list_9-2 0}.lst-kix_list_9-3>li{counter-increment:lst-ctn-kix_list_9-3}.lst-kix_list_11-2>li{counter-increment:lst-ctn-kix_list_11-2}ol.lst-kix_list_8-8{list-style-type:none}.lst-kix_list_12-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-6.start{counter-reset:lst-ctn-kix_list_7-6 0}ol.lst-kix_list_8-4{list-style-type:none}.lst-kix_list_12-1>li:before{content:\"o  \"}ol.lst-kix_list_8-5{list-style-type:none}ol.lst-kix_list_8-6{list-style-type:none}ol.lst-kix_list_8-7{list-style-type:none}ol.lst-kix_list_8-0{list-style-type:none}ol.lst-kix_list_8-1{list-style-type:none}ol.lst-kix_list_8-2{list-style-type:none}ol.lst-kix_list_8-3{list-style-type:none}.lst-kix_list_10-4>li{counter-increment:lst-ctn-kix_list_10-4}.lst-kix_list_13-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-0{list-style-type:none}.lst-kix_list_13-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-8{list-style-type:none}ul.lst-kix_list_18-7{list-style-type:none}ul.lst-kix_list_18-6{list-style-type:none}ul.lst-kix_list_18-5{list-style-type:none}.lst-kix_list_12-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-4{list-style-type:none}ul.lst-kix_list_18-3{list-style-type:none}ul.lst-kix_list_18-2{list-style-type:none}ol.lst-kix_list_6-0.start{counter-reset:lst-ctn-kix_list_6-0 0}ul.lst-kix_list_18-1{list-style-type:none}.lst-kix_list_13-1>li:before{content:\"o  \"}ul.lst-kix_list_24-0{list-style-type:none}ul.lst-kix_list_24-1{list-style-type:none}ul.lst-kix_list_24-2{list-style-type:none}ul.lst-kix_list_24-3{list-style-type:none}ul.lst-kix_list_24-4{list-style-type:none}ul.lst-kix_list_24-5{list-style-type:none}ol.lst-kix_list_11-6{list-style-type:none}ol.lst-kix_list_11-7{list-style-type:none}ol.lst-kix_list_11-8{list-style-type:none}.lst-kix_list_7-1>li{counter-increment:lst-ctn-kix_list_7-1}ol.lst-kix_list_11-2{list-style-type:none}ol.lst-kix_list_11-3{list-style-type:none}.lst-kix_list_3-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_11-4{list-style-type:none}ol.lst-kix_list_11-5{list-style-type:none}ul.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_5-8{list-style-type:none}ul.lst-kix_list_5-5{list-style-type:none}ol.lst-kix_list_11-0{list-style-type:none}ul.lst-kix_list_5-6{list-style-type:none}.lst-kix_list_21-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_8-0>li{counter-increment:lst-ctn-kix_list_8-0}ul.lst-kix_list_24-6{list-style-type:none}ul.lst-kix_list_5-0{list-style-type:none}ul.lst-kix_list_24-7{list-style-type:none}.lst-kix_list_10-0>li{counter-increment:lst-ctn-kix_list_10-0}.lst-kix_list_3-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_24-8{list-style-type:none}ul.lst-kix_list_5-3{list-style-type:none}.lst-kix_list_3-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_5-4{list-style-type:none}.lst-kix_list_26-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_5-1{list-style-type:none}.lst-kix_list_8-0>li:before{content:\"\" counter(lst-ctn-kix_list_8-0,upper-roman) \". \"}ul.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_8-7>li:before{content:\"\" counter(lst-ctn-kix_list_8-7,upper-roman) \". \"}.lst-kix_list_3-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_10-7.start{counter-reset:lst-ctn-kix_list_10-7 0}.lst-kix_list_26-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_21-1>li:before{content:\"o  \"}.lst-kix_list_8-3>li:before{content:\"\" counter(lst-ctn-kix_list_8-3,upper-roman) \". \"}ul.lst-kix_list_13-5{list-style-type:none}ul.lst-kix_list_13-4{list-style-type:none}ul.lst-kix_list_13-3{list-style-type:none}ul.lst-kix_list_13-2{list-style-type:none}ul.lst-kix_list_13-1{list-style-type:none}.lst-kix_list_3-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_13-0{list-style-type:none}.lst-kix_list_26-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li:before{content:\"\" counter(lst-ctn-kix_list_8-4,upper-roman) \". \"}.lst-kix_list_10-2>li{counter-increment:lst-ctn-kix_list_10-2}ol.lst-kix_list_8-5.start{counter-reset:lst-ctn-kix_list_8-5 0}ul.lst-kix_list_13-8{list-style-type:none}.lst-kix_list_11-1>li:before{content:\"o  \"}ul.lst-kix_list_13-7{list-style-type:none}ul.lst-kix_list_13-6{list-style-type:none}.lst-kix_list_21-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-0>li:before{content:\"\" counter(lst-ctn-kix_list_11-0,decimal) \". \"}ol.lst-kix_list_9-3.start{counter-reset:lst-ctn-kix_list_9-3 0}.lst-kix_list_26-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_8-8>li:before{content:\"\" counter(lst-ctn-kix_list_8-8,upper-roman) \". \"}.lst-kix_list_16-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-0{list-style-type:none}ul.lst-kix_list_23-1{list-style-type:none}.lst-kix_list_16-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-2{list-style-type:none}ul.lst-kix_list_23-3{list-style-type:none}ul.lst-kix_list_23-4{list-style-type:none}ul.lst-kix_list_23-5{list-style-type:none}ul.lst-kix_list_23-6{list-style-type:none}.lst-kix_list_4-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-8{list-style-type:none}.lst-kix_list_16-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-6{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}.lst-kix_list_25-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li{counter-increment:lst-ctn-kix_list_8-4}ul.lst-kix_list_4-0{list-style-type:none}ul.lst-kix_list_23-7{list-style-type:none}.lst-kix_list_25-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_23-8{list-style-type:none}ol.lst-kix_list_10-8.start{counter-reset:lst-ctn-kix_list_10-8 0}.lst-kix_list_16-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-4{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}.lst-kix_list_11-3>li{counter-increment:lst-ctn-kix_list_11-3}ol.lst-kix_list_7-1.start{counter-reset:lst-ctn-kix_list_7-1 0}ul.lst-kix_list_12-6{list-style-type:none}ol.lst-kix_list_8-6.start{counter-reset:lst-ctn-kix_list_8-6 0}ul.lst-kix_list_12-5{list-style-type:none}.lst-kix_list_17-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-4{list-style-type:none}ul.lst-kix_list_12-3{list-style-type:none}ul.lst-kix_list_12-2{list-style-type:none}ul.lst-kix_list_12-1{list-style-type:none}.lst-kix_list_17-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-0{list-style-type:none}.lst-kix_list_17-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-8{list-style-type:none}ul.lst-kix_list_12-7{list-style-type:none}ol.lst-kix_list_8-0.start{counter-reset:lst-ctn-kix_list_8-0 0}.lst-kix_list_7-0>li:before{content:\"\" counter(lst-ctn-kix_list_7-0,upper-roman) \". \"}ol.lst-kix_list_9-7.start{counter-reset:lst-ctn-kix_list_9-7 0}.lst-kix_list_22-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_2-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-1{list-style-type:none}ul.lst-kix_list_26-2{list-style-type:none}ul.lst-kix_list_26-3{list-style-type:none}.lst-kix_list_22-1>li:before{content:\"o  \"}.lst-kix_list_27-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-6>li{counter-increment:lst-ctn-kix_list_6-6}.lst-kix_list_7-3>li:before{content:\"\" counter(lst-ctn-kix_list_7-3,upper-roman) \". \"}.lst-kix_list_10-0>li:before{content:\"\" counter(lst-ctn-kix_list_10-0,decimal) \". \"}.lst-kix_list_9-7>li{counter-increment:lst-ctn-kix_list_9-7}.lst-kix_list_13-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-4{list-style-type:none}ul.lst-kix_list_26-5{list-style-type:none}ul.lst-kix_list_26-6{list-style-type:none}ul.lst-kix_list_26-7{list-style-type:none}.lst-kix_list_8-7>li{counter-increment:lst-ctn-kix_list_8-7}ul.lst-kix_list_26-8{list-style-type:none}ul.lst-kix_list_7-2{list-style-type:none}.lst-kix_list_27-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_7-7>li:before{content:\"\" counter(lst-ctn-kix_list_7-7,upper-roman) \". \"}ol.lst-kix_list_8-1.start{counter-reset:lst-ctn-kix_list_8-1 0}.lst-kix_list_15-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-5>li{counter-increment:lst-ctn-kix_list_9-5}.lst-kix_list_10-4>li:before{content:\"\" counter(lst-ctn-kix_list_10-4,decimal) \". \"}.lst-kix_list_10-8>li:before{content:\"\" counter(lst-ctn-kix_list_10-8,decimal) \". \"}.lst-kix_list_4-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-3{list-style-type:none}ul.lst-kix_list_15-2{list-style-type:none}.lst-kix_list_15-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-1{list-style-type:none}.lst-kix_list_15-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_15-0{list-style-type:none}.lst-kix_list_4-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_25-4>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_15-8{list-style-type:none}ul.lst-kix_list_15-7{list-style-type:none}ul.lst-kix_list_15-6{list-style-type:none}.lst-kix_list_9-3>li:before{content:\"\" counter(lst-ctn-kix_list_9-3,decimal) \". \"}ul.lst-kix_list_15-5{list-style-type:none}ul.lst-kix_list_15-4{list-style-type:none}ol.lst-kix_list_7-0.start{counter-reset:lst-ctn-kix_list_7-0 0}.lst-kix_list_25-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_25-0{list-style-type:none}ul.lst-kix_list_25-1{list-style-type:none}ul.lst-kix_list_25-2{list-style-type:none}.lst-kix_list_9-7>li:before{content:\"\" counter(lst-ctn-kix_list_9-7,decimal) \". \"}ul.lst-kix_list_25-3{list-style-type:none}ul.lst-kix_list_25-4{list-style-type:none}.lst-kix_list_11-4>li:before{content:\"\" counter(lst-ctn-kix_list_11-4,decimal) \". \"}.lst-kix_list_12-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_20-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-4>li{counter-increment:lst-ctn-kix_list_7-4}ul.lst-kix_list_25-5{list-style-type:none}.lst-kix_list_1-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_25-6{list-style-type:none}.lst-kix_list_20-1>li:before{content:\"o  \"}ul.lst-kix_list_25-7{list-style-type:none}ul.lst-kix_list_25-8{list-style-type:none}.lst-kix_list_11-8>li:before{content:\"\" counter(lst-ctn-kix_list_11-8,decimal) \". \"}.lst-kix_list_12-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_6-1{list-style-type:none}ol.lst-kix_list_8-4.start{counter-reset:lst-ctn-kix_list_8-4 0}.lst-kix_list_1-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_14-4{list-style-type:none}ul.lst-kix_list_14-3{list-style-type:none}ul.lst-kix_list_14-2{list-style-type:none}.lst-kix_list_13-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_14-1{list-style-type:none}ul.lst-kix_list_14-0{list-style-type:none}.lst-kix_list_10-7>li{counter-increment:lst-ctn-kix_list_10-7}ul.lst-kix_list_14-8{list-style-type:none}ul.lst-kix_list_14-7{list-style-type:none}.lst-kix_list_2-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_8-3.start{counter-reset:lst-ctn-kix_list_8-3 0}ul.lst-kix_list_14-6{list-style-type:none}.lst-kix_list_11-5>li{counter-increment:lst-ctn-kix_list_11-5}ul.lst-kix_list_14-5{list-style-type:none}ol.lst-kix_list_9-8.start{counter-reset:lst-ctn-kix_list_9-8 0}.lst-kix_list_1-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_12-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-2>li{counter-increment:lst-ctn-kix_list_8-2}ul.lst-kix_list_20-2{list-style-type:none}ul.lst-kix_list_20-3{list-style-type:none}.lst-kix_list_19-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_19-1>li:before{content:\"o  \"}ul.lst-kix_list_20-4{list-style-type:none}ul.lst-kix_list_20-5{list-style-type:none}ul.lst-kix_list_20-6{list-style-type:none}ul.lst-kix_list_1-0{list-style-type:none}ul.lst-kix_list_20-7{list-style-type:none}ul.lst-kix_list_20-8{list-style-type:none}.lst-kix_list_19-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-1>li{counter-increment:lst-ctn-kix_list_8-1}ol.lst-kix_list_8-2.start{counter-reset:lst-ctn-kix_list_8-2 0}.lst-kix_list_19-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_20-0{list-style-type:none}ul.lst-kix_list_20-1{list-style-type:none}ol.lst-kix_list_6-6.start{counter-reset:lst-ctn-kix_list_6-6 0}.lst-kix_list_7-0>li{counter-increment:lst-ctn-kix_list_7-0}.lst-kix_list_11-0>li{counter-increment:lst-ctn-kix_list_11-0}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}ul.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_9-6.start{counter-reset:lst-ctn-kix_list_9-6 0}.lst-kix_list_19-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-2.start{counter-reset:lst-ctn-kix_list_11-2 0}.lst-kix_list_19-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-2>li{counter-increment:lst-ctn-kix_list_9-2}ol.lst-kix_list_8-7.start{counter-reset:lst-ctn-kix_list_8-7 0}.lst-kix_list_10-3>li{counter-increment:lst-ctn-kix_list_10-3}.lst-kix_list_18-0>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-1>li:before{content:\"o  \"}.lst-kix_list_18-2>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-7.start{counter-reset:lst-ctn-kix_list_11-7 0}ul.lst-kix_list_22-0{list-style-type:none}.lst-kix_list_2-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_22-1{list-style-type:none}ul.lst-kix_list_22-2{list-style-type:none}ul.lst-kix_list_22-3{list-style-type:none}ul.lst-kix_list_22-4{list-style-type:none}.lst-kix_list_2-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-3>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_22-5{list-style-type:none}ul.lst-kix_list_22-6{list-style-type:none}ul.lst-kix_list_22-7{list-style-type:none}.lst-kix_list_27-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_10-3.start{counter-reset:lst-ctn-kix_list_10-3 0}.lst-kix_list_18-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-4.start{counter-reset:lst-ctn-kix_list_9-4 0}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_list_10-1>li:before{content:\"o  \"}.lst-kix_list_18-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_3-1{list-style-type:none}ul.lst-kix_list_22-8{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_7-7>li{counter-increment:lst-ctn-kix_list_7-7}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_10-7>li:before{content:\"\" counter(lst-ctn-kix_list_10-7,decimal) \". \"}.lst-kix_list_7-8>li{counter-increment:lst-ctn-kix_list_7-8}.lst-kix_list_10-5>li:before{content:\"\" counter(lst-ctn-kix_list_10-5,decimal) \". \"}.lst-kix_list_10-3>li:before{content:\"\" counter(lst-ctn-kix_list_10-3,decimal) \". \"}ol.lst-kix_list_7-3.start{counter-reset:lst-ctn-kix_list_7-3 0}ul.lst-kix_list_11-1{list-style-type:none}.lst-kix_list_11-7>li{counter-increment:lst-ctn-kix_list_11-7}.lst-kix_list_9-2>li:before{content:\"\" counter(lst-ctn-kix_list_9-2,decimal) \". \"}.lst-kix_list_20-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-0>li:before{content:\"\" counter(lst-ctn-kix_list_9-0,decimal) \". \"}ul.lst-kix_list_21-1{list-style-type:none}ul.lst-kix_list_21-2{list-style-type:none}ul.lst-kix_list_21-3{list-style-type:none}ul.lst-kix_list_21-4{list-style-type:none}.lst-kix_list_20-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_21-5{list-style-type:none}ul.lst-kix_list_21-6{list-style-type:none}ul.lst-kix_list_21-7{list-style-type:none}ul.lst-kix_list_21-8{list-style-type:none}ol.lst-kix_list_10-7{list-style-type:none}.lst-kix_list_9-6>li:before{content:\"\" counter(lst-ctn-kix_list_9-6,decimal) \". \"}ol.lst-kix_list_10-8{list-style-type:none}ol.lst-kix_list_10-3{list-style-type:none}.lst-kix_list_9-4>li:before{content:\"\" counter(lst-ctn-kix_list_9-4,decimal) \". \"}ol.lst-kix_list_10-4{list-style-type:none}ol.lst-kix_list_10-5{list-style-type:none}.lst-kix_list_11-3>li:before{content:\"\" counter(lst-ctn-kix_list_11-3,decimal) \". \"}ol.lst-kix_list_10-6{list-style-type:none}ul.lst-kix_list_21-0{list-style-type:none}.lst-kix_list_6-3>li{counter-increment:lst-ctn-kix_list_6-3}.lst-kix_list_20-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-0{list-style-type:none}ul.lst-kix_list_2-8{list-style-type:none}ol.lst-kix_list_10-2{list-style-type:none}.lst-kix_list_20-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-5>li:before{content:\"\" counter(lst-ctn-kix_list_11-5,decimal) \". \"}ul.lst-kix_list_2-2{list-style-type:none}.lst-kix_list_20-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_9-8>li:before{content:\"\" counter(lst-ctn-kix_list_9-8,decimal) \". \"}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:\"o  \"}ul.lst-kix_list_2-7{list-style-type:none}.lst-kix_list_11-7>li:before{content:\"\" counter(lst-ctn-kix_list_11-7,decimal) \". \"}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_8-5>li{counter-increment:lst-ctn-kix_list_8-5}.lst-kix_list_1-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-5.start{counter-reset:lst-ctn-kix_list_10-5 0}.lst-kix_list_1-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_1-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_10-1{list-style-type:none}ol.lst-kix_list_7-5.start{counter-reset:lst-ctn-kix_list_7-5 0}.lst-kix_list_2-1>li:before{content:\"o  \"}.lst-kix_list_27-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_2-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-8>li{counter-increment:lst-ctn-kix_list_11-8}ol.lst-kix_list_7-7.start{counter-reset:lst-ctn-kix_list_7-7 0}.lst-kix_list_3-1>li:before{content:\"o  \"}.lst-kix_list_3-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_26-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-1>li:before{content:\"\" counter(lst-ctn-kix_list_8-1,upper-roman) \". \"}.lst-kix_list_8-2>li:before{content:\"\" counter(lst-ctn-kix_list_8-2,upper-roman) \". \"}.lst-kix_list_6-0>li{counter-increment:lst-ctn-kix_list_6-0}.lst-kix_list_3-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-5.start{counter-reset:lst-ctn-kix_list_11-5 0}.lst-kix_list_21-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-5>li:before{content:\"\" counter(lst-ctn-kix_list_8-5,upper-roman) \". \"}.lst-kix_list_8-6>li:before{content:\"\" counter(lst-ctn-kix_list_8-6,upper-roman) \". \"}.lst-kix_list_26-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_26-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_3-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-2>li:before{content:\"\" counter(lst-ctn-kix_list_11-2,decimal) \". \"}.lst-kix_list_21-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-6.start{counter-reset:lst-ctn-kix_list_11-6 0}.lst-kix_list_16-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-4.start{counter-reset:lst-ctn-kix_list_6-4 0}.lst-kix_list_25-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_17-1>li:before{content:\"o  \"}.lst-kix_list_25-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-1>li:before{content:\"o  \"}.lst-kix_list_7-3>li{counter-increment:lst-ctn-kix_list_7-3}.lst-kix_list_16-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_16-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-8.start{counter-reset:lst-ctn-kix_list_7-8 0}ol.lst-kix_list_11-0.start{counter-reset:lst-ctn-kix_list_11-0 0}ol.lst-kix_list_6-3.start{counter-reset:lst-ctn-kix_list_6-3 0}ol.lst-kix_list_10-2.start{counter-reset:lst-ctn-kix_list_10-2 0}.lst-kix_list_17-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-2>li{counter-increment:lst-ctn-kix_list_6-2}.lst-kix_list_2-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_22-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-1>li:before{content:\"\" counter(lst-ctn-kix_list_7-1,decimal) \". \"}.lst-kix_list_7-5>li:before{content:\"\" counter(lst-ctn-kix_list_7-5,upper-roman) \". \"}.lst-kix_list_9-6>li{counter-increment:lst-ctn-kix_list_9-6}.lst-kix_list_27-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-7>li{counter-increment:lst-ctn-kix_list_6-7}.lst-kix_list_10-6>li{counter-increment:lst-ctn-kix_list_10-6}.lst-kix_list_11-6>li{counter-increment:lst-ctn-kix_list_11-6}ol.lst-kix_list_10-0.start{counter-reset:lst-ctn-kix_list_10-0 0}.lst-kix_list_7-5>li{counter-increment:lst-ctn-kix_list_7-5}.lst-kix_list_15-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-4>li{counter-increment:lst-ctn-kix_list_11-4}ol.lst-kix_list_6-8.start{counter-reset:lst-ctn-kix_list_6-8 0}.lst-kix_list_10-2>li:before{content:\"\" counter(lst-ctn-kix_list_10-2,decimal) \". \"}.lst-kix_list_20-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-5.start{counter-reset:lst-ctn-kix_list_6-5 0}.lst-kix_list_4-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_10-8>li{counter-increment:lst-ctn-kix_list_10-8}.lst-kix_list_25-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_10-6>li:before{content:\"\" counter(lst-ctn-kix_list_10-6,decimal) \". \"}.lst-kix_list_9-1>li:before{content:\"o  \"}ol.lst-kix_list_6-7.start{counter-reset:lst-ctn-kix_list_6-7 0}.lst-kix_list_9-5>li:before{content:\"\" counter(lst-ctn-kix_list_9-5,decimal) \". \"}.lst-kix_list_12-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-6>li:before{content:\"\" counter(lst-ctn-kix_list_11-6,decimal) \". \"}.lst-kix_list_20-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-3.start{counter-reset:lst-ctn-kix_list_11-3 0}.lst-kix_list_1-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-8>li{counter-increment:lst-ctn-kix_list_8-8}.lst-kix_list_1-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-4.start{counter-reset:lst-ctn-kix_list_11-4 0}.lst-kix_list_2-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-2>li:before{content:\"\\0025aa  \"}ol{margin:0;padding:0}table td,table th{padding:0}.c15{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:137.2pt;border-top-color:#000000;border-bottom-style:solid}.c22{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:291.1pt;border-top-color:#000000;border-bottom-style:solid}.c12{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:157.8pt;border-top-color:#000000;border-bottom-style:solid}.c11{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:280.1pt;border-top-color:#000000;border-bottom-style:solid}.c46{-webkit-text-decoration-skip:none;color:#0000ff;font-weight:400;text-decoration:underline;vertical-align:baseline;text-decoration-skip-ink:none;font-size:10pt;font-family:\"\\007b49\\007ebf\";font-style:normal}.c16{margin-left:18pt;padding-top:0pt;padding-left:-3.8pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c24{padding-top:0pt;text-indent:20pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c0{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:\"Arial\";font-style:normal}.c45{padding-top:0pt;text-indent:20pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c38{padding-top:0pt;text-indent:24pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:center}.c5{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:8pt;font-family:\"Arial\";font-style:normal}.c23{-webkit-text-decoration-skip:none;color:#0000ff;font-weight:400;text-decoration:underline;text-decoration-skip-ink:none;font-size:10pt;font-family:\"Arial\"}.c7{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c37{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c6{padding-top:6pt;padding-bottom:6pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c35{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c8{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-indent:20pt;text-align:justify}.c57{font-size:11pt;font-family:\"Arial\";color:#212121;font-weight:700}.c31{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c4{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c14{font-size:8pt;font-family:\"Arial\";color:#000000;font-weight:400}.c29{color:#000000;font-weight:400;font-size:9pt;font-family:\"Arial\"}.c34{font-size:8pt;font-family:\"Arial\";color:#000000;font-weight:700}.c10{color:#000000;font-weight:700;font-size:10pt;font-family:\"Arial\"}.c21{color:#000000;font-weight:700;font-size:9pt;font-family:\"Arial\"}.c33{color:#000000;font-weight:400;font-size:11pt;font-family:\"Arial\"}.c26{padding-top:12pt;padding-bottom:12pt;line-height:1.0;text-align:justify}.c1{font-size:10pt;font-family:\"Arial\";color:#000000;font-weight:400}.c47{color:#000000;font-weight:700;font-size:12pt;font-family:\"Arial\"}.c19{color:#000000;font-weight:400;font-size:10pt;font-family:\"\\007b49\\007ebf\"}.c41{font-size:10pt;font-family:\"Arial\";font-weight:400}.c51{background-color:#ffffff;padding:72pt 16pt 72pt 16pt;margin:auto;}.c17{text-decoration:none;vertical-align:baseline;font-style:italic}.c44{font-size:8pt;font-family:\"Arial\";font-weight:400}.c43{font-size:10pt;font-family:\"Arial\";font-weight:700}.c9{text-decoration:none;vertical-align:baseline;font-style:normal}.c3{padding:0;margin:0}.c2{color:inherit;text-decoration:inherit}.c32{height:6pt}.c55{font-size:10pt}.c18{font-style:italic}.c42{height:44pt}.c52{text-indent:20pt}.c53{height:19pt}.c50{height:103pt}.c48{color:#777777}.c56{text-indent:18pt}.c39{height:74pt}.c36{height:20pt}.c54{margin-left:14.2pt}.c27{height:18pt}.c25{height:10pt}.c13{text-indent:25pt}.c28{height:22pt}.c49{height:59pt}.c40{height:29pt}.c30{height:14pt}.c20{height:45pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:\"Georgia\";line-height:1.0;page-break-after:avoid;font-style:italic;text-align:justify}li{color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}p{margin:0;color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h2{padding-top:5pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h3{padding-top:5pt;color:#000000;font-weight:700;font-size:13.5pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h4{padding-top:5pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}</style><p class=c38><span class=\"c9 c47\">Politique de confidentialité </span></p><p class=c45><span class=\"c1 c9\">Dernière mise à jour&nbsp;: 05/2018</span></p><p class=c45><span class=c43>Vous reconnaissez avoir lu et compris la présente politique de confidentialité. Si vous n\'acceptez pas la présente politique de confidentialité, vous ne devez pas utiliser les services de Tap4Fun. Si vous changez d\'avis à l\'avenir, vous pouvez retirer votre consentement à l\'utilisation de vos informations personnelles conformément à la présente politique.</span></p><p class=c8><span class=\"c1 c9\">Chez Tap4Fun, nous savons que la confidentialité est importante pour vous, veuillez donc prendre le temps de lire soigneusement notre politique de confidentialité. Notre politique est conçue pour vous aider à comprendre&nbsp;:</span></p><p class=c8><span class=\"c10 c9\">1. Quelles sont les informations que nous recueillons sur vous&nbsp;;</span></p><p class=c8><span class=\"c10 c9\">2、Comment nous utiliserons les informations vous concernant&nbsp;;</span></p><p class=c8><span class=\"c10 c9\">3、Avec qui nous partageons vos informations&nbsp;;</span></p><p class=c8><span class=\"c10 c9\">4. Combien de temps nous conserverons vos informations&nbsp;;</span></p><p class=c8><span class=\"c10 c9\">5. Comment je peux exercer mes droits sur mes informations&nbsp;;</span></p><p class=c8><span class=\"c10 c9\">6. La résolution de différends&nbsp;;</span></p><p class=c8><span class=\"c10 c9\">7. Comment nous allons vous informer des modifications&nbsp;;</span></p><p class=c8><span class=\"c10 c9\">8. Les informations de contact;</span></p><p class=c8><span class=\"c1 c9\">La présente politique de confidentialité s\'applique à tous les services de Tap4Fun qui font directement référence ou en lien avec cette politique, mais elle ne s\'applique pas aux services de Tap4Fun qui ont des politiques de confidentialité distinctes.</span></p><p class=c26><span class=c0>SECTION 1&nbsp;: EN QUOI SOMMES-NOUS UN CONTRÔLEUR DE DONNÉES</span></p><p class=c6><span class=c10>1. Les types d\'informations personnelles que nous utilisons</span></p><p class=c8><span class=\"c1 c9\">Cette section décrit les différents types d\'informations personnelles que nous recueillons et la façon dont nous les recueillons. Nous recueillerons et utiliserons les informations suivantes à votre sujet&nbsp;:</span></p><p class=c6><span class=c10>Informations</span><span class=c57>que vous nous fournissez.</span></p><ul class=\"c3 lst-kix_list_23-0 start\"><li class=c16><span class=\"c1 c9\">Lorsque vous vous inscrivez au Jeu (y compris votre pseudonyme désigné, ou les comptes personnalisés et les informations que nous importons à partir de votre compte de médias sociaux connecté (WeChat, Facebook) afin de configurer votre profil, y compris votre nom tel qu\'il apparaît sur votre profil de médias sociaux et votre photo de profil)&nbsp;;</span></li><li class=c16><span class=\"c1 c9\">Lorsque vous vous connectez en tant qu\' « invité » afin d\'utiliser le Jeu (votre pseudonyme)&nbsp;; et</span></li><li class=c16><span class=\"c1 c9\">Lorsque vous participez à une enquête dans le Jeu (auquel cas nous traiterons les informations que vous nous fournissez dans le cadre de l\'enquête).</span></li><li class=c16><span class=\"c33 c9\">Les i</span><span class=\"c1 c9\">nformations que vous fournissez lorsque vous nous demandez de l\'aide, comme votre nom, votre numéro de téléphone et les enregistrements des problèmes que vous rencontrez&nbsp;; et</span></li><li class=c16><span class=\"c1 c9\">Les informations de facturation, telles que votre nom, le numéro de votre carte de paiement et les détails de votre compte de paiement&nbsp;;</span></li></ul><p class=c6><span class=\"c10 c9\">Informations que nous recueillons sur vous.</span></p><p class=c24><span class=\"c1 c9\">Nous recueillons automatiquement certaines données vous concernant lorsque vous utilisez le Jeu, y compris votre adresse IP et les informations relatives à l\'appareil (telles que la version de l\'application, le type de réseau, le système d\'exploitation) et les informations concernant votre utilisation du Jeu, telles que la date et l\'heure des actions. Nous recueillons et stockons également vos données à chaque fois que vous interagissez avec nous, par exemple, lorsque vous utilisez le support in-app pour communiquer avec nous.</span></p><p class=c6><span class=\"c10 c9\">Informations que vous générez et affichez au cours de l\'utilisation des services de Jeu.&nbsp;</span></p><p class=c24><span class=c1>Vous pouvez fournir des informations supplémentaires dans le cadre de votre profil (comme le sexe). Vous pouvez également fournir ou générer des informations lorsque vous communiquez avec d\'autres utilisateurs du Jeu (par exemple, les données du journal du chat, le contenu du chat).</span></p><p class=c6><span class=\"c10 c9\">Données que nous recueillons auprès de nos partenaires.</span></p><ul class=\"c3 lst-kix_list_23-0\"><li class=c16><span class=\"c1 c9\">Les données que nous recevons si vous liez un outil tiers avec le Service (tel que WeChat, Facebook)</span></li><li class=c16><span class=\"c29 c9\">Les données démographiques (afin de déterminer l\'emplacement approximatif de votre adresse IP)</span></li><li class=c16><span class=\"c29 c9\">Les données visant à lutter contre la fraude (tels que l\'abus de remboursement dans les jeux ou la fraude au clic dans la publicité)</span></li><li class=c16><span class=\"c29 c9\">Les données des plates-formes sur lesquelles les jeux s\'exécutent (par exemple pour vérifier le paiement)</span></li><li class=c16><span class=\"c29 c9\">Les données aux fins de publicité et d\'analyse, afin que nous puissions vous fournir un meilleur Service</span></li></ul><p class=c6><span class=\"c10 c9\">Cookies.</span></p><p class=c6><span class=\"c1 c9\">Nous utilisons des cookies et d\'autres technologies similaires (par exemple, balises Web, fichiers journaux, scripts et eTags) (« Cookies ») pour améliorer votre expérience d\'utilisation des Services. Les cookies sont de petits fichiers qui, lorsqu\'ils sont placés sur votre appareil, nous permettent de fournir certaines caractéristiques et fonctionnalités. Vous avez la possibilité d\'autoriser l\'installation de ces cookies ou de les désactiver ultérieurement. Vous pouvez accepter tous les cookies, ou demander à l\'appareil (dans le cas du Jeu) d\'afficher un avis au moment de l\'installation des cookies, ou refuser d\'accepter tous les cookies en ajustant la fonction de rétention des cookies sur votre appareil. Cependant, en cas de refus de votre part d\'installer des cookies, le Jeu peut ne pas pouvoir fonctionner comme prévu.</span></p><p class=c6><span class=\"c10 c9\">2. Comment nous utilisons vos informations personnelles</span></p><p class=c35><span class=\"c1 c9\">Nous utiliserons les informations de la manière suivante:</span></p><p class=\"c25 c35\"><span class=\"c1 c9\"></span></p><p class=\"c35 c25\"><span class=\"c1 c9\"></span></p><a id=t.d061b78f1e84266cbd25e946e780b701de1ad3d1></a><a id=t.0></a><table class=c4><tbody><tr class=c28><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c34>Informations personnelles</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c34>Utilisation</span></p></td></tr><tr class=c28><td class=c12 colspan=1 rowspan=1><p class=c37><span class=c14>Pseudonyme</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous utilisons ces informations pour créer votre compte pour le Jeu conformément à votre demande.</span></p></td></tr><tr class=c53><td class=c12 colspan=1 rowspan=1><p class=c37><span class=c5>Informations de connexion sociale</span></p><p class=c37><span class=c5>WeChat : Identifiant d\'ouverture, photo de profil, pseudonyme, sexe, région</span></p><p class=c37><span class=c44>Facebook&nbsp;: Nom, identifiant Facebook, photo de profil</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c5>Nous utilisons ces informations pour&nbsp;: • créer votre compte pour le jeu conformément à votre demande ; • partager des photos dans le Jeu sur Facebook à votre demande.</span></p></td></tr><tr class=c20><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Identifiant d\'ouverture généré</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous le générons et l\'utilisons pour stocker vos données de Jeu (y compris le niveau et la progression) avec votre profil.</span></p></td></tr><tr class=c36><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Statistiques de jeu (niveau, score)</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous utilisons ces informations pour vous fournir des commentaires et des informations sur votre jeu et vos progrès.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Adresse IP</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous utilisons ces informations pour améliorer nos services, y compris les fonctionnalités du Jeu.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Identifiant de l\'appareil, informations sur l\'appareil</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous utilisons ces informations&nbsp;: • pour améliorer nos services, y compris les fonctionnalités du jeu ; • à des fins de sécurité et de vérification ; • pour identifier et résoudre les bogues et évaluer la fonction du jeu à des fins d\'optimisation ; et • pour lutter contre les utilisateurs qui créent plusieurs comptes.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Identifiant publicitaire</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Si vous cliquez sur un lien qui annonce le Jeu, nous enregistrons l\'Identifiant publicitaire de cette publicité avec votre profil.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Données du chat</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Si vous activez les services de chat (audio ou texte), nous traiterons alors ces données afin d\'envoyer vos messages à d\'autres utilisateurs.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Enregistrements des transactions&nbsp;: paiements sur Google Play ou iOS App Store.&nbsp;</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous utilisons ces informations pour conserver l\'historique de vos transactions.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Identifiant du ticket de service clientèle et communications de l\'utilisateur avec le service clientèle</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous utilisons ces informations pour : •&nbsp;améliorer nos services ; •&nbsp;fournir des services de dépannage tels que la résolution et la correction de problèmes techniques et de bogues.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c14>Informations relatives à la sécurité</span></p></td><td class=c22 colspan=1 rowspan=1><p class=c7><span class=c14>Nous utilisons ces informations&nbsp;:• à des fins de sécurité et de vérification ; • pour identifier et corriger les bogues et évaluer la fonction du jeu à des fins d\'optimisation ; • pour résoudre les pannes de jeu et optimiser la compatibilité des appareils avec le jeu ; et • pour lutter contre les utilisateurs qui créent plusieurs comptes.</span></p></td></tr><tr class=c27><td class=c12 colspan=1 rowspan=1><p class=c7><span class=c5>Informations sur l’enquête et contenu des réponses à l’enquête</span></p></td><td class=c22 colspan=1 rowspan=1><p class=\"c7 c25\"><span class=c5></span></p></td></tr></tbody></table><p class=c6><span class=\"c10 c9\">Analyse, profil et segment.</span></p><p class=\"c35 c56\"><span class=\"c29 c9\">Dans tous les cas et à toutes les fins susmentionnés, nous pouvons analyser, profiler et segmenter toutes les données recueillies.</span></p><p class=c6><span class=\"c9 c10\">Base juridique du traitement</span></p><p class=c45><span class=c41>Si vous êtes un résident de l\'Union européenne, nous nous appuyons sur un certain nombre de fondements juridiques pour traiter les informations vous concernant. Par exemple, nous traiterons les informations vous concernant lorsque nous aurons votre consentement, lorsque nous aurons un intérêt légitime à le faire, lorsque le traitement sera nécessaire à l\'exécution d\'un contrat avec vous et lorsque nous aurons l\'obligation légale de traiter vos informations. Par exemple, nous comptons sur nos intérêts légitimes afin d\'assurer un marketing ciblé et sur la nécessité contractuelle de traiter les informations lorsque vous créez un compte. Pour en savoir plus sur les fondements juridiques sur lesquels nous nous appuyons pour traiter vos informations à toutes fins particulières, veuillez nous contacter via les options proposées ci-dessous dans la rubrique </span><span class=c10>C</span><span class=c43>ontact et réclamations</span><span class=c41>.</span></p><p class=c6><span class=\"c10 c9\">3. Comment nous partageons vos informations personnelles</span></p><p class=c35><span class=\"c1 c9\">Nous partageons vos informations personnelles avec des tiers choisis dans et en dehors de votre pays, y compris&nbsp;:</span></p><ul class=\"c3 lst-kix_list_23-0\"><li class=c16><span class=\"c21 c9\">Autres joueurs et utilisateurs.</span><span class=\"c19 c9\">&nbsp;</span><span class=\"c29 c9\">Les caractéristiques sociales constituent un élément de base de nos jeux. D\'autres joueurs et utilisateurs peuvent, par exemple, voir les données de votre profil, les activités dans le jeu et lire les messages que vous avez postés.</span></li><li class=c16><span class=\"c9 c21\">Partenaires travaillant pour Tap4Fun.</span><span class=\"c9 c19\">&nbsp;</span><span class=\"c9 c29\">Tap4Fun a des partenaires pour effectuer des services pour nous. Ces partenaires traitent vos données uniquement sur et selon les instructions de Tap4Fun pour fournir le Service, tel que l\'hébergement, le support aux joueurs, la publicité, l\'analyse et la prévention de la fraude.</span></li><li class=c16><span class=\"c21 c9\">Autres sociétés et autorités publiques. </span><span class=\"c29 c9\">Afin de lutter contre la fraude et l\'activité illégale, nous pouvons échanger des données avec d\'autres sociétés et organisations et les fournir aux autorités publiques en réponse à des demandes légitimes. Nous pouvons également divulguer vos données sur la base de votre consentement, pour nous conformer à la loi ou pour protéger les droits, la propriété ou la sécurité de nous-mêmes, des joueurs ou d\'autres utilisateurs.</span></li><li class=c16><span class=\"c21 c9\">Sociétés connexes</span><span class=\"c10 c9\">du groupe (Tap4Fun (Hong Kong) Limited.),</span><span class=\"c1 c9\">&nbsp;avec qui nous partageons vos informations personnelles pour exploiter les services de Jeu&nbsp;;</span></li><li class=c16><span class=\"c10 c9\">Organismes d\'application de la loi, autorités publiques ou autres entités judiciaires et organisations.</span></li><li class=c16><span class=\"c21 c9\">Un tiers qui acquiert la totalité ou la quasi-totalité d\'entre nous ou de notre entreprise.&nbsp;</span><span class=\"c29 c9\">Nous divulguerons des informations à un tiers dans le cas où nous vendrions ou achèterions une entreprise ou ferions l\'objet d\'une fusion, auquel cas nous divulguerons vos données à l\'acheteur potentiel de cette entreprise. Nous divulguerons également des informations à un tiers si nous vendons, achetons, fusionnons ou nous associons avec d\'autres sociétés ou entreprises, ou si nous vendons une partie ou la totalité de nos actifs. Dans de telles transactions, les informations de l\'utilisateur peuvent figurer parmi les actifs transférés.</span></li></ul><p class=c6><span class=\"c10 c9\">4. Conservation des données</span></p><p class=c24><span class=\"c1 c9\">Nous conserverons vos informations personnelles comme décrit ci-dessous (sauf indication contraire de la loi applicable).</span></p><p class=\"c24 c25\"><span class=\"c1 c9\"></span></p><p class=\"c24 c25\"><span class=\"c1 c9\"></span></p><p class=\"c24 c25\"><span class=\"c1 c9\"></span></p><a id=t.8dec7981bc9e37ee4db4dbe4b01b7f93970ac3dc></a><a id=t.1></a><table class=c31><tbody><tr class=c30><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c34>Informations personnelles</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c34>Politique de conservation</span></p></td></tr><tr class=c42><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Pseudonyme</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservé pendant toute la durée de vie de votre utilisation du Jeu (c\'est-à-dire jusqu\'à la suppression du compte conformément à votre demande) et ensuite supprimé dans les 30&nbsp;jours.</span></p></td></tr><tr class=c49><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Informations de connexion sociale :<br>Wechat</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservées pendant toute la durée de vie de votre utilisation du Jeu (c\'est-à-dire jusqu\'à la suppression du compte conformément à votre demande ou jusqu\'à ce que vous suspendiez l\'accès à votre compte de médias sociaux) et ensuite supprimées dans les 30&nbsp;jours.&nbsp;</span></p></td></tr><tr class=c50><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Informations de connexion sociale :<br>Facebook</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservées pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi elles seront supprimées dans les 15&nbsp;jours.<br>Si vous ne demandez pas la suppression de votre compte, ces données seront conservées pendant 1&nbsp;an après la fermeture du Jeu, avant d\'être supprimées.&nbsp;</span></p></td></tr><tr class=c50><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5><br>Statistiques de Jeu (niveau, score)</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservées pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi elles seront supprimées dans les 15&nbsp;jours.&nbsp;<br>Si vous ne demandez pas la suppression de votre compte, ces données seront conservées pendant 1&nbsp;an après la fermeture du Jeu, avant d\'être supprimées.&nbsp;</span></p></td></tr><tr class=c40><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Communications par chat (message audio)</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservées pendant 7&nbsp;jours sur nos serveurs et supprimées automatiquement à l\'expiration de cette période.</span></p></td></tr><tr class=c39><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Communications par chat (texte)</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservées pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi elles seront supprimées dans les 7&nbsp;jours.&nbsp;<br>Si vous ne demandez pas la suppression de votre compte, ces données seront conservées pendant 1&nbsp;an après la fermeture du Jeu, avant d\'être supprimées.&nbsp;</span></p></td></tr><tr class=c32><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Identifiant d\'ouverture</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservé pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi il sera supprimé dans les 15&nbsp;jours.&nbsp;<br>Si vous ne demandez pas la suppression de votre compte, ces données seront conservées pendant 1&nbsp;an après la fermeture du Jeu, avant d\'être supprimées.&nbsp;</span></p></td></tr><tr class=c32><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Adresse IP</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservée pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi elle sera supprimée dans les 15&nbsp;jours.&nbsp;<br>Si vous ne demandez pas la suppression de votre compte, ces données seront conservées pendant 1&nbsp;an après la fermeture du Jeu, avant d\'être supprimées.&nbsp;</span></p></td></tr><tr class=c32><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Identifiant de l\'appareil, informations sur l\'appareil</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservés pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi ils seront supprimés dans les 30&nbsp;jours.<br>Si vous ne demandez pas la suppression de votre compte, ces données seront conservées pendant 1&nbsp;an après la fermeture du Jeu, avant d\'être supprimées.&nbsp;</span></p></td></tr><tr class=c32><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Identifiant publicitaire</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservé pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi il sera supprimé dans les 15&nbsp;jours.&nbsp;<br>Si vous ne demandez pas la suppression de votre compte, ces données seront conservées pendant 1&nbsp;an après la fermeture du Jeu, avant d\'être supprimées.&nbsp;</span></p></td></tr><tr class=c32><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Enregistrements des transactions</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Stockés pendant toute la durée de vie de votre utilisation du Jeu (c\'est-à-dire jusqu\'à la suppression du compte conformément à votre demande), puis pendant toute la durée de toute période de conservation pour laquelle de telles données doivent être conservées afin de se conformer à nos obligations légales.</span></p></td></tr><tr class=c32><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Identifiant du ticket de service clientèle et communications de l\'utilisateur avec le service clientèle</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Les données de support sont supprimées dans les 30&nbsp;jours suivant une demande légale de votre part d\'effacement de ces données (voir la section Effacement de la présente politique de confidentialité).</span></p></td></tr><tr class=c32><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Informations relatives à la sécurité&nbsp;</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservées pendant toute la durée de vie de votre utilisation du Jeu jusqu\'à la suppression du compte conformément à votre demande, suite à quoi elles seront supprimées dans les 30&nbsp;jours.&nbsp;</span></p></td></tr><tr class=c40><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c5>Informations de l\'enquête</span></p></td><td class=c11 colspan=1 rowspan=1><p class=c7><span class=c5>Conservées&nbsp;: (a) si vous fournissez votre adresse électronique dans le cadre de l\'enquête, jusqu\'à 6&nbsp;mois (afin que nous puissions vous contacter) puis les données sont anonymisées ; ou (b) si vous ne fournissez pas votre adresse électronique dans le cadre de l\'enquête, jusqu\'à 1&nbsp;mois, puis les données sont anonymisées.</span></p></td></tr></tbody></table><p class=\"c35 c25\"><span class=\"c1 c9\"></span></p><p class=c24><span class=\"c1 c9\">Les informations personnelles sont conservées jusqu\'à la fin de leur cycle de vie (tel qu\'énoncé dans la politique de conservation ci-dessus). Lors de la destruction des informations personnelles, des mesures seront prises pour rendre les informations personnelles irrécupérables ou non reproductibles, et les fichiers électroniques qui contiennent des informations personnelles seront supprimés de façon permanente à l\'aide d\'une méthode technique qui rend les fichiers non reproductibles.</span></p><p class=c24><span class=\"c1 c9\">Si la période de traitement et de conservation a pris fin, mais que des informations personnelles doivent être conservées de façon continue pour d\'autres raisons, y compris aux fins prescrites par les lois applicables, les informations personnelles pertinentes seront stockées et conservées séparément des autres types d’informations personnelles. Si vous avez besoin de détruire vos informations personnelles avant la fin de leur cycle de vie (comme indiqué dans la politique de conservation ci-dessus), nous détruirons vos informations personnelles conformément aux lois locales.</span></p><p class=c26><span class=c0>SECTION 2&nbsp;: VOS DROITS</span></p><p class=c35><span class=\"c10 c18\">La présente section (« Vos droits »)</span><span class=\"c10 c9\">&nbsp;s\'applique aux utilisateurs situés dans l\'Espace économique européen.</span></p><p class=c24><span class=c1>Vous avez certains droits en ce qui concerne les informations personnelles que nous détenons sur vous. Certains de ces droits ne s\'appliquent que dans certaines circonstances (comme indiqué plus en détail ci-dessous). Nous devons répondre à une demande de votre part d\'exercice de ces droits sans retard injustifié et dans un délai minimum d\'un mois (bien que celui-ci puisse être prolongé de deux mois dans certains cas). Pour exercer vos droits, veuillez nous envoyer un e-mail à </span><span class=c23><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c1 c9\">.</span></p><p class=c6><span class=\"c10 c17\">&nbsp;1. Accès</span></p><p class=c24><span class=c1>Vous avez le droit d\'accéder aux informations personnelles que nous détenons sur vous, de connaître la façon dont nous les utilisons, et de savoir avec qui nous les partageons. Vous pouvez accéder aux informations personnelles que vous avez mises à disposition dans le cadre de votre compte en vous connectant à votre compte de Jeu et en communiquant avec </span><span class=c23><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>. Si vous croyez que nous avons d\'autres informations personnelles vous concernant, veuillez nous envoyer un e-mail à</span><span class=c23><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c1 c9\">.</span></p><p class=c6><span class=\"c10 c17\">2. Portabilité</span></p><p class=c24><span class=c41>Vous avez le droit de recevoir une copie de certaines informations personnelles que nous traitons vous concernant. Cela comprend toutes les informations personnelles que nous traitons sur la base de votre consentement</span><span class=c1>&nbsp;(par exemple, certaines informations de l\'enquête) ou en vertu de notre contrat avec vous, comme décrit dans la section «&nbsp;</span><span class=\"c10 c18\">Comment nous utilisons vos informations personnelles</span><span class=\"c1 c9\">&nbsp;». Vous avez le droit de recevoir ces informations sous un format structuré, couramment utilisé et lisible par une machine. Vous avez également le droit de demander que nous transférions ces informations personnelles à une autre partie.&nbsp;</span></p><p class=c24><span class=\"c1 c9\">Si vous souhaitez que nous transférions ces informations personnelles à une tierce partie, veuillez indiquer les coordonnées de cette partie dans votre demande. Notez que nous ne pouvons le faire que lorsque cela est techniquement possible. Veuillez noter que nous pourrions ne pas être en mesure de vous fournir des informations personnelles si cela interfère avec d’autres droits (p. ex., si en fournissant des informations personnelles que nous détenons vous concernant, cela entraîne la divulgation d\'informations sur une autre personne, sur nos secrets commerciaux ou sur la propriété intellectuelle).</span></p><p class=c6><span class=\"c10 c17\">3. Correction</span></p><p class=c8><span class=c41>Vous avez le droit de corriger les informations personnelles vous concernant qui sont inexactes. Vous pouvez accéder aux informations personnelles que vous avez mises à disposition dans le cadre de votre compte en vous connectant à votre compte de Jeu. Si vous croyez que nous avons d\'autres informations personnelles vous concernant et que ces informations sont inexactes, veuillez nous envoyer un e-mail à</span><span class=c23><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>.</span></p><p class=c6><span class=\"c10 c17\">&nbsp;4. Effacement</span></p><p class=c8><span class=c41>Vous pouvez supprimer votre compte, ou supprimer certaines informations personnelles, en vous connectant à votre compte de jeu. Si vous croyez qu’il y a d\'autres informations personnelles que nous aurions traitées et que vous souhaiteriez effacer, veuillez nous envoyer un e-mail à </span><span class=c23><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>.</span></p><p class=\"c8 c25\"><span class=\"c1 c9\"></span></p><p class=c8><span class=\"c1 c9\">Vous pouvez nous demander de supprimer les informations personnelles que nous détenons sur vous dans les cas suivants&nbsp;:</span></p><ul class=\"c3 lst-kix_list_23-0\"><li class=c16><span class=\"c1 c9\">Vous croyez qu\'il n\'est plus nécessaire pour nous de détenir ces informations personnelles&nbsp;; ou</span></li><li class=c16><span class=\"c1 c9\">Vous croyez que les informations personnelles que nous détenons sur vous ont été illégalement traitées par nous.&nbsp;</span></li></ul><p class=\"c35 c25 c54\"><span class=\"c1 c9\"></span></p><p class=c8><span class=\"c1 c9\">Vous pouvez également exercer votre droit de limiter notre traitement de vos informations personnelles (tel que décrit ci-dessous) pendant que nous examinons votre demande.&nbsp;</span></p><p class=\"c8 c25\"><span class=\"c1 c9\"></span></p><p class=c8><span class=\"c1 c9\">Nous pouvons être amenés à conserver des informations personnelles s\'il y a des motifs valables pour nous de le faire en vertu de lois sur la protection des données (par ex., pour la défense d\'un droit en justice ou la liberté d\'expression) mais nous vous le ferons savoir si c\'est le cas. Si vous avez demandé que nous supprimions des informations personnelles qui ont été mises à la disposition du public sur les services du Jeu et s\'il y a des motifs de suppression, nous prendrons des mesures raisonnables pour essayer d\'imposer aux autres qui publient les informations personnelles ou fournissent des liens vers les informations personnelles de les supprimer.</span></p><p class=c6><span class=\"c10 c17\">&nbsp;5. Restriction du traitement uniquement au stockage</span></p><p class=c8><span class=\"c1 c9\">Vous avez le droit de nous obliger à interrompre le traitement des informations personnelles que nous détenons sur vous pour des fins autres que le stockage dans certaines circonstances. Veuillez noter, toutefois, que si l\'on arrête de traiter les informations personnelles, nous pouvons les utiliser à nouveau si nous avons des motifs valables, en vertu de lois sur la protection des données, de le faire (par ex., pour la défense d\'un droit en justice ou pour la protection d’autrui). Comme ci-dessus, si nous acceptons d\'arrêter le traitement des informations personnelles, nous essaierons de l’indiquer à toute tierce partie à qui nous avons divulgué les informations personnelles pertinentes afin qu\'elle puisse également arrêter le traitement.&nbsp;</span></p><p class=c8><span class=\"c1 c9\">Vous pouvez nous demander d\'arrêter le traitement et de stocker uniquement les informations personnelles que nous détenons sur vous dans les cas suivants&nbsp;:&nbsp;</span></p><ul class=\"c3 lst-kix_list_23-0\"><li class=c16><span class=\"c1 c9\">Vous croyez que les informations personnelles ne sont pas exactes pour la période concernée et qu\'il est nécessaire que nous vérifions si elles sont exactes&nbsp;;</span></li><li class=c16><span class=\"c1 c9\">Vous souhaitez supprimer les informations personnelles étant donné que le traitement que nous faisons est illégal, mais vous voulez que nous conservions les informations personnelles mais juste pour les stocker ; ou&nbsp;</span></li><li class=c16><span class=\"c1 c9\">Vous souhaitez supprimer les informations personnelles qui ne sont plus nécessaires à nos objectifs mais vous exigez qu’elles soient conservées pour l\'établissement, l\'exercice ou la défense d\'un droit en justice.</span></li></ul><p class=c6><span class=\"c10 c17\">6. Opposition</span></p><p class=c8><span class=c41>Vous avez le droit de vous opposer au traitement de vos informations personnelles. Envoyez-nous un e-mail à</span><span class=c23><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c1 c9\">&nbsp;et nous examinerons votre demande dans d\'autres circonstances, comme détaillé ci-dessous.</span></p><p class=c6><span class=\"c10 c17\">&nbsp;7. Annonces</span></p><p class=c8><span class=\"c1 c9\">Nous pouvons de temps à autre vous envoyer des annonces lorsque nous considérons qu\'il est nécessaire de le faire (par exemple, lorsque nous suspendons l’accès au Jeu temporairement à des fins de maintenance, ou pour vous envoyer des avis relatifs à la sécurité, la confidentialité ou l\'administration). Vous ne pouvez pas refuser ces annonces liées au service, qui ne sont pas de nature promotionnelle.&nbsp;</span></p><p class=c26><span class=c0>SECTION 3&nbsp;: DISPOSITIONS DIVERSES </span></p><p class=c6><span class=\"c10 c9\">1. Sécurité des informations</span></p><p class=c8><span class=\"c1 c9\">Nous avons mis en œuvre des mesures de sécurité administratives, physiques et techniques qui ont été conçues pour protéger vos informations de la perte, la mauvaise utilisation, l\'accès non autorisé, la divulgation, l\'altération et la destruction. Cependant, vous devrez comprendre qu\'en dépit de nos efforts, aucune sécurité ne peut être garantie comme infaillible.</span></p><p class=c6><span class=\"c10 c9\">2. Informations relatives aux enfants</span></p><p class=c8 id=h.gjdgxs><span class=\"c1 c9\">Nous ne recueillons pas sciemment ni ne sollicitons des informations personnelles de, ou dirigeons ou ciblons la publicité basée sur l\'intérêt à toute personne âgée de moins de 16&nbsp;ans, ou permettons sciemment à ces personnes d\'utiliser nos services. Si vous avez moins de 16&nbsp;ans, veuillez ne pas nous envoyer d\'informations vous concernant, y compris votre nom, adresse, numéro de téléphone, ou adresse e-mail. Aucune personne âgée de moins de 16&nbsp;ans ne peut fournir d\'informations personnelles. Dans l\'éventualité où nous apprendrions que nous avons recueilli des informations personnelles d\'un enfant âgé de moins de 16&nbsp;ans, nous détruirions ces informations aussi rapidement que possible. Si vous pensez que nous pouvons être en possession d\'informations de ou sur un enfant âgé de moins de 16&nbsp;ans, veuillez nous contacter.</span></p><p class=c6><span class=c10>3.</span><span class=c55>&nbsp;</span><span class=\"c10 c9\">Liens vers des sites et des services exploités par d\'autres</span></p><p class=\"c6 c52\"><span class=\"c1 c9\">Le service Tap4Fun peut contenir des liens vers d\'autres sites, applications et services. Du fait que Tap4Fun n’exploite pas ces autres sites, applications et services, nous ne pouvons pas prendre la responsabilité des pratiques de confidentialité des entités qui les exploitent. Nous vous recommandons de toujours vérifier les politiques de confidentialité pour comprendre les pratiques d\'un opérateur. Pour rappel, cette présente politique décrit les pratiques de tap4Fun.</span></p><p class=c6><span class=\"c10 c9\">4. Modifications</span></p><p class=c8><span class=\"c1 c9\">Tap4Fun peut mettre à jour cette présente politique de confidentialité de temps en temps. Quand nous l\'actualisons, nous réviserons la date de «&nbsp;dernière mise à jour&nbsp;» ci-dessus. Si nous faisons d\'importantes modifications dans la manière de recueillir, utiliser, conserver ou partager vos informations personnelles, nous vous avertirons en vous envoyant un e-mail à l\'adresse que vous nous avez indiquée, ou en affichant un avis de modifications des services couverts par la présente politique de confidentialité.</span></p><p class=c6><span class=\"c10 c9\">4. Transfert international</span></p><p class=\"c6 c13\"><span class=\"c1 c9\">Nous pouvons transférer des informations que nous recueillons à votre sujet à des entités affiliées, ou à d\'autres tierces parties à l\'étranger ou de votre pays ou juridiction vers d\'autres pays ou juridictions du monde entier. Veuillez noter que ces pays et juridictions peuvent ne pas avoir les mêmes lois de protection des données que votre propre juridiction, et nous prenons des mesures pour assurer que des garanties adéquates sont en place pour permettre le transfert des informations et l\'utilisation et la divulgation des informations vous concernant, y compris les informations personnelles, comme décrit dans la présente politique.</span></p><p class=c6><span class=\"c10 c9\">5. Contact et réclamations</span></p><p class=c24><span class=c1>Toutes questions, tous commentaires et toutes demandes concernant cette présente politique sont les bienvenus. Veuillez nous contacter par e-mail à </span><span class=c23><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c1 c9\">, par téléphone au 0086-028-83313298, ou par courrier postal à Tap4Fun Co., Ltd, Attn&nbsp;: Privacy Administrator, Building A3, Tianfu software park, high-tech zone, Chengdu, Sichuan, Chine.</span></p><p class=c8><span class=\"c1 c9\">Si vous désirez déposer une réclamation sur la manière dont nous traitons vos informations personnelles, veuillez nous contacter en premier lieu à </span><span class=c46><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=\"c1 c9\">&nbsp;et nous nous efforcerons de traiter votre demande dans les plus brefs délais. Cela ne remet pas en cause votre droit d’engager une action auprès de l\'autorité de protection des données du pays où vous vivez ou travaillez, si vous pensez que nous avons enfreint la législation sur la protection des données.</span></p><br></div><div ng-if=\"privacy.lang == \'pt-BR\'\"><style type=text/css>ol.lst-kix_list_7-0{list-style-type:none}.lst-kix_list_14-1>li:before{content:\"o  \"}.lst-kix_list_14-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-0.start{counter-reset:lst-ctn-kix_list_9-0 0}.lst-kix_list_14-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_14-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-6>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_9-1{list-style-type:none}ol.lst-kix_list_7-4.start{counter-reset:lst-ctn-kix_list_7-4 0}.lst-kix_list_9-0>li{counter-increment:lst-ctn-kix_list_9-0}ol.lst-kix_list_7-5{list-style-type:none}ol.lst-kix_list_7-6{list-style-type:none}ol.lst-kix_list_7-7{list-style-type:none}ol.lst-kix_list_7-8{list-style-type:none}ol.lst-kix_list_7-1{list-style-type:none}ol.lst-kix_list_11-8.start{counter-reset:lst-ctn-kix_list_11-8 0}ol.lst-kix_list_7-3{list-style-type:none}ol.lst-kix_list_7-4{list-style-type:none}.lst-kix_list_14-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-1{list-style-type:none}ul.lst-kix_list_17-0{list-style-type:none}ul.lst-kix_list_17-8{list-style-type:none}ul.lst-kix_list_17-7{list-style-type:none}ul.lst-kix_list_17-6{list-style-type:none}ul.lst-kix_list_17-5{list-style-type:none}ul.lst-kix_list_17-4{list-style-type:none}ul.lst-kix_list_17-3{list-style-type:none}.lst-kix_list_14-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-2{list-style-type:none}ol.lst-kix_list_8-8.start{counter-reset:lst-ctn-kix_list_8-8 0}ol.lst-kix_list_10-4.start{counter-reset:lst-ctn-kix_list_10-4 0}.lst-kix_list_5-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-0{list-style-type:none}.lst-kix_list_24-7>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_27-0{list-style-type:none}ul.lst-kix_list_27-1{list-style-type:none}.lst-kix_list_24-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_27-2{list-style-type:none}.lst-kix_list_5-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-5.start{counter-reset:lst-ctn-kix_list_9-5 0}.lst-kix_list_5-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-3>li{counter-increment:lst-ctn-kix_list_8-3}.lst-kix_list_5-1>li:before{content:\"o  \"}.lst-kix_list_24-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_5-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_24-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_24-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_9-4>li{counter-increment:lst-ctn-kix_list_9-4}ol.lst-kix_list_6-6{list-style-type:none}ul.lst-kix_list_27-3{list-style-type:none}.lst-kix_list_24-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_6-7{list-style-type:none}ul.lst-kix_list_27-4{list-style-type:none}.lst-kix_list_5-4>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-8{list-style-type:none}ul.lst-kix_list_27-5{list-style-type:none}ul.lst-kix_list_27-6{list-style-type:none}.lst-kix_list_5-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-2{list-style-type:none}ul.lst-kix_list_27-7{list-style-type:none}ol.lst-kix_list_6-3{list-style-type:none}ul.lst-kix_list_27-8{list-style-type:none}ol.lst-kix_list_6-4{list-style-type:none}.lst-kix_list_24-6>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-5{list-style-type:none}.lst-kix_list_23-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_6-1>li:before{content:\"o  \"}.lst-kix_list_6-3>li:before{content:\"\" counter(lst-ctn-kix_list_6-3,decimal) \". \"}.lst-kix_list_6-5>li{counter-increment:lst-ctn-kix_list_6-5}.lst-kix_list_6-8>li{counter-increment:lst-ctn-kix_list_6-8}.lst-kix_list_23-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-0>li:before{content:\"\" counter(lst-ctn-kix_list_6-0,decimal) \". \"}.lst-kix_list_6-4>li:before{content:\"\" counter(lst-ctn-kix_list_6-4,decimal) \". \"}.lst-kix_list_23-2>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_16-2{list-style-type:none}ul.lst-kix_list_16-1{list-style-type:none}ul.lst-kix_list_16-0{list-style-type:none}.lst-kix_list_23-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_23-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-2>li:before{content:\"\" counter(lst-ctn-kix_list_6-2,decimal) \". \"}.lst-kix_list_24-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_16-8{list-style-type:none}ul.lst-kix_list_16-7{list-style-type:none}ul.lst-kix_list_16-6{list-style-type:none}ul.lst-kix_list_16-5{list-style-type:none}.lst-kix_list_24-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_16-4{list-style-type:none}.lst-kix_list_6-8>li:before{content:\"\" counter(lst-ctn-kix_list_6-8,decimal) \". \"}ul.lst-kix_list_16-3{list-style-type:none}.lst-kix_list_6-5>li:before{content:\"\" counter(lst-ctn-kix_list_6-5,decimal) \". \"}.lst-kix_list_6-7>li:before{content:\"\" counter(lst-ctn-kix_list_6-7,decimal) \". \"}.lst-kix_list_23-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_23-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_6-6>li:before{content:\"\" counter(lst-ctn-kix_list_6-6,decimal) \". \"}ol.lst-kix_list_10-6.start{counter-reset:lst-ctn-kix_list_10-6 0}.lst-kix_list_7-4>li:before{content:\"\" counter(lst-ctn-kix_list_7-4,upper-roman) \". \"}.lst-kix_list_7-6>li:before{content:\"\" counter(lst-ctn-kix_list_7-6,upper-roman) \". \"}ol.lst-kix_list_6-2.start{counter-reset:lst-ctn-kix_list_6-2 0}.lst-kix_list_22-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_22-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-6>li{counter-increment:lst-ctn-kix_list_7-6}.lst-kix_list_8-6>li{counter-increment:lst-ctn-kix_list_8-6}.lst-kix_list_22-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-7{list-style-type:none}ol.lst-kix_list_9-8{list-style-type:none}.lst-kix_list_13-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-3{list-style-type:none}ol.lst-kix_list_9-4{list-style-type:none}ol.lst-kix_list_9-5{list-style-type:none}.lst-kix_list_7-8>li:before{content:\"\" counter(lst-ctn-kix_list_7-8,upper-roman) \". \"}ol.lst-kix_list_9-6{list-style-type:none}ol.lst-kix_list_9-0{list-style-type:none}ol.lst-kix_list_9-2{list-style-type:none}.lst-kix_list_22-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-8>li{counter-increment:lst-ctn-kix_list_9-8}.lst-kix_list_4-1>li:before{content:\"o  \"}.lst-kix_list_15-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-7{list-style-type:none}ul.lst-kix_list_19-6{list-style-type:none}.lst-kix_list_4-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-5{list-style-type:none}ul.lst-kix_list_19-4{list-style-type:none}ul.lst-kix_list_19-3{list-style-type:none}.lst-kix_list_25-5>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_19-2{list-style-type:none}ul.lst-kix_list_19-1{list-style-type:none}.lst-kix_list_10-5>li{counter-increment:lst-ctn-kix_list_10-5}ul.lst-kix_list_19-0{list-style-type:none}.lst-kix_list_15-1>li:before{content:\"o  \"}.lst-kix_list_25-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_15-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-8{list-style-type:none}.lst-kix_list_6-4>li{counter-increment:lst-ctn-kix_list_6-4}ol.lst-kix_list_9-2.start{counter-reset:lst-ctn-kix_list_9-2 0}.lst-kix_list_9-3>li{counter-increment:lst-ctn-kix_list_9-3}.lst-kix_list_11-2>li{counter-increment:lst-ctn-kix_list_11-2}ol.lst-kix_list_8-8{list-style-type:none}.lst-kix_list_12-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-6.start{counter-reset:lst-ctn-kix_list_7-6 0}ol.lst-kix_list_8-4{list-style-type:none}.lst-kix_list_12-1>li:before{content:\"o  \"}ol.lst-kix_list_8-5{list-style-type:none}ol.lst-kix_list_8-6{list-style-type:none}ol.lst-kix_list_8-7{list-style-type:none}ol.lst-kix_list_8-0{list-style-type:none}ol.lst-kix_list_8-1{list-style-type:none}ol.lst-kix_list_8-2{list-style-type:none}ol.lst-kix_list_8-3{list-style-type:none}.lst-kix_list_10-4>li{counter-increment:lst-ctn-kix_list_10-4}.lst-kix_list_13-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-0{list-style-type:none}.lst-kix_list_13-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-8{list-style-type:none}ul.lst-kix_list_18-7{list-style-type:none}ul.lst-kix_list_18-6{list-style-type:none}ul.lst-kix_list_18-5{list-style-type:none}.lst-kix_list_12-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-4{list-style-type:none}ul.lst-kix_list_18-3{list-style-type:none}ul.lst-kix_list_18-2{list-style-type:none}ol.lst-kix_list_6-0.start{counter-reset:lst-ctn-kix_list_6-0 0}ul.lst-kix_list_18-1{list-style-type:none}.lst-kix_list_13-1>li:before{content:\"o  \"}ul.lst-kix_list_24-0{list-style-type:none}ul.lst-kix_list_24-1{list-style-type:none}ul.lst-kix_list_24-2{list-style-type:none}ul.lst-kix_list_24-3{list-style-type:none}ul.lst-kix_list_24-4{list-style-type:none}ul.lst-kix_list_24-5{list-style-type:none}ol.lst-kix_list_11-6{list-style-type:none}ol.lst-kix_list_11-7{list-style-type:none}ol.lst-kix_list_11-8{list-style-type:none}.lst-kix_list_7-1>li{counter-increment:lst-ctn-kix_list_7-1}ol.lst-kix_list_11-2{list-style-type:none}ol.lst-kix_list_11-3{list-style-type:none}.lst-kix_list_3-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_11-4{list-style-type:none}ol.lst-kix_list_11-5{list-style-type:none}ul.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_5-8{list-style-type:none}ul.lst-kix_list_5-5{list-style-type:none}ol.lst-kix_list_11-0{list-style-type:none}ul.lst-kix_list_5-6{list-style-type:none}.lst-kix_list_21-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_8-0>li{counter-increment:lst-ctn-kix_list_8-0}ul.lst-kix_list_24-6{list-style-type:none}ul.lst-kix_list_5-0{list-style-type:none}ul.lst-kix_list_24-7{list-style-type:none}.lst-kix_list_10-0>li{counter-increment:lst-ctn-kix_list_10-0}.lst-kix_list_3-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_24-8{list-style-type:none}ul.lst-kix_list_5-3{list-style-type:none}.lst-kix_list_3-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_5-4{list-style-type:none}.lst-kix_list_26-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_5-1{list-style-type:none}.lst-kix_list_8-0>li:before{content:\"\" counter(lst-ctn-kix_list_8-0,upper-roman) \". \"}ul.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_8-7>li:before{content:\"\" counter(lst-ctn-kix_list_8-7,upper-roman) \". \"}.lst-kix_list_3-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_10-7.start{counter-reset:lst-ctn-kix_list_10-7 0}.lst-kix_list_26-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_21-1>li:before{content:\"o  \"}.lst-kix_list_8-3>li:before{content:\"\" counter(lst-ctn-kix_list_8-3,upper-roman) \". \"}ul.lst-kix_list_13-5{list-style-type:none}ul.lst-kix_list_13-4{list-style-type:none}ul.lst-kix_list_13-3{list-style-type:none}ul.lst-kix_list_13-2{list-style-type:none}ul.lst-kix_list_13-1{list-style-type:none}.lst-kix_list_3-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_13-0{list-style-type:none}.lst-kix_list_26-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li:before{content:\"\" counter(lst-ctn-kix_list_8-4,upper-roman) \". \"}.lst-kix_list_10-2>li{counter-increment:lst-ctn-kix_list_10-2}ol.lst-kix_list_8-5.start{counter-reset:lst-ctn-kix_list_8-5 0}ul.lst-kix_list_13-8{list-style-type:none}.lst-kix_list_11-1>li:before{content:\"o  \"}ul.lst-kix_list_13-7{list-style-type:none}ul.lst-kix_list_13-6{list-style-type:none}.lst-kix_list_21-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-0>li:before{content:\"\" counter(lst-ctn-kix_list_11-0,decimal) \". \"}ol.lst-kix_list_9-3.start{counter-reset:lst-ctn-kix_list_9-3 0}.lst-kix_list_26-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_8-8>li:before{content:\"\" counter(lst-ctn-kix_list_8-8,upper-roman) \". \"}.lst-kix_list_16-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-0{list-style-type:none}ul.lst-kix_list_23-1{list-style-type:none}.lst-kix_list_16-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-2{list-style-type:none}ul.lst-kix_list_23-3{list-style-type:none}ul.lst-kix_list_23-4{list-style-type:none}ul.lst-kix_list_23-5{list-style-type:none}ul.lst-kix_list_23-6{list-style-type:none}.lst-kix_list_4-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-8{list-style-type:none}.lst-kix_list_16-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-6{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}.lst-kix_list_25-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li{counter-increment:lst-ctn-kix_list_8-4}ul.lst-kix_list_4-0{list-style-type:none}ul.lst-kix_list_23-7{list-style-type:none}.lst-kix_list_25-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_23-8{list-style-type:none}ol.lst-kix_list_10-8.start{counter-reset:lst-ctn-kix_list_10-8 0}.lst-kix_list_16-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-4{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}.lst-kix_list_11-3>li{counter-increment:lst-ctn-kix_list_11-3}ol.lst-kix_list_7-1.start{counter-reset:lst-ctn-kix_list_7-1 0}ul.lst-kix_list_12-6{list-style-type:none}ol.lst-kix_list_8-6.start{counter-reset:lst-ctn-kix_list_8-6 0}ul.lst-kix_list_12-5{list-style-type:none}.lst-kix_list_17-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-4{list-style-type:none}ul.lst-kix_list_12-3{list-style-type:none}ul.lst-kix_list_12-2{list-style-type:none}ul.lst-kix_list_12-1{list-style-type:none}.lst-kix_list_17-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-0{list-style-type:none}.lst-kix_list_17-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-8{list-style-type:none}ul.lst-kix_list_12-7{list-style-type:none}ol.lst-kix_list_8-0.start{counter-reset:lst-ctn-kix_list_8-0 0}.lst-kix_list_7-0>li:before{content:\"\" counter(lst-ctn-kix_list_7-0,upper-roman) \". \"}ol.lst-kix_list_9-7.start{counter-reset:lst-ctn-kix_list_9-7 0}.lst-kix_list_22-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_2-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-1{list-style-type:none}ul.lst-kix_list_26-2{list-style-type:none}ul.lst-kix_list_26-3{list-style-type:none}.lst-kix_list_22-1>li:before{content:\"o  \"}.lst-kix_list_27-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-6>li{counter-increment:lst-ctn-kix_list_6-6}.lst-kix_list_7-3>li:before{content:\"\" counter(lst-ctn-kix_list_7-3,upper-roman) \". \"}.lst-kix_list_10-0>li:before{content:\"\" counter(lst-ctn-kix_list_10-0,decimal) \". \"}.lst-kix_list_9-7>li{counter-increment:lst-ctn-kix_list_9-7}.lst-kix_list_13-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-4{list-style-type:none}ul.lst-kix_list_26-5{list-style-type:none}ul.lst-kix_list_26-6{list-style-type:none}ul.lst-kix_list_26-7{list-style-type:none}.lst-kix_list_8-7>li{counter-increment:lst-ctn-kix_list_8-7}ul.lst-kix_list_26-8{list-style-type:none}ul.lst-kix_list_7-2{list-style-type:none}.lst-kix_list_27-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_7-7>li:before{content:\"\" counter(lst-ctn-kix_list_7-7,upper-roman) \". \"}ol.lst-kix_list_8-1.start{counter-reset:lst-ctn-kix_list_8-1 0}.lst-kix_list_15-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-5>li{counter-increment:lst-ctn-kix_list_9-5}.lst-kix_list_10-4>li:before{content:\"\" counter(lst-ctn-kix_list_10-4,decimal) \". \"}.lst-kix_list_10-8>li:before{content:\"\" counter(lst-ctn-kix_list_10-8,decimal) \". \"}.lst-kix_list_4-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-3{list-style-type:none}ul.lst-kix_list_15-2{list-style-type:none}.lst-kix_list_15-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-1{list-style-type:none}.lst-kix_list_15-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_15-0{list-style-type:none}.lst-kix_list_4-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_25-4>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_15-8{list-style-type:none}ul.lst-kix_list_15-7{list-style-type:none}ul.lst-kix_list_15-6{list-style-type:none}.lst-kix_list_9-3>li:before{content:\"\" counter(lst-ctn-kix_list_9-3,decimal) \". \"}ul.lst-kix_list_15-5{list-style-type:none}ul.lst-kix_list_15-4{list-style-type:none}ol.lst-kix_list_7-0.start{counter-reset:lst-ctn-kix_list_7-0 0}.lst-kix_list_25-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_25-0{list-style-type:none}ul.lst-kix_list_25-1{list-style-type:none}ul.lst-kix_list_25-2{list-style-type:none}.lst-kix_list_9-7>li:before{content:\"\" counter(lst-ctn-kix_list_9-7,decimal) \". \"}ul.lst-kix_list_25-3{list-style-type:none}ul.lst-kix_list_25-4{list-style-type:none}.lst-kix_list_11-4>li:before{content:\"\" counter(lst-ctn-kix_list_11-4,decimal) \". \"}.lst-kix_list_12-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_20-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-4>li{counter-increment:lst-ctn-kix_list_7-4}ul.lst-kix_list_25-5{list-style-type:none}.lst-kix_list_1-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_25-6{list-style-type:none}.lst-kix_list_20-1>li:before{content:\"o  \"}ul.lst-kix_list_25-7{list-style-type:none}ul.lst-kix_list_25-8{list-style-type:none}.lst-kix_list_11-8>li:before{content:\"\" counter(lst-ctn-kix_list_11-8,decimal) \". \"}.lst-kix_list_12-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_6-1{list-style-type:none}ol.lst-kix_list_8-4.start{counter-reset:lst-ctn-kix_list_8-4 0}.lst-kix_list_1-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_14-4{list-style-type:none}ul.lst-kix_list_14-3{list-style-type:none}ul.lst-kix_list_14-2{list-style-type:none}.lst-kix_list_13-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_14-1{list-style-type:none}ul.lst-kix_list_14-0{list-style-type:none}.lst-kix_list_10-7>li{counter-increment:lst-ctn-kix_list_10-7}ul.lst-kix_list_14-8{list-style-type:none}ul.lst-kix_list_14-7{list-style-type:none}.lst-kix_list_2-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_8-3.start{counter-reset:lst-ctn-kix_list_8-3 0}ul.lst-kix_list_14-6{list-style-type:none}.lst-kix_list_11-5>li{counter-increment:lst-ctn-kix_list_11-5}ul.lst-kix_list_14-5{list-style-type:none}ol.lst-kix_list_9-8.start{counter-reset:lst-ctn-kix_list_9-8 0}.lst-kix_list_1-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_12-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-2>li{counter-increment:lst-ctn-kix_list_8-2}ul.lst-kix_list_20-2{list-style-type:none}ul.lst-kix_list_20-3{list-style-type:none}.lst-kix_list_19-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_19-1>li:before{content:\"o  \"}ul.lst-kix_list_20-4{list-style-type:none}ul.lst-kix_list_20-5{list-style-type:none}ul.lst-kix_list_20-6{list-style-type:none}ul.lst-kix_list_1-0{list-style-type:none}ul.lst-kix_list_20-7{list-style-type:none}ul.lst-kix_list_20-8{list-style-type:none}.lst-kix_list_19-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-1>li{counter-increment:lst-ctn-kix_list_8-1}ol.lst-kix_list_8-2.start{counter-reset:lst-ctn-kix_list_8-2 0}.lst-kix_list_19-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_20-0{list-style-type:none}ul.lst-kix_list_20-1{list-style-type:none}ol.lst-kix_list_6-6.start{counter-reset:lst-ctn-kix_list_6-6 0}.lst-kix_list_7-0>li{counter-increment:lst-ctn-kix_list_7-0}.lst-kix_list_11-0>li{counter-increment:lst-ctn-kix_list_11-0}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}ul.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_9-6.start{counter-reset:lst-ctn-kix_list_9-6 0}.lst-kix_list_19-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-2.start{counter-reset:lst-ctn-kix_list_11-2 0}.lst-kix_list_19-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-2>li{counter-increment:lst-ctn-kix_list_9-2}ol.lst-kix_list_8-7.start{counter-reset:lst-ctn-kix_list_8-7 0}.lst-kix_list_10-3>li{counter-increment:lst-ctn-kix_list_10-3}.lst-kix_list_18-0>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-1>li:before{content:\"o  \"}.lst-kix_list_18-2>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-7.start{counter-reset:lst-ctn-kix_list_11-7 0}ul.lst-kix_list_22-0{list-style-type:none}.lst-kix_list_2-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_22-1{list-style-type:none}ul.lst-kix_list_22-2{list-style-type:none}ul.lst-kix_list_22-3{list-style-type:none}ul.lst-kix_list_22-4{list-style-type:none}.lst-kix_list_2-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-3>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_22-5{list-style-type:none}ul.lst-kix_list_22-6{list-style-type:none}ul.lst-kix_list_22-7{list-style-type:none}.lst-kix_list_27-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_10-3.start{counter-reset:lst-ctn-kix_list_10-3 0}.lst-kix_list_18-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-4.start{counter-reset:lst-ctn-kix_list_9-4 0}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_list_10-1>li:before{content:\"o  \"}.lst-kix_list_18-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_3-1{list-style-type:none}ul.lst-kix_list_22-8{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_7-7>li{counter-increment:lst-ctn-kix_list_7-7}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_10-7>li:before{content:\"\" counter(lst-ctn-kix_list_10-7,decimal) \". \"}.lst-kix_list_7-8>li{counter-increment:lst-ctn-kix_list_7-8}.lst-kix_list_10-5>li:before{content:\"\" counter(lst-ctn-kix_list_10-5,decimal) \". \"}.lst-kix_list_10-3>li:before{content:\"\" counter(lst-ctn-kix_list_10-3,decimal) \". \"}ol.lst-kix_list_7-3.start{counter-reset:lst-ctn-kix_list_7-3 0}ul.lst-kix_list_11-1{list-style-type:none}.lst-kix_list_11-7>li{counter-increment:lst-ctn-kix_list_11-7}.lst-kix_list_9-2>li:before{content:\"\" counter(lst-ctn-kix_list_9-2,decimal) \". \"}.lst-kix_list_20-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-0>li:before{content:\"\" counter(lst-ctn-kix_list_9-0,decimal) \". \"}ul.lst-kix_list_21-1{list-style-type:none}ul.lst-kix_list_21-2{list-style-type:none}ul.lst-kix_list_21-3{list-style-type:none}ul.lst-kix_list_21-4{list-style-type:none}.lst-kix_list_20-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_21-5{list-style-type:none}ul.lst-kix_list_21-6{list-style-type:none}ul.lst-kix_list_21-7{list-style-type:none}ul.lst-kix_list_21-8{list-style-type:none}ol.lst-kix_list_10-7{list-style-type:none}.lst-kix_list_9-6>li:before{content:\"\" counter(lst-ctn-kix_list_9-6,decimal) \". \"}ol.lst-kix_list_10-8{list-style-type:none}ol.lst-kix_list_10-3{list-style-type:none}.lst-kix_list_9-4>li:before{content:\"\" counter(lst-ctn-kix_list_9-4,decimal) \". \"}ol.lst-kix_list_10-4{list-style-type:none}ol.lst-kix_list_10-5{list-style-type:none}.lst-kix_list_11-3>li:before{content:\"\" counter(lst-ctn-kix_list_11-3,decimal) \". \"}ol.lst-kix_list_10-6{list-style-type:none}ul.lst-kix_list_21-0{list-style-type:none}.lst-kix_list_6-3>li{counter-increment:lst-ctn-kix_list_6-3}.lst-kix_list_20-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-0{list-style-type:none}ul.lst-kix_list_2-8{list-style-type:none}ol.lst-kix_list_10-2{list-style-type:none}.lst-kix_list_20-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-5>li:before{content:\"\" counter(lst-ctn-kix_list_11-5,decimal) \". \"}ul.lst-kix_list_2-2{list-style-type:none}.lst-kix_list_20-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_9-8>li:before{content:\"\" counter(lst-ctn-kix_list_9-8,decimal) \". \"}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:\"o  \"}ul.lst-kix_list_2-7{list-style-type:none}.lst-kix_list_11-7>li:before{content:\"\" counter(lst-ctn-kix_list_11-7,decimal) \". \"}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_8-5>li{counter-increment:lst-ctn-kix_list_8-5}.lst-kix_list_1-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-5.start{counter-reset:lst-ctn-kix_list_10-5 0}.lst-kix_list_1-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_1-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_10-1{list-style-type:none}ol.lst-kix_list_7-5.start{counter-reset:lst-ctn-kix_list_7-5 0}.lst-kix_list_2-1>li:before{content:\"o  \"}.lst-kix_list_27-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_2-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-8>li{counter-increment:lst-ctn-kix_list_11-8}ol.lst-kix_list_7-7.start{counter-reset:lst-ctn-kix_list_7-7 0}.lst-kix_list_3-1>li:before{content:\"o  \"}.lst-kix_list_3-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_26-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-1>li:before{content:\"\" counter(lst-ctn-kix_list_8-1,upper-roman) \". \"}.lst-kix_list_8-2>li:before{content:\"\" counter(lst-ctn-kix_list_8-2,upper-roman) \". \"}.lst-kix_list_6-0>li{counter-increment:lst-ctn-kix_list_6-0}.lst-kix_list_3-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-5.start{counter-reset:lst-ctn-kix_list_11-5 0}.lst-kix_list_21-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-5>li:before{content:\"\" counter(lst-ctn-kix_list_8-5,upper-roman) \". \"}.lst-kix_list_8-6>li:before{content:\"\" counter(lst-ctn-kix_list_8-6,upper-roman) \". \"}.lst-kix_list_26-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_26-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_3-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-2>li:before{content:\"\" counter(lst-ctn-kix_list_11-2,decimal) \". \"}.lst-kix_list_21-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-6.start{counter-reset:lst-ctn-kix_list_11-6 0}.lst-kix_list_16-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-4.start{counter-reset:lst-ctn-kix_list_6-4 0}.lst-kix_list_25-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_17-1>li:before{content:\"o  \"}.lst-kix_list_25-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-1>li:before{content:\"o  \"}.lst-kix_list_7-3>li{counter-increment:lst-ctn-kix_list_7-3}.lst-kix_list_16-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_16-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-8.start{counter-reset:lst-ctn-kix_list_7-8 0}ol.lst-kix_list_11-0.start{counter-reset:lst-ctn-kix_list_11-0 0}ol.lst-kix_list_6-3.start{counter-reset:lst-ctn-kix_list_6-3 0}ol.lst-kix_list_10-2.start{counter-reset:lst-ctn-kix_list_10-2 0}.lst-kix_list_17-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-2>li{counter-increment:lst-ctn-kix_list_6-2}.lst-kix_list_2-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_22-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-1>li:before{content:\"\" counter(lst-ctn-kix_list_7-1,decimal) \". \"}.lst-kix_list_7-5>li:before{content:\"\" counter(lst-ctn-kix_list_7-5,upper-roman) \". \"}.lst-kix_list_9-6>li{counter-increment:lst-ctn-kix_list_9-6}.lst-kix_list_27-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-7>li{counter-increment:lst-ctn-kix_list_6-7}.lst-kix_list_10-6>li{counter-increment:lst-ctn-kix_list_10-6}.lst-kix_list_11-6>li{counter-increment:lst-ctn-kix_list_11-6}ol.lst-kix_list_10-0.start{counter-reset:lst-ctn-kix_list_10-0 0}.lst-kix_list_7-5>li{counter-increment:lst-ctn-kix_list_7-5}.lst-kix_list_15-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-4>li{counter-increment:lst-ctn-kix_list_11-4}ol.lst-kix_list_6-8.start{counter-reset:lst-ctn-kix_list_6-8 0}.lst-kix_list_10-2>li:before{content:\"\" counter(lst-ctn-kix_list_10-2,decimal) \". \"}.lst-kix_list_20-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-5.start{counter-reset:lst-ctn-kix_list_6-5 0}.lst-kix_list_4-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_10-8>li{counter-increment:lst-ctn-kix_list_10-8}.lst-kix_list_25-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_10-6>li:before{content:\"\" counter(lst-ctn-kix_list_10-6,decimal) \". \"}.lst-kix_list_9-1>li:before{content:\"o  \"}ol.lst-kix_list_6-7.start{counter-reset:lst-ctn-kix_list_6-7 0}.lst-kix_list_9-5>li:before{content:\"\" counter(lst-ctn-kix_list_9-5,decimal) \". \"}.lst-kix_list_12-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-6>li:before{content:\"\" counter(lst-ctn-kix_list_11-6,decimal) \". \"}.lst-kix_list_20-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-3.start{counter-reset:lst-ctn-kix_list_11-3 0}.lst-kix_list_1-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-8>li{counter-increment:lst-ctn-kix_list_8-8}.lst-kix_list_1-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-4.start{counter-reset:lst-ctn-kix_list_11-4 0}.lst-kix_list_2-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-2>li:before{content:\"\\0025aa  \"}ol{margin:0;padding:0}table td,table th{padding:0}.c15{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:291.1pt;border-top-color:#000000;border-bottom-style:solid}.c3{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:280.1pt;border-top-color:#000000;border-bottom-style:solid}.c8{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:137.2pt;border-top-color:#000000;border-bottom-style:solid}.c18{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:157.8pt;border-top-color:#000000;border-bottom-style:solid}.c12{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:\"Arial\";font-style:normal}.c14{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"\\007b49\\007ebf\";font-style:normal}.c4{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:\"Arial\";font-style:normal}.c53{padding-top:0pt;text-indent:24pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:center}.c10{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:8pt;font-family:\"Arial\";font-style:normal}.c16{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:italic}.c20{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:\"Arial\";font-style:normal}.c22{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:\"Arial\";font-style:normal}.c0{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c7{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c21{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c25{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c6{padding-top:6pt;padding-bottom:6pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c35{font-weight:400;vertical-align:baseline;font-size:10pt;font-family:\"\\007b49\\007ebf\";font-style:normal}.c13{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-indent:20pt;text-align:justify}.c33{font-size:8pt;font-family:\"Arial\";color:#000000;font-weight:400}.c41{padding-top:12pt;padding-bottom:12pt;line-height:1.0;text-align:justify}.c19{-webkit-text-decoration-skip:none;color:#0000ff;text-decoration:underline;text-decoration-skip-ink:none}.c9{font-size:10pt;font-family:\"Arial\";color:#000000;font-weight:400}.c50{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c27{font-size:8pt;font-family:\"Arial\";color:#000000;font-weight:700}.c39{font-size:11pt;font-family:\"Arial\";color:#212121;font-weight:700}.c57{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c37{color:#000000;font-weight:700;font-size:9pt;font-family:\"Arial\"}.c29{text-decoration:none;vertical-align:baseline;font-style:normal}.c32{background-color:#ffffff;padding:72pt 16pt 72pt 16pt;margin:auto;}.c56{font-size:8pt;font-family:\"Arial\";font-weight:400}.c34{font-size:10pt;font-family:\"Arial\";font-weight:700}.c17{font-size:10pt;font-family:\"Arial\";font-weight:400}.c31{padding:0;margin:0}.c2{color:inherit;text-decoration:inherit}.c11{margin-left:18pt;padding-left:-3.8pt}.c24{height:10pt}.c42{height:20pt}.c49{font-size:10pt}.c55{height:45pt}.c51{color:#777777}.c28{text-indent:20pt}.c38{color:#000000}.c52{height:19pt}.c45{text-indent:25pt}.c23{height:6pt}.c48{text-indent:18pt}.c47{margin-left:14.2pt}.c46{height:29pt}.c54{height:59pt}.c30{height:22pt}.c44{height:74pt}.c5{height:103pt}.c43{font-style:italic}.c40{height:14pt}.c36{height:44pt}.c26{height:18pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:\"Georgia\";line-height:1.0;page-break-after:avoid;font-style:italic;text-align:justify}li{color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}p{margin:0;color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h2{padding-top:5pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h3{padding-top:5pt;color:#000000;font-weight:700;font-size:13.5pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h4{padding-top:5pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}</style><p class=c53><span class=c22>Política de Privacidade</span></p><p class=\"c25 c28\"><span class=c1>Última atualização: 05/2018</span></p><p class=\"c25 c28\"><span class=c34>Você reconhece que leu e entendeu esta política de privacidade. Se não concordar com esta Política de Privacidade, você não deve usar os serviços da Tap4Fun. Caso mude de ideia no futuro, você pode retirar seu consentimento para o uso de suas informações pessoais de acordo com esta política.</span></p><p class=c13><span class=c1>Na Tap4Fun, sabemos que sua privacidade é muito importante para você, portanto reserve um tempo para ler cuidadosamente nossa Política de Privacidade. Nossa política foi criada para ajudá-lo a entender:</span></p><p class=c13><span class=c0>1、Quais informações coletamos sobre você；</span></p><p class=c13><span class=c0>2、Como utilizaremos as informações sobre você;</span></p><p class=c13><span class=c0>3、Com quem compartilhamos suas informações;</span></p><p class=c13><span class=c0>4、Por quanto tempo mantemos suas informações;</span></p><p class=c13><span class=c0>5、Como você pode exercer seus direitos sobre suas informações;</span></p><p class=c13><span class=c0>6、Resolução de disputas;</span></p><p class=c13><span class=c0>7、Como o notificaremos sobre mudanças;</span></p><p class=c13><span class=c0>8、Informações de contato;</span></p><p class=c13><span class=c1>Essa política de privacidade se aplica a todos os serviços da Tap4Fun que estejam relacionados ou ligados diretamente a essa política, mas não se aplica a serviços da Tap4Fun que tenham políticas de privacidade diferentes das incorporadas a esta política.</span></p><p class=c41><span class=c12>SEÇÃO 1： ONDE ATUAMOS COMO UM CONTROLADOR DE DADOS</span></p><p class=c6><span class=\"c34 c38\">1.Tipos de informações pessoais que usamos</span></p><p class=c13><span class=c1>Essa seção descreve os diversos tipos de informações pessoais que coletamos e como as coletamos. Coletaremos e usaremos as seguintes informações sobre você:</span></p><p class=c6><span class=\"c34 c38\">As informações</span><span class=c39>&nbsp;que você nos fornece.</span></p><ul class=\"c31 lst-kix_list_23-0 start\"><li class=\"c7 c11\"><span class=c1>quando você se registra para um Jogo (incluindo seu apelido, ou contas e informações personalizadas que importamos de sua conta de mídia social conectada (WeChat, Facebook) para configurar seu perfil, incluindo seu nome como ele aparece em seu perfil de mídia social e sua foto de perfil);</span></li><li class=\"c7 c11\"><span class=c1>quando você faz o login como \'convidado\' para utilizar o Jogo (seu apelido); e</span></li><li class=\"c7 c11\"><span class=c1>quando você participa em uma pesquisa no Jogo (no caso em que vamos processar as informações que você fornece como parte da pesquisa).</span></li><li class=\"c7 c11\"><span class=c20>As informações </span><span class=c1>que você nos fornece quando solicita nossa ajuda como seu nome, telefone e registros dos problemas que você está passando; e</span></li><li class=\"c7 c11\"><span class=c1>Informações de faturamento, como seu nome, número do cartão de crédito e detalhes da conta de pagamento;</span></li></ul><p class=c6><span class=c0>Informações que coletamos sobre você.</span></p><p class=\"c7 c28\"><span class=c1>Coletamos automaticamente certos dados seus quando você usa o Jogo, incluindo seu endereço IP e informações do dispositivo (como a versão do aplicativo, tipo de rede, SO) e informações em relação ao seu uso do Jogo, como registros de ações de data e hora. Também coletamos e armazenamos seus dados toda a vez que você interage conosco, por exemplo, quando você usa suporte no aplicativo para se comunicar conosco.</span></p><p class=c6><span class=c0>Informações que você gera e exibe ao usar os serviços do Jogo.&nbsp;</span></p><p class=\"c7 c28\"><span class=c9>Você pode fornecer informações adicionais como parte de seu perfil (como seu sexo). Você também fornece ou gera informações ao se comunicar com outros usuários no Jogo (por exemplo, dados de registro de bate-papos, conteúdo de bate-papos).</span></p><p class=c6><span class=c0>Dados que coletamos de nossos parceiros.</span></p><ul class=\"c31 lst-kix_list_23-0\"><li class=\"c7 c11\"><span class=c1>Dados que recebemos se você conecta uma ferramenta de terceiro com o serviço (como WeChat, Facebook)</span></li><li class=\"c7 c11\"><span class=c4>Dados demográficos (por exemplo, para determinar a localização física de seu endereço IP)</span></li><li class=\"c7 c11\"><span class=c4>Dados de fraude de lutas (como o abuso de reembolso em jogos ou fraude de cliques em anúncios)</span></li><li class=\"c7 c11\"><span class=c4>Dados de plataformas nas quais os jogos são executados (por exemplo, para verificar o pagamento)</span></li><li class=\"c7 c11\"><span class=c4>Dados para fins de anúncios e análises, para que possamos fornecer um melhor serviço</span></li></ul><p class=c6><span class=c0>Cookies.</span></p><p class=c6><span class=c1>Utilizamos cookies e outras tecnologias parecidas (por exemplo sinalizadores web, arquivos de registro, scripts e eTags) (\"Cookies\") para melhorar sua experiência ao usar os serviços. Cookies são pequenos arquivos que, quando colocados em seu dispositivo, permitem a nós fornecer certos recursos e funcionalidades. Você tem a opção de permitir a instalação de tais Cookies ou desativá-los subsequentemente. Você pode aceitar todos os cookies, ou instruir o dispositivo (no caso do Jogo) a fornecer um aviso no momento da instalação dos cookies, ou recusar em aceitar todos os cookies ajustando a função de retenção de cookies relevante em seu dispositivo. Contudo, no caso de recusar a instalar os cookies, o Jogo pode ser incapaz de funcionar conforme esperado.</span></p><p class=c6><span class=c0>2. Como usamos suas informações pessoais</span></p><p class=c7><span class=c1>Utilizaremos suas informações das seguintes formas:</span></p><a id=t.638932107830a4191e3e41362850c08500e0e414></a><a id=t.0></a><table class=c50><tbody><tr class=c30><td class=c18 colspan=1 rowspan=1><p class=c7><span class=c27>Informações pessoais</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c27>Uso</span></p></td></tr><tr class=c30><td class=c18 colspan=1 rowspan=1><p class=c25><span class=c33>Apelido</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Utilizamos essas informações para criar sua conta para o Jogo de acordo com sua solicitação.</span></p></td></tr><tr class=c52><td class=c18 colspan=1 rowspan=1><p class=c25><span class=c10>Informações de conexão social:</span></p><p class=c25><span class=c10>WeChat: OpenID, foto de perfil, apelido, sexo, região</span></p><p class=c25><span class=c56>Facebook: nome, ID do Facebook, foto de perfil</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c10>Utilizamos essas informações para: • criar sua conta para o Jogo de acordo com sua solicitação; • compartilhar fotos do jogo no Facebook sob sua solicitação.</span></p></td></tr><tr class=c55><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>OpenID gerado</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Geramos isso e o usamos para armazenar seus dados do Jogo (incluindo o nível de progresso) com seu perfil.</span></p></td></tr><tr class=c42><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>Estatísticas de jogabilidade (nível, pontuações)</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Utilizamos essas informações para fornecer a você um feedback e informações sobre sua jogabilidade e progresso.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>Endereço IP</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Utilizamos essas informações para melhorar nossos serviços, incluindo a funcionalidade do Jogo.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>ID do dispositivo, informações do dispositivo</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Utilizamos essas informações para: • melhorar nossos serviços, incluindo a funcionalidade do Jogo; • para fins de segurança e verificação; • identificar e encaminhar defeitos e acessar funções do jogo para otimização; e • para combater usuários que se registram através de diversas contas.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>ID de anúncio</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Se você clicar em um link que faz anúncio do Jogo, armazenamos o ID desse anúncio em seu perfil.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>Dados de bate-papo</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Se você ativar os serviços de bate-papo (áudio ou texto), então processaremos tais dados para enviar suas mensagens a outros usuários.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>Registros de transações: pagamentos no Google Play ou iOS App Store&nbsp;</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Utilizamos essas informações para manter um registro de seu histórico de transações.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>ID de tíquete de suporte ao cliente e comunicações do usuário com o suporte</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c7><span class=c33>Utilizamos essas informações para: • melhorar nossos serviços; • fornecer solução de problemas como atender e corrigir problemas técnicos e defeitos.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c33>Informações relacionadas à segurança</span></p></td><td class=c15 colspan=1 rowspan=1><p class=c21><span class=c33>Utilizamos essas informações para: • fins de segurança e verificação; • identificar e atender defeitos e acessar funções do jogo para fins de otimização;&nbsp;• resolver falhas do jogo e otimizar a compatibilidade de dispositivos com o jogo; e • combater o registro de usuários com diversas contas.</span></p></td></tr><tr class=c26><td class=c18 colspan=1 rowspan=1><p class=c21><span class=c10>Informações de pesquisa e conteúdo de respostas de pesquisa</span></p></td><td class=c15 colspan=1 rowspan=1><p class=\"c7 c24\"><span class=c10></span></p></td></tr></tbody></table><p class=c6><span class=c0>análise, perfil e segmento.</span></p><p class=\"c7 c48\"><span class=c4>Em todos os casos e propósitos acima, podemos analisar, traçar o perfil e segmentar todos os dados coletados.</span></p><p class=c6><span class=c0>Base legal para o processamento</span></p><p class=\"c25 c28\"><span class=c17>Se você for residente da União Europeia, nos baseamos em diversos fundamentos jurídicos para processar informações sobre você. Por exemplo, processaremos informações sobre você onde tivermos seu consentimento, onde tivermos um interesse legítimo para isso, onde o processamento for necessário para o desempenho de um contrato com você, e onde tivermos uma obrigação legal para processar suas informações. Por exemplo, nos baseamos em nossos interesses legítimos para servir um mercado alvo e na necessidade contratual de processar informações quando você cria uma conta. Para saber mais sobre os fundamentos jurídicos nos quais nos baseamos para processar suas informações para qualquer fim específico, entre em contato conosco via as opções na seção </span><span class=\"c34 c38\">C</span><span class=c34>ontato e reclamações</span><span class=c1>&nbsp;abaixo.</span></p><p class=\"c25 c24 c28\"><span class=c1></span></p><p class=\"c25 c24 c28\"><span class=c0></span></p><p class=c6><span class=c0>3. Como compartilhamos suas informações pessoais</span></p><p class=c7><span class=c1>Compartilhamos suas informações pessoais com terceiros selecionados e fora de seu país, incluindo:</span></p><ul class=\"c31 lst-kix_list_23-0\"><li class=\"c7 c11\"><span class=\"c29 c37\">outros jogadores e usuários.</span><span class=c14>&nbsp;</span><span class=c4>Recursos sociais são um componente chave de nossos jogos. Outros jogadores e usuários podem, por exemplo, ver seus dados de perfil, atividades no jogo e ler as mensagens que você publica.</span></li><li class=\"c7 c11\"><span class=\"c37 c29\">parceiros que trabalham para a Tap4Fun.</span><span class=c14>&nbsp;</span><span class=c4>A Tap4Fun tem parceiros para realizar serviços para nós. Esses parceiros processam seus dados somente e de acordo com as instruções da Tap4Fun para fornecer o serviço, como hospedagem, suporte ao jogador, anúncios, análises e prevenção de fraudes.</span></li><li class=\"c7 c11\"><span class=\"c37 c29\">outras empresas e autoridades públicas. </span><span class=c4>Para combater fraudes e atividades ilegais, podemos trocar dados com outras empresas e organizações e fornecê-los a autoridades públicas em resposta a solicitações legais. Também podemos divulgar seus dados com base em seu consentimento, para cumprir com a lei ou proteger os direitos, propriedade ou nossa segurança, de nossos jogadores ou outros.</span></li><li class=\"c7 c11\"><span class=\"c37 c29\">empresas</span><span class=c0>&nbsp;do grupo relacionadas (Tap4Fun (Hong Kong) Limited.,</span><span class=c1>&nbsp;com a qual compartilhamos informações pessoais para operar os serviços do Jogo;</span></li><li class=\"c7 c11\"><span class=c0>agências de cumprimento das leis, autoridades públicas ou outros corpos jurídicos e organizações.</span></li><li class=\"c7 c11\"><span class=\"c37 c29\">um terceiro que adquire todos ou substancialmente todos nós ou nosso negócio.&nbsp;</span><span class=c4>Divulgaremos informações a um terceiro no caso de vendermos ou comprarmos qualquer negócio ou ao passar por uma fusão, na qual divulgaremos seus dados para o comprador potencial de tal negócio. Também divulgaremos informações a um terceiro se vendermos, comprarmos, fundirmos ou fizermos parceria com outras empresas ou negócios, ou se vendermos alguns ou todos os nossos ativos. Em tais transações, as informações de usuários podem estar entre os ativos transferidos.</span></li></ul><p class=c6><span class=c0>4. Retenção de dados</span></p><p class=\"c7 c28\"><span class=c1>Reteremos suas informações pessoais conforme descrito abaixo (exceto se de outra forma for solicitado para ser retido por lei aplicável).</span></p><a id=t.cacd13f18801806ad550b307de95ba59a19119f6></a><a id=t.1></a><table class=c57><tbody><tr class=c40><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c27>Informações pessoais</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c27>Política de retenção</span></p></td></tr><tr class=c36><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c10>Apelido</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado pelo tempo de seu uso do Jogo (isto é, até a exclusão da conta de acordo com sua solicitação) e então excluído dentro de 30 dias.</span></p></td></tr><tr class=c54><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c10>Informações de conexão social:<br>WeChat</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado pelo tempo de uso do Jogo (isto é, até a exclusão da conta de acordo com sua solicitação ou quando você revogar o acesso à sua conta de mídia social) e então, excluído dentro de 30 dias.&nbsp;</span></p></td></tr><tr class=c5><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c10>Informações de conexão social:<br>Facebook</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado durante o tempo de seu uso do Jogo, até a exclusão da conta de acordo com sua solicitação, sob a qual ele será excluído dentro de 15 dias.<br>Onde você não solicitar a exclusão da conta, tais dados serão retidos por 1 ano após o Jogo ser descontinuado, antes que sejam excluídos.&nbsp;</span></p></td></tr><tr class=c5><td class=c8 colspan=1 rowspan=1><p class=c21><span class=c10><br>Estatísticas de jogabilidade (nível, heróis, pontuações)</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenadas durante o tempo de uso do Jogo, até a exclusão da conta de acordo com sua solicitação, sob a qual elas serão excluídas dentro de 15 dias.&nbsp;<br>Onde você não solicitar a exclusão da conta, tais dados serão retidos por 1 ano após o Jogo ser descontinuado, antes que sejam excluídos.&nbsp;</span></p></td></tr><tr class=c46><td class=c8 colspan=1 rowspan=1><p class=c21><span class=c10>Comunicações de bate-papo (mensagens de áudio)</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenadas por 7 dias em nossos servidores e excluídas automaticamente após o vencimento de tal período.</span></p></td></tr><tr class=c44><td class=c8 colspan=1 rowspan=1><p class=c21><span class=c10>Comunicações de bate-papo (texto)</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenadas pelo tempo de uso do Jogo, até a exclusão da conta de acordo com sua solicitação, na qual serão excluídas dentro de 7 dias.&nbsp;<br>Onde você não solicitar a exclusão da conta, tais dados serão retidos por 1 ano após o Jogo ser descontinuado, antes que sejam excluídos.&nbsp;</span></p></td></tr><tr class=c23><td class=c8 colspan=1 rowspan=1><p class=c21><span class=c10>OpenID</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado durante o tempo de seu uso do Jogo, até a exclusão da conta de acordo com sua solicitação, sob a qual ele será excluído dentro de 15 dias.&nbsp;<br>Onde você não solicitar a exclusão da conta, tais dados serão retidos por 1 ano após o Jogo ser descontinuado, antes que sejam excluídos.&nbsp;</span></p></td></tr><tr class=c23><td class=c8 colspan=1 rowspan=1><p class=c21><span class=c10>Endereço IP</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado durante o tempo de seu uso do Jogo, até a exclusão da conta de acordo com sua solicitação, sob a qual ele será excluído dentro de 15 dias.&nbsp;<br>Onde você não solicitar a exclusão da conta, tais dados serão retidos por 1 ano após o Jogo ser descontinuado, antes que sejam excluídos.&nbsp;</span></p></td></tr><tr class=c23><td class=c8 colspan=1 rowspan=1><p class=c21><span class=c10>ID do dispositivo, informações do dispositivo</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado durante o tempo de seu uso do Jogo, até a exclusão da conta de acordo com sua solicitação, sob a qual ele será excluído dentro de 30 dias.<br>Onde você não solicitar a exclusão da conta, tais dados serão retidos por 1 ano após o Jogo ser descontinuado, antes que sejam excluídos.&nbsp;</span></p></td></tr><tr class=c23><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c10>ID de anúncio</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado durante o tempo de seu uso do Jogo, até a exclusão da conta de acordo com sua solicitação, sob a qual ele será excluído dentro de 15 dias.&nbsp;<br>Onde você não solicitar a exclusão da conta, tais dados serão retidos por 1 ano após o Jogo ser descontinuado, antes que sejam excluídos.&nbsp;</span></p></td></tr><tr class=c23><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c10>Registros de transações</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenado pelo tempo de seu uso do Jogo (isto é, até a exclusão da conta de acordo com sua solicitação) e então pela duração de quaisquer períodos de retenção para os quais tais dados devem ser retidos para cumprir com nossas obrigações legais.</span></p></td></tr><tr class=c23><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c10>ID de tíquete de suporte ao cliente e comunicações do usuário com o suporte</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Dados de suporte são excluídos dentro de 30 dias a partir de uma solicitação legítima sua para a exclusão de tais dados (veja a seção Exclusão desta Política de Privacidade).</span></p></td></tr><tr class=c23><td class=c8 colspan=1 rowspan=1><p class=c21><span class=c10>Informações relacionadas à segurança&nbsp;</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenadas durante o tempo de seu uso do Jogo, até a exclusão da conta de acordo com sua solicitação, sob a qual elas serão excluídas dentro de 30 dias.&nbsp;</span></p></td></tr><tr class=c46><td class=c8 colspan=1 rowspan=1><p class=c7><span class=c10>Informações de pesquisas</span></p></td><td class=c3 colspan=1 rowspan=1><p class=c7><span class=c10>Armazenadas para: (a) se você fornecer seu e-mail como parte da pesquisa, até seis meses (para que nós possamos acompanhar seu processo) e então os dados serão anonimizados; ou (b) se você não fornecer seu e-mail como parte da pesquisa, até um mês e então os dados serão anonimizados.</span></p></td></tr></tbody></table><p class=\"c7 c24\"><span class=c1></span></p><p class=\"c7 c28\"><span class=c1>Informações pessoais são mantidas até o final do ciclo de vida (conforme definido na política de retenção acima). Ao destruir as informações pessoais, medidas serão tomadas para torná-las irrecuperáveis, e arquivos eletrônicos que contenham informações pessoais serão excluídos permanentemente usando um método técnico que os torna irreproduzíveis.</span></p><p class=\"c7 c28\"><span class=c1>No caso do período de processamento e retenção ter terminado, mas as informações pessoais sejam necessárias para ser retidas continuamente por outras razões incluindo para fins conforme prescrito sob leis aplicáveis, as informações pessoais relevantes serão armazenadas e mantidas separadamente de outros tipos de informações pessoais. Caso você exigir de nós destruir suas informações pessoais antes do final de seu ciclo de vida (conforme definido na política de retenção acima), destruiremos suas informações pessoais de acordo com as leis locais.</span></p><p class=c41><span class=c12>SEÇÃO 2: SEUS DIREITOS</span></p><p class=c7><span class=\"c34 c38 c43\">Essa seção (\"Seus direitos\")</span><span class=c0>&nbsp;se aplica somente aos usuários localizados no Espaço Econômico Europeu.</span></p><p class=\"c7 c28\"><span class=c9>Você tem certos direitos em relação a suas informações pessoais as quais retemos. Alguns deles somente se aplicam em certas circunstâncias (conforme definido em mais detalhes abaixo). Devemos responder a uma solicitação sua para exercer esses direitos sem atrasos impróprios e pelo menos com um mês (apesar de que isso pode ser estendido para dois meses em certas circunstâncias). Para exercer quaisquer de seus direitos, envie um e-mail para </span><span class=\"c19 c17\"><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>.</span></p><p class=c6><span class=c16>1. Acesso</span></p><p class=\"c7 c28\"><span class=c9>Você tem o direito de acessar suas informações pessoais que retemos, saber como as utilizamos, e com quem as compartilhamos. Você pode acessar as informações pessoais que você tornou disponíveis como parte de sua conta ao fazer login na conta do Jogo e ao entrar em contato em </span><span class=\"c19 c17\"><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c9>. Caso acredite que retemos quaisquer outras informações pessoais sobre você, envie um e-mail para </span><span class=\"c19 c17\"><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>.</span></p><p class=c6><span class=c16>2. Portabilidade</span></p><p class=\"c7 c28\"><span class=c17>Você tem o direito de receber uma cópia de certas informações pessoais que processamos sobre você. Isso inclui quaisquer informações pessoais que processamos com base em seu consentimento</span><span class=c9>&nbsp;(por ex., certas informações de pesquisas) ou conforme nosso contrato com você, como descrito na seção “</span><span class=\"c34 c38 c43\">Como usamos suas informações pessoais</span><span class=c1>”. Você tem o direito de receber essas informações em um formato estruturado, comumente usado e de leitura por máquina. Você também tem o direito de solicitar que transferimos essas informações pessoais a outro terceiro. </span></p><p class=\"c7 c28\"><span class=c1>Caso desejar que nós transferirmos tais informações pessoais a um terceiro, certifique-se de detalhar esse terceiro em sua solicitação. Observe que podemos fazer isso apenas onde for tecnicamente viável. Observe que podemos não ser capazes de fornecer a você informações pessoais se isso poderia interferir com direitos de outros (por ex., onde fornecer as informações pessoais que temos sobre você poderia revelar informações sobre outra pessoa ou nossos segredos comerciais ou propriedade intelectual).</span></p><p class=c6><span class=c16>3. Correção</span></p><p class=c13><span class=c17>Você tem o direito de corrigir quaisquer informações pessoais que temos sobre você que não estejam precisas. Você pode acessar as informações pessoais que você disponibilizou como parte de sua conta ao fazer login em sua conta do Jogo. Caso acredite que retemos quaisquer outras informações pessoais sobre você e que as informações não são precisas, envie um e-mail para support@tap</span><span class=\"c19 c17\"><a class=c2 href=mailto:support@tap4fun.com>4fun.com</a></span><span class=c9>.</span></p><p class=c6><span class=c16>4. Exclusão</span></p><p class=c13><span class=c17>Você pode excluir sua conta, ou remover certas informações pessoais, ao fazer login na sua conta do Jogo. Se houver quaisquer outras informações pessoais que você acredita que estamos processando as quais você gostaria que nós excluíssemos, envie um e-mail para </span><span class=\"c17 c19\"><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c9>.</span></p><p class=\"c13 c24\"><span class=c1></span></p><p class=c13><span class=c1>Você pode solicitar para excluirmos as informações pessoais que temos sobre você nas seguintes circunstâncias:</span></p><ul class=\"c31 lst-kix_list_23-0\"><li class=\"c7 c11\"><span class=c1>você acredita que não é mais necessário para nós retermos tais informações pessoais; ou</span></li><li class=\"c7 c11\"><span class=c1>você acredita que as informações pessoais que retemos sobre você estejam sendo processadas ilegalmente por nós.&nbsp;</span></li></ul><p class=\"c7 c24 c47\"><span class=c1></span></p><p class=c13><span class=c1>você também pode exercer seu direito de restringir nosso processamento de suas informações pessoais (como descrito abaixo) enquanto consideramos sua solicitação.&nbsp;</span></p><p class=\"c13 c24\"><span class=c1></span></p><p class=c13><span class=c1>Podemos necessitar reter as informações pessoais se houver fundamentos jurídicos válidos sob leis de proteção de dados para podermos cumpri-los (por ex., para a defesa de processos judiciais ou liberdade de expressão), contudo o informaremos se esse for o caso. Onde você solicitou que excluíssemos as informações pessoais que se tornaram públicas nos serviços do Jogo e há fundamentos jurídicos para a exclusão, tomaremos as medidas razoáveis para tentar informar a outros que estão exibindo suas informações pessoais ou fornecendo links para elas, para também as excluírem.</span></p><p class=c6><span class=c16>5. Restrição de processamento somente para armazenamento</span></p><p class=c13><span class=c1>Você tem o direito de solicitar a nós parar o processando das informações pessoais que retemos sobre você exceto para fins de armazenamento em certas circunstâncias. Observe que, contudo, se pararmos o processamento das informações pessoais, podemos utilizá-las novamente se houver fundamentos jurídicos válidos sob leis de proteção de dados para nós fazermos isso (por ex., para a defesa de processos jurídicos ou para a proteção de outros). Conforme acima, onde concordarmos em parar o processamento das informações pessoais, tentaremos informar a qualquer terceiro o qual divulgamos as informações pessoais relevantes para que eles possam parar também o processamento.&nbsp;</span></p><p class=c13><span class=c1>Você pode solicitar que paremos o processamento e apenas armazenemos as informações pessoais que retemos sobre você onde: </span></p><ul class=\"c31 lst-kix_list_23-0\"><li class=\"c7 c11\"><span class=c1>você acreditar que as informações pessoais não são precisas para o período que leva para verificarmos se são precisas;</span></li><li class=\"c7 c11\"><span class=c1>você desejar excluir as informações pessoais pois você considera que o processamento que estamos fazendo seja ilegal, mas você deseja que ao invés de retemos as informações pessoais, devemos apenas armazená-las; ou&nbsp;</span></li><li class=\"c7 c11\"><span class=c1>você deseja excluir as informações pessoais pois não são mais necessárias para os nossos fins, mas você solicita que sejam armazenadas para o estabelecimento, exercício ou defesa de processos judiciais.</span></li></ul><p class=c6><span class=c16>6. Objeção</span></p><p class=c13><span class=c17>Você tem o direito de se opor ao nosso processamento das informações pessoais sobre você. Consideraremos sua solicitação em outras circunstâncias conforme detalhado abaixo enviando um e-mail para </span><span class=\"c19 c17\"><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>&nbsp;.</span></p><p class=c6><span class=c16>7. Anúncios</span></p><p class=c13><span class=c1>Podemos de tempos em tempos, enviar a você anúncios quando considerarmos que seja necessário fazê-lo (por exemplo, quando suspendemos temporariamente o acesso ao Jogo para manutenção, ou segurança, privacidade ou comunicações relacionadas à administração). Você não pode cancelar esses anúncios relacionados a serviços, que não são de natureza promocional.&nbsp;</span></p><p class=c41><span class=c12>SEÇÃO 3: DIVERSOS </span></p><p class=c6><span class=c0>1. Segurança das informações</span></p><p class=c13><span class=c1>Implementamos medidas de segurança administrativas, físicas e técnicas que são destinadas a proteger suas informações pessoais de perdas, roubo, mau uso, acesso não autorizado, divulgação, alteração e destruição. Você deve entender que, apesar de nossos esforços, nenhum sistema de segurança pode ser garantido como impenetrável.</span></p><p class=c6><span class=c0>2. Informações sobre crianças</span></p><p class=c13 id=h.gjdgxs><span class=c1>Não coletamos intencionalmente ou solicitamos informações de ou direta ou de interesse alvo com base em anúncios a qualquer pessoa abaixo de 16 anos de idade ou permitimos intencionalmente que tais pessoas utilizem nossos serviços. Se você tiver menos de 16 anos de idade, não envie nenhuma informação sobre você a nós, incluindo seu nome, endereço, número de telefone, ou endereço de e-mail. Ninguém abaixo de 16 anos de idade pode fornecer quaisquer informações pessoais. No caso de sabermos que coletamos informações pessoais de uma criança abaixo de 16 anos de idade, excluiremos essas informações assim que possível. Se você acredita que podemos ter quaisquer informações de ou sobre crianças abaixo de 16 anos de idade, favor entrar em contato.</span></p><p class=c6><span class=\"c34 c38\">3.</span><span class=c49>&nbsp;</span><span class=c0>Links para sites e serviços operados por outros</span></p><p class=\"c6 c28\"><span class=c1>O serviço Tap4Fun pode conter links a outros sites, aplicativos e serviços. Devido a Tap4Fun não operar esses outros sites, aplicativos e serviços, não podemos nos responsabilizar por práticas de privacidade das entidades que os operam. Recomendamos que você verifique consistentemente as políticas de privacidade para entender as práticas de um operador. Como lembrete, esta política descreve as práticas da Tap4Fun.</span></p><p class=c6><span class=c0>4. Atualizações</span></p><p class=c13><span class=c1>A Tap4Fun pode atualizar esta Política de Privacidade periodicamente. Quando a atualizarmos, trocaremos a data acima em \"Última atualização\". Se fizermos mudanças materiais na forma como coletamos, utilizamos, retemos ou compartilhamos suas informações pessoais, nós o notificaremos enviando para você um e-mail no último endereço de e-mail que você nos forneceu, ou publicando um aviso sobre as mudanças nos serviços cobertos por esta Política de Privacidade.</span></p><p class=c6><span class=c0>4. Transferência internacional</span></p><p class=\"c6 c45\"><span class=c1>Podemos transferir informações que coletamos sobre você a entidades afiliadas, ou a outros terceiros fora do seu país ou jurisdição a outros países ou jurisdições pelo mundo. Observe que esses países e jurisdições podem não ter a mesmas leis de proteção de dados que a sua própria jurisdição, e tomamos medidas para garantir que proteções adequadas estejam em vigor para permitir a transferência de informações e o uso e divulgação de informações sobre você, incluindo informações pessoais, conforme descrito nesta Política.</span></p><p class=c6><span class=c0>5. Contato e reclamações</span></p><p class=\"c7 c28\"><span class=c9>Perguntas, comentários e solicitações em relação a essa política são bem vindos. Entre em contato conosco via e-mail em </span><span class=\"c19 c17\"><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>&nbsp;, via telefone em 0086-028-83313298, ou via correio em Tap4Fun Co., Ltd, Attn: Privacy Administrator, Building A3, Tianfu software park, high-tech zone, Chengdu, Sichuan, China.</span></p><p class=c13><span class=c1>No caso que você deseje realizar uma reclamação sobre como processamos suas informações pessoais, entre em contato conosco primeiramente pelo e-mail </span><span class=\"c19 c35\"><a class=c2 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c1>&nbsp;e vamos nos esforçar para atender sua solicitação assim que possível. Isso é sem prejuízo de seu direito de lançar uma reclamação com a autoridade de proteção de dados no país em que você mora ou trabalhe onde você acha as leis de proteção de dados forma infringidas por nós.</span></p><br></div><div ng-if=\"privacy.lang == \'ru-RU\'\"><style type=text/css>ol.lst-kix_list_7-0{list-style-type:none}.lst-kix_list_14-1>li:before{content:\"o  \"}.lst-kix_list_14-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-0.start{counter-reset:lst-ctn-kix_list_9-0 0}.lst-kix_list_14-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_14-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_14-6>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_9-1{list-style-type:none}ol.lst-kix_list_7-4.start{counter-reset:lst-ctn-kix_list_7-4 0}.lst-kix_list_9-0>li{counter-increment:lst-ctn-kix_list_9-0}ol.lst-kix_list_7-5{list-style-type:none}ol.lst-kix_list_7-6{list-style-type:none}ol.lst-kix_list_7-7{list-style-type:none}ol.lst-kix_list_7-8{list-style-type:none}ol.lst-kix_list_7-1{list-style-type:none}ol.lst-kix_list_11-8.start{counter-reset:lst-ctn-kix_list_11-8 0}ol.lst-kix_list_7-3{list-style-type:none}ol.lst-kix_list_7-4{list-style-type:none}.lst-kix_list_14-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-1{list-style-type:none}ul.lst-kix_list_17-0{list-style-type:none}ul.lst-kix_list_17-8{list-style-type:none}ul.lst-kix_list_17-7{list-style-type:none}ul.lst-kix_list_17-6{list-style-type:none}ul.lst-kix_list_17-5{list-style-type:none}ul.lst-kix_list_17-4{list-style-type:none}ul.lst-kix_list_17-3{list-style-type:none}.lst-kix_list_14-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_17-2{list-style-type:none}ol.lst-kix_list_8-8.start{counter-reset:lst-ctn-kix_list_8-8 0}ol.lst-kix_list_10-4.start{counter-reset:lst-ctn-kix_list_10-4 0}.lst-kix_list_5-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-0{list-style-type:none}.lst-kix_list_24-7>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_27-0{list-style-type:none}ul.lst-kix_list_27-1{list-style-type:none}.lst-kix_list_24-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_27-2{list-style-type:none}.lst-kix_list_5-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-5.start{counter-reset:lst-ctn-kix_list_9-5 0}.lst-kix_list_5-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-3>li{counter-increment:lst-ctn-kix_list_8-3}.lst-kix_list_5-1>li:before{content:\"o  \"}.lst-kix_list_24-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_5-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_5-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_24-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_24-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_9-4>li{counter-increment:lst-ctn-kix_list_9-4}ol.lst-kix_list_6-6{list-style-type:none}ul.lst-kix_list_27-3{list-style-type:none}.lst-kix_list_24-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_6-7{list-style-type:none}ul.lst-kix_list_27-4{list-style-type:none}.lst-kix_list_5-4>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-8{list-style-type:none}ul.lst-kix_list_27-5{list-style-type:none}ul.lst-kix_list_27-6{list-style-type:none}.lst-kix_list_5-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-2{list-style-type:none}ul.lst-kix_list_27-7{list-style-type:none}ol.lst-kix_list_6-3{list-style-type:none}ul.lst-kix_list_27-8{list-style-type:none}ol.lst-kix_list_6-4{list-style-type:none}.lst-kix_list_24-6>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_6-5{list-style-type:none}.lst-kix_list_23-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_6-1>li:before{content:\"o  \"}.lst-kix_list_6-3>li:before{content:\"\" counter(lst-ctn-kix_list_6-3,decimal) \". \"}.lst-kix_list_6-5>li{counter-increment:lst-ctn-kix_list_6-5}.lst-kix_list_6-8>li{counter-increment:lst-ctn-kix_list_6-8}.lst-kix_list_23-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-0>li:before{content:\"\" counter(lst-ctn-kix_list_6-0,decimal) \". \"}.lst-kix_list_6-4>li:before{content:\"\" counter(lst-ctn-kix_list_6-4,decimal) \". \"}.lst-kix_list_23-2>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_16-2{list-style-type:none}ul.lst-kix_list_16-1{list-style-type:none}ul.lst-kix_list_16-0{list-style-type:none}.lst-kix_list_23-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_23-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_23-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-2>li:before{content:\"\" counter(lst-ctn-kix_list_6-2,decimal) \". \"}.lst-kix_list_24-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_16-8{list-style-type:none}ul.lst-kix_list_16-7{list-style-type:none}ul.lst-kix_list_16-6{list-style-type:none}ul.lst-kix_list_16-5{list-style-type:none}.lst-kix_list_24-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_16-4{list-style-type:none}.lst-kix_list_6-8>li:before{content:\"\" counter(lst-ctn-kix_list_6-8,decimal) \". \"}ul.lst-kix_list_16-3{list-style-type:none}.lst-kix_list_6-5>li:before{content:\"\" counter(lst-ctn-kix_list_6-5,decimal) \". \"}.lst-kix_list_6-7>li:before{content:\"\" counter(lst-ctn-kix_list_6-7,decimal) \". \"}.lst-kix_list_23-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_23-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_6-6>li:before{content:\"\" counter(lst-ctn-kix_list_6-6,decimal) \". \"}ol.lst-kix_list_10-6.start{counter-reset:lst-ctn-kix_list_10-6 0}.lst-kix_list_7-4>li:before{content:\"\" counter(lst-ctn-kix_list_7-4,upper-roman) \". \"}.lst-kix_list_7-6>li:before{content:\"\" counter(lst-ctn-kix_list_7-6,upper-roman) \". \"}ol.lst-kix_list_6-2.start{counter-reset:lst-ctn-kix_list_6-2 0}.lst-kix_list_22-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_22-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-6>li{counter-increment:lst-ctn-kix_list_7-6}.lst-kix_list_8-6>li{counter-increment:lst-ctn-kix_list_8-6}.lst-kix_list_22-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-7{list-style-type:none}ol.lst-kix_list_9-8{list-style-type:none}.lst-kix_list_13-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-3{list-style-type:none}ol.lst-kix_list_9-4{list-style-type:none}ol.lst-kix_list_9-5{list-style-type:none}.lst-kix_list_7-8>li:before{content:\"\" counter(lst-ctn-kix_list_7-8,upper-roman) \". \"}ol.lst-kix_list_9-6{list-style-type:none}ol.lst-kix_list_9-0{list-style-type:none}ol.lst-kix_list_9-2{list-style-type:none}.lst-kix_list_22-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-8>li{counter-increment:lst-ctn-kix_list_9-8}.lst-kix_list_4-1>li:before{content:\"o  \"}.lst-kix_list_15-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-7{list-style-type:none}ul.lst-kix_list_19-6{list-style-type:none}.lst-kix_list_4-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-5{list-style-type:none}ul.lst-kix_list_19-4{list-style-type:none}ul.lst-kix_list_19-3{list-style-type:none}.lst-kix_list_25-5>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_19-2{list-style-type:none}ul.lst-kix_list_19-1{list-style-type:none}.lst-kix_list_10-5>li{counter-increment:lst-ctn-kix_list_10-5}ul.lst-kix_list_19-0{list-style-type:none}.lst-kix_list_15-1>li:before{content:\"o  \"}.lst-kix_list_25-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_15-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_19-8{list-style-type:none}.lst-kix_list_6-4>li{counter-increment:lst-ctn-kix_list_6-4}ol.lst-kix_list_9-2.start{counter-reset:lst-ctn-kix_list_9-2 0}.lst-kix_list_9-3>li{counter-increment:lst-ctn-kix_list_9-3}.lst-kix_list_11-2>li{counter-increment:lst-ctn-kix_list_11-2}ol.lst-kix_list_8-8{list-style-type:none}.lst-kix_list_12-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-6.start{counter-reset:lst-ctn-kix_list_7-6 0}ol.lst-kix_list_8-4{list-style-type:none}.lst-kix_list_12-1>li:before{content:\"o  \"}ol.lst-kix_list_8-5{list-style-type:none}ol.lst-kix_list_8-6{list-style-type:none}ol.lst-kix_list_8-7{list-style-type:none}ol.lst-kix_list_8-0{list-style-type:none}ol.lst-kix_list_8-1{list-style-type:none}ol.lst-kix_list_8-2{list-style-type:none}ol.lst-kix_list_8-3{list-style-type:none}.lst-kix_list_10-4>li{counter-increment:lst-ctn-kix_list_10-4}.lst-kix_list_13-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-0{list-style-type:none}.lst-kix_list_13-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-8{list-style-type:none}ul.lst-kix_list_18-7{list-style-type:none}ul.lst-kix_list_18-6{list-style-type:none}ul.lst-kix_list_18-5{list-style-type:none}.lst-kix_list_12-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_18-4{list-style-type:none}ul.lst-kix_list_18-3{list-style-type:none}ul.lst-kix_list_18-2{list-style-type:none}ol.lst-kix_list_6-0.start{counter-reset:lst-ctn-kix_list_6-0 0}ul.lst-kix_list_18-1{list-style-type:none}.lst-kix_list_13-1>li:before{content:\"o  \"}ul.lst-kix_list_24-0{list-style-type:none}ul.lst-kix_list_24-1{list-style-type:none}ul.lst-kix_list_24-2{list-style-type:none}ul.lst-kix_list_24-3{list-style-type:none}ul.lst-kix_list_24-4{list-style-type:none}ul.lst-kix_list_24-5{list-style-type:none}ol.lst-kix_list_11-6{list-style-type:none}ol.lst-kix_list_11-7{list-style-type:none}ol.lst-kix_list_11-8{list-style-type:none}.lst-kix_list_7-1>li{counter-increment:lst-ctn-kix_list_7-1}ol.lst-kix_list_11-2{list-style-type:none}ol.lst-kix_list_11-3{list-style-type:none}.lst-kix_list_3-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_11-4{list-style-type:none}ol.lst-kix_list_11-5{list-style-type:none}ul.lst-kix_list_5-7{list-style-type:none}ul.lst-kix_list_5-8{list-style-type:none}ul.lst-kix_list_5-5{list-style-type:none}ol.lst-kix_list_11-0{list-style-type:none}ul.lst-kix_list_5-6{list-style-type:none}.lst-kix_list_21-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-5>li:before{content:\"\\0025c6  \"}.lst-kix_list_8-0>li{counter-increment:lst-ctn-kix_list_8-0}ul.lst-kix_list_24-6{list-style-type:none}ul.lst-kix_list_5-0{list-style-type:none}ul.lst-kix_list_24-7{list-style-type:none}.lst-kix_list_10-0>li{counter-increment:lst-ctn-kix_list_10-0}.lst-kix_list_3-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_24-8{list-style-type:none}ul.lst-kix_list_5-3{list-style-type:none}.lst-kix_list_3-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_5-4{list-style-type:none}.lst-kix_list_26-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_5-1{list-style-type:none}.lst-kix_list_8-0>li:before{content:\"\" counter(lst-ctn-kix_list_8-0,upper-roman) \". \"}ul.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_8-7>li:before{content:\"\" counter(lst-ctn-kix_list_8-7,upper-roman) \". \"}.lst-kix_list_3-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_10-7.start{counter-reset:lst-ctn-kix_list_10-7 0}.lst-kix_list_26-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_21-1>li:before{content:\"o  \"}.lst-kix_list_8-3>li:before{content:\"\" counter(lst-ctn-kix_list_8-3,upper-roman) \". \"}ul.lst-kix_list_13-5{list-style-type:none}ul.lst-kix_list_13-4{list-style-type:none}ul.lst-kix_list_13-3{list-style-type:none}ul.lst-kix_list_13-2{list-style-type:none}ul.lst-kix_list_13-1{list-style-type:none}.lst-kix_list_3-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_13-0{list-style-type:none}.lst-kix_list_26-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li:before{content:\"\" counter(lst-ctn-kix_list_8-4,upper-roman) \". \"}.lst-kix_list_10-2>li{counter-increment:lst-ctn-kix_list_10-2}ol.lst-kix_list_8-5.start{counter-reset:lst-ctn-kix_list_8-5 0}ul.lst-kix_list_13-8{list-style-type:none}.lst-kix_list_11-1>li:before{content:\"o  \"}ul.lst-kix_list_13-7{list-style-type:none}ul.lst-kix_list_13-6{list-style-type:none}.lst-kix_list_21-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-0>li:before{content:\"\" counter(lst-ctn-kix_list_11-0,decimal) \". \"}ol.lst-kix_list_9-3.start{counter-reset:lst-ctn-kix_list_9-3 0}.lst-kix_list_26-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_8-8>li:before{content:\"\" counter(lst-ctn-kix_list_8-8,upper-roman) \". \"}.lst-kix_list_16-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-0{list-style-type:none}ul.lst-kix_list_23-1{list-style-type:none}.lst-kix_list_16-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_23-2{list-style-type:none}ul.lst-kix_list_23-3{list-style-type:none}ul.lst-kix_list_23-4{list-style-type:none}ul.lst-kix_list_23-5{list-style-type:none}ul.lst-kix_list_23-6{list-style-type:none}.lst-kix_list_4-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-8{list-style-type:none}.lst-kix_list_16-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_4-6{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}.lst-kix_list_25-1>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-4>li{counter-increment:lst-ctn-kix_list_8-4}ul.lst-kix_list_4-0{list-style-type:none}ul.lst-kix_list_23-7{list-style-type:none}.lst-kix_list_25-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_23-8{list-style-type:none}ol.lst-kix_list_10-8.start{counter-reset:lst-ctn-kix_list_10-8 0}.lst-kix_list_16-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_4-4{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}.lst-kix_list_11-3>li{counter-increment:lst-ctn-kix_list_11-3}ol.lst-kix_list_7-1.start{counter-reset:lst-ctn-kix_list_7-1 0}ul.lst-kix_list_12-6{list-style-type:none}ol.lst-kix_list_8-6.start{counter-reset:lst-ctn-kix_list_8-6 0}ul.lst-kix_list_12-5{list-style-type:none}.lst-kix_list_17-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-4{list-style-type:none}ul.lst-kix_list_12-3{list-style-type:none}ul.lst-kix_list_12-2{list-style-type:none}ul.lst-kix_list_12-1{list-style-type:none}.lst-kix_list_17-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-0{list-style-type:none}.lst-kix_list_17-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_12-8{list-style-type:none}ul.lst-kix_list_12-7{list-style-type:none}ol.lst-kix_list_8-0.start{counter-reset:lst-ctn-kix_list_8-0 0}.lst-kix_list_7-0>li:before{content:\"\" counter(lst-ctn-kix_list_7-0,upper-roman) \". \"}ol.lst-kix_list_9-7.start{counter-reset:lst-ctn-kix_list_9-7 0}.lst-kix_list_22-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_2-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-1{list-style-type:none}ul.lst-kix_list_26-2{list-style-type:none}ul.lst-kix_list_26-3{list-style-type:none}.lst-kix_list_22-1>li:before{content:\"o  \"}.lst-kix_list_27-4>li:before{content:\"\\0025a0  \"}.lst-kix_list_6-6>li{counter-increment:lst-ctn-kix_list_6-6}.lst-kix_list_7-3>li:before{content:\"\" counter(lst-ctn-kix_list_7-3,upper-roman) \". \"}.lst-kix_list_10-0>li:before{content:\"\" counter(lst-ctn-kix_list_10-0,decimal) \". \"}.lst-kix_list_9-7>li{counter-increment:lst-ctn-kix_list_9-7}.lst-kix_list_13-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-7>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_26-4{list-style-type:none}ul.lst-kix_list_26-5{list-style-type:none}ul.lst-kix_list_26-6{list-style-type:none}ul.lst-kix_list_26-7{list-style-type:none}.lst-kix_list_8-7>li{counter-increment:lst-ctn-kix_list_8-7}ul.lst-kix_list_26-8{list-style-type:none}ul.lst-kix_list_7-2{list-style-type:none}.lst-kix_list_27-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_7-7>li:before{content:\"\" counter(lst-ctn-kix_list_7-7,upper-roman) \". \"}ol.lst-kix_list_8-1.start{counter-reset:lst-ctn-kix_list_8-1 0}.lst-kix_list_15-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-5>li{counter-increment:lst-ctn-kix_list_9-5}.lst-kix_list_10-4>li:before{content:\"\" counter(lst-ctn-kix_list_10-4,decimal) \". \"}.lst-kix_list_10-8>li:before{content:\"\" counter(lst-ctn-kix_list_10-8,decimal) \". \"}.lst-kix_list_4-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-3{list-style-type:none}ul.lst-kix_list_15-2{list-style-type:none}.lst-kix_list_15-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_15-1{list-style-type:none}.lst-kix_list_15-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_15-0{list-style-type:none}.lst-kix_list_4-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_25-4>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_15-8{list-style-type:none}ul.lst-kix_list_15-7{list-style-type:none}ul.lst-kix_list_15-6{list-style-type:none}.lst-kix_list_9-3>li:before{content:\"\" counter(lst-ctn-kix_list_9-3,decimal) \". \"}ul.lst-kix_list_15-5{list-style-type:none}ul.lst-kix_list_15-4{list-style-type:none}ol.lst-kix_list_7-0.start{counter-reset:lst-ctn-kix_list_7-0 0}.lst-kix_list_25-8>li:before{content:\"\\0025c6  \"}ul.lst-kix_list_25-0{list-style-type:none}ul.lst-kix_list_25-1{list-style-type:none}ul.lst-kix_list_25-2{list-style-type:none}.lst-kix_list_9-7>li:before{content:\"\" counter(lst-ctn-kix_list_9-7,decimal) \". \"}ul.lst-kix_list_25-3{list-style-type:none}ul.lst-kix_list_25-4{list-style-type:none}.lst-kix_list_11-4>li:before{content:\"\" counter(lst-ctn-kix_list_11-4,decimal) \". \"}.lst-kix_list_12-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_20-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-4>li{counter-increment:lst-ctn-kix_list_7-4}ul.lst-kix_list_25-5{list-style-type:none}.lst-kix_list_1-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_25-6{list-style-type:none}.lst-kix_list_20-1>li:before{content:\"o  \"}ul.lst-kix_list_25-7{list-style-type:none}ul.lst-kix_list_25-8{list-style-type:none}.lst-kix_list_11-8>li:before{content:\"\" counter(lst-ctn-kix_list_11-8,decimal) \". \"}.lst-kix_list_12-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_6-1{list-style-type:none}ol.lst-kix_list_8-4.start{counter-reset:lst-ctn-kix_list_8-4 0}.lst-kix_list_1-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_14-4{list-style-type:none}ul.lst-kix_list_14-3{list-style-type:none}ul.lst-kix_list_14-2{list-style-type:none}.lst-kix_list_13-4>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_14-1{list-style-type:none}ul.lst-kix_list_14-0{list-style-type:none}.lst-kix_list_10-7>li{counter-increment:lst-ctn-kix_list_10-7}ul.lst-kix_list_14-8{list-style-type:none}ul.lst-kix_list_14-7{list-style-type:none}.lst-kix_list_2-0>li:before{content:\"\\0025cf  \"}ol.lst-kix_list_8-3.start{counter-reset:lst-ctn-kix_list_8-3 0}ul.lst-kix_list_14-6{list-style-type:none}.lst-kix_list_11-5>li{counter-increment:lst-ctn-kix_list_11-5}ul.lst-kix_list_14-5{list-style-type:none}ol.lst-kix_list_9-8.start{counter-reset:lst-ctn-kix_list_9-8 0}.lst-kix_list_1-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-8>li:before{content:\"\\0025c6  \"}.lst-kix_list_12-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-2>li{counter-increment:lst-ctn-kix_list_8-2}ul.lst-kix_list_20-2{list-style-type:none}ul.lst-kix_list_20-3{list-style-type:none}.lst-kix_list_19-0>li:before{content:\"\\0025cf  \"}.lst-kix_list_19-1>li:before{content:\"o  \"}ul.lst-kix_list_20-4{list-style-type:none}ul.lst-kix_list_20-5{list-style-type:none}ul.lst-kix_list_20-6{list-style-type:none}ul.lst-kix_list_1-0{list-style-type:none}ul.lst-kix_list_20-7{list-style-type:none}ul.lst-kix_list_20-8{list-style-type:none}.lst-kix_list_19-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-1>li{counter-increment:lst-ctn-kix_list_8-1}ol.lst-kix_list_8-2.start{counter-reset:lst-ctn-kix_list_8-2 0}.lst-kix_list_19-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-3>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_20-0{list-style-type:none}ul.lst-kix_list_20-1{list-style-type:none}ol.lst-kix_list_6-6.start{counter-reset:lst-ctn-kix_list_6-6 0}.lst-kix_list_7-0>li{counter-increment:lst-ctn-kix_list_7-0}.lst-kix_list_11-0>li{counter-increment:lst-ctn-kix_list_11-0}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}ul.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_9-6.start{counter-reset:lst-ctn-kix_list_9-6 0}.lst-kix_list_19-8>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-2.start{counter-reset:lst-ctn-kix_list_11-2 0}.lst-kix_list_19-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_19-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-2>li{counter-increment:lst-ctn-kix_list_9-2}ol.lst-kix_list_8-7.start{counter-reset:lst-ctn-kix_list_8-7 0}.lst-kix_list_10-3>li{counter-increment:lst-ctn-kix_list_10-3}.lst-kix_list_18-0>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-1>li:before{content:\"o  \"}.lst-kix_list_18-2>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-7.start{counter-reset:lst-ctn-kix_list_11-7 0}ul.lst-kix_list_22-0{list-style-type:none}.lst-kix_list_2-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-1>li:before{content:\"\\0025a0  \"}ul.lst-kix_list_22-1{list-style-type:none}ul.lst-kix_list_22-2{list-style-type:none}ul.lst-kix_list_22-3{list-style-type:none}ul.lst-kix_list_22-4{list-style-type:none}.lst-kix_list_2-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-3>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_22-5{list-style-type:none}ul.lst-kix_list_22-6{list-style-type:none}ul.lst-kix_list_22-7{list-style-type:none}.lst-kix_list_27-5>li:before{content:\"\\0025c6  \"}ol.lst-kix_list_10-3.start{counter-reset:lst-ctn-kix_list_10-3 0}.lst-kix_list_18-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_9-4.start{counter-reset:lst-ctn-kix_list_9-4 0}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_list_10-1>li:before{content:\"o  \"}.lst-kix_list_18-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-8>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_3-1{list-style-type:none}ul.lst-kix_list_22-8{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_7-7>li{counter-increment:lst-ctn-kix_list_7-7}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_10-7>li:before{content:\"\" counter(lst-ctn-kix_list_10-7,decimal) \". \"}.lst-kix_list_7-8>li{counter-increment:lst-ctn-kix_list_7-8}.lst-kix_list_10-5>li:before{content:\"\" counter(lst-ctn-kix_list_10-5,decimal) \". \"}.lst-kix_list_10-3>li:before{content:\"\" counter(lst-ctn-kix_list_10-3,decimal) \". \"}ol.lst-kix_list_7-3.start{counter-reset:lst-ctn-kix_list_7-3 0}ul.lst-kix_list_11-1{list-style-type:none}.lst-kix_list_11-7>li{counter-increment:lst-ctn-kix_list_11-7}.lst-kix_list_9-2>li:before{content:\"\" counter(lst-ctn-kix_list_9-2,decimal) \". \"}.lst-kix_list_20-8>li:before{content:\"\\0025aa  \"}.lst-kix_list_9-0>li:before{content:\"\" counter(lst-ctn-kix_list_9-0,decimal) \". \"}ul.lst-kix_list_21-1{list-style-type:none}ul.lst-kix_list_21-2{list-style-type:none}ul.lst-kix_list_21-3{list-style-type:none}ul.lst-kix_list_21-4{list-style-type:none}.lst-kix_list_20-0>li:before{content:\"\\0025cf  \"}ul.lst-kix_list_21-5{list-style-type:none}ul.lst-kix_list_21-6{list-style-type:none}ul.lst-kix_list_21-7{list-style-type:none}ul.lst-kix_list_21-8{list-style-type:none}ol.lst-kix_list_10-7{list-style-type:none}.lst-kix_list_9-6>li:before{content:\"\" counter(lst-ctn-kix_list_9-6,decimal) \". \"}ol.lst-kix_list_10-8{list-style-type:none}ol.lst-kix_list_10-3{list-style-type:none}.lst-kix_list_9-4>li:before{content:\"\" counter(lst-ctn-kix_list_9-4,decimal) \". \"}ol.lst-kix_list_10-4{list-style-type:none}ol.lst-kix_list_10-5{list-style-type:none}.lst-kix_list_11-3>li:before{content:\"\" counter(lst-ctn-kix_list_11-3,decimal) \". \"}ol.lst-kix_list_10-6{list-style-type:none}ul.lst-kix_list_21-0{list-style-type:none}.lst-kix_list_6-3>li{counter-increment:lst-ctn-kix_list_6-3}.lst-kix_list_20-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-0{list-style-type:none}ul.lst-kix_list_2-8{list-style-type:none}ol.lst-kix_list_10-2{list-style-type:none}.lst-kix_list_20-4>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-5>li:before{content:\"\" counter(lst-ctn-kix_list_11-5,decimal) \". \"}ul.lst-kix_list_2-2{list-style-type:none}.lst-kix_list_20-2>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_9-8>li:before{content:\"\" counter(lst-ctn-kix_list_9-8,decimal) \". \"}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:\"o  \"}ul.lst-kix_list_2-7{list-style-type:none}.lst-kix_list_11-7>li:before{content:\"\" counter(lst-ctn-kix_list_11-7,decimal) \". \"}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_8-5>li{counter-increment:lst-ctn-kix_list_8-5}.lst-kix_list_1-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_10-5.start{counter-reset:lst-ctn-kix_list_10-5 0}.lst-kix_list_1-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_1-5>li:before{content:\"\\0025aa  \"}ul.lst-kix_list_10-1{list-style-type:none}ol.lst-kix_list_7-5.start{counter-reset:lst-ctn-kix_list_7-5 0}.lst-kix_list_2-1>li:before{content:\"o  \"}.lst-kix_list_27-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_2-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-8>li{counter-increment:lst-ctn-kix_list_11-8}ol.lst-kix_list_7-7.start{counter-reset:lst-ctn-kix_list_7-7 0}.lst-kix_list_3-1>li:before{content:\"o  \"}.lst-kix_list_3-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_26-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_26-7>li:before{content:\"\\0025a0  \"}.lst-kix_list_8-1>li:before{content:\"\" counter(lst-ctn-kix_list_8-1,upper-roman) \". \"}.lst-kix_list_8-2>li:before{content:\"\" counter(lst-ctn-kix_list_8-2,upper-roman) \". \"}.lst-kix_list_6-0>li{counter-increment:lst-ctn-kix_list_6-0}.lst-kix_list_3-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-5.start{counter-reset:lst-ctn-kix_list_11-5 0}.lst-kix_list_21-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-5>li:before{content:\"\" counter(lst-ctn-kix_list_8-5,upper-roman) \". \"}.lst-kix_list_8-6>li:before{content:\"\" counter(lst-ctn-kix_list_8-6,upper-roman) \". \"}.lst-kix_list_26-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_26-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_3-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_21-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-2>li:before{content:\"\" counter(lst-ctn-kix_list_11-2,decimal) \". \"}.lst-kix_list_21-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-6.start{counter-reset:lst-ctn-kix_list_11-6 0}.lst-kix_list_16-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-4.start{counter-reset:lst-ctn-kix_list_6-4 0}.lst-kix_list_25-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_17-1>li:before{content:\"o  \"}.lst-kix_list_25-3>li:before{content:\"\\0025cf  \"}.lst-kix_list_16-1>li:before{content:\"o  \"}.lst-kix_list_7-3>li{counter-increment:lst-ctn-kix_list_7-3}.lst-kix_list_16-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_16-5>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_7-8.start{counter-reset:lst-ctn-kix_list_7-8 0}ol.lst-kix_list_11-0.start{counter-reset:lst-ctn-kix_list_11-0 0}ol.lst-kix_list_6-3.start{counter-reset:lst-ctn-kix_list_6-3 0}ol.lst-kix_list_10-2.start{counter-reset:lst-ctn-kix_list_10-2 0}.lst-kix_list_17-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_17-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-2>li{counter-increment:lst-ctn-kix_list_6-2}.lst-kix_list_2-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_27-2>li:before{content:\"\\0025c6  \"}.lst-kix_list_22-3>li:before{content:\"\\0025aa  \"}.lst-kix_list_7-1>li:before{content:\"\" counter(lst-ctn-kix_list_7-1,decimal) \". \"}.lst-kix_list_7-5>li:before{content:\"\" counter(lst-ctn-kix_list_7-5,upper-roman) \". \"}.lst-kix_list_9-6>li{counter-increment:lst-ctn-kix_list_9-6}.lst-kix_list_27-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_22-7>li:before{content:\"\\0025aa  \"}.lst-kix_list_18-5>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_6-7>li{counter-increment:lst-ctn-kix_list_6-7}.lst-kix_list_10-6>li{counter-increment:lst-ctn-kix_list_10-6}.lst-kix_list_11-6>li{counter-increment:lst-ctn-kix_list_11-6}ol.lst-kix_list_10-0.start{counter-reset:lst-ctn-kix_list_10-0 0}.lst-kix_list_7-5>li{counter-increment:lst-ctn-kix_list_7-5}.lst-kix_list_15-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-4>li{counter-increment:lst-ctn-kix_list_11-4}ol.lst-kix_list_6-8.start{counter-reset:lst-ctn-kix_list_6-8 0}.lst-kix_list_10-2>li:before{content:\"\" counter(lst-ctn-kix_list_10-2,decimal) \". \"}.lst-kix_list_20-7>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_6-5.start{counter-reset:lst-ctn-kix_list_6-5 0}.lst-kix_list_4-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_4-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_15-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_10-8>li{counter-increment:lst-ctn-kix_list_10-8}.lst-kix_list_25-6>li:before{content:\"\\0025cf  \"}.lst-kix_list_10-6>li:before{content:\"\" counter(lst-ctn-kix_list_10-6,decimal) \". \"}.lst-kix_list_9-1>li:before{content:\"o  \"}ol.lst-kix_list_6-7.start{counter-reset:lst-ctn-kix_list_6-7 0}.lst-kix_list_9-5>li:before{content:\"\" counter(lst-ctn-kix_list_9-5,decimal) \". \"}.lst-kix_list_12-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_11-6>li:before{content:\"\" counter(lst-ctn-kix_list_11-6,decimal) \". \"}.lst-kix_list_20-3>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-3.start{counter-reset:lst-ctn-kix_list_11-3 0}.lst-kix_list_1-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_8-8>li{counter-increment:lst-ctn-kix_list_8-8}.lst-kix_list_1-6>li:before{content:\"\\0025aa  \"}.lst-kix_list_12-6>li:before{content:\"\\0025aa  \"}ol.lst-kix_list_11-4.start{counter-reset:lst-ctn-kix_list_11-4 0}.lst-kix_list_2-2>li:before{content:\"\\0025aa  \"}.lst-kix_list_13-2>li:before{content:\"\\0025aa  \"}ol{margin:0;padding:0}table td,table th{padding:0}.c14{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:137.2pt;border-top-color:#000000;border-bottom-style:solid}.c11{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:157.8pt;border-top-color:#000000;border-bottom-style:solid}.c9{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:291.1pt;border-top-color:#000000;border-bottom-style:solid}.c6{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:280.1pt;border-top-color:#000000;border-bottom-style:solid}.c13{margin-left:18pt;padding-top:0pt;padding-left:-3.8pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c3{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:\"Arial\";font-style:normal}.c5{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c0{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:8pt;font-family:\"Arial\";font-style:normal}.c48{padding-top:0pt;text-indent:24pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:center}.c2{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:\"Arial\";font-style:normal}.c28{padding-top:0pt;text-indent:20pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c30{padding-top:0pt;text-indent:18pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c33{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c19{font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:\"Arial\";font-style:normal}.c20{font-weight:700;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:\"Arial\";font-style:normal}.c1{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c42{margin-left:36pt;padding-top:0pt;text-indent:-16pt;padding-bottom:0pt;line-height:1.0;text-align:justify}.c8{padding-top:6pt;padding-bottom:6pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c24{font-weight:700;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:\"Arial\";font-style:normal}.c17{padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c7{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-indent:20pt;text-align:justify}.c40{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c36{-webkit-text-decoration-skip:none;color:#0000ff;text-decoration:underline;text-decoration-skip-ink:none}.c31{padding-top:12pt;padding-bottom:12pt;line-height:1.0;text-align:justify}.c12{font-size:10pt;font-family:\"Arial\";color:#000000;font-weight:400}.c56{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c22{font-size:10pt;font-family:\"Arial\";font-style:italic;font-weight:700}.c55{font-size:11pt;font-family:\"Arial\";color:#212121;font-weight:700}.c43{font-weight:400;font-size:11pt;font-family:\"Arial\"}.c25{font-size:8pt;font-family:\"Arial\";font-weight:700}.c21{background-color:#ffffff;padding:72pt 16pt 72pt 16pt;margin:auto;}.c29{font-size:10pt;font-family:\"Arial\";font-weight:700}.c27{font-size:10pt;font-family:\"Arial\";font-weight:400}.c10{font-size:8pt;font-family:\"Arial\";font-weight:400}.c16{padding:0;margin:0}.c26{text-decoration:none;vertical-align:baseline}.c4{color:inherit;text-decoration:inherit}.c52{height:20pt}.c44{margin-left:14.2pt}.c34{height:6pt}.c35{height:74pt}.c37{height:103pt}.c46{height:14pt}.c53{vertical-align:baseline}.c15{color:#000000}.c50{height:44pt}.c38{font-style:normal}.c45{text-indent:25pt}.c51{height:29pt}.c41{height:22pt}.c47{height:19pt}.c54{color:#777777}.c32{height:59pt}.c49{height:45pt}.c23{height:18pt}.c39{text-indent:20pt}.c18{height:10pt}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:\"Georgia\";line-height:1.0;page-break-after:avoid;font-style:italic;text-align:justify}li{color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}p{margin:0;color:#000000;font-size:10.5pt;font-family:\"\\007b49\\007ebf\"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h2{padding-top:5pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h3{padding-top:5pt;color:#000000;font-weight:700;font-size:13.5pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h4{padding-top:5pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:5pt;font-family:\"\\005b8b\\004f53\";line-height:1.0;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:\"\\007b49\\007ebf\";line-height:1.0;page-break-after:avoid;text-align:justify}</style><p class=c48><span class=\"c15 c19\">Политика конфиденциальности </span></p><p class=c28><span class=c2>Последнее обновление: 05/2018</span></p><p class=c28><span class=c29>Вы подтверждаете, что ознакомились с настоящей политикой конфиденциальности и она вам понятна. Если вы не согласны с положениями настоящей политики конфиденциальности, не используйте услуги Tap4Fun. Если в будущем вы передумаете, то, в соответствии с настоящей политикой, сможете отозвать свое согласие на использование ваших персональных данных.</span></p><p class=c7><span class=c2>Компания Tap4Fun понимает, насколько важна защита конфиденциальной информации для ее клиентов, и просит вас внимательно ознакомиться с нашей политикой конфиденциальности. В данной политике изложена следующая информация:</span></p><p class=c7><span class=c5>1、Какого рода персональные данные о вас мы собираем.</span></p><p class=c7><span class=c5>2、Как мы используем ваши персональные данные.</span></p><p class=c7><span class=c5>3、Кому мы предоставляем ваши персональные данные.</span></p><p class=c7><span class=c5>4、В течение какого времени мы храним ваши персональные данные.</span></p><p class=c42><span class=c5>5、Каким образом вы можете воспользоваться своими правами в отношении &nbsp; ваших персональных данных.</span></p><p class=c7><span class=c5>6、Разрешение споров.</span></p><p class=c7><span class=c5>7、Каким образом мы информируем вас об изменениях.</span></p><p class=c7><span class=c5>8、Контактная информация.</span></p><p class=c7><span class=c2>Эта политика конфиденциальности распространяется на все услуги Tap4Fun, в условиях предоставления которых имеется прямая ссылка на эту политику, и не относится к тем услугам Tap4Fun, которые оказываются в соответствии с отдельными политиками конфиденциальности, не включающими данную политику.</span></p><p class=c31><span class=\"c24 c15\">РАЗДЕЛ 1. В КАКИХ СЛУЧАЯХ МЫ ЯВЛЯЕМСЯ ОПЕРАТОРОМ ДАННЫХ</span></p><p class=c8><span class=\"c29 c15\">1. Типы используемых нами персональных данных</span></p><p class=c7><span class=c2>В этом разделе описываются различные типы персональных данных, которые мы собираем, и порядок сбора этих данных. Мы собираем и используем следующие персональные данные:</span></p><p class=c8><span class=\"c29 c15\">Данные,</span><span class=c55>&nbsp;которые вы нам предоставляете:</span></p><ul class=\"c16 lst-kix_list_23-0 start\"><li class=c13><span class=c2>в момент вашей регистрации для участия в игре (включая указанный вами никнейм или пользовательские учетные записи и информацию, которые мы импортируем из подключенной вами учетной записи в социальных сетях (WeChat, Facebook) для настройки вашего профиля, включая ваше имя в том виде, в котором оно отображается в профиле социальной сети, и ваш аватар);</span></li><li class=c13><span class=c2>в момент вашего «гостевого» входа в систему для участия в игре (ваш никнейм); а также</span></li><li class=c13><span class=c2>в момент участия в опросе в игре (в этом случае мы будем обрабатывать данные, которые вы нам предоставляете, в рамках опроса).</span></li><li class=c13><span class=\"c26 c15 c38 c43\">данные, </span><span class=c2>которые вы предоставляете, обращаясь к нам за помощью, например, ваше имя, номер телефона и информация о проблемах, с которыми вы столкнулись;</span></li><li class=c13><span class=c2>платежная информация, такая как ваше имя, номер банковской карты и реквизиты платежного счета.</span></li></ul><p class=c8><span class=c5>Данные, которые мы собираем о вас.</span></p><p class=\"c33 c39\"><span class=c2>Когда вы участвуете в игре, мы автоматически собираем о вас определенные данные, включая ваш IP-адрес и информацию об устройстве (например, версию приложения, тип сети, ОС), и данные о том, как вы используете игру, такие как отметки даты и времени. Мы также собираем и сохраняем ваши данные каждый раз, когда вы общаетесь с нами, например, когда вы связываетесь с нами через встроенную в приложение службу поддержки.</span></p><p class=c8><span class=c5>Данные, которые вы генерируете и демонстрируете в процессе использования игровых услуг.&nbsp;</span></p><p class=\"c33 c39\"><span class=c12>В своем профиле вы можете предоставить дополнительную информацию (например, пол). Вы также можете предоставлять или генерировать данные в процессе общения с другими пользователями игры (например, данные журнала чата, содержимое чата).</span></p><p class=c8><span class=c5>Данные, которые мы собираем у наших партнеров.</span></p><ul class=\"c16 lst-kix_list_23-0\"><li class=c13><span class=c2>Данные, которые мы получаем, если вы привязываете к Сервису сторонний ресурс (например, WeChat, Facebook).</span></li><li class=c13><span class=c3>Демографические данные (например, для определения приблизительного местонахождения вашего IP-адреса).</span></li><li class=c13><span class=c3>Данные для борьбы с мошенничеством (таким как злоупотребление возвратом оплат за игры или мошенничество с кликами в рекламе).</span></li><li class=c13><span class=c3>Данные с платформ, на которых запускаются игры (например, для проверки платежа).</span></li><li class=c13><span class=c3>Данные для рекламных и аналитических целей, позволяющие нам повышать качество предоставлямых услуг.</span></li></ul><p class=c8><span class=c5>Файлы cookie.</span></p><p class=c8><span class=c2>Мы используем файлы cookie и другие подобные технологии (например, веб-маяки, файлы журналов, скрипты и eTags) (далее «файлы cookie») для вашего удобства при использовании услуг. Файлы cookie представляют собой небольшие файлы, которые размещаются на вашем устройстве и позволяют нам предоставлять определенные характеристики и функции. Вы можете разрешить установку подобных файлов cookie или впоследствии их отключить. Вы можете принять все файлы cookie, дать устройству инструкции (в случае игры) уведомлять вас во время установки файлов cookie либо отказаться устанавливать любые файлы cookie, отредактировав соответствующую функцию хранения файлов cookie на вашем устройстве. Отказ от установки файлов cookie может повлиять на функциональность игры.</span></p><p class=\"c8 c18\"><span class=c2></span></p><p class=c8><span class=c5>2. Как мы используем ваши персональные данные</span></p><p class=c33><span class=c2>Мы можем использовать ваши персональные данные следующим образом:</span></p><a id=t.1b4b8e5c3ff5de08462fa3792d8c5dff22e1aa9c></a><a id=t.0></a><table class=c56><tbody><tr class=c41><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c15 c25\">Персональные данные</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c25 c15\">Использование</span></p></td></tr><tr class=c41><td class=c11 colspan=1 rowspan=1><p class=c17><span class=\"c10 c15\">Никнейм</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Данная информация используется для создания вашей учетной записи в соответствии с вашим запросом.</span></p></td></tr><tr class=c47><td class=c11 colspan=1 rowspan=1><p class=c17><span class=c0>Данные социальных сетей:</span></p><p class=c17><span class=c0>WeChat: Open ID, аватар, псевдоним, пол, регион</span></p><p class=c17><span class=c10>Facebook: имя, Facebook ID, фото профиля</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=c0>Мы используем эти данные для следующих целей: •&nbsp;создание вашей учетной записи для игры в соответствии с вашим запросом; •&nbsp;публикация фотографий из игры на Facebook по вашему запросу.</span></p></td></tr><tr class=c49><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Сгенерированный Open ID</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Мы генерируем Open ID и используем его для хранения ваших игровых данных (включая уровень и прогресс) в вашем профиле.</span></p></td></tr><tr class=c52><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Статистика игры (уровень, оценки)</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Мы используем эти данные для того, чтобы предоставлять вам отзывы и информацию о вашей игре и ее прохождении.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">IP-адрес</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Мы используем эти данные для улучшения наших услуг, в том числе функциональность игры.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Идентификатор устройства, информация об устройстве</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Мы используем эти данные для следующих целей: •&nbsp;улучшение наших услуг, в том числе функциональность игры; •&nbsp;обеспечение безопасности и проверки; •&nbsp;выявление и устранение ошибок и оценка игровых функций с целью их оптимизации; •&nbsp;борьба с пользователями, регистрирующими несколько учетных записей.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Рекламный идентификатор</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Если вы нажимаете на ссылку, рекламирующую игру, мы сохраняем идентификатор этой рекламы вместе с вашим профилем.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Данные чата</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Если вы активируете службы чата (звукового или текстового), мы обрабатываем такие данные для доставки ваших сообщений другим пользователям.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Записи о транзакциях: платежи в Google Play или iOS App Store&nbsp;</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Мы используем эти данные для ведения истории ваших транзакций.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Идентификатор заявки в службу поддержки клиентов и общение пользователей со службой поддержки</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Мы используем эти данные для следующих целей: • улучшение наших услуг; • устранение неполадок, например решение и устранение технических проблем и ошибок.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Информация о безопасности</span></p></td><td class=c9 colspan=1 rowspan=1><p class=c1><span class=\"c10 c15\">Мы используем эти данные для следующих целей:•&nbsp;обеспечение безопасности и проверки; •&nbsp;выявление и устранение ошибок и оценка игровых функций с целью их оптимизации; •&nbsp;устранение сбоев в игре и оптимизация совместимости устройств с игрой; •&nbsp;борьба с пользователями, регистрирующими несколько учетных записей.</span></p></td></tr><tr class=c23><td class=c11 colspan=1 rowspan=1><p class=c1><span class=c0>Данные опросов и содержание ответов на опросы</span></p></td><td class=c9 colspan=1 rowspan=1><p class=\"c1 c18\"><span class=c0></span></p></td></tr></tbody></table><p class=\"c8 c18\"><span class=c5></span></p><p class=\"c8 c18\"><span class=c5></span></p><p class=c8><span class=c5>Анализ, профилирование и сегментирование.</span></p><p class=c30><span class=c3>Во всех вышеуказанных случаях и целях мы можем анализировать, профилировать и сегментировать все собранные данные.</span></p><p class=c8><span class=c5>Юридическая основа для обработки данных</span></p><p class=c28><span class=c27>Если вы резидент Европейского Союза, при обработке ваших персональных данных мы опираемся на ряд юридических оснований. Например, мы обрабатываем те персональные данные, на обработку которых получено ваше согласие, на обработку которых у нас имеется законное основание, обработка которых необходима для выполнения условий договора с вами и обработка которых относится к нашим юридическим обязательствам. Например, осуществляя прямой маркетинг, мы основываемся на наших законных интересах, а при обработке информации в момент создания вами учетной записи мы основываемся на наших договорных обязательствах. Для получения более подробной информации о законных основаниях для обработки ваших персональных данных с какой-либо конкретной целью свяжитесь с нами при помощи одной из опций в разделе </span><span class=\"c15 c29\">К</span><span class=c29>онтактная информация и жалобы</span><span class=c27>, расположенной ниже.</span></p><p class=c8><span class=c5>3. Кому мы предоставляем ваши персональные данные</span></p><p class=c33><span class=c2>Мы передаем ваши персональные данные определенным третьим лицам в вашей стране и за ее пределами, в том числе:</span></p><ul class=\"c16 lst-kix_list_23-0\"><li class=c13><span class=\"c20 c15\">другим игрокам и пользователям.</span><span class=c2>&nbsp;</span><span class=c3>Социальные функции — это основной компонент наших игр. Например, другие игроки и пользователи могут видеть данные вашего профиля и игровую активность, читать опубликованные вами сообщения;</span></li><li class=c13><span class=\"c20 c15\">партнерам, работающим с Tap4Fun.</span><span class=c2>&nbsp;</span><span class=c3>Партнеры Tap4Fun выполняют для нас ряд услуг. Такие партнеры обрабатывают ваши данные только в соответствии с инструкциями по оказанию услуг Tap4Fun, таких как хостинг, поддержка игроков, реклама, аналитика и предотвращение мошенничества;</span></li><li class=c13><span class=\"c20 c15\">другим компаниям и государственным органам. </span><span class=c3>В целях борьбы с мошенничеством и незаконной деятельностью мы можем обмениваться данными с другими компаниями и организациями и предоставлять их государственным органам в ответ на законные запросы. Мы также можем раскрывать ваши данные на основании вашего согласия, в целях соблюдения законных требований или защиты прав, собственности или безопасности нашей компании, игроков или других лиц;</span></li><li class=c13><span class=\"c20 c15\">связанным</span><span class=c5>&nbsp;компаниям холдинга Tap4Fun (Hong Kong) Limited</span><span class=c2>, которым мы передаем ваши персональные данные для работы игровых служб;</span></li><li class=c13><span class=c5>в правоохранительные органы, государственные органы или иные судебные органы и организации;</span></li><li class=c13><span class=\"c20 c15\">третьей стороне, которая приобретает все или практически все наши структуры или деловые подразделения.&nbsp;</span><span class=c3>Информация подлежит раскрытию третьей стороне в случае продажи или покупки нами какой-либо компании или в результате слияния, и в этом случае мы раскроем ваши данные потенциальному покупателю такой компании. Мы также раскроем информацию третьей стороне в случае продажи, покупки, слияния или сотрудничества с другими компаниями или предприятиями или продажи части или всех наших активов. При подобных транзакциях информация о пользователе может относиться к активам, подлежащим передаче.</span></li></ul><p class=c8><span class=c5>4. Хранение данных</span></p><p class=\"c33 c39\"><span class=c2>Ниже описаны способы хранения ваших персональных данных (за исключением случаев, когда в соответствии с применимым законодательством данные должны храниться иным способом).</span></p><a id=t.6abbe5afc4df34d0c6b2cd29dda3250a4aee3f09></a><a id=t.1></a><table class=c40><tbody><tr class=c46><td class=c14 colspan=1 rowspan=1><p class=c1><span class=\"c25 c15\">Персональные данные</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=\"c25 c15\">Политика хранения данных</span></p></td></tr><tr class=c50><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Никнейм</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры (т.е. до удаления учетной записи по вашему запросу ), а затем удаляется в течение 30 дней.</span></p></td></tr><tr class=c32><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Данные социальных сетей:<br>WeChat</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры (т.е. до удаления учетной записи по вашему запросу или отмены вами доступа к вашей учетной записи в социальных сетях), а затем удаляется в течение 30 дней.&nbsp;</span></p></td></tr><tr class=c37><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Данные социальных сетей:<br>Facebook</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 15 дней.<br>При отсутствии запроса на удаление учетной записи такие данные будут храниться в течение 1 года после закрытия игры, прежде чем они будут удалены.&nbsp;</span></p></td></tr><tr class=c37><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0><br>Статистика игры (уровень, герои, оценки)</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 15 дней.&nbsp;<br>При отсутствии запроса на удаление учетной записи такие данные будут храниться в течение 1 года после закрытия игры, прежде чем они будут удалены.&nbsp;</span></p></td></tr><tr class=c51><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Общение в чате (звуковые сообщения)</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится на наших серверах в течение 7 дней, а после истечения этого срока автоматически удаляется.</span></p></td></tr><tr class=c35><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Общение в чате (текстовые сообщения)</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 7 дней.&nbsp;<br>При отсутствии запроса на удаление учетной записи такие данные будут храниться в течение 1 года после закрытия игры, прежде чем они будут удалены.&nbsp;</span></p></td></tr><tr class=c34><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>OpenID</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 15 дней.&nbsp;<br>При отсутствии запроса на удаление учетной записи такие данные будут храниться в течение 1 года после закрытия игры, прежде чем они будут удалены.&nbsp;</span></p></td></tr><tr class=c34><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>IP-адрес</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 15 дней.&nbsp;<br>При отсутствии запроса на удаление учетной записи такие данные будут храниться в течение 1 года после закрытия игры, прежде чем они будут удалены.&nbsp;</span></p></td></tr><tr class=c34><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Идентификатор устройства, информация об устройстве</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 30 дней.<br>При отсутствии запроса на удаление учетной записи такие данные будут храниться в течение 1 года после закрытия игры, прежде чем они будут удалены.&nbsp;</span></p></td></tr><tr class=c34><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Рекламный идентификатор</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 15 дней.&nbsp;<br>При отсутствии запроса на удаление учетной записи такие данные будут храниться в течение 1 года после закрытия игры, прежде чем они будут удалены.&nbsp;</span></p></td></tr><tr class=c34><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Записи о транзакциях</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранятся в течение всего срока использования вами игры (т.е. до удаления учетной записи по вашему запросу), а затем в течение любого срока хранения, применимого к хранению подобных данных в соответствии с нашими юридическими обязательствами.</span></p></td></tr><tr class=c34><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Идентификатор заявки в службу поддержки клиентов и общение пользователей со службой поддержки</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Данные службы поддержки удаляются в течение 30 дней с момента получения от вас законного запроса об удалении подобных данных (см. раздел «Удаление данных» настоящей политики конфиденциальности).</span></p></td></tr><tr class=c34><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Информация о безопасности&nbsp;</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранится в течение всего срока использования вами игры, вплоть до удаления учетной записи по вашему запросу, после чего удаляется в течение 30 дней.&nbsp;</span></p></td></tr><tr class=c51><td class=c14 colspan=1 rowspan=1><p class=c1><span class=c0>Данные опросов</span></p></td><td class=c6 colspan=1 rowspan=1><p class=c1><span class=c0>Хранятся в течение следующих сроков: (a) если в рамках опроса вы предоставляете адрес вашей электронной почты, данные хранятся в течение 6 месяцев (с целью получения от вас обратной связи) и затем анонимизируются; либо (b) если в рамках опроса вы не предоставляете адрес вашей электронной почты, данные хранятся в течение 1 месяца, а затем анонимизируются.</span></p></td></tr></tbody></table><p class=\"c18 c33\"><span class=c2></span></p><p class=\"c33 c39\"><span class=c2>Персональные данные хранятся до окончания срока их использования (как указано выше в политике хранения данных). При уничтожении персональных данных будут предприняты меры по обеспечению безвозвратности или невоспроизводимости персональных данных, а электронные файлы, содержащие персональные данные, будут удалены навсегда с использованием технического метода, обеспечивающего невоспроизводимость файлов.</span></p><p class=\"c33 c39\"><span class=c2>В тех случаях, когда период обработки и хранения завершен, но персональные данные должны непрерывно храниться по иным причинам, в том числе в целях, предусмотренных действующим законодательством, соответствующие персональные данные будут храниться и поддерживаться отдельно от других видов персональных данных. Если вы потребуете от нас уничтожить ваши персональные данные до окончания срока их использования (как указано выше в политике хранения данных), мы уничтожим ваши персональные данные в соответствии с требованиями местного законодательства.</span></p><p class=c31><span class=\"c24 c15\">РАЗДЕЛ 2. ВАШИ ПРАВА</span></p><p class=c33><span class=\"c22 c15\">Содержание данного раздела («Ваши права»)</span><span class=c5>&nbsp;относится только к пользователям, находящимся на территории ЕЭЗ.</span></p><p class=\"c33 c39\"><span class=c12>Вы обладаете определенными правами в отношении персональных данных, которые мы храним о вас. Некоторые из них применимы только в определенных обстоятельствах (которые подробно изложены ниже). Мы обязаны ответить на ваш запрос на реализацию данных прав без неоправданной задержки и в течение максимум одного месяца (хотя при определенных обстоятельствах этот срок может быть увеличен еще на два месяца). Чтобы воспользоваться любыми своими правами, напишите нам по адресу </span><span class=\"c36 c27\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c2>.</span></p><p class=c8><span class=\"c22 c15 c26\">1. Доступ</span></p><p class=\"c33 c39\"><span class=c12>Вы обладаете правом доступа к персональным данным, которые мы храним о вас, к информации о том, как мы их используем и кому мы их предоставляем. Вы можете получить доступ к персональным данным, предоставленным вами как часть учетной записи, выполнив вход в свою гровую учетную запись и связавшись со службой поддержки по адресу </span><span class=\"c36 c27\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c12>. Если вы полагаете, что мы храним какие-либо иные персональные данные о вас, напишите нам об этом по адресу </span><span class=\"c36 c27\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c2>.</span></p><p class=c8><span class=\"c22 c26 c15\">2. Право переноса</span></p><p class=\"c33 c39\"><span class=c27>Вы имеете право получить копию определенных персональных данных, которые мы обрабатываем о вас. Сюда входят любые персональные данные, которые мы обрабатываем на основании вашего согласия</span><span class=c12>&nbsp;(например, определенная информация из опросов), или на основании связывающего нас договора, как описано в разделе </span><span class=\"c15 c22\">Как мы используем ваши персональные данные</span><span class=c2>. Вы имеете право на получение этих данных в структурированном, стандартном, машиночитаемом формате. Вы также имеете право потребовать, чтобы мы передали эти персональные данные другой стороне.</span></p><p class=\"c33 c39\"><span class=c2>Если вы хотите, чтобы мы передали подобные персональные данные третьей стороне, обязательно укажите реквизиты этой стороны в своем запросе. Обратите внимание на то, что мы можем сделать это только при наличии технической возможности. Помните, что мы не сможем предоставить вам персональные данные, если это будет означать нарушение прав другого лица (например, когда раскрытие персональных данных о вас раскрывает информацию о другом человеке, нашей коммерческой тайне или интеллектуальной собственности).</span></p><p class=\"c33 c39 c18\"><span class=c2></span></p><p class=\"c33 c39 c18\"><span class=c2></span></p><p class=c8><span class=\"c22 c26 c15\">3. Исправление</span></p><p class=c7><span class=c27>Вы обладаете правом на внесение исправлений в хранимые o вас персональные данные, если в них есть ошибки. Вы можете получить доступ к персональным данным, предоставленным вами как часть учетной записи, выполнив вход в свою игровую учетную запись. Если вы полагаете, что мы храним какие-либо иные персональные данные о вас, и в них имеются ошибки, напишите нам об этом по адресу </span><span class=\"c36 c27\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c12>.</span></p><p class=c8><span class=\"c22 c26 c15\">4. Удаление данных</span></p><p class=c7><span class=c27>Вы можете удалить свою учетную запись или определенные персональные данные, выполнив вход в свою игровую учетную запись. Если вы полагаете, что мы обрабатываем какие-либо иные персональные данные о вас, и хотели бы воспользоваться правом на удаление, напишите нам об этом по адресу </span><span class=\"c36 c27\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c12>.</span></p><p class=\"c7 c18\"><span class=c2></span></p><p class=c7><span class=c2>Вы можете потребовать от нас удалить ваши персональные данные в следующих случаях:</span></p><ul class=\"c16 lst-kix_list_23-0\"><li class=c13><span class=c2>когда вы полагаете, что нам больше не нужно хранить такие пресональные данные; или</span></li><li class=c13><span class=c2>когда вы полагаете, что мы незаконно обрабатываем имеющиеся у нас персональные данные о вас.&nbsp;</span></li></ul><p class=\"c33 c18 c44\"><span class=c2></span></p><p class=c7><span class=c2>Вы также можете воспользоваться своим правом ограничить обработку нами ваших персональных данных (как описано ниже) на время рассмотрения нами вашего запроса.&nbsp;</span></p><p class=\"c7 c18\"><span class=c2></span></p><p class=c7><span class=c2>Нам может понадобиться хранить персональные данные, если в соответствии с законом о защите данных имеются веские основания для их хранения (например, для защиты законных требований или свободы выражения), о чем мы проинформируем вас. В тех случаях, когда вы просите удалить персональные данные, которые были публично распространены через игровой сервис, и имеются основания для их удаления, мы применим разумные меры для уведомления других сторон, отображающих персональные данные или предоставляющих ссылки на них, о необходимости их удаления.</span></p><p class=c8><span class=\"c22 c26 c15\">5. Ограничение обработки данных только хранением</span></p><p class=c7><span class=c2>В определенных обстоятельствах вы имеете право потребовать от нас прекратить обработку персональных данных, которые мы храним о вас, ограничив их обработку только хранением. Однако обратите внимание на то, что в случае прекращения обработки персональных данных мы можем использовать их снова, если в соответствии с законом о защите данных имеются веские основания для их использования (например, для защиты законных требований или для защиты других лиц). Как уже говорилось, в случае согласия на прекращение обработки персональных данных мы попытаемся сообщить любой третьей стороне, которой мы раскрыли соответствующие персональные данные, чтобы она также могла прекратить их обработку.&nbsp;</span></p><p class=c7><span class=c2>Вы можете потребовать прекратить обработку ваших персональных данных и разрешить только их хранение в следующих случаях:</span></p><ul class=\"c16 lst-kix_list_23-0\"><li class=c13><span class=c2>когда вы полагаете, что в персональных данных имеются неточности, в течение срока проводимой нами проверки в отношении точности ваших данных;</span></li><li class=c13><span class=c2>если вы хотите удалить персональные данные по причине их незаконной обработки с нашей стороны, но хотели бы, чтобы мы сохранили ваши персональные данные, ограничившись только их хранением; либо&nbsp;</span></li><li class=c13><span class=c2>если вы хотите удалить свои персональные данные, так как они больше не нужны для наших целей, но хотели бы, чтобы мы хранили их с целью установления, реализации или защиты законных требований.</span></li></ul><p class=c8><span class=\"c22 c26 c15\">6. Право на возражение</span></p><p class=c7><span class=c27>Вы обладаете правом на возражение против нашей обработки ваших персональных данных. Запросы в связи с иными обстоятельствами, описанными ниже, отправляйте по адресу </span><span class=\"c36 c27\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c2>.</span></p><p class=c8><span class=\"c22 c26 c15\">7. Объявления</span></p><p class=c7><span class=c2>Время от времени мы можем отправлять вам сообщения, которые считаем необходимыми (например, о временной приостановке доступа к игре в связи с техническим обслуживанием, или в связи с безопасностью, конфиденциальностью или администрированием сайта). Вы не можете отказаться от служебных сообщений, которые по сути не имеют рекламного характера.&nbsp;</span></p><p class=c31><span class=\"c24 c15\">РАЗДЕЛ 3. ПРОЧИЕ ПОЛОЖЕНИЯ </span></p><p class=c8><span class=c5>1. Информационная безопасность</span></p><p class=c7><span class=c2>Мы применяем административные, физические и технические меры безопасности, предназначенные для защиты ваших данных от потери, кражи, неправильного использования, несанкционированного доступа, раскрытия, изменения и уничтожения. Необходимо понимать, что, несмотря на наши усилия, никакие меры безопасности не гарантируют абсолютную защиту.</span></p><p class=c8><span class=c5>2. Информация о детях</span></p><p class=c7><span class=c2>Мы не собираем и не запрашиваем персональные данные, поступающие от прямой или целевой рекламы на основе интересов, о лицах, не достигших 16&nbsp;лет, и не даем таким лицам прямое разрешение на использование наших услуг. Если вам не испольнилось 16 лет, не отправляйте нам информацию о себе, включая ваше имя, адрес, номер телефона или адрес электронной почты. Лица моложе 16 лет не могут предоставлять персональные данные о себе. Если мы узнаем, что мы храним персональные данные о ребенке в возрасте до 16 лет, мы удалим эту информацию как можно скорее. Если вы считаете, что мы можем располагать персональными данными о ком-то, кому меньше 16 лет, свяжитесь с нами.</span></p><p class=c8><span class=\"c29 c15\">3.</span><span class=c27>&nbsp;</span><span class=c5>Ссылки на сторонние сайты и службы</span></p><p class=\"c8 c39\"><span class=c2>Услуги Tap4Fun могут содержать ссылки на другие сайты, приложения и службы. Поскольку Tap4Fun не является оператором этих сайтов, приложений и служб, мы не можем нести ответственность за порядок использования персональных данных, принятый в организациях-операторах этих ресурсов. Для понимания порядка использования персональных данных мы рекомендуем вам внимательно изучить политику конфиденциальности оператора. Напоминаем, что в настоящей политике описывается порядок использования персональных данных, принятый в Tap4Fun.</span></p><p class=c8><span class=c5>4. Изменения</span></p><p class=c7><span class=c2>Tap4Fun сохраняет за собой право время от времени вносить изменения в настоящую политику конфиденциальности. При внесении изменений в эту политику мы также изменяем дату \"последнего обновления\", указанную выше. При внесении существенных изменений в отношении способов сбора, использования, хранения или передачи ваших персональных данных мы уведомим вас об этом, отправив вам электронное письмо на последний предоставленный вами адрес электронной почты или опубликовав уведомление об изменениях в услугах, к которым относится настоящая политика конфиденциальности.</span></p><p class=c8><span class=c5>4. Международная передача информации</span></p><p class=\"c8 c45\"><span class=c2>Мы можем передавать собираемую о вас информацию дочерним предприятиям или другим третьим лицам из одной страны в другую, а также из страны вашего местонахождения или юрисдикции в другие страны или юрисдикции по всему миру. Обратите внимание на то, что эти страны и юрисдикции могут иметь законы о защите данных, отличающиеся от законов, действующих в вашей юрисдикции, и мы принимаем меры для того, чтобы обеспечить надлежащую защиту, необходимую для передачи данных, а также использования и раскрытия информации о вас, включая персональные данные, в соответствии с положениями этой Политики.</span></p><p class=c8><span class=c5>5. Контактная информация и жалобы</span></p><p class=\"c33 c39\" id=h.gjdgxs><span class=c12>Мы приветствуем любые вопросы, комментарии и запросы в отношении настоящей политики. Направляйте их по электронной почте </span><span class=\"c27 c36\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c2>, по телефону 0086-028-83313298 или обычной почтой по адресу: Tap4Fun Co., Ltd, на имя: Privacy Administrator, Building A3, Tianfu software park, high-tech zone, Chengdu, Sichuan, China (Китай).</span></p><p class=c7><span class=c2>Если вы хотите пожаловаться на то, как мы обрабатываем ваши персональные данные, просим вас предварительно связаться с нами по адресу </span><span class=\"c36 c27 c38 c53\"><a class=c4 href=mailto:support@tap4fun.com>support@tap4fun.com</a></span><span class=c2>, и мы постараемся как можно быстрее ответить на ваш запрос. Это не будет означать отказа от вашего права подавать иск в органы защиты персональных данных в стране, в которой вы живете или работаете и в которой мы, по вашему мнению, нарушаем законы о защите данных.</span></p><br></div></div>");
$templateCache.put("app/show/show.html","<div><div class=project-block><p class=\"description-content show-description\"><strong class=game-name>野蛮时代</strong><span>[本游戏仅适合18岁以上玩家玩耍]</span></p><p class=\"description-content show-description\">建造城市据点，不断扩张领土，和其他玩家一同竞争，打造一个强大的部落。</p><p class=\"description-content show-description\">在这个免费的MMO策略游戏里，体验最原始、最有趣的狩猎与玩家激斗！和部落联盟的盟友一起，加入这场史前捕猎盛宴吧。</p><p class=\"description-content show-description\" style=\"font-size: 12px;text-indent: 32px\">版号信息：新广审【2017】4105号 ISBN 978-7-7979-7502-5</p><img class=show-image src=assets/images/brutal_age.png alt=brutal_age></div><div class=content-separator></div><div class=project-block><p class=\"description-content show-description\"><strong class=game-name>Sea For All</strong><span>[本游戏仅适合18岁以上玩家玩耍]</span></p><p class=\"description-content show-description\">作为一款新颖的航海题材的SLG游戏，无论从画面还是游戏玩法都吸引了更广泛的玩家，目前项目正在热推当中。</p><!-- <a href=\"http://update.tap4fun.com/warzone/client/p303/SeaForAll_android_1.4.2_24664_Release_DLC.apk\">立即下载(安卓版本)</a>……</p> --> <img class=show-image src=assets/images/seaforall.png alt=seaforall></div></div>");
$templateCache.put("app/register/register.html","<div class=register-container><h3>实名注册</h3><form style=\"width: 350px\"><div class=form-group><label for=userName>邮箱:</label><input type=email class=form-control id=userName data-ng-model=register.user.email placeholder=\"eg: example@example.com\"></div><div class=form-group><label for=userPassword>密码:</label><input type=password class=form-control id=userPassword data-ng-model=register.user.password></div><div class=form-group><label for=userPasswordConfirm>确认密码:</label><input type=password class=form-control id=userPasswordConfirm data-ng-model=register.user.passwordConfirm></div><div class=form-group><label for=name>身份证姓名:</label><input type=text class=form-control id=name data-ng-model=register.user.name></div><div class=form-group><label for=ID>身份证号:</label><input type=text class=form-control id=ID data-ng-model=register.user.ID></div><label><input type=checkbox data-ng-model=isAgree style=\"outline: none\"><span style=\"color: darkgray;font-size: 12px\">我已阅读并同意相关服务条款和隐私政策</span> <a ui-sref=app.privacy data-ng-click=register.cacheRegisterInfo()>点击阅读 <i class=\"glyphicon glyphicon-new-window\"></i></a></label><button class=\"btn btn-info\" style=\"margin: 10px auto 30px auto;padding: 6px 30px 6px 30px\" data-ng-click=register.register() data-ng-disabled=!isAgree>注册</button></form></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse navbar-mine\"><div class=\"container-fluid container-resize\"><div class=navbar-header><a class=\"navbar-brand navbar-logo\" ui-sref=home><img src=assets/images/logo.png alt=logo height=40 width=77></a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li class=nav-item-ext data-ng-repeat=\"item in nb.navbarMenus\" data-ng-class=\"{\'active-link\': item.isActive, \'nav-link\': true}\"><a ui-sref={{item.uiState}}>{{item.name}}</a></li></ul></div></div></nav>");
$templateCache.put("app/components/siteFooter/siteFooter.html","<footer class=main-footer><div><div><a class=footer-link ui-sref=app.about>关于我们</a><span class=footer-link-separator>|</span> <a class=footer-link ui-sref=app.contact>联系我们</a><span class=footer-link-separator>|</span> <a class=footer-link ui-sref=app.parental>家长监护</a><span class=footer-link-separator>|</span> <a class=footer-link ui-sref=app.disputeHandling>纠纷处理</a></div><div style=\"width:850px;margin:0; padding:0px 0\"><a target=_blank href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002006768\" style=display:inline-block;text-decoration:none;height:20px;line-height:20px><img src=assets/images/jh.png style=float:left><p style=\"float:left;height:20px;line-height:20px;margin: 0px 5px 0px 5px; color:#939393\">川公网安备51019002006768</p></a><a target=_blank href=https://beian.miit.gov.cn/ style=display:inline-block;text-decoration:none;height:20px;line-height:20px><p style=\"float:left;height:20px;line-height:20px;margin: 0px 5px 0px 5px; color:#939393\">蜀ICP备16012054号-1</p></a><a ui-sref=app.about style=display:inline-block;text-decoration:none;height:20px;line-height:20px><p style=\"float:left;height:20px;line-height:20px;margin: 0px 5px 0px 5px; color:#939393\">川网文（2016）1261-045号，川B2-20160108</p></a></div><div><p><span class=foot-message>抵制不良游戏，拒绝盗版游戏 注意自我保护，谨防受骗上当; 适度游戏益脑，沉迷游戏伤身 合理安排时间，享受健康生活。</span></p></div><div class=footer-text><span>成都三叉戟科技有限公司</span><br><strong>Trident Studio </strong>&copy; 2022. All Rights Reserved.</div></div></footer>");}]);